<template>
  <svg
    version="1.1"
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    viewBox="0 0 612 369.3"
    style="enable-background: new 0 0 612 369.3"
    xml:space="preserve"
  >
    <g id="C3" :fill="fill">
      <g>
        <path
          class="st0"
          d="M163.8,257c0.3,0,0.7-0.1,1-0.1C164.5,256.7,164.2,256.5,163.8,257z"
        />
        <path
          class="st0"
          d="M94.5,166.9c0.2-0.5,0.6-0.6,1-0.4c1.4,0.6,2.3-0.2,3.5-0.8c-0.3-0.4-0.6-0.7-0.9-1c-0.2-0.3-0.5-0.6-0.7-0.9
			c-0.1-0.1-0.1-0.2-0.2-0.2c-0.1-0.1-0.1-0.2-0.2-0.3s-0.1-0.2-0.1-0.3c-0.5-0.5-1-1-1.4-1.5c-0.6,0.3-1.1,0.5-1.6,0.7
			c-0.1,0.2-0.2,0.4-0.3,0.6c-0.3,0.2-0.6,0.3-1,0.5c0,0.1,0.1,0.1,0.1,0.2v0.1c0,0.1,0,0.2,0,0.2c0.2,0.2,0.4,0.4,0.5,0.6
			c0.3,0.4,0.5,0.8,0.6,1.3c0,0.1-0.3,0.2-0.5,0.3c-0.1-0.1-0.2-0.2-0.2-0.3c-0.2,0-0.4,0.1-0.7,0.2c0,0.1,0,0.2,0,0.2v0.1
			c0.2,0,0.3,0,0.5,0c-0.1,0.1-0.3,0.2-0.4,0.3c-0.1,0.7,0.9,0.3,1,0.6C94,167.5,94.3,167.4,94.5,166.9z"
        />
        <path
          class="st0"
          d="M81.4,161.8c0.6,0.1,1,0.5,0.9,1.1c0,0.3,0.3,0.6,0.4,1c0.4-0.2,0.7-0.3,1-0.4c0.5,0.2,0.3,1.1,1.4,0.7
			c0.1-0.2,0.2-0.4,0.4-0.7c0.2,0.4,0.4,0.6,0.4,0.8c0,0.4-0.2,0.9-0.3,1.3c-0.1,1.3,0.1,1.5,1.7,1.7c0.3,0,0.6,0.1,1.1,0.1
			c-0.1,0.2-0.2,0.3-0.4,0.5c0.6-0.1,1-0.1,1.5-0.1c0.4,0,0.4-0.2,0.5-0.4c-0.3-0.1-0.4-0.2-0.1-0.6l0,0c-0.1-0.2,0-0.3,0.2-0.5
			c0-0.1,0-0.2-0.1-0.3c-0.2-0.5,0.1-0.8,0.7-1c0.1-0.2,0.1-0.3,0.2-0.5c-0.2-0.2-0.4-0.4-0.4-0.6v-0.1c0-0.1,0.1-0.3,0.1-0.4
			c-0.1-0.1-0.2-0.3-0.3-0.5c-1.3,0.4-2,0-2.2-1.1c-0.2-0.6-0.6-0.7-1.5-0.9l-0.1,0.1c0.1,0.3,0.1,0.6,0.2,1.1
			c-0.2,0.1-0.7,0.5-0.9,0.5c-0.9-0.3-1.5,0.1-2,0.7c-0.3-0.3-0.5-0.5-0.7-0.8c0.3-0.2,0.6-0.4,0.9-0.6c0.2-0.5-0.6-1.4-1.1-1.3
			c-1,0.3-1.6-0.1-2.2-0.5c-0.2-0.2-0.7-0.1-1.2-0.1C79.8,160.9,80.2,161.6,81.4,161.8z M87.7,166.1c-0.2,0.3-0.5,0.5-0.7,0.9
			C86.8,166.4,86.8,166.4,87.7,166.1z"
        />
        <path
          class="st0"
          d="M217.5,247.8c-0.3,0.2-0.5,0.3-0.7,0.4c0.3,0.1,0.5,0.1,0.8,0.2c0.2,0.1,0.4,0.1,0.7,0.2
			c0.1-0.2,0.1-0.4,0.2-0.6c0.1-0.2,0.2-0.5,0.3-0.8c0.3,0.1,0.5,0.2,0.8,0.3s0.6,0.3,0.9,0.4c0.3-0.3,0.7-0.5,0.9-0.7
			c0.2,0,0.4,0.1,0.6,0.1c0.2,0,0.5,0.1,0.7,0.1c0.1,0,0.2,0,0.3,0l0,0c0.1,0.1,0.2,0.1,0.3,0.2c0.4,0.1,0.6-0.5,0.9-0.6
			c0,0,0,0,0.1,0c0,0,0.1,0,0.1,0.1c0,0,0,0,0.1,0.1s0.2,0.1,0.3,0.2c0.4,0.3,0.7,0.5,1.1,0.8c0.2,0.1,0.4,0.3,0.6,0.4
			c0.5-0.3,0.9-0.6,1.1-0.8c0.9,0.1,1.5,0.2,2.2,0.2c0.1,0,0.2,0.2,0.4,0.3c-0.4,0.2-0.8,0.4-1.2,0.6c0,0.1,0.1,0.1,0.1,0.2
			c0.5-0.2,1.1-0.4,1.6-0.6c0.2-0.4-0.3-0.9,0.5-1.2c1.4,0.7-0.6,1.7,0.2,2.4c-0.1,0.3-0.3,0.6-0.4,0.9c-0.2,0.5-0.4,1-0.6,1.5
			c1.2-0.5,1.8-1.2,2-2.1c0-0.1,0.1-0.2,0.1-0.3c-0.5-0.3-0.9-0.5-0.9-1.1c0.8-0.1,1.5-0.3,2.3-0.4c0.1,0.3,0,0.5-0.2,0.7
			c0.2,0.1,0.3,0.2,0.4,0.2c0.4,0.2,0.7,0.4,1.1,0.5c0.1-0.2,0.2-0.3,0.4-0.4c0.5-0.6,1.7-0.3,2-1.2c0.1-0.2,0.8,0.1,0.8,0.5
			c0,0,0,0,0,0.1c-0.1,0.3-0.2,0.6-0.4,0.9c0.5-0.1,1-0.4,1.1-0.9s0.3-0.6,0.8-0.8c0.7-0.4,0.8-1,0.6-1.7c0,0,0,0,0-0.1l0,0
			c-1,0.4-2,0.6-2.8,0.2c-0.2,0-0.4,0-0.6,0c0.1-0.1,0.2-0.1,0.3-0.2c-0.1-0.1-0.1-0.1-0.2-0.2c0.2,0,0.4-0.1,0.6-0.1
			c0.1-0.1,0.3-0.2,0.5-0.3c0,0.1,0,0.2-0.1,0.3c0.5,0,1.1,0,1.6-0.3c0.1,0,0.1-0.1,0.2-0.1c0.2-0.1,0.9,0,1.3,0.5
			c0.1,0.2,0.3,0.4,0.5,0.5c0.2-0.3,0.5-0.5,0.8-0.8c0.1,0.2,0.4,0.5,0.3,0.5c-0.2,0.2-0.5,0.4-0.8,0.6c0.2,0.2,0.5,0.4,0.7,0.6
			c0.1,0.1,0.2,0.2,0.3,0.3c0.3,0.3,1.1-0.3,1,0.4l0,0c-0.1,0.2-0.1,0.4-0.2,0.6c0.3,0,0.7,0,0.6-0.4c0.4-0.1,0.8-0.3,1.2-0.4
			c0.1,0.1,0.2,0.2,0.2,0.3c0.6,1.3,2.2,1.4,3.4,0.3c0.2-0.2,0.3-0.3,0.4-0.5c0.2-0.5,0.7-0.8,1.2-1c0-0.2-0.1-0.4-0.1-0.6
			c-0.5,0.1-1,0.1-1.8,0.2c0.4-0.4,0.8-0.7,1-1c0.3-0.3,0.5-0.6,0.8-1c0.8,0.5,1.1,1.2,1.6,1.9c0.1,0,0.2-0.1,0.3-0.2
			c0.1-0.1,0.2-0.1,0.3-0.2l-0.1-0.1c-0.2-0.2-0.3-0.3-0.4-0.5c0.2-0.3,0.4-0.6,0.6-0.8c-0.4-0.3-0.7-0.4-0.8-0.6c0-0.1,0-0.1,0-0.2
			c0-0.3,0.2-0.5,0.6-0.7c0.1-0.1,0.3-0.1,0.4-0.2c0.2,0.3,0.4,0.5,0.5,0.8c0,0.1,0.1,0.1,0.1,0.2c0,0,0-0.1,0.1-0.1
			c0.4-0.4,0.4-0.5,0.7-1.6c0.2-0.6,0.5-1.1,1.3-1.2c0.7-0.1,1.4,0.2,1.6,0.7c0.1,0.2,0.1,0.3,0.1,0.5c0,0.4-0.2,0.7-0.6,1.1
			c-0.1,0.1-0.2,0.2-0.3,0.4c0.4,0.3,0.7,0.7,0.9,0.9c1.1-0.5,2.2-0.9,3.2-1.4c0.2-0.7,0.5-1.5,0.8-2.4c-1.6,0.2-2.4-0.6-3.2-1.4
			c-0.1-0.1-0.1-0.1-0.2-0.2l-0.1-0.1c-0.1-0.1-0.1-0.1-0.2-0.2l0,0c-0.2-0.2-0.3-0.6-0.2-0.8l0,0c0-0.1,0.1-0.2,0.1-0.2
			c0.1-0.2,0.2-0.4,0.3-0.6c0.1-0.2,0.3-0.4,0.5-0.6c0.6-0.7,1.3-1.2,2.4-1.4c0.9-0.2,1.7-0.1,2.3,0.3c0.2,0.1,0.3,0.2,0.5,0.3
			c0.3,0.3,0.6,0.6,0.9,0.9c0,0.1,0.2,0.1,0.3,0.1c0.4-0.3,0.7-0.5,1.1-0.8c-1.8-1-2.3-2.2-1.6-3.5c0.1-0.1,0.2-0.3,0.3-0.4l0,0
			c0.9-1,2.4-1.2,4.7-0.5c0.1-0.5,0.2-1,0.4-1.8c-1.7,1.3-3.2,0.9-4.6,0.4c-0.1,0-0.2-0.1-0.3-0.1H265c-0.1,0.2-0.3,0.3-0.4,0.5
			c0,0-0.1,0-0.1,0.1c-0.6,0.6-1.3,0.9-2.1,1c-0.4,0-0.7,0-1.1,0c-0.1,0.2-0.1,0.4-0.2,0.6c-0.1,0.2-0.1,0.4-0.2,0.5
			c0.2,0.2,0.6,0.3,0.6,0.5c0,0.1,0,0.2-0.1,0.3v0.1c-0.4,1-2.1,1.9-3.2,1.4c-0.2-0.1-0.2-0.4-0.3-0.6c-0.2,0.2-0.5,0.4-0.5,0.5
			l0.1,0.1c0.4,0.6-0.1,1.1-0.6,1.5l0,0c-0.3,0.2-0.6,0.5-0.9,0.7c-0.3,0.3-0.6,0.5-1,0.8c-0.1,0-0.2,0-0.4,0
			c-0.1-0.3-0.3-0.6-0.4-0.8c-0.2,0-0.3,0.1-0.5,0.1c-0.1,0-0.2,0-0.2,0.1c0-0.1,0-0.1,0-0.2c0.1-0.4,0.2-0.7,0.2-1.1l0,0h-0.1
			c-0.1,0-0.1,0-0.2,0c-0.1,0-0.1,0-0.1-0.1c0.1,0,0.1,0,0.2,0c0.1,0,0.1,0.1,0.2,0.1h0.1l0,0c0.1-0.2,0.2-0.3,0.4-0.5
			c0.1-0.1,0.1-0.2,0.2-0.2c-0.2,0-0.4,0-0.7,0v-0.1c0.2-0.2,0.3-0.5,0.4-0.7c0-0.1-0.2-0.2-0.3-0.3c-0.1,0.1-0.2,0.2-0.3,0.3v0.1
			h-0.1l-0.1,0.1v-0.1c0,0,0,0,0.1,0c0,0,0,0,0-0.1c0,0,0.1,0,0.1-0.1s0.1-0.2,0.1-0.4c0-0.1,0-0.1,0-0.2c0-0.2,0.1-0.5,0-0.7l0,0
			c-0.1-0.3-0.3-0.7-0.5-0.7s-0.4,0-0.5,0c-0.8-0.1-1.3-0.8-2-1.1c-1,1.6-1.6,2-2.9,2.1c-1.5,0.1-2.1,0.5-3.3,1.4
			c-0.6,0.4-1.3,0.7-2.4,1.3c1-1.8,2.3-2.6,3.9-3c-0.3-0.3-0.6-0.7-1-1c-0.2-0.2-0.6-0.2-0.9-0.3c0.1,0.4,0.1,0.9,0.2,1.3
			c-0.5,0.2-1,0.5-1.4,0.7c-0.4-0.2-0.7-0.4-0.8-0.5c-0.9,0.2-1.4,0.3-2,0.4c-0.3,0.1-0.8,0-0.9,0.2c-0.2,0.2-0.1,0.6-0.1,1
			c-0.7,0.4-1.6,0.7-2.3,1.3c-0.6,0.5-1,1.1-1.5,1.8c0.6-0.1,1.1-0.1,1.8-0.2c-0.2,0.5-0.4,0.8-0.5,1.1c0.1,0.1,0.2,0.3,0.3,0.4
			c0.1,0.2,0.3,0.3,0.4,0.5c0.1-0.3,0.2-0.5,0.3-0.8s0.2-0.6,0.3-0.9c0.4,0.1,0.7,0.2,1.1,0.3c0.2,0.1,0.4,0.1,0.7,0.2
			c-0.3,0.4-0.4,0.7-0.3,0.9c0,0.2,0.2,0.4,0.4,0.6c0,0,0,0,0,0.1c0.4,0.3,0.6,0.6,0.6,1c0.1,0.4,0,0.8-0.1,1.3
			c-0.4,1.1-1.7,1.5-2.7,1.1c-0.2-0.1-0.3-0.2-0.5-0.3s-0.3-0.3-0.4-0.4c-0.2-0.2-0.5-0.4-0.7-0.7c-0.3,0-0.5,0-0.7,0
			c-0.5,0-1,0-1.4-0.1c-0.6-0.1-1-0.3-1.3-0.7c0,0-0.1,0-0.1-0.1c-0.4-0.4-0.6-1-0.6-1.7c0-0.2,0.1-0.5,0.1-0.7
			c-0.8,0.2-0.5-0.2-0.4-0.5c0.5-0.1,0.5,0.2,0.5,0.5c0.9-0.3,1.8-0.6,2.5-0.8c0.5-1.2,0.8-2.1-0.4-2.8c-0.4,0.4-0.7,0.9-1.4,0.6
			c-0.4,0.4-0.7,0.8-1.1,1.3c0.7,0.4-0.6,0.9-0.1,1.3c-0.5,0-1,0-1.6,0c0,1,0,1.9,0,2.9c-0.7-0.1-1.1-0.2-1.4-0.2
			c-0.8,0.6-1.7,1-2.1,1.6c-0.2,0.5-0.4,1.1-0.2,1.6c0.1,0.1,0.1,0.2,0.2,0.3c-0.3,0.2-0.5,0.3-0.7,0.4c-0.2,0.1-0.4,0.3-0.7,0.5
			c0-0.3,0-0.5-0.1-0.7c-0.1-0.4-0.4-0.6-1-0.7c0,0.4,0.1,0.8,0.1,1.1v0.1c0,0.5-0.1,1-0.8,1.4l0,0c-0.2-0.3-0.4-0.6-0.5-1l-0.1-0.1
			c-0.2-0.3-0.3-0.6-0.5-0.9c-0.4,0.1-0.8,0.2-1.1,0.2c-1.6,0.2-1.3,0.1-1.9,1.3c0,0.1-0.3,0.1-0.5,0.2c0,0,0,0,0.1,0h-0.1
			c0,0.1-0.1,0.2-0.1,0.2c-0.1,0.1-0.2,0.1-0.3,0.1c0,0-0.1-0.1-0.1-0.2c0.1,0,0.2-0.1,0.3-0.1s0.2,0,0.3-0.1c0,0,0,0,0-0.1l0,0
			c-0.3-0.2-0.6-0.4-0.7-0.4c-0.6,0.3-1.1,0.6-1.6,1v0.1C216.8,247.6,217.1,247.7,217.5,247.8z M238.2,246.5
			C238.2,246.5,238.3,246.6,238.2,246.5c-0.2,0.2-0.4,0.2-0.6,0.3c0-0.1,0-0.2,0-0.3C237.8,246.5,238,246.5,238.2,246.5z M259,241.3
			c0.1,0,0.2,0,0.3,0c-0.1,0.1-0.1,0.1-0.2,0.2c-0.1,0-0.1-0.1-0.2-0.1C258.9,241.4,259,241.3,259,241.3z M263.4,232.6
			c0.1,0,0.2,0.1,0.4,0.2c-0.2,0.2-0.3,0.2-0.4,0.3c-0.1-0.1-0.2-0.2-0.2-0.3C263.1,232.7,263.3,232.6,263.4,232.6z M263,234.7
			l-0.1,0.1c0-0.1,0-0.1-0.1-0.2C262.9,234.6,263,234.6,263,234.7z M242.2,240.5c-0.1,0-0.2,0-0.3,0l0.1-0.1c0.1,0,0.2,0,0.3,0.1
			C242.3,240.4,242.2,240.5,242.2,240.5z M246.3,248.4L246.3,248.4c-0.1,0-0.1,0.1-0.1,0.1s0,0-0.1,0
			C246.2,248.4,246.2,248.4,246.3,248.4C246.3,248.3,246.3,248.3,246.3,248.4C246.3,248.3,246.3,248.3,246.3,248.4z M246.3,244.9
			c-0.1,0-0.1,0-0.2-0.1c-0.4-0.2-0.7-0.5-0.8-0.8c-0.1-0.2-0.1-0.4,0-0.6c0.3-0.7,0.4-1.4,0.8-2c0.2-0.3,0.4-0.6,0.7-0.9l0,0l0,0
			c-0.3,0.1-0.6,0.1-0.9,0.2c0-0.1-0.1-0.1-0.1-0.2c0.3-0.2,0.6-0.4,1.2-0.7c-0.1,0.3-0.1,0.5-0.2,0.7l0,0l0,0c0.1,0,0.1,0,0.2,0
			c0.6-0.1,1,0.3,1.2,0.7c0,0.1,0.1,0.2,0.1,0.2c0.1,0.3,0.2,0.7,0.4,1c0.1,0.4,0.3,0.8,0.4,1.1l0,0c-0.2,0.2-0.4,0.3-0.6,0.5
			c-0.2,0.2-0.5,0.3-0.7,0.5C247.2,244.8,246.7,245,246.3,244.9z M249.1,246.2c-0.5,0.6-0.9,0.3-1.4-0.2c0.3-0.2,0.6-0.4,1-0.7
			C248.8,245.7,249.2,246.1,249.1,246.2z M249.1,240.5c0,0-0.1,0-0.1-0.1c0.1,0,0.2-0.1,0.3-0.1l0.1,0.1
			C249.3,240.4,249.2,240.5,249.1,240.5z M252,242.2c-0.2,0.8-0.8,1.2-1.2,1.7c0-0.4,0.1-0.9,0.3-1.3c0.2-0.4,0.5-0.8,0.9-1.2
			C252.1,241.7,252.1,241.9,252,242.2z M249.1,234.8c0.5,0.1,0.8,0.2,1.2,0.3c0.1,0,0.1,0,0.2,0.1c-0.8,0.3-1.4,0.6-2,0.9l-0.1-0.1
			l-0.1-0.1C248.6,235.6,248.8,235.3,249.1,234.8z M243.6,236.4c0.5-0.2,1.1-0.3,1.6-0.2c0.2,0.1,0.4,0.2,0.6,0.4
			c0.1,0.1,0.3,0.3,0.5,0.4c0.2,0.1,0.3,0.3,0.4,0.5c0,0.2,0,0.4-0.1,0.7c0.8-0.7,1.6-1,2.4-1.1c0.2,0,0.5,0,0.7,0s0.5,0,0.7,0.1
			c0.1,0,0.2,0,0.2,0c0.1,0,0.1,0,0.2,0c0.6,0.1,1.2,0.1,1.8,0.2l0,0l0.1-0.1v0.1l0,0c0,0.8,0,1.3-0.4,1.6s-1.1,0.5-2.2,0.7
			c0-0.2-0.1-0.4-0.1-0.7c-0.4,0.2-0.7,0.4-1,0.5c-0.1,0.1-0.2,0.1-0.4,0.2c-0.4,0-0.6-0.1-0.8-0.3c-0.3-0.2-0.5-0.5-0.6-0.9
			c0-0.1-0.1-0.3-0.1-0.4c-1,0.7-1.7,1.5-3.1,1.2c-0.3-0.1-0.6-0.2-0.8-0.3s-0.4-0.3-0.6-0.5c-0.2-0.3-0.4-0.6-0.6-1
			c0-0.1-0.1-0.3-0.1-0.4C242.3,237,242.9,236.7,243.6,236.4z M240,240c0,0-0.1,0-0.1-0.1l0.1-0.1l0.1,0.1L240,240z M240.2,236.4
			c-0.1-0.2,0.2-0.4,0.4-0.7c0.3,0.2,0.6,0.3,0.7,0.5c0,0.2-0.3,0.4-0.4,0.6C240.6,236.7,240.3,236.6,240.2,236.4z M235.4,246.5
			c0,0.1,0.1,0.2,0.1,0.4c-0.3,0.1-0.6,0.2-0.9,0.3c0-0.1-0.1-0.1-0.1-0.2C234.8,246.8,235.1,246.7,235.4,246.5z M233.3,245.2
			c0.3,0.1,0.5,0.2,0.8,0.3c-0.1,0.2-0.2,0.4-0.2,0.6l0,0c0.1,0,0.1,0.1,0.2,0.1c-0.1,0-0.1,0-0.2-0.1l0,0c-0.5,0.1-0.9,0.8-1.7,0.3
			C232.6,246,232.9,245.6,233.3,245.2z M231.3,243.3c0.1,0,0.1,0,0.2,0v0.1C231.4,243.4,231.3,243.4,231.3,243.3
			C231.3,243.4,231.3,243.3,231.3,243.3z M230.5,244.8c0.1-0.2,0.2-0.4,0.4-0.5l0,0c0.2-0.1,0.5-0.1,1-0.1c0.1,0,0.2,0,0.3,0
			c-0.4,0.6-1.1,0.7-1.8,0.8C230.5,244.9,230.5,244.8,230.5,244.8z M228.7,241.9c0.2,0.7,0.5,1.2-0.4,1.6l0,0h-0.1
			c-0.1,0.1-0.2,0.2-0.4,0.3c0-0.1-0.1-0.1-0.1-0.2c0.2,0,0.3-0.1,0.5-0.1c0,0,0,0,0.1-0.1l0,0c-0.1-0.1-0.2-0.3-0.4-0.4
			c-0.1-0.1-0.2-0.2-0.4-0.3C227.9,242.5,228.3,242.2,228.7,241.9z"
        />
        <path
          class="st0"
          d="M70.6,183.3c0.2-0.2,0.4-0.4,0.6-0.6c-0.1-0.1-0.2-0.2-0.3-0.3c-0.2-0.1-0.9,0.1-0.9,0.2
			c-0.1,0.5-0.4,0.8-0.8,1.2c0.2,0.2,0.4,0.4,0.7,0.6C70.1,183.9,70.3,183.6,70.6,183.3z"
        />
        <path
          class="st0"
          d="M264.2,136.9c-0.4-0.1-1.2,0-0.6-0.5c0,0,0,0,0.1-0.1c-0.4-0.1-0.9-0.1-1.6-0.3c0.1,0.2,0.2,0.4,0.3,0.5
			c0.1,0.2,0.1,0.3,0.2,0.4c0,0.3,0,0.5-0.1,1C263.1,137.6,263.6,137.3,264.2,136.9z"
        />
        <path
          class="st0"
          d="M257.3,248.4c-0.2-0.7-0.4-1.4-0.6-2.1c-1.1,0.7-2.2,1.4-3.6,0.9l0,0c0.1,0.1,0.2,0.2,0.4,0.3c0,0,0,0,0.1,0
			c0,0,0,0,0.1,0c1.3-0.2,2.4,0.3,3.4,1.2C257.1,248.6,257.2,248.5,257.3,248.4z"
        />
        <path
          class="st0"
          d="M239.8,231L239.8,231c0.1,0,0.1,0,0.2,0C239.9,231.1,239.8,231.1,239.8,231C239.7,231,239.8,231,239.8,231
			c-0.6,0.6-1.2,1.2-2.1,2.1c1.2-0.3,2.1-0.4,2.9-0.6c0.1-0.6,0.1-1.2,0.3-1.7c0.1-0.5,0.7-0.7,1.1-0.4c0.4,0.2,0.7,0.5,1.2,1
			c-0.2-0.9-0.3-1.5-0.5-2.3C241.7,229.7,240.4,230,239.8,231z"
        />
        <path
          class="st0"
          d="M261.7,227.1c0.6-0.2,0.6-0.6,0.5-1.1c-0.5-0.1-1-0.2-1.4,0.2c-0.1,0.1-0.1,0.1-0.2,0.2
			c-0.1,0.1-0.2,0.3-0.3,0.4c-0.5,0.7-1,1.4-1.7,2c-0.5,0.5-1.2,1.1-1.9,1.3c-1.1,0.3-1.5,1-1.7,1.7c-0.1,0.2-0.2,0.5-0.2,0.8
			c0.5,0,0.9-0.2,1,0.1c0,0,0,0,0,0.1c0.1,0,0.2,0,0.3-0.1c0-0.1,0.1-0.1,0.1-0.2c0.7-1.1,1.7-1.8,3.2-2c0.1-0.2,0.2-0.4,0.2-0.5
			s0-0.2,0-0.2C259.7,228.6,260.2,227.6,261.7,227.1z"
        />
        <path
          class="st0"
          d="M243.8,232c0-0.1-0.1-0.1-0.1-0.2l-0.1,0.1C243.6,232,243.7,232,243.8,232z"
        />
        <path
          class="st0"
          d="M150.4,138.9c-0.8,0.7,0.3,1,0.2,1.5c-0.1,0.3-0.1,0.6-0.1,0.9c0.8,0.7,2.2,1.1,4.1,1.2
			c-0.1,0.8-0.3,1.5-0.4,2.3c-0.9,0.1-1.8,0-2.7,0.2c-0.4,0.1-0.8,0.2-1.2,0.4c0.1,0.4,0.2,0.7,0.3,1.1c0.8-0.2,1.4-0.4,1.7-1
			c0-0.1,0.3-0.1,0.4-0.1c0,0.2,0,0.5,0.1,0.7c0,0.1,0,0.2,0,0.4c0,0.1,0,0.2,0,0.3c1.7-0.7,1.7-0.7,2.9,0.6
			c0.2-0.4,0.3-0.9,0.6-1.2s0.9-0.5,1.3-0.5c0.3,0,0.7,0.4,0.7,0.7s-0.3,0.7-0.6,1c-0.2,0.2-0.6,0.1-0.9,0.3c-0.3,0.1-0.4,0.4-1,0.9
			c1.1-0.1,1.7-0.2,2.2-0.2c0.6-0.7,1.1-1.2,1.6-1.7c-0.3-0.2-0.7-0.4-1-0.6c0.5-0.9,1.9,0.5,2.2-0.9c-0.4-0.2-0.9-0.4-1.3-0.6
			c1.7-1.3,1.7-1.3,1.3-2.3c-1.9-0.3-3.9,0.3-5.9,0.3c0,0,0,0,0-0.1c-0.1-0.3-0.1-0.5-0.2-0.7c-0.1-0.4-0.2-0.8-0.3-1
			c0-0.2,0-0.3,0-0.4c0-0.4,0.2-0.6,0.6-1c0.8,0.5,0.1,1.4,0.4,1.8c0.4,0.2,0.7,0.3,1.1,0.4c0.2,0.1,0.5,0.2,0.7,0.3
			c0.1-0.1,0.2-0.3,0.2-0.4l0,0c0-0.8,0.4-1.4,0.8-2l-0.1-0.2c-0.3,0.1-0.6,0.2-0.9,0.3c-0.6-0.7-1-1.5-2.3-1.3
			c-0.8,0.1-1.4-0.3-1.5-1c-0.1-0.5-0.4-0.9-0.7-1.3c-0.2-0.2-0.3-0.4-0.4-0.6c-0.6,0.2-1.1,0.5-1.6,1c-0.1,0.1-0.3,0.3-0.4,0.4l0,0
			c0.1,0,0.2,0.1,0.2,0.2c0,0.1-0.1,0.2-0.1,0.3c-0.2,0-0.3,0-0.4,0c-0.1,0.2-0.3,0.4-0.4,0.6h0.1
			C150.1,138.3,150.6,138.8,150.4,138.9z M158.7,142.4c0.3,0.3,0.5,0.4,0.5,0.5c0,0.2-0.1,0.3-0.2,0.5c-0.2-0.1-0.4-0.2-0.5-0.3
			C158.5,143,158.6,142.8,158.7,142.4z M157.6,144.6v0.1c0,0,0,0.1-0.1,0.1C157.5,144.8,157.5,144.7,157.6,144.6
			C157.5,144.6,157.6,144.6,157.6,144.6z M155.9,140.9L155.9,140.9l-0.1,0.1L155.9,140.9z M151.7,140.2c0.3-0.2,0.7-0.2,0.9-0.7
			c0.5-0.9,0.6-0.9,1.7-0.2c-0.1,0.2-0.2,0.3-0.3,0.5c-0.2,0.3-0.4,0.7-0.6,1c-0.2,0.3-0.3,0.7-0.4,1c0,0.1-0.1,0.2-0.1,0.3v0.1
			c-0.2,0-0.3,0-0.5-0.1c-0.2,0-0.4-0.1-0.5-0.1c-0.4-0.2-0.8-0.5-0.8-0.8C150.9,140.9,151.3,140.5,151.7,140.2z"
        />
        <path
          class="st0"
          d="M268.6,130.6c0,0.1-0.1,0.2-0.1,0.3c0.1,0.1,0.2,0.2,0.4,0.3C268.8,131,268.7,130.8,268.6,130.6z"
        />
        <path
          class="st0"
          d="M258.2,232.8c0,0.3,0,0.6,0,0.9c0,0.3,0,0.6,0,0.9c0.5-0.5,1-1,1.6-1.5c0,0,0,0,0-0.1
			C259.3,232.5,258.8,232.3,258.2,232.8z"
        />
        <path
          class="st0"
          d="M283.8,139.3C283.8,139.3,283.7,139.3,283.8,139.3C283.7,139.4,283.7,139.4,283.8,139.3L283.8,139.3z"
        />
        <path
          class="st0"
          d="M162.5,143l-0.1-0.1c-0.1,0-0.2,0.1-0.3,0.1c0,0,0.1,0,0.1,0.1C162.3,143.1,162.4,143,162.5,143z"
        />
        <path
          class="st0"
          d="M266.5,116.6c-0.2,0-0.4,0.1-0.6,0.1c-0.4,0.1-0.7,0.3-1.1,0.5c0.3-0.1,0.6-0.1,0.9-0.2
			c0.5,0.5,0.9,0.9,0.2,1.5c-0.5,0.2-0.8-0.7-1.4-0.1c-0.1-0.1-0.4-0.2-0.4-0.3c0-0.1,0-0.2,0-0.3c-0.4,0.4-0.7,0.8-0.8,1.3
			c0,0.1,0,0.2-0.1,0.3c-0.1,0.5-0.2,1-0.3,1.6c0.2,0,0.5-0.1,0.5-0.1c0.2,0.2,0.3,0.5,0.4,0.9c-0.2,0.1-0.3,0.1-0.5,0.2l0.1,0.1
			c0.4,0.4,0.7,0.7,1.5,0.6c0.4-0.1,0.8,0.1,1.1,0.3c0.2,0.1,0.3,0.3,0.4,0.5c0.1,0.3,0.3,0.5,0.4,0.8c0.2,0,0.4-0.1,0.5-0.1
			c0.7-0.3,0.1-0.8,0.1-1.2c0.2,0,0.5-0.1,0.7-0.1c0-0.2,0-0.4,0-0.6c0.4-0.3,0.8-0.5,1.1-0.8c0.2-0.1,0.3-0.3,0.4-0.4l0,0
			c0.3-0.8,0.8-1.4,0.5-2.2c-0.1-0.2,0-0.3,0.1-0.5c0,0,0-0.1-0.1-0.1C269.6,117,268,116.4,266.5,116.6z M268.3,120.6l0.1,0.1v0.1
			C268.4,120.8,268.3,120.8,268.3,120.6C268.2,120.7,268.3,120.7,268.3,120.6z M267.8,117.9c0.1,0,0.2,0,0.3,0
			c0,0.1-0.1,0.2-0.1,0.2h-0.2C267.7,118,267.7,117.9,267.8,117.9z M267.4,118.6c0.3,0.3,0.7,0.6,0.2,1c-0.1,0.1-0.6,0-0.8-0.1
			l-0.1-0.1c-0.4-0.3-0.8-0.7,0.2-1.2c0.1,0.1,0.2,0.1,0.3,0.2S267.3,118.6,267.4,118.6z"
        />
        <path
          class="st0"
          d="M299.7,246c0.2-0.3,0.5-0.6,0.7-1c-3,0-3.7-0.3-5.4-2.2c0,0.4-0.2,0.7-0.1,1c0.5,1.1,0.4,2.1-0.1,3
			c0.1,0,0.1,0,0.1,0c0.8,0,1.5,0.3,1.8,0.9l0,0l0,0c0.1,0.3,0.1,0.6,0.3,0.9c0.1-0.4,0.3-0.7,0.4-1.1c0.1-0.4,0.1-0.7,0-1.1
			c0-0.1-0.1-0.2-0.2-0.4c0.5-0.3,0.9-0.5,1.5-0.9c0.1,0.3,0.2,0.5,0.3,0.9c0.1,0,0.3,0,0.4,0.1C299.6,246.1,299.7,246,299.7,246z"
        />
        <path
          class="st0"
          d="M87.6,178.7c0-0.4,0-0.8-0.1-1.2c0-0.4-0.1-0.8-0.4-1.1l0,0c0.1-0.1,0.2-0.2,0.3-0.3
			c-0.1-0.1-0.2-0.2-0.3-0.3c-0.1,0.2-0.2,0.4-0.4,0.8c-0.1,0.2-0.2,0.3-0.3,0.6c-0.2-0.3-0.3-0.5-0.4-0.7v-0.1
			c-0.7,0.3-1.4,1.1-1.3,1.7c0.1,0,0.2-0.1,0.2-0.1c0.1,0,0.1,0,0.2,0c0.4,0,0.8,0,1.5,0.2c0,0.2,0,0.4,0,0.7
			C87,178.9,87.3,178.8,87.6,178.7z"
        />
        <path
          class="st0"
          d="M279.7,139.9c0-0.3,0.1-0.6,0.1-0.9c-0.2,0-0.3,0.1-0.5,0.1c0,0.1,0.1,0.1,0.1,0.2
			C279.5,139.6,279.6,139.7,279.7,139.9z"
        />
        <path
          class="st0"
          d="M277,136.7c0,0.1,0.1,0.3,0.2,0.4c0.1-0.5,0.2-0.9,0.2-1.4c-0.1-0.1-0.2-0.3-0.4-0.4
			C277.1,135.8,277,136.3,277,136.7z"
        />
        <path
          class="st0"
          d="M268.5,128.4c0.4,0.1,0.7,0.2,0.9,0.2c-0.1,0.2-0.1,0.3-0.2,0.5c0.5,0,1-0.1,1.6-0.4c1.2-0.5,1.7-1.3,1.9-2.2
			c0,0-0.1,0-0.1,0.1c-0.5,0.3-1,0.8-1.9,0.6C269.9,127.1,269.1,127.7,268.5,128.4z"
        />
        <path
          class="st0"
          d="M274.8,141L274.8,141C274.9,141,274.9,141,274.8,141c0.1,0,0.2,0,0.3,0l0,0l0,0c-0.1,0-0.2-0.1-0.3-0.1
			C274.9,140.8,274.8,140.9,274.8,141z"
        />
        <path
          class="st0"
          d="M271,139.5c0.2-0.2,0.5-0.4,0.7-0.5c-0.2-0.2-0.4-0.4-0.6-0.7c0,0,0,0.1,0.1,0.1c0,0,0,0,0,0.1s0.1,0.2,0,0.3
			v0.1c-0.1,0.1-0.1,0.3-0.3,0.4C270.9,139.4,271,139.4,271,139.5z"
        />
        <path
          class="st0"
          d="M270.6,137.8L270.6,137.8c-0.1-0.1-0.2-0.3-0.4-0.4C270.3,137.6,270.5,137.7,270.6,137.8z"
        />
        <path
          class="st0"
          d="M288.9,137.6c0.3,0.2,0.6,0.4,1,0.6c0-0.3,0.1-0.5,0.1-0.8c0.2-1,0.4-1.9,0.1-2.7c-0.2-0.7-0.3-1.4-0.4-2.1
			c-0.6,0.1-0.8,0-0.5-0.7c0-0.1-0.2-0.1-0.4-0.2c-0.7,0.3-1.5,0.4-2.3,0.4c-0.2-0.2-0.4-0.3-0.5-0.5c-0.1-0.1-0.2-0.1-0.3-0.2
			c-0.3-0.4-0.5-0.8-0.5-1.2c-0.6,0.2-1,0.2-1.4-0.1c-0.3,0.5-1.1,0.3-1.5,0.6c-0.5,0.4-0.9,0.8-1.6,1c-0.2,0-0.3,0.5-0.5,0.7
			c-0.3,0.2-0.6,0.3-1.1,0.5c0.2,0.5,0.1,1.1-0.8,1.6c-0.2-0.2-0.4-0.4-0.7-0.7c-0.1,0.1-0.2,0.2-0.2,0.3l0.1,0.1
			c0.1,0.2,0.3,0.3,0.5,0.5c0.7,0.5,0.9,1.1,0.9,1.9c0,0.1,0,0.2,0,0.3c1,0.6,1.8,1.5,3.6,1.6c-1.2,0.5-1.4,1.5-2.5,1.8
			c0.1,0.1,0.2,0.2,0.2,0.3c0.1,0.1,0.2,0.3,0.3,0.4c1.6,0.2,2.9,0.2,4-1.2l0,0c-0.3-0.1-0.5-0.2-0.8-0.2l0,0
			c-0.6,0.2-1.2,0.4-1.5-0.3c0-0.1,0-0.2,0-0.2c0-0.1,0.1-0.3,0.2-0.3c0.4-0.2,0.9-0.4,1.1-0.4c0.6-1,1-1.9,1.5-2.7
			C286.7,135.6,287.6,136.7,288.9,137.6z M281.9,131.8c0.3,0.1,0.6,0.1,0.9,0.2v0.1c0,0.1,0,0.1-0.1,0.2c-0.2,0-0.3-0.1-0.5-0.1
			c-0.1,0-0.3,0-0.4-0.1C281.8,132,281.8,131.9,281.9,131.8z M280.9,131.9c0-0.1,0.1-0.2,0.1-0.3
			C280.9,131.7,280.9,131.8,280.9,131.9c0,0.1,0,0.2-0.1,0.3c-0.1,0-0.1-0.1-0.2-0.1C280.7,132,280.8,131.9,280.9,131.9z M283.5,135
			c0,0,0.1,0,0.1,0.1C283.5,135.1,283.5,135.1,283.5,135C283.4,135.1,283.4,135.1,283.5,135c-1.4,0.8-1.4,0.8-2.9,0.2
			c-0.4-0.4,0.1-1.1-0.2-1.6c-0.1-0.1-0.1-0.2-0.3-0.3c-0.3-0.2,0.4-0.8,0.7-0.7c0.7,0.5,1.6,0.2,2.4,0.5c0.2,0.1,0.4,0.2,0.6,0.4
			C283.7,134,283.5,134.5,283.5,135C283.4,135.1,283.4,135,283.5,135z M285.4,132.9c0.9,0,1.2,0.4,1.1,1c-0.1,0.7-0.7,0.9-1.9,1.2
			C285,134.1,285.2,133.5,285.4,132.9z"
        />
        <path
          class="st0"
          d="M268,133.1c0.3-0.2,0.5-0.4,0.6-0.7C268.4,132.6,268.2,132.8,268,133.1C268,133,268,133,268,133.1z"
        />
        <path
          class="st0"
          d="M82.4,166.4c-0.7-0.1-1.4,0.3-1.3,0.8c0,0.1,0.1,0.1,0.1,0.2h-0.1c0.1,0.4,0.3,0.9,1,1c0.9,0.1,1.5,0.4,1.9,1
			c0.1-0.1,0.1-0.2,0.2-0.3s0.4,0.1,0.8,0.1c-0.3,0.3-0.4,0.5-0.6,0.6c0.4,0.2,0.9,0.1,1.5-0.2c0.4-0.2,0.8-0.4,1.6-0.7
			c-0.9,1,0.2,0.8,0.3,1.2c-0.2,0.1-0.4,0.2-0.8,0.3c0.2,0.4,0.5,0.8,0.8,1.2c-0.2,0.1-0.5,0.2-0.7,0.2c-0.1,0.3-0.1,0.7-0.3,0.8
			c-0.1,0-0.1,0.1-0.1,0.1c0.3,0.1,0.5,0.4,0.5,0.9c-0.4-0.2-0.7-0.4-1-0.6c-0.6,0.2-1,0.1-2.6-0.4h-0.1c-0.3,0.4-0.6,0.9-0.9,1.4
			c0.2,0.4,0.5,0.8,0.7,1.2c0,0.1,0.1,0.1,0.1,0.2c0.2,0,0.4,0,0.6,0l0.1-0.1c0.2-0.1,0.7-0.1,0.9,0c0.3,0,0.7,0.1,1,0.2
			c0.3,0.2,1.2-0.3,1.9-0.5c0.2-0.1,0.4-0.2,0.6-0.2c0.2-0.2,0.2-0.5,0.2-0.9c-0.3-0.3-0.6-0.7-0.9-1c0.3-0.3,0.5-0.5,0.7-0.7
			c-0.3-0.2-0.5-0.4-0.7-0.5c0.3-0.4,0.6-0.8,1-1.2c-0.1-0.2-0.2-0.4-0.3-0.8c1.2,0.3,1.3-0.5,1.6-1.1c-0.7-0.2-1.6-0.2-2.2-1
			c-0.3,0.4-0.7,0.8-1,1.3c-0.4-0.3-0.7-0.5-0.8-0.7c-0.4-0.5-0.8-0.8-1.5-1.1c-0.5-0.2-0.9-0.4-1.3-0.6l0,0l0,0
			C83,166.6,82.7,166.5,82.4,166.4z M84,173.7c-0.1-0.1-0.1-0.1-0.2-0.2l-0.1-0.1c0,0,0,0,0.1,0s0.2-0.1,0.2-0.1
			c0.1,0,0.1,0.1,0.1,0.2C84.1,173.6,84,173.7,84,173.7z"
        />
        <path
          class="st0"
          d="M294.5,237.5c-0.1,0-0.1,0-0.2,0.1c0.1,0.2,0.1,0.4,0.2,0.5c0.1,0,0.1,0,0.2-0.1
			C294.6,237.9,294.5,237.7,294.5,237.5z"
        />
        <path
          class="st0"
          d="M220,137.8c0.7-0.2,1.4-0.2,2-0.1c0.4-0.4,0.9-0.8,1.5-1c-0.2,0.5-0.3,0.9-0.5,1.4c0.4,0.2,0.7,0.6,0.8,1
			c0.2,0.5,0.1,1.1-0.1,1.6c-0.2,0.6-0.6,1-1.2,1.3c-0.5,0.3-1,0.5-1.6,0.6c0.4,0.3,0.7,0.4,1.1,0.5c0.5,0.1,1,0,1.5-0.1
			s1-0.3,1.4-0.2s0.8,0.2,1.1,0.3c-0.4-0.6-0.3-1.2,0.6-1.9c0.4-0.3,0.7-0.8,0.7-1.2c0.1-0.7,0.1-1.3,0-2c-0.1,0-0.2,0-0.3,0
			c-0.4-0.1-0.7-0.2-1.1-0.4c-0.4,0.1-0.7,0.2-1.1,0.3c0-0.5,0-0.9,0-1.4c0-0.1-0.1-0.1-0.1-0.2c-0.5,0.1-1,0.2-1.5,0.3
			c0.2-0.7,0.4-1.4,0.6-2.4c0.4-0.2,0.8-0.4,1.3-0.6c0.2-0.3,0.5-0.5,0.8-0.7l0.1-0.1c0-0.4-0.1-0.7-0.1-1.1c0-0.4-0.1-0.7-0.2-1.1
			l-0.1,0.1c-0.4,0.5-1.1,1-1.8,1.3c-1.5,0.7-2.8,0.1-4-0.4c-0.1,0.5,0,1,0.4,1.5c0.1,0.2,0.2,0.3,0.4,0.5c-0.6,0.6-1.3,0.7-2.1,0.8
			c-0.1,0.4-0.2,0.8-0.3,1.2c0.6,0.1,1.1,0.2,1.6,0.2C219.4,136.7,219.9,137.2,220,137.8z"
        />
        <path
          class="st0"
          d="M228.9,142.4c-0.5,0.7-1.2,0.8-1.9,0.9c0.5,0.2,1,0.3,1.5,0.5l0,0h0.1c0.1-0.1,0.1-0.2,0.2-0.3
			c0.1,0,0.1,0.1,0.2,0.1c-0.1,0.1-0.3,0.1-0.4,0.2c0,0,0,0,0,0.1l0,0l0,0l0,0c0.1,0.1,0.1,0.2,0.2,0.2c0.1,0.1,0.1,0.1,0.1,0.2
			c0.4,0.7,0.3,1.5,0.3,2.2c0.5-0.1,1.1,0.1,1.6-0.3c0.5-0.4,1.1-0.5,1.7-0.5c-0.1-0.4-0.2-0.8-0.4-1.3c0.7-0.3,1.4-0.5,2.2-0.8
			v-0.1c-0.5-0.4-0.9-0.9-1.4-1.3c-0.4,0.4-0.4,1.1-1.2,1.4c-0.4-0.5-0.8-1.1-1.2-1.7c-0.1-0.2-0.3-0.4-0.4-0.6
			C229.7,141.6,229.2,142,228.9,142.4z"
        />
        <path
          class="st0"
          d="M249.9,130.9c0.1,0.1,0.3,0.1,0.4,0.1c0,0,0.1-0.1,0.2-0.3c-0.2,0-0.3-0.1-0.4,0S249.9,130.9,249.9,130.9z"
        />
        <path
          class="st0"
          d="M254.8,233.3C254.8,233.3,254.7,233.2,254.8,233.3c-0.1-0.1-0.2-0.1-0.2,0c0,0,0,0.1,0.1,0.1
			C254.7,233.4,254.7,233.3,254.8,233.3z"
        />
        <path
          class="st0"
          d="M257.2,255L257.2,255c-0.3,0.2-0.5,0.7-0.7,0.7c-0.9-0.1-1.2,0.3-1.8,0.8c0,0.1,0,0.3,0,0.5
			c-0.1,0-0.2-0.1-0.3-0.1c1.1,0.6,2,1.2,3.6,0.6c-0.2-0.3-0.3-0.5-0.5-0.8c0.1-0.2,0.3-0.4,0.5-0.6c-0.1-0.1-0.1-0.3-0.2-0.4
			c-0.1-0.3,0-0.7,0.1-1C257.8,254.8,257.5,254.9,257.2,255z"
        />
        <path
          class="st0"
          d="M41.6,291c0,0.1,0,0.1,0,0.2c1.4-0.2,1.5-0.4,1-1.3C42.3,290.3,41.9,290.7,41.6,291z"
        />
        <path
          class="st0"
          d="M270.9,140.5c0,0.1,0.1,0.3,0.3,0.4l0.1,0.1c0.5,0.4,0.9,0.6,1.7,0.4c0.3-0.1,0.7,0.1,0.9,0.2
			c0,0.1,0,0.1,0.1,0.2c0.2,0.6,0.5,1.1,0.7,1.7c0.3-0.3,0.5-0.5,0.8-0.8c0.2,0.5,0.3,0.8,0.3,1.1c0.8,0,1.4-0.1,2.3-0.1
			c-0.1-0.9-0.3-1.8-0.4-2.7c0-0.1,0-0.3-0.1-0.4c-0.1,0.1-0.2,0.1-0.3,0.2c-1.8-1.7-1.8-1.7-4.4-1.2c-0.5,0.1-0.9,0.4-1.3,0.6
			C271.4,140.3,271.1,140.4,270.9,140.5z M277.4,141.4c0,0,0.1,0,0.1,0.1l-0.1,0.1c0,0-0.1,0-0.1-0.1
			C277.3,141.5,277.3,141.5,277.4,141.4z M277.1,141C277,141,277,141.1,277.1,141c-0.2,0.2-0.3,0.3-0.4,0.3c0,0-0.1-0.1-0.2-0.1
			l-0.1-0.1c0.1-0.1,0.3-0.2,0.4-0.2C276.9,140.8,277,140.9,277.1,141z M274.7,140.3c0.1-0.2,0.3-0.4,0.4-0.6c0.5,0,1,0,1.3,0.3
			c0.1,0.1,0.2,0.2,0.2,0.3c-0.3,0.6-0.9,0.5-1.4,0.7l0,0c0,0,0,0-0.1,0c-0.1,0.1-0.1,0.3-0.2,0.4c0-0.1-0.1-0.2-0.1-0.3
			c0,0,0,0-0.1,0c0,0,0,0,0-0.1c-0.1-0.1-0.4-0.3-0.4-0.3C274.5,140.5,274.6,140.4,274.7,140.3z M273.2,140.2c0.1,0,0.1,0.1,0.2,0.1
			c-0.1,0.1-0.1,0.1-0.2,0.2c0,0-0.1,0-0.1-0.1C273.2,140.3,273.2,140.2,273.2,140.2z"
        />
        <path
          class="st0"
          d="M233.8,147.1c0.4,0,0.6-0.2,0.7-0.6c0.1-0.3,0.5-0.6,0.6-1c0.1-0.3,0.1-0.7-0.1-0.8c-0.1,0-0.1-0.1-0.1-0.1
			c-0.2,0.2-0.5,0.4-1,0.4c-0.4,0-0.8,0.4-1.2,0.7c0.2,0,0.5,0,0.7,0c-0.1,0.3-0.2,0.5-0.2,0.6C233.2,146.7,233.2,147,233.8,147.1z"
        />
        <path
          class="st0"
          d="M231.7,131.6c-0.1,0-0.1-0.1-0.2-0.1c0,0,0.1,0,0.1-0.1c0.1-0.1,0.2-0.1,0.2-0.2l0.1,0.1
			c0.1,0.1,0.3,0.3,0.4,0.4l0,0c0.5,0.1,1.1,0.1,1.8,0.1c1.6,0.8,0.2,2.4,1.2,3.4c0.8-0.1,1.4,0,2,0.5c0.4,0.3,1,0.6,1.4,0.9
			c0.1-0.1,0.2-0.2,0.3-0.3c1.3,0.1,1.4,0.1,3.4-0.5c0.2,0.2,0.4,0.4,0.6,0.6c0.3-0.3,0.6-0.5,1-0.8c0.1,1.8,1.6,1,2.7,1
			c0.1,0.4,0.2,0.9,0.3,1.3c0.1,0.4,0.3,0.8,0.6,1.1l0.1,0.1c0.2,0.2,0.5,0.4,0.8,0.5c-0.1,0.2-0.3,0.4-0.4,0.5
			c-0.1,0.1-0.2,0.2-0.2,0.4c0.4,0.1,0.7,0.1,1,0.2c0.2,0,0.4,0.1,0.6,0.1c-0.1,0.2-0.3,0.3-0.6,0.3c-0.4,0-0.8,0-0.9,0.6
			c0.3,0,0.6,0,0.9,0c0.4,0,0.8,0,1.1,0.1c0.7,0.1,1.4,0.2,1.9,0.8c-0.2,0.2-0.2,0.4-0.3,0.5c-0.1,0.3,0.1,0.5,0.5,0.7
			c0.1,0.1,0.4-0.1,0.6-0.1c-0.2-0.2-0.3-0.4-0.4-0.5c-0.1-0.1-0.1-0.1-0.2-0.2c0.9-0.5,1.7-0.9,2.5-1.3c-0.2,0-0.5,0-0.6-0.1
			c-0.1-0.4-0.3-0.8,0.4-1.1l0,0h0.1l0.1-0.1v0.1c0,0,0,0-0.1,0c0,0,0,0-0.1,0.1l0,0c0.2,0.3,0.4,0.5,0.6,0.8c1-0.1,1.2-0.8,1-1.3
			c-0.2-0.4,0-0.7,0.2-0.9c0.1-0.1,0.3-0.2,0.4-0.4c0.2,0.2,0.5,0.5,0.8,0.8c0.1,0.1,0.2,0.2,0.3,0.3c0-1,0-1.6,0-2.2
			c0.5,0.2,1,0.4,1.5,0.6c0.6,0.2,1.2,0.2,1.9,0.4c0.1-0.1,0.4-0.4,0.7-0.8c-0.6,0-1,0.1-1.7,0.1c0.6-0.4,0.9-0.6,1.2-0.8
			c-0.1-0.1-0.3-0.3-0.4-0.5c-0.1-0.1-0.2-0.2-0.2-0.3c-0.1,0.2-0.2,0.3-0.3,0.4c-0.4,0.3-0.8,0.4-1.3,0.4c-0.1,0-0.3,0-0.4,0h-0.1
			c-0.1,0-0.2,0-0.3,0c-0.2,0-0.3,0-0.4,0.1s-0.2,0.2-0.2,0.4c-0.1-0.1-0.2-0.1-0.3-0.2c-0.5-0.3-1.1-0.7-1.7-1c0,0-0.1,0-0.1-0.1
			c0,0-0.1,0-0.1,0.1c-0.6,0.8-1.5,0.5-2.3,0.6c-0.2,0.4-0.4,0.8-0.7,1.1s-0.7,0.5-1.1,0.7c-0.5,0.2-0.9,0.5-1.3,0.8l0,0l0,0l0,0
			l0,0c-0.1-0.1-0.1-0.2-0.2-0.2c0,0,0-0.1-0.1-0.1c0-0.1-0.1-0.1-0.1-0.2c-0.1-0.1-0.1-0.2-0.2-0.3c0,0,0,0-0.1,0l0,0l-0.1-0.1
			c0,0,0,0-0.1,0c0.1,0,0.1,0,0.2,0.1l0,0c0.7-0.4,1.3-0.7,2.1-1.2c-0.2-0.2-0.2-0.4-0.2-0.5c0-0.4,0.3-0.8,0-1.2
			c-0.2-0.4,0.3-1.1,0.5-1.8c-1.5,0.6-1.3,1.5-1.2,2.5c-1.3-0.2-1.3-0.2-2-1.2c-0.1-0.1-0.4-0.3-0.6-0.3c-0.1,0-0.2,0-0.3-0.1
			c-0.1,0.1-0.2,0.3-0.3,0.4c-0.2-0.3-0.5-0.5-0.8-0.8c-0.3-0.4-0.7-0.7-1.1-1.1c0.3-0.5,0.5-1.1,0.5-1.6c0.1-0.8-0.1-1.5-0.5-2.2
			c-0.2,0-0.4-0.1-0.6-0.2c-0.1,0-0.2,0-0.2-0.1c-0.3-0.1-0.6-0.2-0.9-0.3c0.3-0.3,0.5-0.6,0.7-0.8c-0.1-0.1-0.1-0.1-0.2-0.2
			c-0.3-0.3-0.7-0.6-1.1-1c-2.4-0.8-5-0.2-7.5,1.2c-1.7-1-2.9-1.2-4.1-0.4c-0.9,0.5-1.5,1.6-1.2,2.4
			C230.8,131,231.2,131.3,231.7,131.6z M252.7,140.1c-0.4,0.2-0.8,0.3-1.4,0.6C251.6,139.9,252.1,139.9,252.7,140.1z M249,138.3v0.1
			c-0.2,0-0.4,0.1-0.6,0.1v-0.1C248.6,138.3,248.8,138.3,249,138.3z M244.3,135.3c0,0-0.1,0-0.1-0.1s0-0.2,0.1-0.3
			c0.1,0,0.2,0.1,0.2,0.1C244.5,135.1,244.4,135.2,244.3,135.3z M244.4,131.1c0.5-0.1,1.2,0.4,1.4,0.9c0,0.1,0.1,0.1,0.1,0.2
			c0.1,0.4-0.4,1-0.9,1.1c-0.1,0-0.2,0-0.3,0c-0.3,0-0.7-0.2-0.9-0.5c-0.1-0.2-0.2-0.3-0.3-0.5l0,0
			C243.4,131.7,243.8,131.2,244.4,131.1z M235.7,133.1c0.5-0.3,0.8-0.5,1.3-0.8C236.6,132.9,236.6,132.9,235.7,133.1z M241.4,129.8
			c0.1-0.2,0.3-0.4,0.5-0.4c0.2-0.1,0.5-0.1,0.8-0.1c-0.3,0.2-0.6,0.4-0.8,0.6l0,0c-0.2,0.2-0.5,0.3-0.7,0.6
			C241.2,130.2,241.3,130,241.4,129.8z M241.2,131.9c0.1,0,0.2,0.1,0.2,0.2c-0.1,0.1-0.2,0.2-0.2,0.2c-0.1-0.1-0.2-0.1-0.3-0.2
			C241,132,241.1,131.9,241.2,131.9z M239.7,127.5l0.1,0.1c0,0.1-0.1,0.2-0.1,0.3c0,0-0.1,0-0.1-0.1
			C239.6,127.6,239.6,127.6,239.7,127.5z M241,133.9c-0.4,0.1-0.8,0.4-1.1,0.3c-0.8-0.2-1.1-0.8-1.5-1.3
			C240,132.1,240.1,132.2,241,133.9z M238.3,135.4c-0.1,0.1-0.1,0.2-0.2,0.2c-0.1-0.1-0.2-0.1-0.3-0.2c0.1-0.1,0.2-0.1,0.2-0.2
			C238.1,135.3,238.2,135.3,238.3,135.4z M237.1,130.6c0,0.1,0.1,0.2,0.1,0.4c0,0,0,0,0.1,0h-0.1c0.2,0.1,0.5,0.2,0.8,0.3l0,0
			c-0.9,0.8-1,0.9-1.4,0.2l0,0c0,0,0,0-0.1,0v-0.1c-0.1,0-0.3,0.1-0.4,0.1c-0.2,0.1-0.4,0.1-0.6,0.1c-0.1,0-0.1,0-0.2,0
			c-0.6,0-1.1-0.2-1.3-0.6c-0.2-0.3-0.2-0.7,0-1.1c0.2-0.3,0.5-0.6,0.7-0.9C236.3,128.9,236.9,129.6,237.1,130.6z M234.5,128.8
			c-0.7-0.4-1.1-0.6-1-1.1C234.2,127.8,234.5,128.1,234.5,128.8z M233,131.2L233,131.2c0.1-0.1,0.1-0.2,0.1-0.2
			C233.1,131.1,233.1,131.1,233,131.2C233.1,131.2,233.1,131.2,233,131.2c0,0.1,0,0.2-0.1,0.2C233,131.4,233,131.3,233,131.2z"
        />
        <path
          class="st0"
          d="M249.4,130.5c0.1-0.1,0.2-0.3,0.3-0.4c-0.2,0-0.3-0.1-0.5-0.1c0,0.1-0.1,0.3-0.1,0.4
			C249.2,130.4,249.3,130.4,249.4,130.5z"
        />
        <path
          class="st0"
          d="M2,208L2,208L2,208C2,208,2,207.9,2,208c0-0.1,0.1-0.2,0.1-0.2S2.1,207.9,2,208L2,208c0.4,0.3,0.8,0.5,1,1
			c0.1-0.1,0.1-0.1,0.2-0.2c0.1-0.1,0.2-0.2,0.3-0.3c1.3,0.3,2,0.2,2.3-0.4c0.1-0.2,0.2-0.5,0.3-1c-0.4,0.1-0.8,0-1.1,0
			c-0.7-0.2-1.1-0.7-1.2-1.4c-0.5,0.1-0.9,0.1-1.3-0.1c-0.2-0.1-0.5-0.2-0.7-0.3c-0.3-0.2-0.5-0.5-0.5-0.8c0-0.1,0-0.1,0.1-0.2
			c0-0.1,0-0.1,0.1-0.2c0.1-0.1,0.2-0.2,0.3-0.3c0,0,0.1,0,0.1-0.1c0,0,0,0,0.1,0l0,0h0.1c0.3-0.1,0.5-0.2,0.8-0.3
			c0.6-0.1,1.1,0.1,1.2,0.6c0.1,0.4,0,0.8,0,1.2c0.6,0,1.3,0,1.9,0c0.5,0,1,0,1.6,0c0-0.1,0-0.1,0-0.2c0-1.2,0.1-2.3,0.1-3.2
			c0.7-0.4,1.3-0.8,1.9-1.1c0,0,0.1,0,0.1-0.1s-0.1-0.1-0.1-0.2c-0.8-1.1-2.1-0.6-3-0.7c-1.1,1.1,0.3,1.7,0.1,2.8
			c-0.9-1-0.7-2.1-1.1-3.1c-0.6-0.1-1.4-0.2-2.1-0.4c-0.1,0.3-0.2,0.6-0.3,0.7c-0.7-0.4-1.4-0.8-2.2-1.1c-0.3-0.2-0.7-0.4-1-0.5v3.6
			h0.1c0.1,0.2,0.1,0.3,0.2,0.5c-0.1,0-0.1,0-0.2,0.1c0-0.1-0.1-0.2-0.1-0.3v1.1c0.1,0,0.1-0.1,0.2-0.1s0.2,0.1,0.2,0.1
			c0,0.1-0.1,0.1-0.1,0.2c-0.1-0.1-0.2-0.1-0.3-0.2v4c0.5,0.4,1.1,0.6,1.7,0.8C1.8,207.9,1.9,207.9,2,208z M4.2,200.7
			c0.2-0.1,0.5,0.2,0.9,0.4c-0.3,0.3-0.5,0.6-0.8,0.8c-0.2-0.2-0.7-0.3-0.7-0.5C3.7,201.1,4,200.7,4.2,200.7z M0.4,200.4
			C0.4,200.4,0.4,200.5,0.4,200.4c-0.1,0.1-0.1,0.2-0.1,0.2C0.3,200.5,0.3,200.5,0.4,200.4L0.4,200.4c0-0.1,0.1-0.2,0.1-0.2l0.1,0.1
			C0.6,200.3,0.5,200.3,0.4,200.4z"
        />
        <path
          class="st0"
          d="M102.6,293.6c0.1,0,0.2-0.4,0.3-0.6c0.1-0.1,0.3-0.1,0.4-0.2c-0.1,0-0.1-0.1-0.2-0.1
			c-0.1,0.1-0.2,0.2-0.2,0.3c-0.8-1-1.3-1.3-2.2-1.4c0,0.2-0.1,0.4-0.3,0.5c0.5,0.1,1,0.1,1.6,0.2c-0.2,0.4-0.3,0.9-0.4,1.3
			C101.8,293.6,102.2,293.7,102.6,293.6z"
        />
        <path
          class="st0"
          d="M98.2,295.6c-0.1,0.3-0.2,0.6-0.3,0.9c0.5-0.2,0.9-0.4,1.2-0.7C98.8,295.8,98.5,295.7,98.2,295.6z"
        />
        <path
          class="st0"
          d="M30.2,298.2c-0.2-0.1-0.3-0.2-0.5-0.3c-0.3,0.4-0.6,0.8-1,1.1C29.3,298.8,29.8,298.5,30.2,298.2z"
        />
        <path
          class="st0"
          d="M96.2,295.9c-0.6,0.3-1.2,0.7-1.7,1.1l0,0c0.6,0.8,0.5,2-0.2,2.7c0,0-0.1,0-0.1,0.1c0.2,0.3,0.5,0.6,0.9,0.9
			c0-0.2,0-0.4-0.1-0.7c0.9-0.4,1.7-0.8,2.3-1c0.2-1,0.4-1.7,0.6-2.5c-0.5,0.1-1,0.2-1.6,0.3c0-0.4,0-0.7,0-1.1
			C96.3,295.8,96.2,295.8,96.2,295.9z"
        />
        <path
          class="st0"
          d="M130.9,275.9C130.9,275.9,130.9,275.8,130.9,275.9c-0.1-0.1-0.1-0.1-0.2-0.1c0,0.1,0,0.1,0,0.2
			C130.8,275.9,130.8,275.9,130.9,275.9z"
        />
        <path
          class="st0"
          d="M13.4,305.2c0-0.4,0.1-0.7,0.1-0.9c-0.1,0.1-0.3,0.2-0.4,0.3l0,0c0,0.1-0.1,0.1-0.1,0.2
			C13.1,304.9,13.2,305.1,13.4,305.2z"
        />
        <path
          class="st0"
          d="M89,180.2c0-0.8-0.7-1.1-1.3-1.4c-0.1,0.7-1.3,1.1-1,1.8C87.5,180.4,88.2,180.3,89,180.2z"
        />
        <path
          class="st0"
          d="M92.5,166.1c-0.1,0-0.3,0.1-0.4,0.1c0.2,0,0.3,0.1,0.5,0.1C92.5,166.3,92.5,166.2,92.5,166.1z"
        />
        <path
          class="st0"
          d="M21.8,299.8c-0.4-0.1-0.6-0.2-0.8-0.4c-0.3-0.4-0.3-0.9-0.4-1.4c0,0,0,0.1-0.1,0.1c-0.2,0-0.4-0.1-0.6-0.1
			c-0.3,0.1-0.5,0.1-0.8,0.2c0,0,0,0,0,0.1s0.1,0.4,0.2,0.4c1.2,0.2,1.2,1.6,2.4,1.8v-0.1C21.9,300,21.9,299.8,21.8,299.8z"
        />
        <path
          class="st0"
          d="M27.3,307.5c-0.9-1-0.7-2.2,0.7-2.9c0.5-0.3,0.8-0.5,1.1-0.8c-0.2-0.1-0.3-0.2-0.4-0.4
			c-0.2-0.3,0.2-0.9,0.7-0.9c0.1,0,0.3,0,0.4,0.1c0-0.2,0-0.4-0.1-0.7c-0.3-1-1.2-1.4-3-1.3c-0.2,0-0.3,0-0.6,0c0-0.1,0-0.1,0-0.2
			c-0.3,0-0.6,0-0.9-0.1c-0.1,0.1-0.2,0.2-0.3,0.3c-0.4,0.5-0.8,0.8-1.4,0.8c0.2,0.4,0.5,0.7,0.7,1.1c0.8,1,1.2,2.1,1.2,3.3
			c0,0.7,0.1,1.2,0.5,1.7c0.2,0.3,0.5,0.5,0.9,0.8l0,0c0,0,0,0-0.1,0c-0.3,0.1-0.5,0.1-0.8,0.2s-0.5,0.1-0.7,0.2l0.1,0.1l-0.1,0.1
			l-0.1-0.1v-0.1c-1.6,0.6-2.4,2.2-1.7,3.4c0.6,1.1,2.4,1.5,3.9,1c1.7-0.7,2.5-2.2,1.8-3.4C28.6,309.1,27.9,308.3,27.3,307.5z
	M25.2,303.5c0-0.1,0-0.1,0-0.2c0.1,0,0.1,0.1,0.1,0.1C25.3,303.4,25.2,303.4,25.2,303.5z"
        />
        <path
          class="st0"
          d="M43.5,295.6c0.1-0.1,0.3-0.2,0.4-0.3c0.1,0.2,0.4,0.5,0.4,0.7c0,0.4,0,0.9-0.1,1.3c0.8-1.1,0.7-2.2-0.3-3.4
			c-0.3-0.3-0.6-0.7-0.9-1.1v-0.1c-0.3,0.3-0.6,0.5-1,0.7c0.1,0.2,0.3,0.4,0.5,0.5C43.2,294.4,43.5,295,43.5,295.6z"
        />
        <path
          class="st0"
          d="M104,298.4c-1.1,0.4-2.5,0.2-3.4,1.2c0.1,0.2,0.2,0.4,0.4,0.5c0.7,1,0.5,2.1-0.4,3c-0.8,0.8-2.3,1.2-3.4,0.9
			c-1.3-0.3-1.9-1.2-2-2.3c-0.3,0.2-0.6,0.4-0.9,0.6c-0.3-0.7-0.8-1.3-1.4-1.7c-0.6,0.2-1.3,0.2-1.8,0c-0.4-0.1-0.7-0.4-1-0.6
			c-1.3,0.1-2.3,0.6-3.1,1.3c0.1,0.1,0.2,0.2,0.4,0.3c2-0.1,3.1,0.4,3.5,1.5c0.3,0.8-0.3,2-1.2,2.5c-0.6,0.3-1.1,0.5-1.7,0.4
			c0.6,0.3,1.3,0.4,1.9,0.7c-0.2,0.4-0.4,0.9-0.7,1.4c-0.1,0.3-0.3,0.6-0.4,0.9c0.2-0.1,0.5-0.3,0.8-0.4c0.4-0.2,0.8-0.3,1.3-0.5
			c0.1,0.7-0.1,1.2-0.5,1.5c-0.2,0.2-0.4,0.3-0.6,0.4c-0.7,0.3-1.3,0.2-1.7-0.5l0,0c-0.3,0.1-0.6,0.1-0.9,0.2
			c-2.1,0.5-3.5,2-3.7,3.7c-0.1,0.7,0.1,1.3,0.4,1.8c0.5-0.5,0.9-1,1.5-1.5c-0.3-0.2-0.5-0.4-0.9-0.7c0.4-0.2,0.7-0.4,1-0.4
			c0.1,0,0.2,0,0.4,0c0.6-0.1,1.1,0,1.5,0.3s0.7,0.7,0.9,1.3c0.6-0.1,1.3-0.2,1.9-0.3c0.2,0,0.5,0.2,0.7,0.4
			c0.4,0.5,0.3,1.2-0.4,1.7c-0.6,0.4-1,0.4-1.7,0c-0.2-0.1-0.5-0.3-0.8-0.6c-0.2,0.1-0.4,0.2-0.6,0.4c-1,0.6-1.7,0.7-2.3,0.5
			c0.4,0.3,0.9,0.5,1.4,0.6c1.9,0.5,4.2-0.1,5.5-1.5c0.3-0.3,0.5-0.6,0.7-0.9c0.5-0.6,1.2-1.2,2.1-1.4c-0.2-0.3-0.3-0.5-0.5-0.5
			c-0.1,0.1-0.3,0.1-0.4,0.2s-0.3,0.2-0.4,0.3c0-0.1,0-0.1-0.1-0.2c-0.3,0-0.6-0.1-0.9-0.2c-0.7-0.3-1-1-0.7-1.6
			c0-0.1,0.1-0.2,0.1-0.2c0.2-0.4,0.6-0.7,1.1-0.8c0.4-0.1,0.9-0.1,1.3,0c0.4,0.2,0.7,0.5,1.1,0.7c0.4-0.2,0.7-0.6,1.1-0.7
			c0.4-0.2,0.8-0.2,1.2-0.3c0.5-0.9,1.1-1.5,1.8-1.8c0.1,0,0.1,0,0.2-0.1c0-0.2,0-0.4-0.1-0.5c0-0.2-0.2-0.4-0.2-0.6
			c0-0.4,0.6-0.7,0.9-0.5c0.8,0.5,1.5,1.1,2.2,1.5c-0.1,0.2-0.2,0.3-0.4,0.5c0.1,0,0.1,0.1,0.2,0.1c0.2,0.2,0.4,0.5,0.4,0.7
			c0.5-0.3,1-0.5,1.7-0.3c0,0.1,0,0.3,0,0.4c0,0.3,0.1,0.5,0.1,0.8c0.1,0.4,0.4,0.8,0.8,1.1c0.1-0.1,0.3-0.1,0.4-0.1
			c1-0.2,1.9,0.1,2.3,0.7c0.8-0.1,1.4-0.5,2-0.9c-1.7,0-3.1-0.8-3.4-2.2c-0.1-0.5-0.1-1-0.1-1.6c-0.3,0.1-0.6,0.3-1,0.4
			c-0.8,0.3-1.5,0.3-2.2,0.2c-0.5-0.1-1.1-0.3-1.5-0.7c-0.6-0.5-1.1-0.9-2-1c-0.8-0.1-0.9-0.8-0.3-1.3c0.8-0.7,1.7-1.4,2.6-2.1
			c0.5-0.3,1.1-0.6,1.7-0.9c-0.1-0.5-0.4-1-0.3-1.5C103.4,299.4,103.8,298.9,104,298.4L104,298.4L104,298.4z M90.8,312.4
			c-0.1-0.1-0.3-0.1-0.4-0.2l0.1-0.2c0.1,0,0.3,0.1,0.4,0.1C90.9,312.3,90.8,312.3,90.8,312.4z M92.8,301.1c0.2,0.2,0.3,0.2,0.3,0.4
			c0,0-0.1,0.2-0.2,0.2s-0.3-0.1-0.4-0.1C92.5,301.4,92.7,301.3,92.8,301.1z M96.6,307.4c-0.3,0.8-1.1,1.4-2.1,1.6
			c-0.4,0.1-0.7,0.1-1.1,0.1h-0.1c-0.7-0.1-1.3-0.4-1.6-0.9c-0.2-0.2-0.3-0.5-0.3-0.9c-0.2-1.2,0.8-2.4,2.4-2.7
			c1.4-0.3,2.9,0.5,3.1,1.7C96.9,306.6,96.8,307,96.6,307.4z"
        />
        <path
          class="st0"
          d="M46.3,301.7c0.3-0.1,0.7-0.4,0.6-0.9c-0.2-0.6-0.6-1.2-0.9-1.8c-0.1,0-0.2,0.1-0.4,0.1c0,0.3,0,0.7,0,1.3
			c-0.5-0.5-0.7-0.9-1.1-1.3c-0.5,0-1.3,0.6-1.7-0.3c0.1-0.1,0.2-0.1,0.3-0.3c0,0,0,0-0.1-0.1c-0.5,0.3-0.7,0.6-0.8,0.9
			c0.1,0.5,0.3,1,1.3,1.1C44.5,300.6,45.3,301.2,46.3,301.7z"
        />
        <path
          class="st0"
          d="M12.5,304.4c0.2,0.1,0.3,0.2,0.5,0.4c0-0.1,0-0.1,0.1-0.2l0,0c0-0.1-0.1-0.3-0.2-0.5
			C12.7,304.2,12.6,304.3,12.5,304.4z"
        />
        <path
          class="st0"
          d="M88.8,287.1c-0.6,0.3-1,0.8-1.4,0.8c-0.8,0.1-1.1,0.4-1.4,0.9c-0.2,0.3-0.3,0.6-0.6,0.8
			c-0.5,0.4-1,0.8-1.3,1.3v0.1H84c0,0.1-0.1,0.1-0.1,0.2c0.1,0,0.1-0.1,0.2-0.1l0,0c0.2-0.1,0.5-0.2,0.7-0.1
			c0.9,0.1,0.9,0.1,1.9-0.2c0-0.4,0-0.7,0.1-1.2c0.1,0,0.2,0,0.3,0c0,0-0.1,0-0.1-0.1c0.9-0.3,1.5-0.6,2.3-0.9
			C89.1,288,88.9,287.5,88.8,287.1z"
        />
        <path
          class="st0"
          d="M60.8,182.9c-0.2,0-0.3,0-0.5,0c0.1,0.1,0.2,0.1,0.3,0.2C60.7,183.1,60.7,183,60.8,182.9z"
        />
        <path
          class="st0"
          d="M51.5,292.3c-0.7-0.4-1.1-0.1-1.6,0.1c0,0,0,0,0,0.1l0,0c-0.1,0-0.1,0.1-0.2,0.1c-0.3,0.2-0.6,0.3-0.9,0.5
			c0,0.2,0,0.3-0.1,0.5c0.4,0,0.7,0.1,1.1,0.1C50.4,293.2,51,292.8,51.5,292.3z"
        />
        <path
          class="st0"
          d="M61.8,307.1C61.8,307.1,61.7,307.1,61.8,307.1c-0.4-0.4-0.9-0.8-1.3-1.2c-0.3,0.7-0.3,0.7,0.2,1.4
			c0.1,0.1,0.1,0.2,0.2,0.3c0.1,0,0.2,0.2,0.2,0.2c0.2,0.9,1.3,1.2,1.7,2c0.1,0.1,0.3,0.2,0.5,0.3c0.3-0.4,0.7-0.7,1-1.1
			c0.5,0.4,1,0.8,1.5,1.2c0.5-0.3,1-0.5,1.4-0.8l-0.1,0.1c0,0,0,0,0.1,0c0,0,0,0,0-0.1c0.3-0.3,0.6-0.6,1-1
			c-0.2-0.2-0.4-0.4-0.6-0.6c-0.9,0.2-1.9,0-2.7-0.7c-0.2-0.2-0.3-0.4-0.6-0.7c-0.5,0.5-1,1-1.6,1.5
			C62.4,307.8,62.1,307.5,61.8,307.1z M60.5,306.3L60.5,306.3l0.1-0.1L60.5,306.3z"
        />
        <path
          class="st0"
          d="M268.6,264.2c-0.1,1.1,0.5,1.9,1.3,2.6c0.2,0.2,0.4,0.3,0.6,0.5l0,0c0.2,0.1,0.4,0.2,0.6,0.3
			c0.6,0.2,1.3,0.2,2,0.1c0.4-1,1.4-1.7,2.7-1.8c0.4,0,0.7,0,1,0.1c0.4-0.5,0.7-1.1,0.9-1.8c0-0.3,0.1-0.5,0.3-0.8
			c0.3-0.6,0.8-1.1,1.5-1.5c1.9-1.2,2.7-2.6,2.2-4.4c0-0.1,0-0.2,0-0.3l0.1-0.1c0.9-0.2,0.9-0.2,1.3,1.2c0.5-0.1,1.1-0.2,1.8-0.3
			c-0.2-0.6-0.8-1-1.4-1.2c0.7-0.9,1.5-1.7,2-2.5c0.5-1,0.2-1.9-0.7-2.9c1.3,0,2.4-0.2,3.2-0.8c-0.3-0.2-0.5-0.5-0.5-0.7
			c0.1-0.4,0.1-0.7,0-1c-0.2-0.5-0.6-1-0.9-1.5c-0.5-0.9-0.6-1.8-0.3-2.7c-0.2-0.1-0.3-0.3-0.5-0.4c0.4-0.3,0-0.6-0.1-0.8
			c-0.2-0.5-0.3-1,0.8-1.4c0.3,0.4,0.6,0.8,0.8,1.2c1.2-1.2,2.8-1.8,4.6-1.5c1,0.2,1.9,0.3,2.9-0.1c0.2-0.9,0.7-1.8-0.7-2.5
			c-0.5-0.2-0.7-0.9-1-1.5c0,0,0,0-0.1,0c-0.1,0.3-0.1,0.7-0.7,0.6c-0.1,0-0.2-0.2-0.2-0.3s0-0.1,0.1-0.1c0,0,0,0,0-0.1
			c0.2-0.3,0.6,0,0.8-0.1c0,0,0,0,0-0.1l0,0l0,0l0,0c-0.1-0.2-0.1-0.4-0.2-0.6c0.3-0.1,0.6-0.1,0.9-0.2c0.1-0.4,0.2-0.8,0.3-1.3
			c-0.3,0-0.3-0.1-0.1-0.3l0,0c-0.1-0.2-0.1-0.4-0.2-0.7c0-0.1-0.1-0.2-0.1-0.3c-0.4,0.7-0.7,1.1-1,1.6c0.1,0.4,0.2,0.8,0.2,1.2
			c-0.2,0-0.4,0.1-0.8,0.1h-0.1c0-0.1,0-0.1,0.1-0.1c0.2-0.5,0.4-0.9,0.6-1.2v0.1c0-0.5,0.1-0.9,0.1-1.4c0-0.6,0-1.2,0-1.8
			c-0.1,0-0.3,0-0.4-0.1c-0.2,0.3-0.5,0.7-0.7,1s-0.2,0.7-0.3,1.1c-0.4,1.1-1,1.3-2.3,1c-0.7-0.2-1.5-0.3-2-0.3
			c-0.9,0.7-1.5,1.2-2.3,1.8c-0.1,0.6-0.3,1.3-0.4,2c1.1,0.4,0.6-0.9,1.4-0.9c0.8,0.3,0.8,0.9,0.5,1.7c-0.9,0-2,1-2.6-0.3
			c-0.9,0.2-1.4,1.1-2.4,0.8c-0.1,0-0.4,0.3-0.5,0.4c-0.3,0.3-0.5,0.8-0.8,0.9c-0.7,0.2-0.9,0.4-0.8,1c0,0.1,0,0.2,0,0.3
			c-0.1,0.2-0.3,0.4-0.5,0.6c-0.2,0.1-0.3,0.2-0.5,0.4c-0.3,0.2-0.7,0.4-1,0.5s-0.6,0.2-0.9,0.1c-0.6,0-1.1-0.2-1.6-0.4
			c-0.4-0.2-0.7-0.6-0.9-1.1c-0.1-0.3-0.2-0.6-0.3-0.9c-0.4,0.1-0.8,0.1-1.1,0.3c-0.4,0.2-0.6,0.4-1.2,0.8c0.1-0.5,0-0.8,0.1-1.1
			c0.1-0.2,0.4-0.4,0.8-0.7c-0.5-0.3-0.9-0.5-1.3-0.7s-0.7-0.4-1-0.6c-0.7,0.3-0.5,0.6-0.4,1c0.2,0.8,0.2,1.4-0.1,2
			c-0.1,0.3-0.3,0.7-0.6,0.9c-0.1,0.1-0.3,0.2-0.4,0.4c-0.6,0.4-1.5,0.7-2.6,0.8c-0.4,0-0.8,0.1-1.3,0.2c0.1,0.4-0.1,0.7,0.1,1
			c0.1,0.1,0.2,0.2,0.4,0.2l0,0c0.1,0,0.1-0.1,0.2-0.1c0.1-0.2,0.3-0.4,0.4-0.6c0.1,0.1,0.1,0.1,0.2,0.2c-0.2,0.1-0.4,0.3-0.6,0.4
			l-0.1,0.1c0,0,0,0-0.1,0c-0.4,0.6-0.7,1.2-1.2,1.8c-0.6,0.8-1.5,1.3-2.5,1.5c-0.8,0.2-1.6,0.1-2.4-0.1c-0.1,0-0.2-0.1-0.4-0.1
			c-0.3-0.1-0.7-0.3-1.1-0.4c-0.2,0.1-0.3,0.3-0.5,0.4c-0.1-0.1-0.1-0.3-0.2-0.4c-0.2,0.2-0.3,0.3-0.4,0.4c0.1,0.1,0.2,0.2,0.3,0.4
			l0,0c0.1,0.2,0.3,0.3,0.4,0.4c0.1,0.1,0.2,0.1,0.2,0.2c-0.1,0.1-0.1,0.2-0.2,0.3c0.4,0.8,1.2,1.2,2.4,1.1l0,0
			c-0.1,0.6-0.2,1.2-0.4,1.7c0.1,0,0.2-0.1,0.3-0.1c1.2-0.2,2.3,0.3,2.4,1.2c1.1,1.2,3,1.2,4.6,1.5c0.7,0.1,0.8,0.4,0.9,0.8
			c-0.1,0.1-0.1,0.2-0.2,0.2c-0.3,0.2-0.7,0.5-0.9,0.7c-0.9,1.1-2.4,1.8-2.4,3.3c0,0.3,0,0.6,0.1,0.8c0.3,0.9,1,1.3,2.4,1.3
			c0.6,0,1.2-0.1,1.9-0.1C268.5,263.7,268.6,264,268.6,264.2z M285.7,244.2L285.7,244.2h-0.1C285.6,244.2,285.6,244.2,285.7,244.2z
	M279.7,251.5c0.2-1.1,0.5-2.3,0.8-3.5c0.5,0,1,0,1.3,0.1c0.4,0.1,0.7,0.3,0.9,0.5c0.2,0.2,0.4,0.4,0.5,0.5
			c0.4,0.4,0.4,1.1-0.1,1.4c-0.8,0.6-1.7,1.1-2.6,1.5C280.2,252.3,279.6,251.9,279.7,251.5z M277.8,245.7c0,0,0.1,0,0.1,0.1
			c-0.1,0-0.2,0.1-0.3,0.1c0,0-0.1,0-0.1-0.1C277.6,245.8,277.7,245.8,277.8,245.7z M277.8,253.8c0.9-0.2,2.1,0.4,2.3,1
			c0.1,0.8-0.7,1.8-1.7,2c-0.9,0.2-1.8-0.4-1.9-1.2C276.3,254.8,276.9,254,277.8,253.8z M269.3,252.1c0,0-0.1,0-0.1-0.1s0-0.2,0-0.3
			c0.1,0,0.2,0.1,0.2,0.1C269.4,251.9,269.3,252,269.3,252.1z M272.8,265.9c-0.1,0-0.1,0.1-0.2,0.1l0,0c-0.2-0.2-0.3-0.4-0.5-0.6
			l-0.1-0.1c0.1-0.1,0.2-0.1,0.3-0.2c0,0,0,0.1,0.1,0.1c0.2,0.2,0.4,0.4,0.5,0.6l0,0C272.9,265.9,272.8,265.9,272.8,265.9z
	M274.3,248.1c0.1,0.1,0.1,0.3,0.2,0.4l0,0l0,0l0,0c0.1,0,0.2,0,0.3,0.1c0.1,0.1,0,0.2,0,0.4c-0.1-0.1-0.2-0.1-0.3-0.2
			c0-0.1,0-0.2,0-0.2l0,0l0,0c0,0,0,0,0-0.1c-0.1-0.1-0.2-0.2-0.4-0.2C274.1,248.2,274.2,248.2,274.3,248.1z M275.3,262.9
			c0.1,0.3,0.1,0.6,0,0.9c-0.1,0.4-0.4,0.7-0.8,0.9c-0.1,0.1-0.2,0.1-0.4,0.1c-0.4,0.1-0.8,0.1-1.2-0.1c-0.4-0.2-0.7-0.4-0.8-0.8
			c-0.1-0.2-0.1-0.5,0-0.8c0.1-0.2,0.2-0.5,0.4-0.7c0.2-0.2,0.5-0.4,0.8-0.5c0,0,0,0,0.1,0C274.2,261.9,275.1,262.3,275.3,262.9z
	M271.9,251.5c-0.1-0.1,0.2-0.4,0.3-0.6c0.3,0.1,0.6,0.2,1,0.4c-0.2,0.2-0.4,0.5-0.5,0.5C272.5,251.7,272.1,251.6,271.9,251.5z
	M272.3,243.8C272.3,243.8,272.3,243.7,272.3,243.8C272.3,243.7,272.3,243.7,272.3,243.8C272.3,243.7,272.3,243.7,272.3,243.8
			c0.1-0.2,0.2-0.3,0.3-0.4l0,0c0-0.1,0-0.1,0.1-0.2c0.1,0,0.1,0.1,0.2,0.1c-0.1,0-0.2,0.1-0.2,0.1l0,0
			C272.5,243.5,272.4,243.6,272.3,243.8C272.3,243.7,272.3,243.8,272.3,243.8c0,0.1,0,0.1,0,0.2c-0.1,0-0.1-0.1-0.2-0.1
			C272.1,243.8,272.2,243.8,272.3,243.8z M270.5,244.5h0.1c1.4-0.3,2.8,0.5,3,1.7c0,0.2,0,0.3,0,0.5c0,0.1,0,0.3-0.1,0.4
			c-0.2,0.6-0.7,1.2-1.4,1.5c-0.2,0.1-0.4,0.2-0.7,0.2c-0.3,0.1-0.7,0.1-1,0c-1-0.1-1.9-0.8-2-1.7c0-0.1,0-0.1,0-0.2
			C268.4,245.9,269.3,244.8,270.5,244.5z M267.4,246.7c0.1,0,0.2,0,0.3,0.1l-0.1,0.1c-0.1,0-0.2,0-0.3-0.1
			C267.4,246.8,267.4,246.7,267.4,246.7z M268.4,250C268.3,250,268.3,250,268.4,250c-0.2,0.2-0.3,0.5-0.4,0.7c0,0.2-0.1,0.3-0.1,0.5
			c-0.3,1.1-1.1,1.6-2.7,1.8c-0.3,0-0.6,0.1-1,0.1c-0.3-0.3-0.6-0.7-0.8-1.1c-0.5-0.9-0.2-1.9,0.6-2.5c0.2-0.2,0.4-0.3,0.7-0.4
			c0.7-0.2,1.5-0.2,2.2,0.1C267.4,249.4,267.8,249.7,268.4,250l-0.1-0.1C268.3,249.9,268.3,250,268.4,250l0.1,0.1c0,0,0,0.1,0.1,0.1
			c0,0-0.1,0-0.1-0.1C268.4,250.1,268.4,250,268.4,250z"
        />
        <path
          class="st0"
          d="M51.9,304c0.4,0,0.7,0,1.1,0.1c0.1-0.1,0.3-0.1,0.5-0.1c0.1,0.1,0.1,0.3,0.2,0.4c0,0,0.1,0,0.1,0.1
			c0.3,0.1,0.5,0.3,0.8,0.5c0.2-0.4,0.5-0.8,0.7-1.1c-0.1,0-0.3-0.1-0.4-0.1c-0.4-0.1-0.7-0.2-1-0.4c-0.1,0.1-0.1,0.1-0.2,0.1
			c-0.1,0-0.3-0.1-0.5-0.1c0.1-0.1,0.2-0.2,0.2-0.2c-0.7-0.5-1-1.1-0.8-1.9c0.3-1.4,1.4-1.9,3.9-2.1c0.3-1-0.2-2-0.4-2.7
			c-0.8-0.4-1.4-0.6-1.8-0.8c-0.8,0-1.6,0.2-2.2,0.2c-0.3,0.4-0.6,0.7-1,1.2c0.1,0.1,0.4,0.3,0.8,0.7c-0.3,0.7-0.6,1.4-0.9,2.1
			c0.2,0.1,0.5,0.1,0.9,0.2c-0.6,0.7-1.4,1.3-2.2,1.2c-1-0.2-1.5,0.5-2.1,0.7c-0.9,0.3-0.9,1.1-0.2,1.6c0.5,0.4,1.1,0.7,1.6,1.1
			c0.3,0.2,0.5,0.4,0.8,0.5c0.2-0.2,0.5-0.4,0.9-0.6c0,0,0.1,0,0.1-0.1C51.2,304.2,51.5,304.1,51.9,304z M52.6,296.2
			c0,0.1,0.1,0.1,0.1,0.2l-0.1,0.1C52.6,296.5,52.6,296.4,52.6,296.2C52.5,296.3,52.6,296.3,52.6,296.2z"
        />
        <path
          class="st0"
          d="M153.7,290c1,0,2.1-0.1,3.2-0.1c0.2-0.7,0.3-1.4,0.5-1.9c-1.3-0.3-2.6-0.6-3.7-0.9
			C153.7,288,153.7,289,153.7,290z"
        />
        <path
          class="st0"
          d="M79.6,309.3c0.1-0.2,0-0.6-0.3-0.7c-0.2-0.1-0.7,0.1-1,0.2c-0.3,0.2-0.5,0.4-0.8,0.7
			c-0.2-0.1-0.4-0.2-0.7-0.4c0.4-0.8,1.5-1.4,1.3-2.4c-0.9,0.2-1.1,0.9-1.6,1.3c-0.7-0.2-1.8,0.6-2.1-0.5c-0.4,0.3-0.6,0.4-0.9,0.7
			c-0.1-0.8,0.2-1.8-1.2-2c-1,0.5-0.1,1-0.2,1.5c-0.9,0-0.8-0.8-1.5-1.1c0.5-0.4,0.9-0.7,1.3-1c-0.3-0.1-0.5-0.1-0.9-0.2
			c0.3-0.5,0.6-1,1-1.6c-0.1-0.1-0.2-0.2-0.3-0.4c-0.5-0.1-0.9-0.2-1.5-0.3c0,0.9-0.9,1.6-0.9,2.4c0.2-0.1,0.4-0.1,0.7-0.2
			c-0.3,1-0.5,1.9-0.9,3c0.1,0.3,0.2,0.9,1.4,0.7c0.3-0.1,0.7,0.4,1.1,0.7c-0.7,0.4-1.3,0.8-1.8,1.1c0.5,0.9,0.5,0.9,1.9,0.6
			c0-0.4-0.1-0.7-0.1-1.1c0.4,0.1,0.8,0.2,1.4,0.4c-0.2-0.5-0.3-0.8-0.4-1.2c0.5-0.1,0.9-0.2,1.4-0.3c0.4-0.1,0.8-0.4,1.5-0.7
			c-0.3,0.6-0.5,0.9-0.6,1.3c0.3,0.5,0.6,1,1.7,0.7c0.5-0.1,1.2,0.3,1.9,0.5C79.1,310.4,79.4,309.9,79.6,309.3z"
        />
        <path
          class="st0"
          d="M74.7,300.5c0.3-0.3,0.6-0.6,0.8-0.9c-0.4-0.4-0.8-0.8-1.1-1.2c-0.4-0.1-0.8-0.1-1.3,0.1l0,0
			c-0.2,0.3-0.4,0.6-0.6,0.9c0,0.4,0.1,0.7,0.1,1c0.2-0.1,0.3-0.2,0.5-0.3C73.6,300.2,74.1,300.3,74.7,300.5z"
        />
        <path
          class="st0"
          d="M181.5,324.8c0.1,0.2,0.3,0.6,0.4,0.9c0.1,0,0.2,0,0.3,0c0-0.2,0.2-0.6,0.1-0.6c-0.9-0.5-0.7-1.3-0.8-2.1
			c1.5-0.7,2.9-0.1,4.4-0.4c-0.8-0.2-1.6-0.5-2.3-0.7c-0.1-0.8-0.2-1.5-0.2-2.3c0.4-0.2,0.8-0.2,1.1,0.3c0.3,0.7,0.9,1,1.9,0.8
			c0.6-0.8,0-1.3-0.5-2c0.3-0.2,0.6-0.6,1-1c-0.3-0.3-0.5-0.6-0.8-0.9c-1.3,1.1-1.4,1.1-2.6,0.7c-1.7-0.6-1.7-0.6-3.5-0.2
			c-0.3-0.6-0.6-1.3-0.9-2c-0.5,0-1.1-0.1-2.1-0.1c0.5-0.4,0.8-0.6,1.3-0.9c-0.8,0-1.6,0.4-1.8-0.3c0.2-0.2,0.3-0.4,0.5-0.7
			c-0.1,0-0.1-0.1-0.2-0.1c-0.3,0.2-0.7,0.5-1.1,0.8c-0.9-0.3-1.8-0.5-2.7-0.9c-0.2-0.1-0.3-0.3-0.3-0.4c0.1-0.2,0.4-0.4,0.6-0.5
			c0.2,0,0.4,0.1,0.7,0.2c0.6-1.2-0.9-1.7-0.9-2.8c0.8-0.2,1.2-1.3,2.5-1c-0.5,0.6-1,1.1-1.5,1.7c0.8,0.5,1.4,1,2.4,1
			c0.1-0.5,0.3-1,0.4-1.7c0.4,0.8,0.8,1.4,0.3,2.2c-0.1,0.2,0.1,0.6,0.2,1c0.6-0.3,1.1-0.5,1.7-0.8c0.4,0.4,0.7,0.7,1,1.1
			c0.6,0.2,1.3,0.4,1.9,0.6c-0.2,0.4-0.5,0.8-0.5,1.2c0,0.4,0.2,0.8,1,0.8c0.4,0,0.6,0.6,1,1c0.2-0.2,0.6-0.4,0.7-0.6
			c0.1-0.2-0.1-0.6-0.2-0.6c-1.1-0.2-0.2-1.1-0.7-1.5c-0.1-0.1,0.4-0.6,0.6-1c1,0.5,1.6,0.2,2.2-0.7c-1-0.4-2-0.8-2.9-1.2
			c0-2.1-0.8-2.7-3.5-2.5c-0.3-0.3-0.6-0.6-0.8-0.9c-1.3,0-1,1.7-2.5,1.3c0.1-0.3,0.2-0.5,0.3-0.7c0.5-1.1,0.5-2.1-1.2-2.5
			c0.5-0.7,1-1.4,1.5-2.1c-0.4-0.5-1.1-0.6-1.7-0.4c-1.3,0.4-2.5,0.9-3.9,1.4c-0.3-0.8,0.7-1.6,0.7-2.5c0,0,0,0,0.1,0
			c0,0,0,0-0.1-0.1v0.1c-0.2-1.4-0.6-1.6-2.9-1.8c1.6-0.7,1.8-1.6,1.7-2.7l0,0c-1.3,1.3-3.1,1.5-4.9,1.5c-0.1,0.7-0.2,1.3-0.2,1.9
			c0,0,0,0,0-0.1l0,0c0.4-0.4,0.7-0.7,1.2-1.2c0.4,0.5,0.6,0.9,1,1.3c-0.4,0.4-0.8,0.9-1.3,1.5c-0.4-0.7-0.7-1.1-0.9-1.6l0,0l0,0
			c-0.2,0.3-0.4,0.6-0.6,0.9c-1.1,1.6-2.8,2.6-4.9,2.7c-2.3,0.1-4-0.7-5-2.3c-0.7-1.1-0.6-2.2-0.3-3.5c-2-0.1-3.6-0.7-4.5-2.1
			c-1-1.4-0.6-3,0.1-4.5c-0.6,0-1,0-1.5-0.1c-2.4-0.3-3.7-2-3.1-4c0.6-1.9,2.9-3.1,5.2-2.7c0.5,0.1,0.9,0.2,1.4,0.3
			c0.1,0.1,0.1,0.2,0.2,0.3c0-0.1,0.1-0.1,0.1-0.2c-0.1-0.1-0.2-0.1-0.3-0.2c-0.1-0.8-0.1-1.6-0.2-2.3c-1.7,0.2-3.3,0.3-5,0.5
			c-0.7,1.1-1.8,1.8-3.4,1.6c-1.1-0.1-1.9-0.7-2.1-1.6c-0.4-1.5,0.7-2.4,2.1-3.2c-0.2-0.4-0.3-0.7-0.4-1.1c-0.3-1.5,0.3-2.9,0.7-4.4
			c-0.3-0.3-0.5-0.5-0.8-0.8c-1-1.4-0.5-3.2,1.1-4.2c1.7-1,3.9-0.8,5.1,0.5c0.1,0.2,0.2,0.4,0.4,0.5c1,1.1,2.1,1.3,3.8,0.7
			c0.1,0,0.2,0,0.4,0c0.3,0.3,0.6,0.7,1,1.1c0.5-1.5,1.7-2.3,3-2.8c0-0.4,0-0.7-0.1-1c0-0.5,0-1-0.1-1.4c0-0.5-0.4-0.7-0.9-0.6
			c-0.1,0.2-0.1,0.5-0.2,0.7c0,0.1,0,0.2-0.1,0.4c-0.5,1.4-1.9,2.3-3.5,2.2c-1.6-0.1-2.8-1-2.9-2.2c-0.2-1.4,0.9-2.7,2.5-3.2
			c0.4-0.1,0.8-0.2,1.2-0.3c0.1,0,0.1,0,0.2,0c-0.3-0.6-0.3-1.2-0.3-1.8c0.1-1.2,0.9-2.3,1.5-3.4c-1.4-0.2-2.3-0.8-2.6-1.9
			c-0.1-0.2-0.5-0.4-0.8-0.5c-1.2-0.3-2.1,0-2.8,0.7c-0.3,0.3-0.5,0.6-0.7,0.9s-0.3,0.6-0.4,0.9c0.2,0,0.4,0,0.5,0
			c0.3,0,0.6,0,0.8,0.1c0.9,0.2,1.5,0.8,1.8,1.6c0,0.1,0,0.3,0,0.4c0.1,0.8-0.3,1.6-1.2,2.1c-1.1,0.7-2.3,0.8-3.4,0.2
			c-0.3-0.1-0.6-0.2-1-0.4c-0.3,0.3-0.4,0.5-0.6,0.7c-0.5,0.3-1.4,0.2-1.4-0.2c0.2-1.4-1.1-2.4-1.1-3.7c0-0.2,0.1-0.3,0.2-0.6
			c1.2,0.4,1.1,1.5,1.6,2.1c0.2-0.7,0.4-1.3,0.7-1.9s0.6-1.3,0.8-1.9c0.2-0.5,0.4-1,0.5-1.5c0-0.1,0-0.1,0.1-0.2v-0.1
			c0.1-0.4-0.2-0.6-0.7-0.7c0,0,0,0-0.1,0c0,0.1,0,0.1-0.1,0.2v0.1c0.1,1.1-0.5,1.9-1.7,2.4c-0.9,0.4-2.1,0.1-2.7-0.5
			c-0.7-0.8-0.8-1.6-0.1-2.6c0.3-0.3,0.4-0.6,0.1-1c-0.4-0.4,0-0.8,0.4-1s0.9-0.3,1.4-0.5c0-0.1-0.1-0.2-0.2-0.3
			c-0.2-0.3-0.4-0.6-0.7-0.8c-0.1-0.1-0.2-0.2-0.4-0.3c-0.4-0.2-0.8-0.4-1.2-0.5c-0.1,0-0.3-0.1-0.4-0.2c0,0.4,0,0.6-0.1,0.8
			c0.5,0.1,0.5,0.3,0.3,0.5c-0.1,0.1-0.2,0.1-0.3,0.1c-0.7,0.2-1.4,0.5-2.1,0.5c-0.7,0-1.3-0.3-2.2-0.5c0.1,0.5,0,1,0.2,1.5
			c0,0.1,0,0.1,0.1,0.2c0.1,0.2,0.3,0.3,0.5,0.5c0.3,0.2,0.5,0.3,0.8,0.5c-0.2,0.2-0.5,0.4-0.7,0.6l0,0c-0.4,0.3-0.8,0.6-1.1,0.9
			l-0.1,0.1c0.3,0.7,0.9,1.1,1.5,1.3c0.3,0.1,0.6,0.2,0.9,0.4c0.4,0.2,0.7,0.3,1,0.6c-0.5,0.8-0.2,1.4,0.6,2.1
			c0.3-0.1,0.7-0.2,1.3-0.3c-0.6,0.9-1.9,1.1-2.1,2.2c0,0.1,0,0.1,0,0.2h0.1c0.2,0,0.5,0.1,0.7,0.1c0.5,0.1,1,0.2,1.3,0.5
			c0.2,0.2,0.3,0.3,0.4,0.6c0.1,0.2,0.7,0.1,1,0.2c1.1,0.2,1.9,0.6,2.3,1.5c0.5,1,0.1,2.2-0.8,3c-1.1,0.9-2.3,1.1-3.6,0.7
			c-0.2-0.1-0.4-0.1-0.6-0.2c-1-0.3-1.2-0.1-2.1,0.8c-0.1,0.1-0.3,0.2-0.4,0.3l0,0c-0.6,0-1.2,0-1.8,0c0.3,1.5,0.3,1.5-0.4,2.5
			c1.4,0.8,1.6,1.3,1,2c-0.6,0.6-1.2,0.5-2.6-0.5c-0.4,0.3-0.8,0.6-1.2,0.9v0.2c0.4,0,0.8,0,1.3,0.1c-1.1,0.5-2.2,0.8-3.4,1.1
			c-2.1,0.5-2.8,0.6-2.9,2c0,0.4,0,0.9,0.1,1.6c0.1,1.2,0.6,2.3,1,3.4c0.4,1,0.3,1.8-0.8,2.7c-0.2-1.8-0.1-3.4-0.7-4.8
			c-0.2-0.1-0.4-0.1-0.5-0.2c-0.2-0.1-0.4-0.1-0.6-0.2c1-1.3,0.3-2.1-0.8-2.9c-1.8,1.1-3.2,3.1-5.7,1.8c-0.6,0.6-1.2,1-2,0.9
			c-0.2,0-0.4,0-0.6-0.1c-0.9-0.4-1-1-0.8-1.8v-0.1c0-0.2,0-0.3-0.1-0.4c-0.1,0-0.2-0.1-0.2-0.1c-0.4-0.2-0.5-0.5-0.5-0.8
			c0-0.4,0.3-0.9,0.3-1.4c-0.4,0-0.8,0-1.2,0c-0.5-0.1-1-0.1-1.5-0.1c-0.3,0-0.6,0-0.9,0.1s-1-0.3-1.3-0.6c-0.4-0.4-0.3-1,0.2-1.4
			c0.1-0.1,0.3-0.2,0.5-0.3c0.1-0.1,0.2-0.2,0.4-0.3c0.3-0.2,0.5-0.4,0.5-0.5s0-0.2-0.2-0.3h-0.1c-0.3-0.2-0.8-0.2-1.2,0.2
			c0,0,0,0-0.1,0.1c-0.4,0.4-0.8,0.7-1.2,1.1c-0.1,0.1-0.1,0.2-0.1,0.2c0.1,0.3,0.3,0.5,0.5,0.9c-0.8-0.1-1.4-0.2-2-0.2
			c-0.1,0.4-0.1,0.6-0.2,1c-0.1,0-0.2-0.1-0.3-0.1c-0.2-0.1-0.5-0.2-0.7-0.3c-0.2-0.1-0.3-0.1-0.5-0.2c-0.3,0.2-0.5,0.4-0.9,0.6
			c-0.3-0.1-0.6-0.5-0.8-0.4c-1,0.3-1.7,0.1-2.3-0.3c0,0-0.1,0-0.1-0.1c-0.3-0.2-0.6-0.5-1-0.8c-0.2-1.2,1-1.7,1.7-2.4
			c-0.5-0.5-1-1-1.4-1.5c-1,0.4-1.9,0.8-2.5,1.6c-0.6,0.8-2,0.7-2.7-0.1c-0.2-0.3-0.4-0.6-0.6-1c-0.9,0.5-0.6,1.2-1,1.7
			c0.3,0.1,0.6,0.2,1.1,0.3c-0.5,0.3-0.7,0.4-0.9,0.5l0,0c0,0-0.1,0.1-0.2,0.1c-0.2,0.1-0.4,0.3-0.7,0.5c0.9,0,1.2,0,1.7,0
			c-0.6,0.7-1.2,1.4,0.1,1.9c0.4-0.2,0.8-0.4,1.3-0.6c0.1-0.1,0.3-0.1,0.4-0.2c0.4-0.2,0.9-0.4,1.3-0.6c0.2,0,0.4,0.2,0.6,0.3
			c-0.2,0.1-0.3,0.3-0.5,0.4s-0.4,0-0.7,0c0,0.2,0,0.4,0,0.6c0,0.4,0.1,0.9,0.1,1.2c0.1,0,0.3,0,0.5,0c1.2,0,2.5,0.7,3.2-0.7
			c0.4,0.4,0.6,1.2,1.1,1.3c0.6,0.2,1,0.4,1.2,0.7c0.3,0.5,0.3,1.1,0.2,1.7l0,0c0,0.1,0.1,0.3,0.2,0.6c1-0.4,1.9-0.7,2.8-1.1
			c0.3-0.1,0.4-0.6,0.6-1c0.3,0.2,0.5,0.3,0.8,0.5c-0.8,0.7-1.1,1.4-0.2,2.2c0.4,0.4,0.8,1.2-0.1,1.9c2.1-0.2,2.3-0.2,3,1.3
			c0.1,0.3,0.2,0.7,0.3,0.9c1.3-0.6,1.7-2.3,3.7-1.9c-0.2,0.3-0.3,0.6-0.4,0.9c-0.1,0.4,0,0.9,0.6,0.9c1.3,0.1,1.2,0.9,1.3,1.6
			c-1.4,0.6-1.4,0.6-1.8,1.8c0.3,0.2,0.6,0.5,0.9,0.7c0.2,0.1,0.4,0.2,0.6,0.3c-0.3,0.4-0.6,0.7-0.9,1.1c2.6,0,2.6,0,3.6-0.8
			c-0.4,1.1,0.5,0.6,1,0.6c0,0.2,0,0.4,0,0.6c0.2-0.1,0.4-0.1,0.5-0.1c0.3-0.1,0.6-0.1,0.8-0.2c0.4,0.3,0.8,0.6,1.2,0.8
			c0.1,0.1,0.3,0.2,0.4,0.3c0.3-0.2,0.6-0.4,0.8-0.6c0.5-0.3,0.9-0.4,1.6-0.3c0.9,0.1,1.5-0.3,1.6-1.2c0.5,0.2,0.8,0.3,1.1,0.4
			c-0.1,0.3-0.2,0.6-0.3,1c0.3,0.2,0.7,0.4,0.9,0.7c0.1,0.1,0.2,0.4,0.1,0.5c-0.1,0.2-0.4,0.3-0.6,0.3c-0.3,0-0.7-0.2-1-0.3
			c-0.2-0.1-0.5,0-0.9-0.1c0.3,0.5,0.5,1,0.9,1.3s0.9,0.4,1.4,0.6c-0.7,0.3-1.4,0.6-2.2,0.9c0.3,0.5,0.5,0.9,0.8,1.2c0,0,0,0,0.1,0
			c0,0,0,0.1,0.1,0.1c0.4,0.1,0.9,0,0.6,0.8c-0.3-0.3-0.4-0.6-0.6-0.8h-0.1l0,0l0,0c-0.4,0-0.9,0.1-1.3,0.1c-0.3,0-0.5,0-0.8,0.1
			c0.1,0.3,0.2,0.6,0.3,1c-1-0.3-2,0-2.8-0.6c-0.2-0.2-0.9-0.3-1.2-0.1c-1,0.5-2.2-0.1-3.2,1c-0.4-0.8-0.7-1.3-0.9-1.9
			c-1.5,0.2-1.5,0.2-2.2-1.2c-0.1-0.1-0.2-0.2-0.4-0.3c-0.4,0.3-0.8,0.6-1.1,0.8c-0.5,0-1-0.1-1.3-0.1c-0.1,0-0.1,0-0.2,0
			c-0.2,0.3-0.3,0.6-0.4,0.8l-0.1,0.1c-0.1,0-0.1-0.1-0.2-0.1c-0.2-0.1-0.2-0.1-0.2-0.2c-0.1-0.1-0.1-0.2-0.2-0.3
			c-0.3-1-0.3-1-1.6-0.7c-0.3,0-0.6,0-0.8-0.1c-0.4-0.2-0.6-0.6-0.9-0.9c0.1-0.4,0.2-0.8,0.3-1.2c-0.9-0.3-1.2,0.7-1.8,0.7
			c-0.6,0-1.3-0.1-2.2-0.3c0.5,0.4,0.8,0.6,1,0.8c0.8,0.6,1,1.4,0.7,2.2c-0.2,0.6-0.9,1.2-1.3,1.8l0,0l0,0c0.4,0.1,0.8,0.2,1.3,0.4
			c0.3-0.5,0.6-1,1-1.6c0.4-0.1,0.8-0.3,1.3-0.4c1.2-0.3,2.2-0.1,3.1,0.5c0.1,0.1,0.2,0.2,0.4,0.3c0.8,0.9,0.8,1.9,0.1,2.9
			c-0.1,0.2-0.3,0.3-0.4,0.4c-0.7,0.7-1.7,1.1-2.9,1c-0.4,0-0.7-0.1-1.1-0.1c-0.1-0.1-0.3-0.1-0.4-0.2c-0.3-0.4-0.6-0.7-1.1-1.2
			c-0.2,0.5-0.4,0.8-0.6,1.2c0.6,0.1,1,0.2,1.5,0.2c0.1,0.1,0.3,0.1,0.4,0.2c0.8,0.8,1.4,1.6,1.2,2.7c0,0.2-0.1,0.3-0.1,0.5
			c0.2-0.1,0.5-0.2,0.7-0.2c0.4-0.1,0.8-0.2,1.1-0.3c0.1,0,0.1,0,0.2-0.1c2.1-0.4,3.9,0.6,4.2,2.4c0,0.1,0,0.2,0,0.4
			c0.2,0.1,0.4,0.1,0.5,0.1c0.6-0.3,1.2-0.6,1.8-0.9c0.5,0.3,0.8,0.6,1.2,0.9c0.2,0.1,2.2-0.5,2.3-0.6c0.4-0.6,0.1-1.3-0.8-1.9
			c-0.3,0.4-0.5,0.8-0.8,1.3c-0.3-0.1-0.5-0.1-0.7-0.2c0.3-0.9,0.6-1.7,0.9-2.6c1-0.3,2-0.6,2.4-1.7c1,0.1,2,0.1,3,0.6
			s2,0.1,2.5-0.9c0.2-0.4,0.3-0.9,0.5-1.3c0.3-0.5,0.7-0.9,1.1-1.6c0.4,1.6,0.4,1.8-1.2,5.8c0.4-0.3,0.8-0.4,0.9-0.6
			c0.2-0.5,0.2-1,0.4-1.5s0.6-1,1-1.6c0.3,0.5,0.5,0.8,0.8,1.2c0.6-1.4,0.8-2.7,0-3.9c0.2-0.2,0.4-0.4,0.7-0.6
			c1.5-1,2.2-0.9,2.9,0.4c0.3,0.6,0.6,1.1,1,1.8c0,0-0.2,0.1-0.4,0.3c-0.4,0.4-0.5,0.7,0,1s1,0,1.3-0.5c0.7-1.2,1.7-1.5,3.4-1.1
			c-0.5,0.3-1.4,0-1.5,0.6c0,0.6,0.1,1.2,0.3,1.7c0.2,0.4,0.8,0.4,1.2,0.1c0.3-0.3,0.6-0.6,0.9-0.9c0.2,0.2,0.6,0.4,1.1,0.8
			c0.3-0.8,0.5-1.4,0.2-1.9c-0.4-0.7-0.7-1.4,0.6-1.9c0.1-1.5,2.1-1.9,3-3c0.2,0.1,0.5,0.2,0.8,0.3c-0.3,0.3-0.5,0.5-0.8,0.8
			c0.2,0.1,0.4,0.1,0.6,0.2c-0.1,0.8-0.2,1.5-0.3,2.3c0.5,0,0.9,0,1.2,0c-0.1,0.2-0.1,0.4-0.2,0.5c-0.3,0.2-0.7,0.3-1,0.5
			c0.4,0.2,0.7,0.4,1.2,0.6c0.3-1.3,1.4-1.5,3-1.8c-0.5,0.4-0.8,0.7-1,0.9c0.3,0.1,0.6,0.1,1.2,0.3c-0.7,0.2-1,0.3-1.3,0.4
			c-0.9,0.3-1.6,0.7-1.9,1.6c-0.1,0.4-0.5,0.7-0.9,1.3c1.1-0.4,1.9-0.8,2.7-1.1c0.8-0.3,1.6-0.4,2.6-0.7c0.3,0.1,0.7,0.2,0.4,0.8
			c-0.3,0.7,0,1.6-0.9,2.2c0.2,1.1-1.1,2.2,0,3.2c0.1,0,0.2,0,0.4,0c0.1,0.1,0.1,0.2,0.2,0.5c0.9-0.6,2-1,1.9-2.2
			c0.2,0,0.4,0.1,0.6,0.1c-0.3-0.2-0.6-0.4-0.7-0.6c-0.1-0.2,0.3-0.6,0.7-0.8c0.4-0.2,1.1,0.1,1,0.5c0,0.3-0.3,0.6-0.6,1
			c0.4,0.2,0.8,0.4,1.4,0.3c0.3-0.1,1,0.4,1,0.7c0.1,0.8,0.9,0.9,1.5,1.4c-0.2,0.3-0.4,0.7-0.7,1.1c0.6-0.1,1-0.1,1.6-0.2
			c-0.6,0.4-1,0.7-1.5,1.1c0.1,0.1,0.3,0.1,0.4,0.1c0.1-0.4,0.5-0.8,1-0.9c0.6-0.1,1.4,0.2,1.5,0.8c0.1,0.4-0.3,1-0.8,1.2
			c0.4,0.3,1,0.3,1.5,0.5c0.6-0.4,1.1-1.3,2-1l-0.1-0.1c0.1-0.1,0.1-0.1,0.2-0.2c0.1,0.1,0.2,0.2,0.3,0.2c-0.1,0-0.1,0.1-0.2,0.1
			c0.1,0.1,0.2,0.1,0.4,0.2c-0.5,0.6-1,1.2-1.6,1.9c0.1,0.2,0.2,0.5,0.3,0.9c0.1,0.7,0.3,1.2,1.4,1c0.4-0.1,0.9,0.3,1.4,0.5
			c-0.2,0.6-0.4,1-0.6,1.5c0.7,0.5,1-0.3,1.5-0.4l0,0c0-0.1,0-0.3,0-0.4c0.1,0.1,0.2,0.2,0.3,0.3l0,0c0.5,0.3,0.9,0.5,1.4,0.8
			c0.7-0.2,1.3-0.4,2-0.6c0,0.8,0,1.5,0.1,2.1c0.2,0.8,1.1,0.8,2,0.9c-0.6,0.8-0.7,1.6-0.5,2.3c0.7,0.5,1.3,0,2-0.1
			c0.2,0.2,0.4,0.4,0.6,0.7c1.5-0.3,2.4,0,3.2,1.1c0.5,0.7,1.5,1,2.4,1.5c0.1-0.5,0.2-0.9,0.3-1.4
			C179.9,324.1,180.6,324.4,181.5,324.8z M141.6,263.2c0,0-0.1,0-0.1-0.1l0.1-0.1c0,0,0.1,0,0.1,0.1
			C141.7,263.1,141.6,263.2,141.6,263.2z M109,277.5c-0.1-0.1-0.2-0.1-0.3-0.2c0.1-0.1,0.2-0.2,0.2-0.2c0.1,0,0.2,0.1,0.3,0.1
			C109.1,277.3,109.1,277.4,109,277.5z M119.2,284.4c-0.1-0.1-0.1-0.1-0.2-0.2l-0.1-0.1c0,0,0-0.1,0.1-0.1c0,0,0.1,0,0.2,0.1
			c0.1,0,0.2,0.1,0.3,0.1C119.3,284.2,119.3,284.3,119.2,284.4z M114.8,297.6l0.1,0.1l-0.1,0.1c0,0-0.1,0-0.1-0.1
			C114.7,297.7,114.7,297.7,114.8,297.6z M114.5,296.8c0,0,0.1,0,0.1,0.1c-0.1,0.1-0.2,0.1-0.3,0.2c0,0-0.1,0-0.2-0.1
			C114.3,296.9,114.4,296.8,114.5,296.8z M114.6,302.8c-0.3,0-0.7-0.2-0.8-0.4c-0.1-0.2,0.3-0.5,0.5-0.9c0.3,0.3,0.7,0.4,0.7,0.7
			C115.1,302.4,114.7,302.8,114.6,302.8z M122,298.1c-0.1-0.1-0.1-0.2-0.2-0.2l0.1-0.1c0.1,0.1,0.1,0.1,0.2,0.2
			C122.1,297.9,122.1,298,122,298.1z M138.3,284.9c-0.7-0.5-0.7-0.5-0.8-1.3c0.8-0.4,1.4-0.3,1.7,0.2
			C139.5,284.3,138.9,284.6,138.3,284.9z M139.7,279c-0.7,0.2-1.4,0-1.9-0.4c-0.2-0.2-0.4-0.4-0.4-0.7c0-0.1,0-0.3,0-0.4
			c0.1-0.7,0.7-1.3,1.6-1.4c0.4-0.1,0.7-0.1,1,0c0.6,0.1,1,0.5,1.1,1.1c0,0.1,0,0.2,0,0.3C141.2,278.1,140.6,278.8,139.7,279z
	M144.3,292.7c-0.1,0-0.1-0.1-0.1-0.1c0.1,0,0.2-0.1,0.3-0.1c0,0,0.1,0,0.1,0.1C144.5,292.6,144.4,292.7,144.3,292.7z M150.5,307
			c-0.1,0.1-0.2,0.1-0.3,0.1c0-0.1-0.1-0.2-0.1-0.2c0.1-0.1,0.2-0.2,0.3-0.3l0.3,0.1C150.7,306.7,150.6,306.9,150.5,307z
	M162.1,310.2c-0.1,0-0.2,0-0.2-0.1s0-0.2,0-0.3c0.1,0,0.1,0.1,0.2,0.1C162.2,310,162.1,310.1,162.1,310.2z M165.8,307.3
			c-1.1,0.3-2.3-0.2-2.5-1.1c-0.3-1,0.5-2.1,1.6-2.4s2.3,0.3,2.6,1.2C167.8,305.9,167,306.9,165.8,307.3z M168.5,300.5
			c-0.1,0-0.1-0.1-0.2-0.1c0.1-0.1,0.1-0.1,0.2-0.2C168.5,300.3,168.5,300.4,168.5,300.5z"
        />
        <path
          class="st0"
          d="M172,294.5c0,0.1,0,0.2,0,0.4c0,0.3-0.1,0.6-0.2,0.9c0.2,0,0.5-0.1,0.7-0.2
			C172.4,295.2,172.2,294.9,172,294.5z"
        />
        <path
          class="st0"
          d="M220.8,267.8c0.1,0.1,0.1,0.1,0.2,0.2c0.2-0.1,0.4-0.3,0.6-0.4c-0.1-0.1-0.2-0.1-0.2-0.2
			C221.2,267.5,221,267.7,220.8,267.8z"
        />
        <path
          class="st0"
          d="M231.5,257.8L231.5,257.8C231.6,257.7,231.6,257.7,231.5,257.8C231.6,257.7,231.5,257.7,231.5,257.8z"
        />
        <path
          class="st0"
          d="M232.2,255.9c0.1-0.1,0.2-0.1,0.2-0.2c-0.1,0-0.2,0-0.3,0C232.1,255.8,232.1,255.8,232.2,255.9z"
        />
        <path
          class="st0"
          d="M232.5,256.7c-0.1,0-0.1-0.1-0.2-0.1c0,0.1,0,0.2,0,0.3C232.4,256.8,232.4,256.7,232.5,256.7z"
        />
        <path
          class="st0"
          d="M205.6,302.6c-0.1-0.7-0.1-1.4-0.2-2c2.3-0.2,2.3-0.2,3.1-2.2c-0.6-1.3-2-1.4-3.5-1.4
			c0.1-2.2,0.2-4.3,0.2-6.4c1.2-0.4,2.2-1,2.2-2.2c0-1-0.9-1.5-2.1-1.6c-0.2-0.9-0.4-1.8-0.5-2.6c0-0.3,0.1-0.7,0.3-1
			c0.6-0.9,0.5-0.8-0.2-1.6c-0.3-0.3-0.4-0.9-0.4-1.3c0-1,0.1-2.1,0.3-3.1c0.1-0.4-0.1-0.7-0.3-1.1c-0.6-1,0-2,1.4-2.3
			c0.3-0.1,0.7-0.2,0.9-0.1c1.7,0.5,3.6,0,5.4,0.2c0.3,0.3,0.5,0.7,0.8,1.1c0.4,0.5,1.1,0.5,1.8,0.3c0.8-0.2,1.3-0.6,1.3-1.2
			c0-0.3,0-0.5,0-0.8c-0.6-0.2-0.6-0.4-0.7-1.3c0.3,0.4,0.5,0.6,0.8,0.9c0.1-0.4,0.3-0.8,0.5-1.2c0.1-0.1-0.1-0.4-0.2-0.6
			c0.2,0,0.3,0,0.5,0c0-0.1-0.1-0.1-0.1-0.2c0.8-1.3,0.8-1.3,0.6-2.6c0.3,0.3,0.7,0.5,0.7,0.7c0,0.9,0.4,1.5,0.9,2.3
			c0.3-0.1,0.6-0.3,0.9-0.8c0.7,0.2,1.4,0.4,2,0.2c-0.2-0.5-0.3-1-1-1.1c0.6-0.7-0.7-0.4-0.5-0.8c0.4-0.9-0.1-0.7-0.8-0.7
			c-0.8,0-1.2-0.9-1.5-1.6c0.7-0.1,1.4-0.2,2.3-0.3c-0.5-0.2-0.8-0.3-0.9-0.5c-0.2-0.2-0.2-0.5-0.3-0.7c-0.8,0.2-1.2,0.4-1.7,0.8
			c-0.8,0.7-1.3,0.7-2-0.1c-0.1-0.2-0.2-0.4-0.4-0.5c-0.3-0.2-0.6-0.5-1-0.5c-1.7-0.2-1.9-0.3-2.2-1.6c0-0.2-0.1-0.4-0.1-0.5
			c-0.4,0.1-0.8,0.1-1.2,0.2c0.1,0.5,0.1,1,0.2,1.4c-0.6,0.1-1.5,0.4-1.7,0.3c-0.6-0.7-1.9-0.3-2.5-1.2l0,0
			c-0.2-0.3-0.5-0.6-0.8-0.9c-0.3-0.2-0.5-0.4-0.9-0.6c-0.7-0.4-1-0.9-1.2-1.6c0.8-0.5,1.7-1,2.5-1.4c0.1-0.1,0.3,0.1,0.5,0.1
			c0.3,0,0.7,0,1,0c1,0,1.4-0.8,2.3-1c-0.1-0.3-0.2-0.5-0.3-0.7c-0.3,0.1-0.5,0.1-0.9,0.2c0.1-0.2,0.2-0.4,0.4-0.6
			c0.3-0.5,0.5-1,0.8-1.4c0.1-0.2,0.3-0.5,0.4-0.7c-0.2-0.2-0.4-0.4-0.6-0.6c-0.2-0.2-0.4-0.4-0.6-0.6l0,0c0.2,0,0.4-0.1,0.5-0.2
			c0.1,0,0.2-0.1,0.3-0.1c0.5-0.3,0.8-0.7,1.2-1.2c0.2-0.3,0.4-0.6,0.6-0.9c0.3-0.4,0.6-0.7,1.1-0.9c0.6-0.2,0.5-1,1.2-1.2
			c0.1,0-0.1-0.6-0.1-0.9c0-0.1-0.1-0.3-0.1-0.4c-0.7,0.4-1.5,0.7-2.2,1.1c0,0,0-0.1-0.1-0.1c0.2-0.2,0.5-0.4,1-0.9
			c-1.4,0.5-2.3,0.8-3.4,1.2c0.4,0.3,0.6,0.5,0.8,0.7c-1,0-1.7-0.8-2.7,0c-0.5-0.9-0.4-1.6,0.3-2.2c0.1,0.4,0.3,0.8,0.9,0.6
			c0.3-0.1,0.7-0.6,0.7-0.8c0-0.4-0.3-0.7-0.5-1.1c-0.3-0.5-0.7-1-1.2-1.6c1.4-0.1,0.5-1,1.1-1.4c0.4-0.3-0.2-0.5-0.3-0.7
			c-0.3-0.8-0.8-1.2-2-0.9c-0.4,0.1-0.9-0.2-1.3-0.3c-0.3-0.9,0.1-2.2-1.4-2.6h0.1l0,0c0.1,0.2,0.3,0.5,0.5,0.8
			c-0.3,0.1-0.6,0.2-0.9,0.4c-0.2-0.5-0.3-0.9,0.4-1.2l0,0c-1.1-0.1-2.2-0.2-3.2-0.3c-0.6,2.1,0.1,4,0.3,6c0,0,0.1,0,0.2,0.1
			c0.3-0.3,0.6-0.5,1.1-0.9c0.1,0.5,0.4,0.9,0.2,1.3c-0.1,0.2-0.8,0.3-1.1,0.4c-0.2,0.6-0.4,1.2-0.6,1.7c-0.3,0.6-0.4,1.2,0.2,1.7
			c1,1.1,1.5,2.3,1.3,3.8l0,0c-0.1,0.4-0.1,0.8-0.4,1.1c-0.1,0.1-0.2,0.3-0.3,0.4c-0.7,0.7-1.3,1.2-2,1.4c0.4,0.4,0.7,0.7,1,0.9
			c0.2-0.1,0.3-0.1,0.4-0.2c0.3-0.1,0.5-0.2,0.8-0.3l0,0c0.2,0.4,0.4,0.7,0.5,1c0.1,0.2,0.2,0.4,0.3,0.6c0.2-0.2,0.5-0.3,0.5-0.5
			s0-0.3-0.1-0.5c0-0.2-0.1-0.3-0.1-0.5c0.2,0.1,0.3,0.2,0.4,0.3c0.2,0.2,0.4,0.4,0.6,0.7c0.2,0.4,0.3,0.7,0.3,1.2
			c0,0.2,0,0.4,0,0.7c0,0.2-0.6,0.5-0.9,0.7c-0.2-0.3-0.4-0.5-0.6-0.7c-0.3-0.3-0.6-0.5-1.2-0.8c-0.3-0.1-0.7-0.3-1.1-0.4
			c-0.1-0.1-0.3-0.1-0.4-0.2l0,0c-0.4-0.1-0.6-0.3-0.7-0.6c-0.1-0.3-0.1-0.8,0.2-1.5c-0.8,0.2-1.8-0.1-2.9-1l-0.1-0.1
			c0.6-1.2,0.6-1.2,2.1-1.2c0.5,0,1-0.1,1.4-0.3c0.9-0.3,1.1-0.6,0.9-1.5c-0.1-0.8-0.4-1.5-1.1-2c-0.7-0.5-0.8-1.2-0.7-1.9
			c0.1-2.1-0.5-4.1-1.6-5.9c-0.5,0-0.9,0.2-1.2,0c-1.3-0.6-2.2,0.2-3.2,0.7c-0.7,0.4-0.5,0.9,0,1.2c1.2-0.5,1.6-0.6,2-0.2
			c0.4,0.4,0.3,0.7-0.7,1.5c-0.3-0.1-0.7-0.1-1.2-0.3c0.1,0.7-0.2,1.3-0.6,1.8c-0.4,0.6-1,1.1-1.3,1.9c-0.5-0.4-1-0.7-1.5-1.1
			c-1.3-1-2.6-1.9-4-2.9c-0.1,0.4-0.2,0.7-0.3,1c0,0.1,0,0.1-0.1,0.2c-0.4,1.5-0.8,3-0.2,4.6c0.4,0.9,0.2,1.9-0.2,2.9l0,0l0,0
			c1.2-0.7,2.4-1.2,4-0.9c0.2,0.2,0.6,0.5,0.9,1c0.7,0.9,0.5,2.1-0.4,2.9c-0.8,0.8-2.3,1.1-3.4,0.8c-1.2-0.4-1.9-1.4-1.6-2.6
			c0.1-0.4,0.2-0.8,0.4-1.2l0,0l0,0c-0.5,0.5-1,1-1.6,1.6c0.1,1,1,2-0.4,2.9c0,0.2,0,0.3,0.1,0.4c0.7,1.9,0.2,2.8-2,3.8
			c-0.4,0.2-0.9,0.4-1,0.5c-1,1.4-0.7,2.4,0,3.3l0,0c0,0.1,0.1,0.1,0.1,0.2c0.1,0.1,0.2,0.3,0.3,0.4s0.1,0.2,0.2,0.3
			c0.2,0.3,0.4,0.5,0.5,0.8c0.2,0.4,0.4,0.7,0.5,1.1c0,0,0,0,0,0.1c0.1,0.2,0.1,0.4,0.2,0.5c0.2,0.6,0.1,1.2-0.2,1.8
			c-0.1,0.1-0.1,0.2-0.2,0.3c-0.4,0.6-1,1.1-1.7,1.4c-0.2,0.1-0.5,0.2-0.8,0.3c-0.3,0.1-0.6,0.1-1,0.1c-1.3,0-2.5-0.5-3.1-1.4
			c-0.2-0.2-0.3-0.5-0.4-0.8c0-0.1,0-0.2,0-0.3c0-0.4,0-0.8,0.1-1.1c0.3-0.8,0.8-1.5,1.7-1.9c0.3-0.2,0.6-0.3,1-0.4l0,0
			c0.5-0.1,1-0.2,1.8-0.4c-0.1-0.1-0.3-0.2-0.4-0.3c-0.5-0.5-0.8-1-1-1.5c-0.1-0.5-0.1-1-0.1-1.5c0.1-1.4-0.2-2.8-1.1-4.1
			c-0.2-0.3-0.4-0.7-0.6-1c-0.3-0.6-0.6-1.1-0.9-1.7c-0.1-0.1-0.1-0.2-0.2-0.3c-0.7-0.1-1.3-0.3-1.8-0.6l-0.1-0.1
			c-0.3-0.3-0.6-0.7-0.7-1.2c0-0.2-0.5-0.4-0.7-0.5l0,0c-0.4-0.2-0.6-0.5-0.5-0.8c0-0.1,0.1-0.3,0.3-0.5c0.4,0.2,0.8,0.4,1.2,0.6
			h0.1l0,0c0.4-0.4,0.7-0.7,0.7-0.7c-0.3-1.4-1.5-0.9-2.3-1.1c0-0.5,0.1-1,0.1-1.6c-0.4,0.2-0.8,0.3-1.2,0.4
			c-0.2,0.1-0.3,0.1-0.5,0.2c-0.2,0.9-0.3,1.8-0.7,2.7s-1.1,1.7-1.5,2.5c-0.5,0.9-1.7,1.3-2.5,2.1c0.2,0.4,0.5,0.3,0.8,0
			c1-1.1,2.3-1.4,3.6-0.8c0.4,0.2,0.7,0.2,1.2,0.1c0.2,0,0.4-0.1,0.6-0.1c1.2-0.1,1.9,0.5,2,1.5c0,0,0,0,0,0.1c0,1-1.2,2.1-2.4,1.9
			c-0.6-0.1-0.8,0.1-1.2,0.3c-1,0.6-2.2,0.8-3.1,0.2c-0.8-0.6-1.7-0.7-2.7-0.5c-0.1,0.4-0.2,0.7-0.3,1.4c-0.5-0.7-0.7-1.1-1.1-1.4
			c-0.3-0.3-0.7-0.4-1.1-0.6c0.4-0.7,1.2-0.4,1.8-0.7c0.2-0.9,0.1-1.7-1.1-2.1c-0.4,0.3-0.8,0.6-1.3,0.8c-0.4,0.3-0.9,0.5-1.3,0.7
			c-0.1,0-0.1,0.1-0.2,0.1c-1,0.3-1.3,0.8-1.9,1.5c1.4,0.3,2.1,1.4,3.7,1.2c1.6-0.2,2.7,0.7,2.8,2c0,0.7,0.4,1,0.9,1.3
			c0.1,0,0.1,0.1,0.2,0.1c1.2,0.8,2.3,1.5,3.5,2.3c0.9,0.6,1.4,1.5,1.1,2.5c-0.1,0.5-0.3,1-0.7,1.3c-0.4,0.5-0.9,0.8-1.6,1
			c-0.2,0-0.3,0.1-0.5,0.1c-1.3,0.4-2.7,0.6-4.1,1c0,0.1,0,0.1,0,0.2c0.1,0.5,0.1,1.1-0.1,1.6l0,0c-0.1,0.4-0.3,0.7-0.7,1.1
			c-0.9,1-2.1,1.3-3.5,1.4c-0.1,0.6-0.3,1.1-0.4,1.7c-0.1,0.5-0.3,1-0.4,1.6c0.8,0.2,1.6,0.5,2.5,0.7c-0.1-0.4-0.1-0.7-0.1-1.1
			c0-1.4,0.6-2.7,2.3-3.5c0.1,0,0.2-0.1,0.3-0.1c0.4-0.2,0.8-0.3,1.2-0.4c0.6-0.1,1.1-0.1,1.7,0.1c0.5,0.1,0.9,0.3,1.3,0.5
			c0.7,0.4,1.6,1,1.7,1.6c0.1,0.3,0,0.7,0,1c-0.1,0.7-0.3,1.3-0.4,2c0.6,0,1.2-0.1,1.8-0.1c0.1,0,0.2,0,0.2,0
			c2.3,0.1,4.1,1.6,4.1,3.4c0,0.3,0,0.7-0.1,1c-0.1,0.4-0.3,0.8-0.5,1.2c-0.7,1.1-1.9,1.9-3.4,2.2c0,0.1-0.1,0.2-0.3,0.4
			c-0.1,0.1,0.3,0.6,0.6,1.1c0.4,0.2,1-0.8,1.6-0.2c0.2,0.2,0.4,0.4,0.7,0.7c0-0.7,0.6-1.4,1.4-1.7c1-0.3,2,0.1,2.2,1
			c1-0.4,1.9-0.8,3-1.3c0.1,0,0.4,0.2,0.7,0.2c0.4,0,0.9,0,1.2-0.1c1-0.4,2.3-2.7,1.9-3.5c-0.7-1.3-1.1-2.7-2.4-3.8
			c-0.3-0.3-0.6-0.6-0.8-1c-0.2,0.7-0.7,1.4-1.4,1.8c-0.3,0.2-0.7,0.4-1.2,0.6c-0.1,0-0.2,0.1-0.3,0.1c-1.9,0.4-4-0.7-4.3-2.2
			c-0.1-0.5,0-1,0.2-1.5c0.4-1.1,1.5-2,2.9-2.3c0.6-0.1,1.2-0.1,1.7,0c1,0.2,1.8,0.7,2.2,1.5v-0.1c-0.4-0.6-0.1-1.2,0.1-1.9
			c0.1-0.4,0-0.8,0.1-1.3c0-0.2,0.2-0.4,0.3-0.6c0-0.1,0.1-0.1,0.1-0.2l0,0c0.7,0.2,1.3,0.4,1.9,0.6c0-0.1,0.1-0.3,0.2-0.4
			c0.2-0.3,0.4-0.5,0.8-0.6c0.2-0.1,0.4-0.1,0.6,0c0.4,0.1,0.8,0.3,0.9,0.7c0.1,0.5-0.1,0.9-0.6,1.2c0.8,0.4,1.5,0.9,2.3,1.3
			c0.7-0.6,1.3-1.3,2-1.9c1.3,0.3,2.6,0.4,2.6,1.9c0.5-0.3,0.7-0.5,1-0.6c0.4-0.2,0.9-0.4,1.3-0.5c0.4-0.1,1.8-0.6,2.2-0.7
			c1.3-0.5,2.7-0.8,4.2-0.6c0.7,0.1,1.3,0.2,2.1,0.3c-0.4,0.1-0.7,0.2-0.9,0.3c-0.6,0.3-0.7,0.7-0.3,1.1s1,0.8,1.3,1.1
			c0.2,1.2,0.4,2.2,0.5,3.2c0.1,0.3,0.2,0.7,0.1,1c-0.3,1.3,0.1,2.5,0.5,3.6c0.5,1.2,0.6,2.4-0.5,3.6c-0.2,0-0.4-0.1-0.6,0
			c-0.3,0.1-0.6,0.3-0.8,0.5c0.2,0.2,0.4,0.5,0.7,0.7c0.1,0.1,0.5-0.1,0.7-0.1c0.8-0.1,1.2,0.1,1.2,0.7c0.2,2,0.4,4.1,0.6,6.2
			c-1.1-0.1-2.2-0.1-2.9,0.7c-0.3,0.4-0.6,0.9-0.7,1.4c-0.1,1.3,1.2,1.9,3.6,1.6C204.7,301.2,204.5,302.2,205.6,302.6z M209.8,270.6
			c-0.1-0.1-0.2-0.2-0.2-0.4c0-0.1,0.1-0.2,0.2-0.2c0.1,0,0.2,0,0.3,0C210,270.2,209.9,270.4,209.8,270.6z M210.3,268.2
			c0.2-0.1,0.7-0.1,0.8,0c0.3,0.5,0.5,1,0.8,1.5h0.1c0,0,0,0,0,0.1c0.3,0,0.9,0,0.9,0.1c0.3,0.8,0.9,0,1.4,0.1
			c0.1,0.2,0.2,0.6,0.1,0.8c-0.1,0.4-0.3,1-1.1,0.5c-0.1,0-0.5,0.2-0.8,0.4c-0.9-0.5-0.8-1.2-0.6-1.9l0,0c0,0,0,0,0-0.1
			c-1.1,0.1-1.7-0.2-1.8-0.9C210,268.6,210.1,268.3,210.3,268.2z M209.6,266.7c0.1,0,0.2,0.1,0.2,0.2c-0.1,0.1-0.2,0.1-0.3,0.1
			s-0.1-0.1-0.2-0.2C209.5,266.7,209.6,266.6,209.6,266.7z M209.2,252.8C209.2,252.8,209.3,252.8,209.2,252.8c0,0,0-0.1,0.1-0.1h0.1
			C209.3,252.7,209.3,252.7,209.2,252.8C209.3,252.8,209.2,252.8,209.2,252.8L209.2,252.8z M208.3,253.4L208.3,253.4L208.3,253.4
			c0.1,0,0.1,0.1,0.1,0.1l0,0c0.2,0,0.3,0,0.6-0.1c0,0.1,0,0.1-0.1,0.2c-0.1,0.2-0.2,0.4-0.2,0.6c0,0.1-0.1,0.3-0.1,0.4
			c0,0.1,0,0.3-0.1,0.4c-0.1-0.1-0.1-0.2-0.2-0.3c-0.2-0.3-0.2-0.5-0.1-0.9C208.2,253.7,208.3,253.6,208.3,253.4L208.3,253.4
			C208.4,253.5,208.3,253.5,208.3,253.4L208.3,253.4h-0.1C208.2,253.4,208.2,253.4,208.3,253.4z M201.4,246.8c0,0-0.1,0-0.1-0.1
			l0.1-0.1c0,0,0.1,0,0.1,0.1C201.4,246.7,201.4,246.8,201.4,246.8z M204.5,256.5c0,0.1-0.1,0.2-0.1,0.2c-0.1,0-0.1,0-0.2,0l0,0
			c0.1-0.2,0.1-0.4,0.2-0.5c0.1,0,0.2,0.1,0.3,0.1C204.6,256.3,204.6,256.4,204.5,256.5z M204.4,254.4c0-0.1,0.1-0.1,0.1-0.2
			C204.4,254.2,204.4,254.3,204.4,254.4L204.4,254.4L204.4,254.4L204.4,254.4L204.4,254.4L204.4,254.4z M206.3,257.6
			c-0.1,0-0.3-0.1-0.4-0.1c0-0.1,0.1-0.3,0.2-0.3c0.1,0,0.3,0.1,0.5,0.1C206.4,257.4,206.4,257.6,206.3,257.6z M207.7,256.4
			C207.7,256.4,207.6,256.4,207.7,256.4c-0.1,0-0.1-0.1-0.1-0.1l0.1-0.1c0,0,0.1,0,0.1,0.1l0,0C207.8,256.4,207.7,256.4,207.7,256.4
			z M207.8,250.8c-0.8,0.8-0.8,0.8-1.8,0.1C206.7,250,207.1,250.7,207.8,250.8z M207,243.5L207,243.5c0-0.1,0-0.1,0-0.1
			c0-0.1,0-0.1,0-0.2v-0.1l0.1,0.1c0,0.1-0.1,0.1-0.1,0.2V243.5L207,243.5c0.1,0.5,0.3,1.1-0.4,1.5
			C205.8,244.1,205.9,243.9,207,243.5z M205.7,242.4c0.1,0,0.2,0.1,0.4,0.2c-0.1,0.2-0.3,0.3-0.4,0.4l-0.2-0.1
			C205.5,242.7,205.6,242.6,205.7,242.4z M205.7,256.5c0.1,0.1,0.2,0.1,0.3,0.2c-0.1,0.1-0.2,0.2-0.4,0.2c-0.1,0-0.2-0.1-0.3-0.1
			C205.5,256.7,205.6,256.6,205.7,256.5z M205.4,253.5c-0.2,0-0.3,0.1-0.4,0.1c-0.5,0-0.6-0.4-0.8-0.7c-0.3-0.5,0-0.8,0.3-1.3
			c0-0.1,0.1-0.2,0.1-0.3C204.9,252.2,205.1,252.8,205.4,253.5z M200.8,240.9l0.1-0.1c0.1,0,0.2,0,0.3,0c-0.1,0.1-0.1,0.2-0.2,0.2
			C200.9,241,200.8,240.9,200.8,240.9z M201,241.8c0.2-0.2,0.3-0.4,0.5-0.6c0.2-0.1,0.4-0.1,0.7-0.1
			C202.1,241.9,201.6,241.9,201,241.8z M201.8,242.1c0.6-0.1,1.2-0.3,1.7-0.4l0,0c0,0,0,0,0.1,0c0-0.2,0.1-0.3,0.1-0.5
			c0.1,0.1,0.2,0.1,0.4,0.2c-0.1,0.1-0.3,0.2-0.5,0.3c0,0,0,0,0,0.1l0,0c0,0.5,0.5,0.2,0.9,0.3c-0.3,0.4-0.6,0.9-0.9,1.2
			C202.1,243,202.1,243,201.8,242.1z M203.6,244.7h-0.1H203.6L203.6,244.7z M203.8,250.1L203.8,250.1L203.8,250.1
			c-0.1,0.1-0.3,0.2-0.6,0.4c0.1-0.3,0.1-0.6,0.2-0.8c0.2,0,0.5,0,0.7,0.1l0,0l0,0c0.1-0.2,0.3-0.3,0.4-0.5c0.6,0.6,0.6,0.6-0.5,1.4
			C204,250.4,203.9,250.3,203.8,250.1z M199.4,251.4c0.1,0,0.3,0,0.4,0.1c-0.1,0.2-0.1,0.4-0.2,0.6c-0.1,0-0.2,0-0.2,0
			C199.4,251.8,199.4,251.6,199.4,251.4z M198,247.4C198,247.4,198,247.5,198,247.4c0,0.1-0.1,0.1-0.2,0.2c0-0.1,0-0.1,0-0.2
			C197.9,247.4,198,247.4,198,247.4z M181.9,286.6L181.9,286.6l-0.1,0.1L181.9,286.6z M181.4,285.8c0.1,0,0.2,0,0.3,0
			c-0.1,0.1-0.1,0.2-0.2,0.2c-0.1,0-0.2,0-0.2-0.1S181.3,285.8,181.4,285.8z M180.9,287.1c-0.2,0.3-0.4,0.7-0.6,1.1
			C179.8,287.6,180.3,287.3,180.9,287.1z M179.9,286.7v0.1h-0.1L179.9,286.7z M169.9,263.5c0.2-1.1,1.2-2,2.5-2.3
			c0.6-0.1,1.2-0.1,1.7,0c1.1,0.2,1.9,0.9,2.2,1.8c0.1,0.4,0.1,0.7,0,1.1c-0.3,1.1-1.3,2-2.6,2.3c-0.5,0.1-1,0.1-1.5,0
			c-1.2-0.2-2.1-0.9-2.3-2C169.9,264.1,169.9,263.8,169.9,263.5z M173.4,276.8c-0.4,0.2-0.8,0.4-1.2,0.5c-0.1,0-0.2,0.1-0.3,0.1
			c-2.2,0.5-4.3-0.5-4.6-2.3c-0.2-1,0-1.8,0.5-2.5c0.2-0.3,0.5-0.6,0.9-0.8c0.5-0.3,1-0.6,1.7-0.7c0.6-0.1,1.1-0.2,1.6-0.1
			c0.1,0,0.1,0,0.2,0.1c0.6,0.1,1.1,0.3,1.6,0.6c0.1,0.1,0.2,0.1,0.3,0.2c0.2,0.2,0.3,0.3,0.5,0.5c0.1,0.2,0.2,0.3,0.3,0.5
			s0.1,0.3,0.2,0.5C175.4,274.6,174.7,276,173.4,276.8z M196.7,264.8l0.1-0.1C196.8,264.7,196.8,264.8,196.7,264.8v0.1V264.8z
	M192.8,248.5c0-0.1-0.1-0.1-0.1-0.2C192.7,248.3,192.7,248.4,192.8,248.5C192.8,248.4,192.8,248.4,192.8,248.5
			c0.1-0.1,0.2-0.1,0.3-0.2c0.8-0.6,1.7-0.9,2.7-0.4c0.8,0.4,0.9,0.9,0.5,2.2c0.1,0.1,0.3,0.2,0.4,0.3l0,0c0.1,0.1,0.2,0.1,0.3,0.2
			c-0.3,0.5-0.5,0.8-0.7,0.8s-0.4-0.1-0.7-0.3l0,0c-0.2-0.1-0.3-0.2-0.5-0.2C192.7,250.6,192.4,250.3,192.8,248.5L192.8,248.5z
	M195.9,252.1c0,0.3-0.1,0.3-0.4,0.5c-0.1,0-0.1,0.1-0.2,0.1c0.2-0.3,0.4-0.6,0.6-0.9C195.9,251.9,195.9,252,195.9,252.1z
	M193.3,256.3c-0.3-0.2-0.5-0.6-0.6-1c0-0.2,0.3-0.5,0.6-0.7c0,0,0,0,0.1,0c0.2,0,0.5,0.1,0.7,0.2c0,0,0,0,0,0.1
			c0.2,0.2,0.3,0.5,0.5,0.8C194.2,256.3,193.8,256.6,193.3,256.3z M194.5,256.7l-0.1,0.1c0,0-0.1,0-0.1-0.1l0.1-0.1
			C194.4,256.6,194.4,256.7,194.5,256.7z M193.1,251.9c0.9-0.4,1.3-0.2,1.8,0.5C194.1,252.2,193.7,252.1,193.1,251.9z M189.1,250
			c-0.1-0.4,0-0.9,0.6-1.2c0.5-0.2,1.1-0.7,1.6,0c-0.3,0.6-0.6,1.3-0.9,2C189.5,251,189.3,250.4,189.1,250z M185.7,259.9
			c-0.7-0.4-1.1-0.6-1.5-0.8C184.9,258.9,185.3,259,185.7,259.9z M184.7,266.7c-0.2,0-0.4-0.1-0.7-0.2s-0.5-0.3-0.7-0.5
			s-0.4-0.5-0.4-0.8c-0.1-0.4-0.1-0.7,0-1.1c0-0.1,0.1-0.1,0.1-0.2c0.4-0.8,1.3-1.4,2.2-1.5c0.4,0,0.7,0,1,0.1
			c0.5,0.1,0.9,0.3,1.3,0.7c0.2,0.2,0.4,0.4,0.5,0.7c0,0,0,0,0,0.1c0.1,0.4,0,0.9,0.9,0.9c0,0,0,0-0.1,0c-0.7,0.5-1.2,0.9-1.7,1.2
			C186.4,266.7,185.6,266.9,184.7,266.7z M188.6,260.6c0-0.1,0.1-0.1,0.2-0.2c0.1,0.1,0.1,0.1,0.2,0.2c0,0.1-0.1,0.1-0.2,0.2
			C188.7,260.7,188.6,260.7,188.6,260.6z M188.9,268.5c0-0.6-1.2-0.9,0.1-1.7C189,267.4,190.2,267.7,188.9,268.5z M193.5,261.6
			l0.1-0.1l0.1,0.1H193.5z M193.8,260.3c-0.2-0.1-0.3-0.1-0.5-0.1c-0.3,0-0.7,0.1-1.1,0.1c-0.1-0.1-0.2-0.3-0.3-0.4
			c-0.2-0.3-0.3-0.5-0.5-0.8c-0.5,0.1-0.9,0.2-1.3,0.3c-0.9,0.2-1.6,0-1.9-0.5c-0.3-0.6-0.4-1.3,0.2-1.9c0.5-0.6,1.2-0.8,2-0.7
			c0.9,0.2,1.9,0.3,2.7,0.6c0.5,0.2,1.1,0.6,1.2,1c0.1,0.3,0.3,0.6,0.6,0.7c0.2,0.1,0.5,0.3,0.8,0.4c-0.2,0.3-0.4,0.5-0.6,0.7
			c-0.2,0.3-0.5,0.6-0.7,0.8C194.2,260.5,194,260.4,193.8,260.3z M195.5,272.2c-0.1,0-0.2,0-0.2-0.1s0-0.2,0.1-0.3
			c0.1,0,0.2,0,0.2,0.1C195.6,272.1,195.5,272.2,195.5,272.2z M196,273c-0.1,0-0.3,0-0.3-0.1s0-0.2,0-0.4c0.2,0,0.4,0,0.4,0.1
			C196.1,272.7,196,272.9,196,273z M197.6,266.9c-0.3,0.4-0.7,0.8-1.1,1.2c-0.3,0.3-0.6,0.6-1,1c-0.1-0.2-0.2-0.3-0.3-0.4
			c-0.2-0.4-0.4-0.7-0.7-1l0,0l0,0c0.5-0.1,0.9-0.2,1.3-0.3c0.1-0.1,0.2-0.3,0.3-0.5c0.2-0.3,0.5-0.7,0.7-1.1
			c0.4,0.1,0.6,0.2,0.7,0.4C197.8,266.4,197.8,266.6,197.6,266.9z M198.2,274.4l-0.1-0.1c0-0.1,0.1-0.3,0.2-0.4
			c0.1,0.1,0.2,0.2,0.2,0.2C198.4,274.2,198.3,274.3,198.2,274.4z M198.7,264.2c0,0-0.1,0-0.1-0.1s0-0.2,0.1-0.3c0,0,0.1,0,0.1,0.1
			C198.7,264,198.7,264.1,198.7,264.2z M204.5,265.7c0,0,0.1,0,0.2,0c-0.1,0-0.1,0.1-0.2,0.1c-0.1,0-0.1,0-0.2,0
			C204.4,265.8,204.5,265.7,204.5,265.7z M199.6,260.8c-0.4-0.1-0.4-0.4-0.4-0.7c0-0.1,0-0.1,0-0.2c0.2-0.4,0.5-0.7,1.1-0.7
			c0.2,0,0.3,0.1,0.5,0.1c0.2,0.1,0.4,0.1,0.6,0.2c-0.2,0.4-0.3,0.8-0.6,1C200.5,260.8,200,260.9,199.6,260.8z M200,274
			c0,0-0.1,0-0.1-0.1l0.1-0.1l0.1,0.1C200.1,274,200.1,274,200,274z M200.4,274.5l0.1-0.1v0.1H200.4z M201.9,270.8
			c0-0.1-0.1-0.1-0.1-0.2l0.1-0.1c0.1,0,0.1,0.1,0.2,0.1C202.1,270.7,202,270.8,201.9,270.8z M202.6,269.1c-0.1,0-0.3,0-0.5,0
			c0.1-0.1,0.2-0.3,0.4-0.3c0.1-0.1,0.3,0,0.6-0.1C202.8,269,202.7,269.1,202.6,269.1z M202.6,263.9c0,0,0,0.1-0.1,0.1
			c-0.2,0.3,0,0.8,0,1.2v0.1c0,0.4,0,0.8-0.5,1s-0.8,0-1.1-0.2c-0.1-0.1-0.2-0.2-0.2-0.3c-0.1-0.2-0.2-0.5-0.3-0.8
			c0-0.1-0.1-0.2-0.1-0.4c0-0.1,0.1-0.2,0-0.3c-0.9-1.6,0.3-2.8,1.7-3.9C203,261.4,203.8,262.4,202.6,263.9z M203.3,267.5
			c0.5-0.6,1-1.1,2-1.2c0.5-0.1,1-0.6,1.4-0.9c1.2,0.6,1.3,0.8,0.8,1.7c-0.3,0.6-0.7,1.1-0.2,1.8c0.3,0.4-1.1,1.6-1.8,1.6
			c-0.4,0-0.7-0.3-0.9-0.5c-0.3-0.4-0.5-0.8-0.7-1.2C203.7,268.5,203.5,268,203.3,267.5z"
        />
        <path
          class="st0"
          d="M176,291c0.1,0,0.2,0.1,0.3,0.1c0-0.2-0.1-0.4-0.1-0.5C176.1,290.7,176.1,290.8,176,291z"
        />
        <path
          class="st0"
          d="M212.1,261.2c-0.3,0.3-0.5,0.6-0.7,0.9C212.5,262,212.5,262,212.1,261.2z"
        />
        <path
          class="st0"
          d="M83.5,183C83.4,183,83.4,183,83.5,183C83.4,183.1,83.4,183.1,83.5,183C83.5,183.1,83.5,183.1,83.5,183
			L83.5,183L83.5,183z"
        />
        <path
          class="st0"
          d="M266.4,125L266.4,125c0.2,0.1,0.3,0.2,0.4,0.3c0.1-0.1,0.2-0.2,0.4-0.4c-0.1,0-0.2-0.1-0.2-0.1
			c-0.1,0-0.2-0.1-0.3-0.1C266.6,124.7,266.5,124.9,266.4,125z"
        />
        <path
          class="st0"
          d="M18.1,193c0.1-0.4,0.2-0.7,0.4-1c-0.5-0.2-1-0.4-1.3-0.7c-0.3,0.8-0.3,1.5,0.1,2.1c-0.1-0.3-0.1-0.7,0.3-1.1
			C17.7,192.6,17.9,192.8,18.1,193z"
        />
        <path
          class="st0"
          d="M13.8,182.2c0,0.1-0.1,0.3-0.2,0.4c-0.1,0-0.2,0-0.3,0c0-0.1,0-0.3,0-0.4c-0.4,0.3-0.7,0.7-1,1.1
			c-0.3,0.5-0.7,0.9-0.9,1.2c0.1,0.3,0.3,0.4,0.3,0.7c0.1,1.2,1,2.9,1.8,3.5c0.7,0.1,1.5,0.2,2.2,0.3c-0.1-0.4-0.3-0.7-0.2-1
			c0.1-0.8,0.2-1.6,0.6-2.3s1.2-1.4,2-1.9s1.3-1,1.7-1.8c0.5,0.1,1,0.2,1.3,0.2c0.1,0.4,0.2,0.6,0.3,0.9c0.2-0.1,0.4-0.2,0.6-0.3
			c-0.4-0.8-1.2-1.4-2.2-1.8c-2-0.8-4.4-0.4-6.1,0.9C13.8,182,13.8,182.1,13.8,182.2z"
        />
        <path
          class="st0"
          d="M28.2,183.7c0.1,0,0.2,0,0.2-0.1c0.1,0,0.1,0,0.2-0.1c0.4-0.2,0.7-0.3,1.1-0.4c1.7-0.6,2.6,0,3.3,1.7
			c0.2,0.6,0.7,1.1,1,1.7c0.8-0.2,0.9-0.6,0.9-0.9c0,0,0,0,0-0.1c-0.4-0.7-1-1.2-0.9-2c-0.3-0.3-0.6-0.6-1-0.7
			c-0.8-0.3-1.1-0.8-1.3-1.3c-1.7-0.4-3.2,0.3-3.7,1.6C28,183.4,28.1,183.6,28.2,183.7z"
        />
        <path
          class="st0"
          d="M235.6,111.4c0.8,0.6,1.2,1.5,1.3,2.5c0.5,0,1.1,0,1.7,0c0.2,0.3,0.4,0.7,0.7,0.9c0.5,0.5,1.4,0.5,2,0.2
			c0.7-0.4,1-0.8,1.2-1.2c0.2-0.6-0.1-1.2-1-1.7c-0.1,0-0.1-0.1-0.2-0.2c1-0.9,1.2-1.1,0.9-1.8c-0.1-0.2-0.2-0.4-0.3-0.6
			c0,0,0-0.1-0.1-0.1c0,0.2,0,0.4-0.1,0.6c-0.3,0.8-1,1.5-2,1.6c-0.4,0.1-0.9,0-1.2-0.1c-0.7-0.2-1.3-0.7-1.5-1.4c0-0.1,0-0.3,0-0.4
			c0-0.2,0-0.5,0.1-0.7c-0.6,0-1.2-0.1-1.9-0.1c0,0.3,0,0.6-0.1,0.8c0,0.2,0.1,0.6,0,0.6c-0.3,0.2-0.4,0.3-0.5,0.5
			C234.9,110.9,235.2,111.2,235.6,111.4L235.6,111.4z M235,109.9c0.1,0,0.1,0,0.2-0.1c0.2-0.1,0.3-0.1,0.5-0.2v0.1v0.1
			C235.5,109.9,235.3,110,235,109.9C235.1,110,235.1,110,235,109.9z"
        />
        <path
          class="st0"
          d="M259.8,86c1.7,0,2.7-0.7,3.7-1.9c0.7-0.9,0.8-2,0.2-2.8c-0.6,0.1-1.2,0.1-1.8,0.2c0.3-0.4,0.7-0.7,1.1-1
			c-0.6-0.5-1.5-0.7-2.6-0.7c-0.4,0-1,0.2-1.3,0.5c-0.9,0.8-1.7,1.6-2.4,2.4c-0.3,0.3-0.3,0.7-0.4,0.9c0.1,0.3,0.2,0.5,0.2,0.6
			C257.1,85.3,258.2,86,259.8,86z M258.1,83.1c0.4-0.3,0.8-0.4,1.3-0.5c0.2,0,0.5-0.1,0.7-0.1c0.1,0.2,0,0.5,0,0.7
			c-0.1,0.4-0.4,0.7-0.8,0.9l0,0c-0.7,0.3-1.3,0.1-1.7-0.4C257.6,83.4,257.8,83.2,258.1,83.1z"
        />
        <path
          class="st0"
          d="M5,189.3c0.3,0.1,0.7,0.1,1,0.1c0.9,0.1,1.1,0,1.4-0.9c0.1-0.2,0.1-0.4,0.2-0.7c0.9,0.6,1.1,1.3,0.8,2.2
			c0.5-0.2,0.8-0.3,1.1-0.4c1.1-0.4,1.8-0.5,2.5-0.3c0.1-0.1,0.3-0.2,0.4-0.3c0.1,0-0.1-0.3-0.1-0.6c-0.2,0.2-0.3,0.3-0.4,0.4
			c-0.2-0.3-0.3-0.6-0.5-0.9c-0.2-0.3-0.6-0.6-0.9-0.8c-0.1,0.3-0.1,0.5-0.2,0.7c-0.7-0.3-1.1-0.7-1.3-1.2c-0.6,0-1.2,0.1-1.8,0.3
			C5.8,187.4,5.1,188.3,5,189.3z M11.4,188.3v0.1c0,0-0.1,0-0.1,0.1c0,0,0-0.1-0.1-0.1C11.3,188.4,11.3,188.3,11.4,188.3z
	M8.4,186.9c0,0,0.1,0,0.1,0.1l-0.1,0.1H8.3C8.3,187,8.3,186.9,8.4,186.9z"
        />
        <polygon class="st0" points="7.5,189.7 7.4,189.7 7.4,189.8 		" />
        <path
          class="st0"
          d="M173.8,97.9c1.8-0.3,2.9-1.5,2.6-2.9c-0.2-1.4-1.7-2.2-3.4-1.8c-1.6,0.3-2.8,1.7-2.6,3
			C170.7,97.4,172.2,98.2,173.8,97.9z"
        />
        <path
          class="st0"
          d="M89.1,141.4c0.4,0.4,0.9,0.6,1.7,0.7c0.6,0.1,1.1,0.1,1.5,0.6c0.1,0.1,0.3,0.3,0.5,0.4c0-0.1,0-0.1,0-0.2
			c0-0.1,0-0.1,0-0.2c0-0.3,0.2-0.7,0.4-0.9c0.1-0.2,0.3-0.4,0.5-0.5c0.2-0.4,0.3-0.7,0.4-1c0.2-0.9-0.2-1.7-1-2.1
			c-0.4,0.8-1.3,1.5-2.3,1.7c-0.7,0.2-1.5,0.1-2.1-0.2C88.5,140.3,88.6,140.9,89.1,141.4z"
        />
        <path
          class="st0"
          d="M2.8,184.7c0-0.1,0-0.1,0.1-0.2c0.2,0.1,0.4,0.2,0.5,0.3c0.3,0,0.5,0,0.8-0.1c1.1-0.2,1.9-1,2.2-1.9
			c-0.1-0.1-0.1-0.1-0.2-0.2c-0.5-0.8-1-1.6-1.7-2.3l0,0c-0.5-0.1-1-0.1-1.5,0c-1.5,0.4-2.5,1.7-2.2,2.9
			C1.1,183.9,1.9,184.5,2.8,184.7z"
        />
        <path
          class="st0"
          d="M96.5,140c0.5,0.1,1,0.2,1.5,0.2c-0.1,0.4-0.2,0.7-0.2,1.1c0.3,0.3,0.5,0.7,0.5,1.2c0.2,0.2,0.4,0.4,0.7,0.5
			c1.3-1.2,0.4-2-0.3-2.9c0.4-0.4,0.8-0.7,1.1-1c-0.2-0.6-0.6-1.1-1.1-1.6c-0.1-0.1-0.3-0.2-0.4-0.4c-0.1,0-0.1-0.1-0.2-0.1
			c-0.5-0.4-1-0.7-1.5-1.1c-0.7-0.1-1.1,0.2-1.5,0.7h0.1c-0.2,0.2-0.3,0.5-0.5,0.7c-0.2,0.5-0.2,0.9,0,1.3
			C95,139.3,95.6,139.8,96.5,140z"
        />
        <path
          class="st0"
          d="M13.5,179.4c0,0.2,0,0.5,0.1,0.7c1.2-0.4,1.9-1.4,1.7-2.5c-0.2-1.2-1.7-2-3.2-1.7c-0.4,0.1-0.7,0.2-1,0.4
			c0.1,0,0.1,0,0.2,0.1C12.7,177.1,13.4,178.1,13.5,179.4z M14.1,177.7c0.1,0,0.1-0.1,0.2-0.1l0,0c0.1,0,0.1,0,0,0
			C14.3,177.7,14.2,177.7,14.1,177.7c0,0.1,0,0.2-0.1,0.3C14.1,177.9,14.1,177.8,14.1,177.7z"
        />
        <path
          class="st0"
          d="M226.5,129c0.4,0.1,0.8,0.1,1.3,0c0.7-0.1,1.3-0.4,1.7-0.9c-1.8-0.1-2.8-1.1-3.4-2.5
			c-0.4,0.3-0.8,0.5-1.2,0.8c-0.1,0.1-0.1,0.3-0.1,0.4C225.7,127.6,226.3,128.3,226.5,129z M228.3,128.5c0.1,0,0.2,0,0.3,0.1
			c-0.1,0.1-0.1,0.2-0.2,0.2c-0.1,0-0.2,0-0.3-0.1C228.1,128.7,228.2,128.6,228.3,128.5z"
        />
        <path
          class="st0"
          d="M230.4,132.8h-0.1c0.5,0.3,0.9,0.6,1.3,0.9C231.3,133.3,230.9,133,230.4,132.8z"
        />
        <path
          class="st0"
          d="M231.8,134.9c0-0.3,0-0.6-0.1-0.9c0,0.3,0,0.6-0.1,0.9c-0.1,0.4-0.2,0.9-0.4,1.3c0,0,0.1,0,0.1-0.1
			c0.1-0.4,0.3-0.7,0.4-1.1C231.8,135,231.8,135,231.8,134.9z"
        />
        <path
          class="st0"
          d="M231.6,120c0.6,0,1.2-0.2,1.9-0.3c0.6,1.4,1.3,1.8,2.8,1.5c-0.3-0.2-0.5-0.5-0.6-0.8c0-0.1-0.1-0.1-0.1-0.2
			c0-0.2,0-0.4,0-0.6c0.2-0.6,0.7-1.1,1.5-1.2c0.3,0,0.5,0,0.8,0c-0.3-0.3-0.6-0.5-0.8-0.6c-0.9-0.5-1.7-0.2-3.1,0.7l0,0
			c-0.2-0.2-0.4-0.3-0.6-0.4l0,0c-0.5,0.1-1.1,0.2-1.5,0.3c-0.2,0.4-0.4,0.8-0.5,1.2c0,0.1-0.1,0.1-0.1,0.2
			C231.2,119.9,231.4,120,231.6,120C231.5,120,231.5,120,231.6,120z"
        />
        <path
          class="st0"
          d="M236.4,138c0.5-0.3,0.3-0.5-0.1-0.6C236.4,137.6,236.4,137.8,236.4,138z"
        />
        <path
          class="st0"
          d="M237.3,137.3C237.3,137.2,237.3,137.2,237.3,137.3c-0.3-0.8-0.9-1.2-1.8-1.3c-0.5,0-1,0.1-1.4-0.1
			c-0.4-0.1-0.7-0.2-1.1-0.2c-0.6,0-1.1,0.2-1.6,0.5c-0.1,0.2-0.2,0.4-0.3,0.7l0,0c0.6,0.2,1.1,0.3,1.6,0.4c0.1,0.4,0.1,0.9,0.3,1.3
			c0.1,0.2,0.2,0.3,0.3,0.4c0.1,0,0.2,0,0.3,0c0-0.5,0-0.9,0.1-1.2c0.9-0.3,0.9-0.3,1.9-0.2c0.2,0,0.5-0.1,0.7-0.1l0,0
			c0.2-0.1,0.5-0.3,0.6-0.3C237.1,137.2,237.2,137.2,237.3,137.3z"
        />
        <path
          class="st0"
          d="M73.3,167.6c-0.2,0-0.4,0.1-0.5,0.1c0,0,0,0,0.1,0s0.1,0,0.2,0.1c0.8,0.3,1.2,0.8,1.6,1.7
			c0.7,0.1,1.3,0.3,2,0.4c0.4-0.2,0.6-0.4,0.6-0.8c0.1-0.3,0-0.7,0-1.2c0-0.1,0-0.2,0-0.3c-0.2,0-0.4,0-0.6,0s-0.4,0-0.5,0
			c0,0.1-0.1,0.2-0.1,0.3s-0.1,0.2-0.1,0.3c-0.1-0.1-0.2-0.3-0.2-0.4c0-0.1,0-0.2,0-0.2c0-0.2-0.1-0.3-0.1-0.6
			c-0.3,0.1-0.6,0.2-0.9,0.3c-0.4,0.1-0.7,0.2-1.1,0.3C73.4,167.6,73.4,167.6,73.3,167.6z"
        />
        <path
          class="st0"
          d="M304.1,81.7c0.5,0.5,1.2,0.7,2.1,0.6v-3.7c-0.2,0-0.4,0-0.6,0c-0.3,0.1-0.6,0.2-0.9,0.3
			c-0.7,0.4-1.1,1.2-1,1.9C303.7,81.2,303.9,81.5,304.1,81.7z"
        />
        <path
          class="st0"
          d="M69.4,153.1c-0.3,0.7,0,1.6,0.9,1.8h0.1c0.3,0.1,0.7,0.1,1,0c0.1,0,0.1,0,0.2,0c1.2-0.3,2.3-1.2,2.2-2.3
			c0-0.5-0.2-1,0.2-1.7c-0.9,0.2-1.6,0.3-2.2,0.5s-1.3,0.5-1.8,0.8C69.7,152.6,69.5,152.8,69.4,153.1z"
        />
        <path
          class="st0"
          d="M299.5,87.6c0.3,0.4,0.7,0.2,1,0c-0.1-0.1-0.1-0.2-0.2-0.4c-0.1-0.3,0-0.5,0.1-0.8c0.2-0.5,0.8-1,1.5-1.1
			c0.6-0.1,1.1,0.1,1.5,0.4c-0.3-1-1.6-1.6-2.9-1.2c-1,0.3-1.7,1.1-1.6,1.9C298.9,86.8,299.2,87.2,299.5,87.6z"
        />
        <path
          class="st0"
          d="M25.9,178.9c-1.3,0.2-2.1,1.2-1.9,2.1c0,0.1,0,0.1,0.1,0.2c0.3,0.2,0.8,0.4,1.3,0.4c0.8,0,1.1-0.4,1.3-0.9
			c0.1-0.2,0.2-0.4,0.4-0.6c0.2-0.3,0.3-0.5,0.5-0.8C27.1,178.9,26.5,178.8,25.9,178.9z"
        />
        <path
          class="st0"
          d="M27.5,180.8c-0.1,0.1-0.1,0.1-0.1,0.2c-0.2,0.3-0.2,0.7-0.2,0.9c0.6-0.4,1-1,0.9-1.7c0-0.2-0.1-0.5-0.3-0.7
			C27.8,180,27.8,180.5,27.5,180.8z"
        />
        <path
          class="st0"
          d="M66.9,181.1c0.2,0.1,0.3,0.2,0.4,0.3c0.3,0.2,0.5,0.5,0.7,0.7c0.2-0.6,0-1.3-0.6-1.6
			c-0.8-0.5-1.9-0.4-2.7,0.2C65.4,181.1,66.1,181.2,66.9,181.1z"
        />
        <path
          class="st0"
          d="M62.6,176.3c-0.4-0.2-1-0.3-1.5-0.2c-0.1,0-0.2,0.1-0.3,0.1c0,0.1,0,0.1,0,0.2c0.5,0,0.9,0,1.3,0.2
			c0.7,0.3,1.2,0.8,1.4,1.6c0.1-0.3,0.2-0.6,0.1-0.9C63.3,176.9,63,176.6,62.6,176.3z"
        />
        <path
          class="st0"
          d="M75.8,177.7c-0.1-0.1-0.2-0.1-0.3-0.2c-0.2-0.1-0.4-0.2-0.6-0.1c-1.1,0.3-2.3,0.4-3.4,1.2
			c0.7-0.1,1.1-0.1,1.4-0.2c0.3,0.6,0.5,0.9,0.8,1c0.2,0.1,0.6,0.2,1.2,0.3c0.3,0,0.5,0.2,0.7,0.3c0.2,0.2,0.4,0.3,0.6,0.3
			c0.1-0.2,0.4-0.2,0.6-0.2l0,0c0,0,0,0,0.1,0c0-0.1,0-0.1,0-0.2c0.1,0,0.1,0.1,0.2,0.1c-0.1,0-0.1,0.1-0.2,0.1c0,0,0,0,0,0.1
			c0,0,0,0-0.1,0v0.1c0.2-0.1,0.5-0.2,0.7-0.4C77.4,178.9,76.7,178.2,75.8,177.7z"
        />
        <path
          class="st0"
          d="M279.7,98.9c-0.3,0.1-0.6,0.2-0.9,0.4c-0.6,0.4-0.9,1-0.8,1.6c0.2,0.8,1.2,1.3,2.3,1c1.1-0.3,1.8-1.1,1.5-2
			c-0.1-0.5-0.5-0.8-1.1-1C280.5,98.8,280.1,98.8,279.7,98.9z"
        />
        <path
          class="st0"
          d="M278.8,84.7c1-0.3,1.9-1.2,1.7-2c-0.2-0.7-1.3-1.1-2.4-0.8c-1,0.2-1.9,1.2-1.8,1.8
			C276.5,84.4,277.8,84.9,278.8,84.7z"
        />
        <path
          class="st0"
          d="M282.9,94.9c0.1,0.8,1.1,1.3,2.1,1.1c1.1-0.2,1.8-1,1.7-1.8c-0.1-0.8-1.2-1.4-2.2-1.2
			C283.5,93.3,282.8,94.1,282.9,94.9z"
        />
        <path
          class="st0"
          d="M302.9,127.6c-0.7-0.2-1.4-0.2-2.1,0c-0.2,0-0.4,0-0.6,0c0,0.1,0,0.2,0,0.3c0.2,0.8,1.2,1.3,2.2,1.1
			c0.8-0.2,1.4-0.7,1.5-1.4C303.6,127.6,303.3,127.7,302.9,127.6z"
        />
        <path
          class="st0"
          d="M289.9,90.1c0.4-0.1,0.7-0.2,0.9-0.4c0.2-0.2,0.4-0.4,0.5-0.6c0.1-0.3,0.1-0.5,0-0.8c-0.2-0.7-1.1-1.2-2-1
			s-1.7,1.1-1.6,1.9C287.9,89.9,288.9,90.4,289.9,90.1z"
        />
        <path
          class="st0"
          d="M294.6,84.4c0.6-0.1,1-0.4,1.3-0.7c0.2-0.3,0.4-0.7,0.3-1c-0.1-0.8-1.1-1.3-2.1-1.1l0,0
			c-0.9,0.2-1.7,1.1-1.5,1.9C292.7,84.1,293.6,84.5,294.6,84.4z"
        />
        <path
          class="st0"
          d="M99.8,156.3c-0.8-1.3-0.8-1.3-2.3-1.4c-0.8-0.1-1.3,0.3-1.1,1c0.1,0.4,0.5,0.8,0.4,1c-0.3,0.6,0,1,0.4,1.3
			c0-0.1,0.1-0.1,0.1-0.2c0.2-0.3,0.5-0.4,0.7-0.6c0-0.1-0.1-0.3-0.1-0.4c0.2,0.1,0.4,0.2,0.6,0.2c0.3-0.1,0.6-0.1,0.9,0
			C99.5,157,99.7,156.6,99.8,156.3z"
        />
        <path
          class="st0"
          d="M100.3,133.4c0.3,0,0.5,0,0.8,0c0.5-0.2,1.1-0.4,1.6-0.7c0.1-0.1,0.2-0.1,0.4-0.2c0.1-0.4,0-0.7-0.1-1
			c-0.2-0.4-0.5-0.7-0.9-1c-0.6,0.3-1.1,0.5-1.5,0.7c0.1,0.2,0.1,0.3,0.2,0.5c0,0.2,0,0.4,0,0.7
			C100.6,132.7,100.5,133.1,100.3,133.4z"
        />
        <path
          class="st0"
          d="M37.1,147.3c0.1,0,0.3-0.1,0.4-0.1c0.1-0.3,0.3-0.5,0.6-0.8c0.1,0.1,0.1,0.2,0.2,0.3c0.2-0.3,0.3-0.6,0.3-0.9
			c-0.1-0.7-0.9-1.2-1.7-1.1c-0.9,0.1-1.7,0.9-1.6,1.7C35.4,147,36.3,147.5,37.1,147.3z"
        />
        <path
          class="st0"
          d="M108.8,119.6c1.4,0.1,2.8,0.1,4.3,0c0.7-0.1,1.4-0.1,2.2-0.2c-0.5-0.5-1.1-0.8-1.7-1
			c-0.3-0.1-0.5-0.2-0.8-0.2c-1.1-0.1-2.1,0.1-3.2,0.9C109.3,119.2,109,119.4,108.8,119.6z"
        />
        <path
          class="st0"
          d="M43.4,145.1c1-0.2,1.6-1,1.4-1.7c-0.2-0.6-1.2-1.1-2-0.9c-0.9,0.2-1.4,0.9-1.3,1.7
			C41.7,144.9,42.4,145.3,43.4,145.1z"
        />
        <path
          class="st0"
          d="M208.2,118.9c0.1-0.1,0.2-0.2,0.3-0.3c0.3,0.1,0.5,0.1,0.8,0.2c0-0.5,0.1-1,0.1-1.4c0.2-0.2,0.4-0.3,0.6-0.5
			c-0.2,0-0.4,0-0.6,0c-0.9,0.2-1.5,1-1.3,1.6C208,118.7,208.1,118.8,208.2,118.9z"
        />
        <path
          class="st0"
          d="M108.2,117.1C108.2,117.2,108.2,117.2,108.2,117.1c0.2,0.2,0.4,0.4,0.5,0.6c0.4,0.2,0.9,0.3,1.4,0.2
			c0.8-0.2,1.3-0.9,1.2-1.5c-0.1-0.7-1-1.1-1.9-1c-0.2,0-0.4,0.1-0.6,0.2c-0.5,0.3-0.8,0.9-0.7,1.4
			C108.2,117.1,108.2,117.1,108.2,117.1z"
        />
        <path
          class="st0"
          d="M24.9,176.5c0.1-0.1,0.2-0.2,0.3-0.3c0.1-0.1,0.2-0.2,0.3-0.3c0.2,0.1,0.3,0.2,0.4,0.3s0.1,0.2,0.1,0.3
			c0.5-0.1,0.9-0.4,1.2-1.1c-0.3-0.3-0.5-0.7-0.8-0.9s-0.6-0.3-0.9-0.2c-0.3,0-0.6,0.1-0.9,0.3c-0.5,0.3-0.8,0.6-0.7,1.1
			C24.1,176.1,24.5,176.4,24.9,176.5z M26.3,174.6l0.1,0.1c0,0,0,0,0,0.1c0,0-0.1,0-0.1,0.1c0,0-0.1,0-0.1,0.1
			C26.2,174.8,26.2,174.7,26.3,174.6C26.2,174.6,26.3,174.6,26.3,174.6z"
        />
        <path
          class="st0"
          d="M83.2,179.1c0.6-0.4,0.6-0.8,0.1-1.4c-0.1-0.2-0.3-0.3-0.4-0.4c-0.4-0.4-0.8-0.5-1.4-0.2
			c-0.7,0.3-0.8,0.7-0.7,1.4c0.1,0.2,0.3,0.4,0.5,0.6c0.2,0.2,0.5,0.3,0.8,0.4c0.3-0.2,0.6-0.2,0.9-0.3
			C83.1,179.1,83.1,179.1,83.2,179.1z"
        />
        <path
          class="st0"
          d="M62.7,175.1c0.2-0.3,0.4-0.6,0.3-0.9c0-0.3-0.2-0.5-0.4-0.6c-0.3,0.1-0.5,0.2-0.8,0.3
			c-0.1,0.1-0.3,0.2-0.5,0.3s-0.3,0.3-0.4,0.4c-0.1,0.3-0.2,0.7-0.3,1c0.3,0.1,0.6,0.2,0.9,0.1C62.1,175.6,62.5,175.4,62.7,175.1z"
        />
        <path
          class="st0"
          d="M283.1,86.6c0.7-0.2,1.3-0.8,1.2-1.4c-0.1-0.6-1-1-1.7-0.9c-0.7,0.2-1.2,0.8-1.1,1.4
			C281.5,86.4,282.3,86.8,283.1,86.6z"
        />
        <path
          class="st0"
          d="M305.5,94.6c-2.1,0.3-2.6,1.1-1.8,2.7C305.6,96.7,306,96,305.5,94.6z"
        />
        <path
          class="st0"
          d="M279.4,91.6c0.4-0.7,0-1.2-1.4-1.6c-0.4,0.7-0.7,1.4-1.1,2.1c0,0,0,0,0,0.1c0.2,0.1,0.4,0.1,0.5,0.1
			C278.5,92.5,279.1,92.3,279.4,91.6z"
        />
        <path
          class="st0"
          d="M43.3,148.6c1.4-0.1,2.6-0.3,4-0.4c-0.7-1.2-1.1-1.4-2.2-1.2C44.1,147.2,43.5,147.6,43.3,148.6z"
        />
        <path
          class="st0"
          d="M109.4,129.2c0.7-0.1,1.2-0.7,1.2-1.2c0-0.6-0.8-1-1.5-0.8c-0.7,0.1-1.2,0.7-1.1,1.3
			C108.1,129,108.7,129.3,109.4,129.2z"
        />
        <path
          class="st0"
          d="M294.6,91c-0.6,0.6-0.8,1.3-0.2,2.1l0.1-0.1c0,0,0.1,0,0.1-0.1c0.4-0.4,0.9-0.8,1.3-1.2
			c0.5-0.4,0.9-0.9,1.4-1.3c-0.7-0.1-1.2-0.2-1.6-0.1C295.3,90.5,294.9,90.7,294.6,91z"
        />
        <path
          class="st0"
          d="M305.6,123.2c0.2,0.1,0.4,0.1,0.6,0.1v-2c-0.5,0.1-0.9,0.4-1.1,0.8C304.8,122.6,305.1,123,305.6,123.2z"
        />
        <path
          class="st0"
          d="M105.5,122.5c0.7-0.3,0.8-0.6,0.8-1.3c0-0.1,0-0.2,0-0.3l0,0c-1.2-0.1-2.2,0.2-3.1,1.2
			C103.8,122.8,104.6,122.9,105.5,122.5z"
        />
        <path
          class="st0"
          d="M59.4,164.9c0.4,0.1,0.7,0,1-0.1c0.5-0.3,0.5-0.9,0.1-1.5c-0.1-0.2-0.3-0.3-0.5-0.3c-0.2-0.1-0.4-0.1-0.6,0
			c-0.1,0-0.2,0.1-0.4,0.1c-0.2,0.1-0.3,0.2-0.5,0.3s-0.4,0.3-0.7,0.4c0.2,0.3,0.3,0.4,0.4,0.6C58.6,164.6,59,164.8,59.4,164.9z"
        />
        <path
          class="st0"
          d="M38.1,167.7c0.1,0.3,0.3,0.5,0.6,0.6c0.2-0.6,0.6-1.1,1.2-1.6c0.1-0.1,0.1-0.1,0.2-0.2
			c-0.3-0.2-0.6-0.2-0.9-0.1C38.5,166.6,38,167.2,38.1,167.7z"
        />
        <path
          class="st0"
          d="M236.8,114.8L236.8,114.8c-0.1,0.6-0.4,1.2-0.8,1.7l0,0c0.6-0.1,1.1-0.7,1.1-1.1
			C237,115.1,236.9,114.9,236.8,114.8L236.8,114.8z"
        />
        <path
          class="st0"
          d="M16.3,148.8c0.7-0.1,1.2-0.7,1.1-1.2c-0.1-0.4-0.8-0.8-1.4-0.7c-0.7,0.1-1.2,0.7-1.1,1.3
			C15.1,148.7,15.7,148.9,16.3,148.8z"
        />
        <path
          class="st0"
          d="M87.3,148.7c-0.2-0.2-0.3-0.4-0.4-0.6c-0.1-0.3,0-0.7,0.3-1.1c-0.6,0-1.1,0.1-1.3,0.8
			c0.3,0.3,0.6,0.6,1.1,0.8C87,148.7,87.1,148.7,87.3,148.7z"
        />
        <path
          class="st0"
          d="M296.9,93.7c1.6-0.7,1.8-0.9,1.4-2.4l0,0c-0.7,0.3-1.2,0.6-1.5,0.9C296.5,92.6,296.6,93,296.9,93.7z"
        />
        <path
          class="st0"
          d="M88.7,161.4c0.7-0.2,1.5-0.2,1.8-1c-0.2-0.3-0.4-0.6-0.6-0.8c-0.5,0-0.9,0-1.2,0
			C87.5,160.4,88.1,160.9,88.7,161.4z"
        />
        <path
          class="st0"
          d="M242.3,84.9c0.5-0.1,1.1-0.8,0.9-1.1c-0.2-0.3-0.7-0.5-0.9-0.6c-0.9,0.1-1.2,0.6-1.2,1
			C241.1,84.7,241.7,85,242.3,84.9z"
        />
        <path
          class="st0"
          d="M155.2,131.7c-0.1-0.1-0.1-0.2-0.2-0.3l0,0c-0.1,0.1-0.2,0.2-0.2,0.3C155,131.8,155.1,131.8,155.2,131.7z"
        />
        <path
          class="st0"
          d="M73.2,114.3c-0.2-0.7-0.5-1.4-0.8-2.2c-0.1,1.3-0.2,2.5-0.4,3.8C73.2,115.2,73.4,115,73.2,114.3z"
        />
        <path
          class="st0"
          d="M92.2,159.7c-0.1,0.3,0,0.6,0,0.9c0,0.3-0.1,0.7-0.2,1.1c0.5,0,0.9,0,1.3,0c-0.1,0.2-0.3,0.4-0.5,0.8
			c0.5-0.2,0.8-0.3,1.1-0.4C93.7,161.1,93.1,160.4,92.2,159.7z"
        />
        <path
          class="st0"
          d="M93.9,162.1L93.9,162.1L93.9,162.1C94,162.1,94,162.1,93.9,162.1C94,162,93.9,162.1,93.9,162.1z"
        />
        <path
          class="st0"
          d="M267.1,86.3c0.5-0.2,0.8-0.5,0.7-0.9c-0.1-0.5-0.6-0.8-1.1-0.6c-0.5,0.1-0.9,0.6-0.8,1.1
			C266,86.2,266.5,86.5,267.1,86.3z"
        />
        <path
          class="st0"
          d="M261,73.5c0.6-0.1,0.8-0.5,0.8-0.9s-0.6-0.7-1.2-0.6c-0.5,0.1-0.9,0.7-0.8,1C260.1,73.5,260.5,73.6,261,73.5z
			"
        />
        <path
          class="st0"
          d="M245.5,108.1C245.5,108.1,245.5,108.2,245.5,108.1c0.4,0.2,0.6,0.4,0.6,0.8c0.4-0.3,0.6-0.8,0.8-1.6
			C246.4,107.6,245.9,107.9,245.5,108.1z"
        />
        <path
          class="st0"
          d="M245.3,109c-0.2-0.2-0.2-0.4,0-0.7c-0.3,0.2-0.7,0.4-1,0.6c0.4,0.2,0.8,0.2,1.1,0.3
			C245.3,109.1,245.3,109,245.3,109z"
        />
        <path
          class="st0"
          d="M293.7,97.5c-1.5,0.4-1.7,0.8-1.2,1.9C293.7,98.6,293.7,98.6,293.7,97.5z"
        />
        <path
          class="st0"
          d="M105.8,139.3c0-0.4-0.2-0.6-0.6-0.7c-0.2,0.5-0.6,0.9-1.1,1.2c0.2,0.2,0.5,0.4,0.9,0.3
			C105.5,140,105.8,139.8,105.8,139.3z"
        />
        <path
          class="st0"
          d="M104,155.5c0.2-0.5,0.2-0.9,0.2-1.4c-0.2-0.1-0.5-0.2-0.9-0.3C103.2,154.4,103.3,155,104,155.5z"
        />
        <path
          class="st0"
          d="M69.7,151c0.1,0,0.1-0.1,0.2-0.1c-0.1-0.1-0.2-0.2-0.2-0.3c-0.1-0.3,0-0.7,0.2-1c-0.2,0-0.4,0-0.6,0.1
			c-0.3,0.2-0.5,0.5-0.9,0.9C69,150.7,69.4,151,69.7,151z"
        />
        <path
          class="st0"
          d="M89.7,134.7c0.1,0,0.2,0,0.3,0c-0.2-0.2-0.6-0.3-1-0.2c-0.5,0.1-0.9,0.5-0.7,0.8
			C88.7,135,89.2,134.8,89.7,134.7z"
        />
        <path
          class="st0"
          d="M94.1,160.4c0.6,0.3,1.3,0.5,2,0.7c0.1,0,0.5-0.3,0.5-0.4c-0.1-0.2-0.3-0.4-0.5-0.5c-0.5-0.2-1.1-0.4-1.8-0.6
			C93.9,159.9,93.6,160.2,94.1,160.4z"
        />
        <path
          class="st0"
          d="M88,154c-1-0.3-1.1-1.6-2.7-1.1c0.3,0.5,0.6,1,0.9,1.4C86.9,154.2,87.4,154.1,88,154z"
        />
        <path
          class="st0"
          d="M292.6,129.3c-0.2-0.2-0.5-0.3-0.7-0.5c-0.7,0.3-1,0.6-0.8,0.9C291.6,129.5,292.1,129.4,292.6,129.3z"
        />
        <path
          class="st0"
          d="M34.4,158.3c-0.6-0.6-0.6-1.4-2-1.2C33,158.4,33,158.4,34.4,158.3z"
        />
        <path
          class="st0"
          d="M250.5,83.1c0-0.4-0.3-0.7-0.8-0.5c-0.3,0.1-0.6,0.4-1.1,0.8c0.5,0.2,0.8,0.5,1.2,0.5
			C250.3,83.9,250.6,83.5,250.5,83.1z"
        />
        <path
          class="st0"
          d="M246.8,117.1c0.5,0.1,0.9,0.2,1.2,0.3c0-0.1,0.1-0.1,0.2-0.2c0-0.1,0-0.3,0-0.4c-0.4-0.2-0.7-0.3-0.9-0.2
			C247.1,116.7,247,116.9,246.8,117.1z"
        />
        <path
          class="st0"
          d="M246.8,117.2c-0.1,0.1-0.1,0.2-0.2,0.3c0.1,0.1,0.2,0.1,0.4,0.2C246.9,117.5,246.9,117.4,246.8,117.2z"
        />
        <path
          class="st0"
          d="M246.3,87.5c0.3-0.5,0.5-0.8,0.6-1.1c0-0.4-0.7-0.6-1.1-0.4c-0.3,0.2-0.6,0.6-0.5,0.8
			C245.4,87.2,245.9,87.3,246.3,87.5z"
        />
        <path
          class="st0"
          d="M89.3,156c0.5-0.9,0-1.3-0.3-1.6c-0.1-0.1-0.5-0.1-0.8,0c-0.1,0-0.2,0.4-0.2,0.5
			C88.4,155.2,88.8,155.5,89.3,156z"
        />
        <path
          class="st0"
          d="M81,169.9c0.1,0.1,0.3,0.2,0.4,0.2c0.2,0,0.3,0,0.6-0.1l-0.1-0.1c0.1-0.1,0.1-0.1,0.2-0.2
			c0.1,0,0.1,0.1,0.2,0.1c-0.5-0.5-0.4-1.2-1.4-1.2l0,0c0,0,0,0-0.1,0l0,0C80.3,169.1,81.4,169.4,81,169.9z"
        />
        <path
          class="st0"
          d="M70.6,159c0-0.1-0.6-0.4-0.7-0.4c-0.3,0.2-0.6,0.5-0.7,0.8c0,0.1,0.4,0.3,0.8,0.5
			C70.3,159.6,70.6,159.3,70.6,159z"
        />
        <path
          class="st0"
          d="M242.3,102.6c0.1,0.2,0.5,0.3,0.8,0.4c0.2-0.2,0.5-0.5,0.4-0.7c0-0.2-0.4-0.3-0.8-0.5
			C242.5,102.1,242.2,102.4,242.3,102.6z"
        />
        <path
          class="st0"
          d="M265,75.9c0.2-0.1,0.5-0.5,0.5-0.6c-0.1-0.2-0.5-0.4-1-0.7c-0.2,0.5-0.4,0.9-0.3,1.1
			C264.2,75.9,264.8,76,265,75.9z"
        />
        <path
          class="st0"
          d="M242.5,108.5C242.5,108.5,242.5,108.6,242.5,108.5c0,0.1,0,0.1,0.1,0.1c0.1,0.2,0.4,0.4,0.7,0.7
			c0.3-0.4,0.8-0.7,0.7-0.8c-0.1-0.3-0.5-0.4-0.8-0.6C242.9,108.1,242.5,108.4,242.5,108.5z"
        />
        <path
          class="st0"
          d="M80.1,174.6c-1.1-0.1-1.6,0.2-1.9,0.9C79.1,175.7,79.4,175.2,80.1,174.6z"
        />
        <path
          class="st0"
          d="M275.4,106.6L275.4,106.6c0.2,0,0.3-0.4,0.5-0.6c-0.1,0-0.1-0.1-0.2-0.1c-0.2-0.1-0.4-0.2-0.6-0.2
			c-0.1,0-0.3,0.3-0.6,0.6C274.9,106.5,275.2,106.6,275.4,106.6z"
        />
        <path
          class="st0"
          d="M254.3,85.8c-0.2-0.1-0.5-0.4-0.8-0.4c-0.1,0-0.4,0.3-0.6,0.6c0.3,0.1,0.6,0.3,0.8,0.3
			C254,86.3,254.1,86,254.3,85.8z"
        />
        <path
          class="st0"
          d="M43.3,161L43.3,161c0.2,0.1,0.5,0.1,0.9,0.1c-0.5-0.4-0.4-1-1.2-1.2c0.1,0.1,0.2,0.3,0.2,0.5
			C43.3,160.5,43.3,160.7,43.3,161C43.3,160.9,43.3,160.9,43.3,161z"
        />
        <path
          class="st0"
          d="M62.4,156.7c0.3-0.2,0.5-0.4,0.9-0.7c-0.7,0-1.3,0-1.8,0c-0.1,0-0.3,0-0.4,0c0.2,0.1,0.3,0.2,0.5,0.3
			C61.8,156.4,62.1,156.6,62.4,156.7z"
        />
        <path
          class="st0"
          d="M115.2,112.9L115.2,112.9L115.2,112.9c0,0.5,0.3,0.8,0.9,1c0.1-0.7-0.2-1.1-1-1.6
			C115.1,112.5,115.1,112.6,115.2,112.9C115.1,112.9,115.2,112.9,115.2,112.9z"
        />
        <path
          class="st0"
          d="M109.7,145.8c-0.1-0.1-0.3-0.1-0.4-0.2c-0.2,0.2-0.5,0.5-0.6,0.7c0,0.1,0.3,0.3,0.6,0.5
			c0.2-0.3,0.5-0.6,0.5-0.8C109.8,146,109.8,146,109.7,145.8C109.8,145.9,109.8,145.9,109.7,145.8
			C109.8,145.8,109.8,145.8,109.7,145.8C109.7,145.8,109.7,145.8,109.7,145.8C109.7,146,109.7,145.9,109.7,145.8
			C109.6,145.9,109.6,145.8,109.7,145.8z"
        />
        <path
          class="st0"
          d="M239.8,105.7c-0.2-0.1-0.5-0.3-0.7-0.3s-0.4,0.3-0.7,0.6c0.3,0.2,0.7,0.4,0.8,0.4
			C239.4,106.2,239.6,105.9,239.8,105.7z"
        />
        <path
          class="st0"
          d="M32.5,163.2c0.2,0.2,0.5,0.3,0.7,0.5c0.2-0.2,0.5-0.4,0.4-0.4c-0.2-0.2-0.4-0.4-0.8-0.6
			C32.7,162.9,32.4,163.2,32.5,163.2z"
        />
        <path
          class="st0"
          d="M70.3,173.2c0.1-0.7-0.3-1-1.2-1.2C69.3,172.7,69.4,173.2,70.3,173.2z"
        />
        <path
          class="st0"
          d="M15.4,192.6c0.1-0.4,0.1-0.7,0.2-1c-0.3,0.1-0.7,0-0.9,0.2C14.3,192.3,14.8,192.4,15.4,192.6z"
        />
        <path
          class="st0"
          d="M86.8,158.7c-0.1,0.1-0.2,0.2-0.3,0.3c0,0.1,0.1,0.1,0.2,0.2c0.3,0.3,0.7,0.5,1.4,0.2
			c-0.2-0.1-0.3-0.2-0.5-0.3C87.3,159,87.1,158.8,86.8,158.7z M87.9,159.4L87.9,159.4L87.9,159.4L87.9,159.4z"
        />
        <path
          class="st0"
          d="M274.5,96.6c-0.2,0.5-0.4,0.9-0.7,1.6C274.9,97.4,274.9,97.4,274.5,96.6z"
        />
        <path
          class="st0"
          d="M290.1,129.9C290.1,129.9,290,129.9,290.1,129.9c-0.1,0.2,0,0.4,0,0.6c0.2-0.1,0.4-0.3,0.5-0.4
			C290.5,129.9,290.3,129.9,290.1,129.9z"
        />
        <path
          class="st0"
          d="M246.3,105.2c0.1,0.2,0.5,0.3,0.7,0.3s0.4-0.4,0.4-0.5c0-0.2-0.4-0.3-0.7-0.4
			C246.5,104.8,246.3,105,246.3,105.2z"
        />
        <path
          class="st0"
          d="M292.2,111.3c-0.8,0.2-0.9,0.5-0.6,1.2C292.2,112.1,292.5,111.8,292.2,111.3z"
        />
        <path
          class="st0"
          d="M138.5,153.4c0.3-0.5,0.5-0.8,0.7-1.2c-0.6,0.2-1,0.4-0.8,1.1C138.4,153.4,138.5,153.4,138.5,153.4z"
        />
        <path
          class="st0"
          d="M4.2,186.6c0.1,0,0.1,0.1,0.3,0.1c0-0.4,0-0.5-0.2-0.6C4.2,186.3,4.2,186.4,4.2,186.6z"
        />
        <path
          class="st0"
          d="M10,151c0-0.3,0-0.6,0.1-0.9c-0.1,0-0.2,0-0.4,0c0,0.4-0.1,0.9-0.1,1.3l0,0c0.1,0,0.3,0,0.4,0
			C9.9,151.3,9.9,151.1,10,151z"
        />
        <path
          class="st0"
          d="M276.6,113.4c0.2-0.1,0.3-0.2,0.5-0.3c-0.1-0.1-0.3-0.2-0.5-0.4c-0.1,0.3-0.3,0.4-0.3,0.6
			C276.2,113.3,276.5,113.5,276.6,113.4z"
        />
        <path
          class="st0"
          d="M290.5,96.3c-0.3,0.3-0.7,0.6-1,0.9c0.1,0.1,0.1,0.1,0.2,0.2c0.3-0.3,0.7-0.6,1-0.9
			C290.6,96.4,290.5,96.4,290.5,96.3z"
        />
        <path
          class="st0"
          d="M66.9,177l0.1-0.1c-0.2-0.1-0.3-0.1-0.5-0.2C66.6,176.8,66.8,177,66.9,177z"
        />
        <path
          class="st0"
          d="M32.1,177.9c-0.2-0.3-0.3-0.5-0.5-0.7c0.1,0.4,0.3,0.7-0.4,0.9c0.2,0,0.4,0,0.6,0C32,178.1,32,178,32.1,177.9
			z"
        />
        <path
          class="st0"
          d="M243,114.2c-0.2,0.1-0.4,0.3-0.4,0.5c0,0.1,0.4,0.3,0.5,0.2c0.2-0.1,0.3-0.3,0.5-0.5
			C243.3,114.3,243.1,114.1,243,114.2z"
        />
        <path
          class="st0"
          d="M254.8,111.2c0.3-0.7,0.3-0.7-0.7-0.7C254.4,110.8,254.6,111,254.8,111.2z"
        />
        <path
          class="st0"
          d="M12.6,189.6c0.1,0.1,0.2,0.2,0.4,0.3c0.2-0.4,0.4-0.7,0.6-1C12.9,189,12.6,189.2,12.6,189.6z"
        />
        <path
          class="st0"
          d="M13.5,188.9L13.5,188.9C13.6,188.8,13.5,188.8,13.5,188.9C13.5,188.8,13.5,188.8,13.5,188.9
			C13.5,188.8,13.5,188.9,13.5,188.9z"
        />
        <path
          class="st0"
          d="M228.8,140.8c0,0.1,0.2,0.2,0.4,0.2c0.1-0.1,0.3-0.3,0.3-0.4c0,0-0.3-0.1-0.4-0.2
			C229,140.6,228.8,140.7,228.8,140.8z"
        />
        <path
          class="st0"
          d="M13.9,168.8c0.1-0.1,0.2-0.3,0.2-0.4c-0.2,0-0.3,0-0.5,0c-0.1,0.1-0.2,0.2-0.3,0.4
			C13.6,168.8,13.9,168.8,13.9,168.8z"
        />
        <path
          class="st0"
          d="M239.1,100.1c0,0,0.3-0.2,0.3-0.3c0-0.1-0.2-0.3-0.4-0.5c-0.2,0.3-0.4,0.5-0.4,0.6
			C238.6,99.9,238.9,100,239.1,100.1z"
        />
        <path
          class="st0"
          d="M250.5,89c-0.3,0-0.5,0-0.8,0c0.2,0.1,0.5,0.2,0.8,0.4C250.5,89.1,250.5,89,250.5,89z"
        />
        <path
          class="st0"
          d="M68.8,176.1c-0.1-0.1-0.1-0.1-0.2-0.2c-0.2,0.1-0.4,0.3-0.6,0.4l-0.1,0.1c0.1,0.1,0.1,0.1,0.2,0.2
			C68.3,176.5,68.6,176.3,68.8,176.1z"
        />
        <path
          class="st0"
          d="M18.6,152.5c-0.2-0.1-0.3-0.3-0.5-0.2c-0.2,0-0.3,0.2-0.5,0.5c0.3,0.1,0.4,0.2,0.5,0.1
			C18.3,152.8,18.5,152.7,18.6,152.5z"
        />
        <path
          class="st0"
          d="M22.1,161.6c0.1-0.2,0.2-0.3,0.3-0.5c0-0.1-0.2-0.1-0.4-0.3c-0.1,0.2-0.2,0.4-0.2,0.6
			C21.7,161.5,22,161.5,22.1,161.6z"
        />
        <path
          class="st0"
          d="M16.3,194.9L16.3,194.9c0.1-0.1,0.1-0.1,0.1-0.1C16.4,194.8,16.3,194.8,16.3,194.9
			C16.3,194.8,16.3,194.9,16.3,194.9z"
        />
        <path
          class="st0"
          d="M295.8,103.3c-0.1,0-0.2,0.1-0.4,0.1c0.2,0.3,0.3,0.5,0.5,0.8c0.1,0,0.1-0.1,0.2-0.1
			C296.1,103.9,295.9,103.6,295.8,103.3z"
        />
        <path
          class="st0"
          d="M238,116.9c0.1,0,0.2,0,0.3-0.1c-0.1-0.2-0.1-0.4-0.2-0.6c-0.1,0-0.2,0-0.3,0.1
			C237.9,116.5,237.9,116.7,238,116.9z"
        />
        <path
          class="st0"
          d="M91.2,162.7c0,0.1,0.2,0.1,0.2,0.1c0.1-0.1,0.3-0.2,0.3-0.3s-0.2-0.1-0.4-0.3
			C91.3,162.5,91.2,162.6,91.2,162.7z"
        />
        <path
          class="st0"
          d="M120.3,104L120.3,104C120.3,103.9,120.2,103.9,120.3,104C120.2,103.9,120.2,104,120.3,104L120.3,104z"
        />
        <path
          class="st0"
          d="M120.8,104.6c-0.2-0.2-0.4-0.4-0.5-0.6C120.3,104.3,120,104.6,120.8,104.6z"
        />
        <path
          class="st0"
          d="M228.9,131.9c0-0.1-0.2-0.1-0.4-0.1l-0.2,0.2c0.1,0.1,0.2,0.2,0.3,0.3C228.8,132.1,228.9,132,228.9,131.9z"
        />
        <path
          class="st0"
          d="M92.7,120.6c-0.2-0.1-0.4-0.1-0.6-0.2c0,0.1-0.1,0.2-0.1,0.2C92.2,120.6,92.4,120.7,92.7,120.6
			C92.6,120.8,92.7,120.7,92.7,120.6z"
        />
        <path
          class="st0"
          d="M0,185.3v0.2c0-0.1,0.1-0.1,0.1-0.2C0.1,185.4,0,185.3,0,185.3z"
        />
        <path
          class="st0"
          d="M138,149.8c-0.1-0.1-0.2-0.2-0.3-0.2c-0.1,0.1-0.2,0.2-0.3,0.3C137.6,149.8,137.8,149.8,138,149.8L138,149.8z
			"
        />
        <path
          class="st0"
          d="M290.9,122.5c0,0.1,0,0.2-0.1,0.2c0.1,0,0.2,0,0.3,0c0-0.1,0.1-0.2,0.1-0.3
			C291.1,122.5,291,122.5,290.9,122.5z"
        />
        <path
          class="st0"
          d="M76.9,172.4c-0.1,0.1-0.3,0.2-0.4,0.3c0.2,0,0.4,0,0.7,0C77,172.5,76.9,172.3,76.9,172.4z"
        />
        <path
          class="st0"
          d="M83,143.6l-0.1-0.1c-0.1,0-0.2,0.1-0.3,0.1c0.1,0.1,0.1,0.1,0.2,0.2C82.9,143.7,82.9,143.7,83,143.6z"
        />
        <path
          class="st0"
          d="M30.4,177.3c-0.1,0-0.1,0.1-0.2,0.1c0.1,0.1,0.2,0.2,0.3,0.4C30.5,177.6,30.4,177.5,30.4,177.3z"
        />
        <path
          class="st0"
          d="M262.7,121.5c0-0.1,0-0.3,0.1-0.4c-0.1,0.1-0.2,0.2-0.3,0.3C262.6,121.4,262.7,121.4,262.7,121.5z"
        />
        <path
          class="st0"
          d="M262.8,121.1C262.8,121,262.9,121,262.8,121.1c0.1-0.1,0.1-0.1,0.1-0.1L262.8,121.1
			C262.8,121,262.8,121,262.8,121.1z"
        />
        <path
          class="st0"
          d="M191.9,100c0.1,0,0.2-0.1,0.2-0.1c-0.1-0.1-0.1-0.2-0.2-0.2c-0.1,0-0.2,0.1-0.3,0.1
			C191.8,99.9,191.8,100,191.9,100z"
        />
        <path
          class="st0"
          d="M90.8,162c0.1,0,0.2,0.1,0.3,0.1c0.1,0,0.2-0.1,0.2-0.2c-0.1,0-0.2-0.1-0.4-0.1
			C90.9,161.8,90.8,161.9,90.8,162z"
        />
        <path
          class="st0"
          d="M28.9,177.2c0.1-0.1,0.2-0.1,0.2-0.2c0-0.1-0.1-0.2-0.1-0.2c-0.1,0.1-0.1,0.1-0.2,0.2
			C28.9,177.1,28.9,177.2,28.9,177.2z"
        />
        <path
          class="st0"
          d="M16.8,194.3c-0.1,0-0.2-0.1-0.3-0.1c0,0.2-0.1,0.3-0.1,0.5C16.5,194.6,16.7,194.5,16.8,194.3z"
        />
        <path
          class="st0"
          d="M69.8,178.8c0-0.1-0.1-0.2-0.2-0.3c-0.1,0.1-0.2,0.1-0.2,0.2c0.1,0.1,0.1,0.2,0.2,0.2
			C69.6,178.9,69.8,178.8,69.8,178.8z"
        />
        <path
          class="st0"
          d="M258.7,113.3c0.1-0.1,0.2-0.2,0.3-0.3c-0.1,0-0.2-0.1-0.3-0.1c-0.1,0-0.2,0.2-0.3,0.2
			C258.6,113.1,258.7,113.2,258.7,113.3z"
        />
        <path
          class="st0"
          d="M23.5,177.8c0.1,0,0.1-0.2,0.1-0.2c-0.1,0-0.2,0-0.2,0c-0.1,0.1-0.1,0.2-0.1,0.2S23.4,177.9,23.5,177.8z"
        />
        <path
          class="st0"
          d="M29.8,176.3c-0.1-0.1-0.2-0.2-0.2-0.2c-0.1,0.1-0.2,0.1-0.2,0.2c0.1,0.1,0.1,0.2,0.2,0.2
			C29.6,176.4,29.7,176.3,29.8,176.3z"
        />
        <path
          class="st0"
          d="M27.9,151.7c-0.1,0-0.2,0-0.3,0c-0.1,0.1-0.1,0.2-0.2,0.3c0.1,0,0.2,0.1,0.3,0.1
			C27.8,151.9,27.9,151.8,27.9,151.7z"
        />
        <path
          class="st0"
          d="M264.8,69.2c-0.1,0-0.2-0.1-0.4-0.1c0,0.1-0.1,0.2-0.1,0.3l0.2,0.1C264.6,69.4,264.7,69.3,264.8,69.2z"
        />
        <path
          class="st0"
          d="M72.5,167.1c-0.1,0.1-0.1,0.2-0.2,0.2c0.1,0,0.2-0.1,0.4-0.1C72.6,167.2,72.5,167.1,72.5,167.1z"
        />
        <path
          class="st0"
          d="M72.3,167.3C72.2,167.3,72.2,167.4,72.3,167.3C72.2,167.4,72.2,167.4,72.3,167.3
			C72.2,167.4,72.2,167.4,72.3,167.3C72.2,167.4,72.2,167.4,72.3,167.3z"
        />
        <path
          class="st0"
          d="M240.4,75.8l-0.1-0.1c0,0-0.1,0-0.1,0.1v0.1C240.3,75.9,240.3,75.9,240.4,75.8z"
        />
        <path
          class="st0"
          d="M281.7,121.9c-0.1,0-0.2,0-0.2,0v0.1c0.1,0,0.1,0.1,0.2,0.1C281.7,122.1,281.7,122,281.7,121.9z"
        />
        <path
          class="st0"
          d="M120.1,103.5c-0.1,0.1-0.1,0.1-0.2,0.2c0.1,0.1,0.2,0.1,0.3,0.2C120.2,103.8,120.1,103.7,120.1,103.5z"
        />
        <path
          class="st0"
          d="M117.4,124.6c0-0.1-0.1-0.2-0.1-0.2c-0.1,0-0.1,0.1-0.2,0.1C117.2,124.6,117.2,124.6,117.4,124.6
			C117.3,124.6,117.4,124.6,117.4,124.6z"
        />
        <path
          class="st0"
          d="M95.7,157.6c-0.1,0-0.1,0-0.2,0C95.5,157.6,95.5,157.6,95.7,157.6C95.7,157.7,95.7,157.6,95.7,157.6z"
        />
        <path
          class="st0"
          d="M140.2,147.7c-0.1,0-0.2-0.1-0.2-0.1c-0.1,0-0.1,0.1-0.2,0.2C139.9,147.8,140,147.8,140.2,147.7
			C140.2,147.8,140.2,147.7,140.2,147.7z"
        />
        <path
          class="st0"
          d="M95.7,156.4c0-0.1,0-0.3,0-0.4l0,0l0,0c-0.1,0-0.1,0-0.2,0C95.5,156.1,95.6,156.3,95.7,156.4
			C95.5,156.5,95.6,156.5,95.7,156.4C95.6,156.5,95.6,156.4,95.7,156.4L95.7,156.4z"
        />
        <path
          class="st0"
          d="M85.4,157.9c0-0.1-0.2-0.1-0.2-0.1c0,0.1-0.1,0.2-0.1,0.3l0.2,0.1C85.4,158.1,85.4,158,85.4,157.9z"
        />
        <path
          class="st0"
          d="M91.5,154.8c0,0,0-0.1-0.1-0.1c0,0,0,0-0.1,0.1C91.4,154.8,91.4,154.9,91.5,154.8
			C91.4,154.9,91.5,154.9,91.5,154.8z"
        />
        <path
          class="st0"
          d="M0.5,174.4c0,0-0.1-0.1-0.2-0.1c0,0.1-0.1,0.2-0.1,0.2l0.1,0.1C0.4,174.5,0.5,174.5,0.5,174.4z"
        />
        <path
          class="st0"
          d="M81.2,171c-0.1,0-0.2,0-0.3,0l-0.1,0.1c0.1,0,0.2,0,0.3,0C81.1,171.1,81.1,171.1,81.2,171z"
        />
        <path
          class="st0"
          d="M296.3,124.2l-0.1-0.1l-0.1,0.1c0,0.1,0.1,0.1,0.1,0.2C296.2,124.3,296.3,124.3,296.3,124.2z"
        />
        <path
          class="st0"
          d="M105.2,150.1c0,0,0.1,0.1,0.2,0.1c0-0.1,0-0.2,0-0.2C105.3,150,105.2,150,105.2,150.1
			C105.2,150,105.2,150,105.2,150.1z"
        />
        <path
          class="st0"
          d="M78.2,180.3l0.1-0.1c0,0,0-0.1-0.1-0.1c0,0,0,0.1-0.1,0.1C78.2,180.3,78.2,180.3,78.2,180.3z"
        />
        <path
          class="st0"
          d="M83.4,144.3c-0.1,0-0.2,0-0.3,0l-0.1,0.1c0.1,0,0.2,0,0.3,0C83.4,144.4,83.4,144.3,83.4,144.3z"
        />
        <path
          class="st0"
          d="M99,151v0.1h0.1C99.1,151.1,99.1,151,99,151C99.1,151,99,151,99,151z"
        />
        <path
          class="st0"
          d="M9.7,170.3L9.7,170.3c-0.1,0.1-0.1,0.1,0,0.2C9.7,170.4,9.7,170.3,9.7,170.3z"
        />
        <path
          class="st0"
          d="M98.5,150.4c0.1,0,0.2,0,0.3,0c-0.1,0-0.1,0-0.2,0C98.6,150.3,98.5,150.4,98.5,150.4z"
        />
        <path
          class="st0"
          d="M270.7,111.9l-0.1-0.1c-0.1,0-0.2,0.1-0.3,0.1c0.1,0,0.2,0,0.3,0C270.6,112,270.6,111.9,270.7,111.9z"
        />
        <path
          class="st0"
          d="M69.9,180.5c0-0.1,0-0.1,0-0.2c-0.1,0.1-0.3,0.1-0.7,0.3C69.6,180.5,69.7,180.5,69.9,180.5z"
        />
        <path
          class="st0"
          d="M1,189.3H0.9c-0.1,0.1-0.2,0.1-0.1,0.2c0,0,0.1,0.1,0.2,0.1C1,189.4,1,189.4,1,189.3z"
        />
        <path
          class="st0"
          d="M78.2,177.7L78.2,177.7c-0.2-0.1-0.4-0.1-0.6,0c0,0.1,0,0.1,0,0.2C77.8,177.8,78,177.8,78.2,177.7z"
        />
        <path
          class="st0"
          d="M60.4,155.4c-0.1,0-0.1,0.1-0.2,0.1c0.1,0,0.2,0.1,0.3,0.1C60.4,155.6,60.4,155.5,60.4,155.4z"
        />
        <path
          class="st0"
          d="M276.3,136.9c0,0,0.1,0,0.1,0.1c0-0.1,0.1-0.1,0.1-0.2h-0.1C276.3,136.8,276.3,136.8,276.3,136.9z"
        />
        <polygon class="st0" points="75.5,172.5 75.3,172.6 75.5,172.6 		" />
        <path
          class="st0"
          d="M231.5,138.2c-0.1,0-0.2,0-0.3,0C231.3,138.3,231.4,138.3,231.5,138.2C231.5,138.3,231.5,138.3,231.5,138.2z"
        />
        <polygon class="st0" points="30.5,180.5 30.6,180.5 30.6,180.4 		" />
        <path
          class="st0"
          d="M80.5,168.5c0.1,0,0.2,0,0.3,0c0-0.1-0.1-0.1-0.1-0.2C80.6,168.4,80.6,168.4,80.5,168.5z"
        />
        <path
          class="st0"
          d="M275.5,125.4C275.5,125.3,275.5,125.3,275.5,125.4h-0.1C275.4,125.3,275.4,125.4,275.5,125.4z"
        />
        <path
          class="st0"
          d="M31,178.1c0.1,0,0.2,0,0.3,0C31.2,178.1,31.1,178.1,31,178.1c-0.1-0.1-0.3-0.2-0.4-0.3l-0.1-0.1
			c0,0.1,0,0.1,0.1,0.2C30.7,178,30.9,178.1,31,178.1z"
        />
        <polygon class="st0" points="279.1,123.3 279.2,123.3 279.1,123.2 		" />
        <path
          class="st0"
          d="M31.2,176.8h-0.1C31.1,176.8,31.1,176.9,31.2,176.8c0.1,0.1,0.2,0.2,0.4,0.3c0,0,0,0.1,0.1,0.1
			c0-0.1,0-0.1,0-0.2C31.5,177,31.3,176.9,31.2,176.8z"
        />
        <path
          class="st0"
          d="M80.9,165.9l-0.1,0.1c0.1,0,0.2-0.1,0.3-0.1C81,165.9,80.9,165.9,80.9,165.9z"
        />
        <path
          class="st0"
          d="M72.2,167.4c-0.1,0-0.1,0.1-0.2,0.1c0,0,0,0,0.1,0h0.1C72.2,167.5,72.2,167.5,72.2,167.4z"
        />
        <polygon class="st0" points="236.2,127.6 236.3,127.5 236.2,127.5 		" />
        <polygon class="st0" points="139.6,146.9 139.6,147 139.7,146.9 		" />
        <path
          class="st0"
          d="M85.6,158.6c0.1,0,0.2-0.1,0.3-0.1l-0.1-0.1C85.7,158.5,85.7,158.6,85.6,158.6z"
        />
        <path
          class="st0"
          d="M29.5,168l-0.1-0.1l-0.1,0.1l0.1,0.1C29.5,168.1,29.5,168.1,29.5,168z"
        />
        <polygon class="st0" points="251.6,119 251.5,119.1 251.6,119.1 		" />
        <path
          class="st0"
          d="M29,167.3l-0.1-0.1l-0.1,0.1l0.1,0.1C28.9,167.4,29,167.3,29,167.3z"
        />
        <path class="st0" d="M8.5,171.7l-0.1,0.1L8.5,171.7z" />
        <polygon class="st0" points="83.8,154.8 83.7,154.7 83.7,154.8 		" />
        <path
          class="st0"
          d="M60.9,156L60.9,156C61.1,156,61,155.9,60.9,156c-0.1-0.1-0.3-0.2-0.4-0.3c0,0,0,0-0.1,0v0.1
			C60.7,155.8,60.8,155.9,60.9,156z"
        />
        <path
          class="st0"
          d="M43.7,150.8c-0.1,0-0.2-0.1-0.2-0.1h-0.1c0,0,0,0,0,0.1C43.5,150.8,43.6,150.8,43.7,150.8z"
        />
        <path
          class="st0"
          d="M277.4,99.6l0.1,0.1l0.1-0.1C277.5,99.6,277.5,99.6,277.4,99.6L277.4,99.6z"
        />
        <path
          class="st0"
          d="M96.7,135.8L96.7,135.8C96.6,135.9,96.7,135.9,96.7,135.8C96.7,135.9,96.7,135.9,96.7,135.8L96.7,135.8z"
        />
        <path
          class="st0"
          d="M24.9,145.5C24.8,145.5,24.8,145.5,24.9,145.5C24.8,145.6,24.8,145.5,24.9,145.5L24.9,145.5z"
        />
        <path
          class="st0"
          d="M118.1,118.8L118.1,118.8h-0.2C117.9,118.8,117.9,118.9,118.1,118.8C118,118.9,118,118.8,118.1,118.8z"
        />
        <path
          class="st0"
          d="M92.4,121.3L92.4,121.3h0.2H92.4C92.5,121.2,92.5,121.2,92.4,121.3z"
        />
        <path class="st0" d="M271.7,79.7l-0.1,0.1L271.7,79.7z" />
        <polygon class="st0" points="128.1,101.8 128,101.8 128,101.9 		" />
        <path
          class="st0"
          d="M93.3,165.3c-0.1,0.1-0.1,0.2-0.2,0.2l0,0l0,0C93.2,165.5,93.3,165.4,93.3,165.3z"
        />
        <path
          class="st0"
          d="M262.4,283.1c-0.6-0.6-1.4-0.6-2.3-0.4c-1.9,0.5-3.2,2-3.1,3.5c0,0.4,0.2,0.8,0.3,1.3
			c-3.2-0.2-5.1,0.5-6.1,2.2c-0.9,1.5-0.5,3.2,0.9,4.1s3.5,1,5.1,0.1c2.1-1.1,2.7-2.6,1.9-5.2c0.7,0,1.2,0.1,1.7,0
			c1.9-0.2,3.3-1.2,3.8-2.6c0.2-0.6,0.2-1-0.4-1.5C263.6,284.2,263,283.7,262.4,283.1z"
        />
        <path
          class="st0"
          d="M198.8,291.3c-0.8,0.3-1.6,0.5-2.4,0.9c-1.1,0.6-0.6,1.5-0.9,2.4c-1.6-0.1-2.7-0.8-4-1.2
			c-0.1,0-0.1-0.4-0.1-0.7c0.8,0.3,1.4,0.5,2.3,0.8c-0.5-1.4-0.9-2.6-1.3-3.8c1.7-0.3,2.6-1,2.4-2c-0.2-0.8-1.2-1.3-2.2-1
			c-1.2,0.3-1.7,1.2-1.4,2.8c-1-0.1-2-0.1-3.2-0.2c1,1.1,1,1.1,0.6,2.3c-1.8-0.5-3.6-1-5.6-1.6c0,0.4-0.1,0.5,0,0.6
			c0.4,0.9,1.2,1.6,1.1,2.7c-0.1,0.9,1.3,1.3,2.4,0.8c0.8-0.5,1.5-0.4,2.3-0.3c2,0.3,3.6,1.2,5.5,2c-0.6,0.2-0.9,0.3-1.7,0.5
			c1.8,0.3,3.1,0.6,4.5,0.7c0.7,0.1,1.3-0.4,1.3-1.2c0-0.5,0.4-0.6,0.7-0.8c1.3-0.9,1.5-1.8,0.6-2.9
			C199.5,291.8,199.2,291.6,198.8,291.3z"
        />
        <path
          class="st0"
          d="M237.1,304.6c-0.4-1.9-2.4-2.9-4.8-2.4c-2.4,0.5-3.9,2.3-3.6,4.1c0.3,1.8,2.6,3,4.8,2.5
			C236.1,308.2,237.5,306.3,237.1,304.6z"
        />
        <path
          class="st0"
          d="M126.8,317.2c-0.8-0.8-1.5-1.8-3.1-1.9c-0.2,0-0.4-0.2-0.5-0.3c0-0.8,0.3-1.3,1.1-1.7
			c1.2-0.8,1.3-1.9,0.4-2.7c-0.8-0.6-1.9-0.6-2.8,0.2c-0.9,0.8-0.9,1.7-0.1,2.2c0.4,0.3,0.8,0.5,1.3,0.8c-0.4,1-1,1.7-1.9,2.3
			c-0.4,0.3-0.8,0.7-1.1,1.1c-0.6,0.7-0.6,1.9,0,2.3c0.6,0.5,1.4,0.9,2.1,1.2c1,0.4,2.1,0.3,3.2-0.1
			C126.8,320,127.7,318.1,126.8,317.2z"
        />
        <path
          class="st0"
          d="M139.2,316.9c-0.4-0.7-0.3-1.4-0.1-2.1c0.1-0.2,0-0.5-0.1-1c-0.3,0.7-0.4,1.1-0.6,1.6
			c-0.9-1.1,0.2-2.3-0.3-3.3c-0.3,0.2-0.5,0.4-0.7,0.6c-0.2-0.4-0.2-0.9-0.5-1.1c-1-0.6-1.7-1.3-1.3-2.5c0-0.2-0.5-0.4-0.8-0.6
			c-0.2,0.3-0.6,0.6-0.6,0.8c0,0.3,0.2,0.7,0.4,1c-0.1,0.1-0.2,0.2-0.3,0.2c-0.1-0.1-0.2-0.2-0.3-0.3c-0.8-1.3-1.6-2.5-2.5-3.7
			c-0.4-0.5-0.6-1-0.1-1.6c0.5-0.7,0-1.2-0.4-1.7s-0.9-0.9-1.9-0.6c-0.1,0.4-0.2,0.8-0.4,1.2c-0.2,0-0.4,0-0.8,0c0,0.4-0.2,0.7,0,1
			c0.4,0.8,0.3,1.9,1.5,2.2c0.2,0.8,0.8,1.3,1.7,1.7c0.1,0-0.1,0.3-0.1,0.4c0.9,0.3,1.1,1,1.5,1.6c0.2,0.2,0.5,0.5,0.8,0.5
			c1.2,0.2,2.1,0.8,2.4,1.6c0.2,0.6,0.6,1.2,0.8,1.9c0.1,0.3,0.4,0.5,0.3,0.8c-0.4,1.5,0.8,2.2,1.7,3.1
			C139.3,318,139.6,317.4,139.2,316.9z M128.9,303.9c0.5,0.4,0.6,0.9,0.8,1.4C129.1,304.9,129.1,304.8,128.9,303.9z"
        />
        <path
          class="st0"
          d="M231.6,299.8c-0.1-0.1-0.1-0.2-0.1-0.3c0-0.1,0-0.1,0.1-0.2c0-0.1,0-0.2-0.1-0.4c-0.6-1.5-2.4-2.3-4.3-1.9
			c-0.1,0-0.3,0.1-0.4,0.1c-0.1,0.1-0.1,0.3-0.2,0.4c-0.4,0.5-0.8,1-1.6,0.9l0,0l-0.1,0.1v-0.1l0,0c0,0-0.1,0-0.1-0.1
			c-0.6,0.7-0.9,1.6-0.9,2.7c-0.3,0.1-0.6,0.3-0.9,0.4c0,0.1,0.1,0.1,0.1,0.2c0.3,0,0.7-0.1,1-0.1c1.7,1.6,3.4,2,5.3,1
			C230.8,302,231.6,300.9,231.6,299.8z"
        />
        <path
          class="st0"
          d="M255.6,284.5c2.1-0.5,3.4-2,3.1-3.7c-0.3-1.6-2.2-2.6-4.3-2.2c-0.9,0.2-1.7,0.6-2.3,1.2
			c0.1,0.4,0.1,0.8-0.1,1.2c-0.1,0.2-0.3,0.5-0.5,0.6c-0.1,0.1-0.2,0.1-0.3,0.2c0,0.2,0,0.3,0,0.5c0.1,0.3,0.2,0.6,0.4,0.9
			c0.1-0.1,0.2-0.1,0.3-0.1c0.3-0.1,0.7,0.2,1.3,0.5c-0.2,0.2-0.4,0.5-0.6,0.6C253.4,284.6,254.5,284.8,255.6,284.5z"
        />
        <path
          class="st0"
          d="M93.1,290.3c-0.1,0-0.3,0-0.4,0c-0.1,0.1-0.2,0.2-0.2,0.3c-0.4,0.6-1.1,1.1-1.5,1.5c-0.7,0-1.2-0.2-1.6-0.4
			c-0.6,0.9-0.7,1.9-0.7,2.8c0.5,0.4,1,0.7,1.5,1c1.1,0.6,2.6,0.5,3.7-0.2c0-0.8-0.1-1.5,0-2.2c0-0.4,0.3-1,0.7-1.2
			c0.2-0.1,0.3-0.3,0.5-0.4C94.6,290.8,94,290.5,93.1,290.3z M89.6,292.7c-0.1-0.1-0.1-0.1-0.1-0.2s0.1-0.1,0.2-0.2
			c0.1,0.1,0.1,0.1,0.2,0.2C89.7,292.6,89.6,292.6,89.6,292.7z M89.9,294.9L89.9,294.9c0.1,0,0.2,0,0.3,0
			C90.1,294.9,90,294.9,89.9,294.9z M92.3,292.7c-0.2-0.1-0.5-0.2-0.4-0.2c0-0.2,0.2-0.3,0.3-0.5c0.1,0.1,0.4,0.1,0.4,0.3
			C92.6,292.3,92.4,292.5,92.3,292.7z"
        />
        <path
          class="st0"
          d="M222.5,302.5c-0.2,0.2-0.4,0.3-0.6,0.4c-0.7,0.3-1.3,0.6-2.3,1.1c-0.5-0.3-0.8-0.6-1-1.1
			c-1.1,0.8-2,1.9-2.1,2.6c0,0.7,0.4,1.2,1.2,1.4c0.7,0.2,1.5,0.3,2.3,0.4c1.3,0.1,2.4-0.4,3.2-1.4s0.8-2.1,0-2.9
			C223.1,302.9,222.8,302.7,222.5,302.5z"
        />
        <path
          class="st0"
          d="M21.6,317.7c0.8-0.3,1.5-0.7,1.9-1.4c0.1-0.2,0.2-0.4,0.3-0.6c0.1-0.3,0.1-0.6,0.1-0.9l0,0
			c-0.1-1.1-1-2-2.5-2.2c-1.6-0.3-3.9,1-4.1,2.5c-0.1,0.9,0.5,1.4,0.7,2.2c0.5,0.2,0.9,0.3,1.4,0.5C20.2,318,21,317.9,21.6,317.7z"
        />
        <path
          class="st0"
          d="M225.2,294.2c0.3,0.1,0.5,0.2,0.7,0.3c0-0.2,0-0.4,0-0.6c-0.2-0.9-1.1-1.5-2.1-1.8c0.2,0.5,0.2,1.1,0,1.7
			C224.2,294,224.7,294.1,225.2,294.2z"
        />
        <path
          class="st0"
          d="M223.2,297.3h0.1c-0.7-0.5-1.3-1.2-1.5-2c0.4-0.3,0.7-0.7,1.1-1.1c-0.4-0.6-1-1.2-0.9-1.9
			c-1.6,0.4-2.8,1.9-2.6,3.2C219.7,296.8,221.4,297.6,223.2,297.3z"
        />
        <path
          class="st0"
          d="M216.1,302c1.7-0.4,2.8-1.8,2.6-3.1c-0.3-1.5-1.8-2.3-3.7-1.9c-1.8,0.4-3,1.7-2.7,3.2
			C212.6,301.6,214.3,302.4,216.1,302z"
        />
        <path
          class="st0"
          d="M101.7,311.4c-0.7,0.6-1.7,0.7-2.8,0.3c-1,0.5-1.7,1.4-1.7,2.4c0,0,0.1,0,0.1,0.1h-0.1c0,0.1,0,0.2,0,0.4
			c0.3,1.3,2,2.1,3.7,1.8c1.7-0.4,2.9-1.7,2.6-3.1C103.4,312.3,102.7,311.6,101.7,311.4z"
        />
        <path
          class="st0"
          d="M228.6,291c0.3,0,0.6,0.2,0.7,0.4c0.3,0.5,0.9,0.5,1.5,0.6c0.2,0,0.3,0.1,0.5,0.1c1.2-0.6,1.9-1.7,1.6-2.8
			c-0.3-1.3-2-2.1-3.6-1.8c-1.3,0.3-2.3,1.3-2.5,2.3c0.1,0.2,0.1,0.4,0,0.7v0.1c0.1,0.5,0.4,0.9,0.7,1.2c-0.1-0.2,0-0.6,0.2-0.7
			C227.9,291,228.3,290.9,228.6,291z"
        />
        <path
          class="st0"
          d="M280,268.6c1.2,1.2,2.1,1.4,3.4,0.9c0.9-0.4,1.5-1.4,1.3-2.2c-0.2-0.6-0.6-0.9-1.3-1.1c0,0.2-0.1,0.4-0.3,0.6
			c-0.2,0.2-0.4,0.4-0.7,0.4l0,0c-0.6,0.1-1.2-0.2-1.3-0.7c-0.1-0.3-0.1-0.6,0.1-0.8c-0.4-0.4-0.8-0.6-1.2-0.7
			c-0.5-0.1-1-0.1-1.5,0.1c-0.4,0.2-0.8,0.5-1,0.8c0.1,0,0.1,0.1,0.2,0.1c0.2,0.1,0.3,0.1,0.5,0.2c0.2,0.2,0.4,0.4,0.5,0.6
			c0.2,0.4,0.4,0.9,0.5,1.5c-0.2,0-0.5,0-0.7,0C278.7,268.6,279.3,268.6,280,268.6z"
        />
        <path
          class="st0"
          d="M210.2,296.3c1.2-0.1,2.1-0.6,2.6-1.6c0.2-0.3,0.1-0.8,0.8-0.8c-0.2-0.2-0.4-0.3-0.8-0.6
			c0.9-0.4,2.1-0.5,2-1.5c0-0.5-0.3-0.8-0.9-0.9c-1.1-0.1-1.6,0.5-1.9,1.1c-0.7,0-1.2-0.1-1.8-0.1c-1.6,0.1-2.7,1.2-2.6,2.4
			C207.6,295.5,208.7,296.4,210.2,296.3z"
        />
        <path
          class="st0"
          d="M27,317.2c-1.4-0.6-3-0.2-4.1,0.9c-0.9,0.9-0.5,1.8-0.3,2.6c-0.7-0.1-1.3-0.3-2.1-0.4c-0.7-0.1-1.4,0-2.3,0.2
			c0.6-1.3,0.4-2.4-0.2-3.3c-0.3-0.1-0.6-0.2-0.8-0.3c-0.5-0.2-0.9-0.3-1.4-0.4c-0.7-0.1-1.3,0-2,0.3c-0.2,0.1-0.4,0.2-0.6,0.3
			c-1.2,0.8-1.7,1.8-1.5,2.9v0.1c0,0.2,0.1,0.4,0.1,0.6c-0.7-0.1-1.4-0.3-2.1-0.4l0,0c0.1-0.8,0.3-1.7,0.4-2.5
			c1.8-0.6,2.7-1,3.1-1.9c0.2-0.5,0.3-1.1,0.3-1.9c0.5-0.1,0.9-0.3,1.4-0.4l0,0c0.3-0.1,0.6-0.2,1-0.3c0.4-0.1,0.8-0.2,1.2-0.4
			c1.1-0.4,1.7-1.1,1.8-2.1c0.1-0.9-0.4-1.6-1.3-2c-1.1-0.5-2.2-1.1-3.2-1.7c-0.3-0.2-0.5-0.6-0.6-1c-0.3-1-1.2-1.4-2.4-1.4
			c-0.1,0-0.2,0-0.2,0c-0.5,0-0.8,0-1.1-0.1c-0.5-0.1-0.9-0.3-1.9-0.8c0.3-0.4,0.7-0.8,1.2-1.1c0.3-0.2,0.6-0.3,0.9-0.5
			c0.6-0.3,1.1-0.6,1.6-1l0,0c0.3-0.4,0.8-0.7,1.4-0.7c0.8-0.1,1.4,0.2,1.8,0.8v0.1l0,0l0,0c0.3,0.5,0.2,1.2-0.5,1.7
			c-0.3,0.2-0.6,0.4-0.9,0.6c0.8-0.1,1.5-0.1,2.1,0.3c0.1,0.1,0.3,0.1,0.5,0.1c0.5,0,1.1,0,1.4-0.2c0.9-0.8,2.6-0.4,3.2-1.5
			c0.2-0.4,0.3-0.9,0.1-1.3c-0.2-0.5-0.8-0.8-1.4-0.6c-0.8,0.2-1.4,0.1-2.1,0c-0.2-0.1-0.5,0-0.7,0c-0.1,0.2-0.3,0.2-0.6,0.2
			c-0.3,0.1-0.7,0.3-1,0.5c0.4-0.5,0.7-0.9,1.1-1.4c0.5-0.6,0.9-1.2,1.1-1.9c-1,0.1-1.7-0.9-1.2-1.7c0.1-0.2,0.2-0.3,0.3-0.5
			c0.2-0.2,0.3-0.3,0.4-0.4c0-0.2-0.1-0.4-0.1-0.6c-0.2-1.1-0.5-2.2-0.7-3.2c0-0.1-0.1-0.3-0.2-0.4c-0.6-0.8-1.5-0.9-2.4-0.2
			c-0.4,0.3-0.7,0.5-1.2,0.6c-0.8,0.2-1.6,0.5-2.5,0.7C9,293,8.2,293.1,7.9,294c0,0.1-0.5,0.3-0.8,0.4c-0.1,0-0.1,0-0.2,0
			s-0.3,0-0.4-0.1c-0.5,0-0.9,0.2-1.3,0.4c-0.6,0.3-1.3,0.6-2,1c0,0.9-0.2,1.6-1.2,2c-0.9,0.4-1.5,0.1-2-0.2v10.3
			c0.6,0.2,1.1,0.6,1.4,1.1c0.4-0.1,0.8-0.2,1.2-0.5c0.8-0.5,1.1-1.2,0.9-1.9v-0.1c-1.1,0.2-2.2-0.3-2.4-1.2v-0.1
			c-0.1,0-0.3,0-0.4,0c0.2-0.4,0.4-0.7,0.5-1c0.3-0.6,0.9-1.2,1.7-1.4c1.2-0.3,2.3,0.3,2.6,1.3l0,0c0.4,0.3,0.9,0.5,1.3,0.8
			c-0.7,1.2-1.2,2.5-0.7,3.8c-0.8,0.5-1.7,0.8-2.3,1.4c-0.3,0.3-0.4,0.7-0.5,1.1c0,0.1,0,0.2,0,0.3v0.1c0.1-0.1,0.2-0.2,0.3-0.3
			c0.3-0.2,0.7-0.4,1.1-0.5c1.4-0.3,2.7,0.4,3,1.6c0,0.1,0,0.2,0,0.3c0.7-0.5,1-1.3,1.1-2.3c1.3,0.6,0.4,1.8,1,2.2
			c-0.7,0.7-1.5,1.3-2.2,2c-0.1,0.1-0.2,0.2-0.4,0.3c-0.1-0.1-0.3-0.2-0.6-0.4c-0.3,0.2-0.8,0.4-1.2,0.5c-0.3,0.1-0.6,0.1-0.9,0
			c-0.9-0.1-1.7-0.6-2-1.4c-0.6-0.5-1.2-0.7-2-0.7c-0.2,0-0.3,0-0.5,0v0.5v3.5c0.1-0.1,0.3-0.1,0.4-0.2c0.9-0.2,1.9,0.2,2.1,1
			c0.2,0.7-0.4,1.6-1.3,1.8c-0.4,0.1-0.8,0.1-1.2-0.1v5.1c0.3,0,0.6,0,0.9,0.2c0.3-0.2,0.6-0.5,0.8-0.8c0.6,0,1.3,0,2-0.1
			c0.6-0.1,1.2-0.3,1.9-0.5c0.1,0.7,0.3,1.3,0.4,2c-1.6-0.5-3.1-0.5-4.4,0.7c-1,0.9-1.3,1.9-0.8,2.9c0.7,1.3,2.1,1.7,3.9,1.4
			c-1.1,3.2,0,4.6,4,5.1c-0.1,1.1,0,2.2,0.9,2.9c0.1,0.1,0.2,0.2,0.3,0.2c0.4,0.3,0.9,0.5,1.3,0.7h0.2h0.7h2.8
			c0.4-0.2,0.7-0.4,1.1-0.6c-0.1-0.8,0.3-1.4,1.3-1.8c0.1-0.1,0.3-0.1,0.4-0.2l0,0l0,0l0.1-0.1l0,0c0.3,0.3,0.5,0.5,0.8,0.8
			c1.1-0.9,1.1-1,0.1-1.8c0,0,0,0-0.1,0c-0.2,0.1-0.4,0.2-0.7,0.4c-0.1-0.3-0.1-0.6-0.2-1c0.4-0.1,0.7-0.1,0.9-0.1
			c0.3,0,0.5,0,0.8-0.1c0.7-0.2,1.4-0.5,2-1c1.1-1,1.7-2.4,0.8-3.8c-0.5-0.8-1.3-1.2-2.4-1.3c-0.1,0-0.2,0-0.3-0.1
			c-0.4,0-0.8,0-1.3,0c0.1-0.6,0.1-1.2,0.2-1.9c0.4,0,0.7-0.1,1.1-0.1l0,0c1.4,0,2.5-0.6,3.2-1.4c1-1,1.3-2.4,0.6-3.4
			c-0.1-0.2-0.2-0.4-0.2-0.6c0.4,0.1,0.7,0.2,1.1,0.3c1.5,0.3,3.1-0.3,3.8-1.4C28.8,319.1,28.3,317.8,27,317.2z M15.8,309.9
			c0.5,0.2,0.7,0.6,0.5,1.1s-0.8,0.9-1.4,0.9c-1-0.1-1.2-0.6-1.2-1.4C14.3,309.9,15,309.5,15.8,309.9z M14,312.2
			c0.1,0.1,0.2,0.2,0.4,0.3c0.1,0.1,0.2,0.2,0.3,0.2l-0.1,0.1c-0.1,0.1-0.2,0.2-0.2,0.2c-0.2-0.2-0.4-0.4-0.5-0.6
			C13.8,312.3,13.9,312.2,14,312.2z M11.2,292.9c0.8-0.2,1.6,0.3,1.8,0.9c0.1,0.6-0.4,1.2-1.2,1.4c-0.9,0.2-1.6-0.2-1.7-0.9
			C9.9,293.7,10.5,293.1,11.2,292.9z M10.3,295.7c0.1,0.1,0.2,0.3,0.3,0.4c0,0-0.2,0.2-0.3,0.2c-0.2-0.1-0.3-0.2-0.4-0.4
			C10,295.9,10.1,295.8,10.3,295.7z M10.9,316.3l-0.1-0.1c0.1-0.1,0.2-0.1,0.3-0.2l0.1,0.1C11.1,316.2,11,316.2,10.9,316.3z
	M9,297.4L9,297.4L9,297.4L9,297.4z M5.5,299.7c-0.1-0.8,0.6-1.6,1.5-1.8c0.2,0,0.4-0.1,0.6,0c0.3,0,0.6,0.1,0.9,0.3
			c0.4,0.2,0.6,0.5,0.7,0.9c0.1,0.3,0,0.7-0.2,0.9c-0.1,0.2-0.3,0.4-0.5,0.5c-0.3,0.2-0.6,0.3-0.9,0.4
			C6.5,301.1,5.6,300.5,5.5,299.7z M9.4,309.6c-1.2,0.2-2.3-0.3-2.5-1.3c-0.2-1.1,0.6-2.1,1.9-2.4c0.6-0.1,1.1,0,1.5,0.2
			c0.6,0.3,1,0.7,1,1.3c0.1,0.5-0.1,1-0.4,1.4C10.6,309.1,10.1,309.4,9.4,309.6z M10.1,327.6c0,0.3-0.1,0.5-0.2,0.8
			c-0.9,0.1-1.7,0.1-2.6,0.2c0-0.7-0.1-1.5-0.1-2.2c0.4,0,0.8,0.1,1.2,0.1c0.6,0.1,1.2,0.1,1.8,0.2C10.1,327,10.1,327.3,10.1,327.6z
	M12,327.2c-0.5-0.8-0.5-1.3,0.2-1.9C12.8,326,12.6,326.5,12,327.2z"
        />
        <path
          class="st0"
          d="M94.7,316.3c-0.8-0.3-1.7-0.3-2.4,0c-0.4,0.4-1,0.8-1.4,1.1l0,0c-0.5,0.7-0.6,1.5-0.2,2.2
			c0.3,0.4,0.6,0.8,0.9,1.2c0.6,0,1.3,0,1.9-0.1c1.3-0.1,2.3-0.9,2.6-2C96.4,317.8,95.8,316.8,94.7,316.3z M93.5,318.1
			c-0.2,0-0.4-0.2-0.5-0.3c0-0.1,0.2-0.3,0.3-0.3c0.2,0,0.4,0.1,0.7,0.1C93.8,317.8,93.7,318.1,93.5,318.1z"
        />
        <path
          class="st0"
          d="M294.6,290.9c-0.2-1.2-1.8-2-3.3-1.7c-1.4,0.3-2.5,1.6-2.3,2.8c0.2,1.2,1.7,1.9,3.2,1.6
			C293.7,293.4,294.8,292.1,294.6,290.9z"
        />
        <path
          class="st0"
          d="M227.3,284.1c-0.1-0.5-0.4-1.1-0.6-1.7c-0.1,0.1-0.2,0.1-0.3,0.1c-0.4,0-0.8,0-1.2-0.1
			c-1.4,0-2.7,0.6-3.1,1.7c-0.4,0.9-0.1,1.8,0.8,2.4c0.9,0.5,2.1,0.6,3.1,0.1C227,286,227.6,285.1,227.3,284.1z M222.9,283.5
			c-0.1,0-0.1,0-0.2,0c0.1,0,0.2,0,0.3,0C223,283.4,223,283.5,222.9,283.5z"
        />
        <path
          class="st0"
          d="M220.2,288.7c-0.3-1.1-1.8-1.8-3.2-1.4s-2.4,1.6-2.1,2.7c0.3,1.1,1.7,1.8,3.1,1.5
			C219.5,291.2,220.5,289.8,220.2,288.7z"
        />
        <path
          class="st0"
          d="M285,283.3c-0.5,0.2-1.1,0.4-0.7,1c0,0.1-0.2,0.4-0.3,0.4c-1.1,0.2-0.7,0.8-0.7,1.2c0.1,0.6,0.5,1,1,1.3
			c0.1,0,0.2-0.1,0.3-0.1c0.6-0.1,1.2,0.1,1.5,0.4c0.2,0,0.3,0,0.5-0.1c1.5-0.4,2.5-1.7,2.1-2.9C288.3,283.4,286.5,282.8,285,283.3z
			"
        />
        <path
          class="st0"
          d="M260.8,293c-1.6,0.3-2.6,1.5-2.4,2.7c0.2,1.1,1.6,1.9,3.1,1.6s2.6-1.5,2.4-2.7
			C263.6,293.4,262.3,292.7,260.8,293z"
        />
        <path
          class="st0"
          d="M19.6,307c-0.2,0.1-0.4,0.1-0.6,0.1c0,0.1,0,0.2,0,0.3c0.2,1.2,1.5,1.9,3,1.6c0,0,0,0,0.1,0c0,0,0,0,0.1,0
			c1.4-0.3,2.4-1.4,2.2-2.6c-0.2-1.2-1.6-1.8-3.1-1.5h-0.1c0,0.1,0.1,0.1,0.1,0.2C21.3,306,20.7,306.8,19.6,307z"
        />
        <path
          class="st0"
          d="M109.2,322.6c-0.8,0.1-1.6,0.1-2.3,0.3c-0.9,0.3-1.3,1.2-1.1,1.9c0.1,0.8,0.9,1.3,1.8,1.3s2.1-0.6,2.4-1.3
			c0.2-0.5,0.3-1,0.4-1.4c0.3-0.1,0.7-0.2,0.9-0.4c0.9-0.6,0.9-1.3,0.1-1.9c-0.2-0.1-0.3-0.2-0.5-0.3
			C109.7,321.2,109.2,321.8,109.2,322.6z"
        />
        <path
          class="st0"
          d="M217.2,279.5c0,0.5,0.3,0.9,0.8,1.3c0.4,0.2,0.8,0.3,1.3,0.5c0,0.4-0.3,0.9,0.4,1c0.9,0.2,1.4-0.1,2.3-1.2
			c-0.2-0.3-0.5-0.6-0.7-0.9c0.1-0.1,0.2-0.1,0.2-0.2c0.3,0.1,0.6,0.2,0.9,0.4c0.1,0,0.2-0.1,0.3-0.1c-0.4-0.7-0.8-1.5-1.3-2.1
			s-1.3-0.8-2.2-0.6c-0.6,0.1-1,0.4-1.4,0.7c0.4,0.4,0.5,1,0.5,1.6C217.8,279.8,217.4,279.6,217.2,279.5z"
        />
        <path
          class="st0"
          d="M300.7,263.5C300.7,263.5,300.7,263.6,300.7,263.5c-0.5,0.3-0.9,0.7-1.5,1.1c0.4,0.7,0.6,1.4,1.1,2
			c0.3,0.4,0.7,0.5,0.4,1.1c-0.2,0.4,0.2,0.8,0.7,0.8s1-0.3,1-0.7c0,0,0,0,0-0.1c-0.2-0.6,0.2-0.9,0.6-1.3c0.9-0.8,1-1.7,0.5-2.6
			C303,262.9,301.9,262.8,300.7,263.5z"
        />
        <path
          class="st0"
          d="M254.4,249.4c-0.2-0.4-0.7-0.8-1.5-1.2c-0.5,0.7-1.3,1.2-1.4,2l-0.1,0.1c0.1,0.8,0.9,1,1.6,1.3
			c-0.4,0.3-0.6,0.5-0.7,0.7l0,0l0,0c-0.2,0.4-0.1,0.6,0.3,1.2c0,0.1,0.1,0.2,0,0.2c-0.2,0.2-0.3,0.3-0.3,0.4c0,0.2,0.2,0.4,0.4,0.6
			c0.3,0.2,0.8,0.4,1.2,0.5c0.6,0.1,1.3-0.4,1.1-0.8c-0.2-0.4-0.3-0.9-0.3-1.3c0-0.2-0.1-0.4-0.2-0.6c-0.2-0.1-0.4-0.1-0.6-0.3
			c-0.3-0.2-0.4-0.4-0.6-0.7l0,0l0,0c-0.2-0.5-0.1-1.2,0.4-1.7C253.9,249.7,254.2,249.6,254.4,249.4z M254.6,254.2
			c-0.8,0.1-1.2,0.1-1.9,0.2C253.4,253.7,253.8,254,254.6,254.2z"
        />
        <path
          class="st0"
          d="M248.9,260.7c0.8-0.7,1.6-1.4,2.6-2.3c-1-0.2-1.9-0.3-2.5-0.6c-0.5-0.2-1.1-0.3-1.6-0.3
			c-0.3,0-0.5,0.1-0.8,0.3c-1-1.2-1-1.2-2.6-0.9c-0.1,0.5-0.2,0.9-0.3,1.5c0.5,0.1,0.9,0.2,1.4,0.2c0.2,0,0.5,0.1,0.7,0.1
			C246.2,260,246.9,260.5,248.9,260.7z"
        />
        <path
          class="st0"
          d="M86.9,321.3c0.1,0.5,0.1,0.9,0.2,1.4s0.3,0.9-0.4,1.2c-0.1,0.1,0,0.4,0,0.6s0,0.3,0,0.5
			c1.3-0.3,2.2-1.3,2-2.4C88.5,322,87.7,321.5,86.9,321.3z"
        />
        <path
          class="st0"
          d="M73.1,327.8c0.2-0.8-0.3-1.5-1.2-1.7c-0.9-0.2-1.8-0.3-2.6-0.8c-0.1-0.1-0.6,0.1-0.8,0.2
			c-0.1,0.1-0.2,0.4-0.1,0.5c0.6,0.5,0.3,1.1,0.2,1.8c-0.3,1.2,1.1,2.1,2.6,1.8C72.2,329.4,73,328.7,73.1,327.8z"
        />
        <path
          class="st0"
          d="M211.2,285.6c0.4,0.2,0.9,0.2,1.4,0.3c0.7,1.1,0.7,1.1,2.3,1.1c-0.5-1-1-1.8-0.4-2.9c0.5-0.8-0.5-1.7-1.6-1.9
			c-1.1-0.2-2.1,0.3-2.6,1.2C209.8,284.3,210.2,285.3,211.2,285.6z"
        />
        <path
          class="st0"
          d="M80.6,315.9c-1.3,0.2-2.3,1.4-2.1,2.4c0.1,0.5,0.5,1,1,1.2c0.2-0.2,0.5-0.5,0.8-0.7c0.6-0.3,1.5-0.3,2,0.2
			l0.1,0.1c0.6-0.5,1-1.2,0.8-1.9C83.1,316.3,81.8,315.7,80.6,315.9z"
        />
        <path
          class="st0"
          d="M52.9,334.3c-0.8,0.3-1.5,0.7-2.2,1.1c0.2,1.1,0.4,1.5,0.9,2.1s1.2,0.7,1.9,0.4c0.6-0.2,1.2-0.5,1.7-0.9
			c0.7-0.6,0.8-1.4,0.3-2.1C55,334.3,53.7,334,52.9,334.3z"
        />
        <path
          class="st0"
          d="M30.3,298.2c0,0.2,0.1,0.5,0.2,0.7c0.1,0.6,0.4,0.9,0.8,1.2c-0.1-0.1-0.1-0.2-0.1-0.2
			C31.5,299,31,298.6,30.3,298.2z"
        />
        <path
          class="st0"
          d="M32.3,300.4c-0.1-0.1-0.2-0.1-0.5-0.1C31.9,300.4,32.1,300.4,32.3,300.4z"
        />
        <path
          class="st0"
          d="M193.9,316.5c-0.7-0.2-1.5-0.3-2.2-0.4c-0.5,0-1,0.2-1.5,0.4c-0.3,0.1-0.6,0.4-0.8,0.6
			c-1.1,0.8-1.2,1.4-0.6,2.6c0.4-0.2,1-0.7,1.3-0.6c1.6,0.4,2.8-0.1,3.9-1.1c0.2-0.2,0.5-0.3,0.8-0.4
			C194.7,316.9,194.5,316.6,193.9,316.5z"
        />
        <path
          class="st0"
          d="M254.9,298.5c-1.3,0.3-2.1,1.4-1.8,2.4s1.6,1.6,2.8,1.3c1.2-0.3,2.1-1.4,1.8-2.4
			C257.4,298.8,256.2,298.2,254.9,298.5z"
        />
        <path
          class="st0"
          d="M237.7,309c-1.2,0.3-2.1,1.4-1.9,2.3c0.2,1,1.5,1.6,2.8,1.3c1.2-0.3,2.1-1.5,1.8-2.4S238.9,308.7,237.7,309z"
        />
        <path
          class="st0"
          d="M39.7,301.9c-0.2,0.1-0.4,0.3-0.6,0.5c-0.4,0.3-1.2,0-1.5,0.6c-0.3-0.2-0.6-0.3-0.9-0.3
			c0.5,0.5,1.6,0.2,2.4,0.4c0.3-0.4,0.5-0.8,0.8-1.1C39.8,302,39.8,302,39.7,301.9z"
        />
        <path
          class="st0"
          d="M34.5,302.6c0.2,0,0.3,0,0.5,0c-0.2-0.1-0.3-0.2-0.5-0.2C34.5,302.5,34.5,302.5,34.5,302.6z"
        />
        <path
          class="st0"
          d="M249.1,294.4c-1.3,0.2-2.2,1.3-2,2.3c0.2,0.9,1.3,1.5,2.6,1.3s2.1-1.1,2-2.1
			C251.6,294.8,250.4,294.1,249.1,294.4z"
        />
        <path
          class="st0"
          d="M225.4,273.2c-0.7,0.4-1,1.1-0.9,1.8c0.2,1.1,1.2,1.7,2.6,1.4c1.2-0.2,2.1-1.2,1.9-2.1
			c-0.1-0.9-1.1-1.5-2.2-1.5c0.2,0.1,0.4,0.1,0.6,0.2c0.5,0.2,0.2,0.6-0.2,0.9C226.5,273.6,225.9,273.5,225.4,273.2L225.4,273.2z
	M225.9,275.9L225.9,275.9h-0.1C225.8,275.9,225.8,275.9,225.9,275.9z"
        />
        <path
          class="st0"
          d="M65.5,327.8c0.2-0.9-0.1-1.7-1.2-2.1c-0.6,1.2-0.6,1.2,0.5,2.4c-0.9,0.9-1,1-0.6,1.4c0.8,0.8,1.6,1.7,3.1,1.9
			C69.1,329.4,68.5,328.2,65.5,327.8z"
        />
        <path
          class="st0"
          d="M34.1,306.6c-0.1-0.2-0.1-0.5-0.3-0.7c-0.6-1-2.6-1.1-3.5-0.3c-0.9,0.8-0.9,1.9-0.1,2.6s2.2,0.6,3.1-0.2
			c0.4-0.3,0.8-0.7,1.2-1C34.4,306.8,34.2,306.7,34.1,306.6z"
        />
        <path
          class="st0"
          d="M293.7,278.3c-1.2,0.3-2.1,1.2-1.9,2.2c0.2,0.9,1.4,1.5,2.5,1.3c1.2-0.2,2.2-1.4,2-2.3S294.9,278,293.7,278.3
			z"
        />
        <path
          class="st0"
          d="M242.3,300.4c-0.3-1.3-1.4-1.9-3.4-1.7c0.4,1.6,0,3.3,0.7,4.8C241.7,302.8,242.6,301.8,242.3,300.4z"
        />
        <path
          class="st0"
          d="M286.1,274.5c0.3,1,1.3,1.4,2.6,1.1c1.2-0.3,2-1.3,1.8-2.2c-0.2-0.9-1.5-1.5-2.6-1.3
			C286.6,272.4,285.8,273.5,286.1,274.5z"
        />
        <path
          class="st0"
          d="M276.5,268.9v-0.1c0,0.1-0.1,0.1-0.1,0.2c-0.3,0.5-0.6,0.9-0.8,1.4c-0.3,0-0.6,0.1-0.9,0.1
			c-0.3,0.1-0.5,0.2-0.7,0.3c-0.4,0.2-0.7,0.5-0.8,1c-0.3,1.1,0.7,1.5,1.4,2.1c0.9-0.4,1.6-0.7,2.4-1.1
			C276.9,271.5,277.1,270.2,276.5,268.9z"
        />
        <path
          class="st0"
          d="M234,296.9c0.4,0.1,0.8,0.2,1.3,0.1c1.2-0.2,2-1.3,1.8-2.2c-0.2-0.8-1.5-1.4-2.5-1.1
			c-1.1,0.3-1.9,1.2-1.7,2.1c0,0.1,0.1,0.3,0.2,0.4c0-0.1-0.1-0.2-0.1-0.4c0.2,0.1,0.4,0.1,0.5,0.2
			C233.8,296.3,233.9,296.6,234,296.9z"
        />
        <path
          class="st0"
          d="M58.4,313.8c0,0.2-0.1,0.5-0.2,0.7c-0.1,0.4-0.4,0.8-0.7,1.2h0.1c-0.2,0.5-0.5,0.7-0.8,1
			c-0.4,0.3-0.8,0.7-0.3,1.1c0.4,0.3,0.9,0,1.3-0.3c0.3-0.3,0.6-0.5,0.9-0.8c0.4,0.2,0.7,0.3,1.6,0.6c-0.6-1.2-0.3-1.9,0.5-2.6
			c0.3-0.3,0.2-0.7,0.4-1.4c-0.9,0.4-1.5,0.7-2.2,1.1C58.7,314.2,58.5,314,58.4,313.8z"
        />
        <path
          class="st0"
          d="M50,308.8c-0.3-0.1-0.6-0.3-0.9-0.5c-0.2-0.1-0.3-0.2-0.5-0.3c0-0.4,0.1-0.8,0.2-1.2
			c-0.1,0.1-0.2,0.1-0.3,0.2c-0.5,0.3-1,0.6-1.5,0.9c-0.1,0.1-0.2,0.1-0.3,0.2c0.6,0.9,1.2,1.7,1.8,2.5c0.6-0.2,1.1-0.5,1.4-0.7
			c0.3-0.2,0.4-0.4,0.3-0.7C50.1,309.1,50,308.9,50,308.8z"
        />
        <path
          class="st0"
          d="M229.8,278.1c0.1,0.2,0.2,0.5,0.3,0.7l0,0c0,0,0,0.1,0.1,0.1l0,0c0.2,1,0.1,2,1.3,2.8
			c0.6-0.4,1.2-0.7,1.5-1.1c0.3-0.3,0.6-0.9,0.4-1.2l-0.1-0.1c-0.2,0.1-0.6,0.1-0.7,0c-0.3-0.3-0.6-0.6-0.5-1.2l0,0
			C231.5,277.7,230.7,277.5,229.8,278.1z"
        />
        <path
          class="st0"
          d="M249.8,288.1c0.8-0.5,1.4-0.4,2.2-0.4c0.2,0,0.4-0.1,0.9-0.3c-1-0.7-1.9-1.3-2.9-1.9c-0.6-0.3-1.4-0.1-2,0.4
			s-0.7,1.3-0.2,1.8C248.2,288.2,249.2,288.5,249.8,288.1z"
        />
        <path
          class="st0"
          d="M259.2,257.6c-0.3,0-0.7,0-1.1,0.4c0,0.3,0.1,0.5,0.2,0.6C258.5,258.2,258.8,257.8,259.2,257.6z"
        />
        <path
          class="st0"
          d="M261.6,258.6c0.8-0.2,1.1-0.8,1-1.3c-0.1-0.4-0.4-0.9-0.8-1.2c0,0-0.1,0-0.1-0.1c-0.3,0.4-0.7,0.7-1.2,0.9
			c0.2,0.2,0.4,0.5,0.2,0.8c0.3,0.1,0.5,0.3,0.5,0.5s0,0.4-0.2,0.7C261.2,258.8,261.4,258.7,261.6,258.6z"
        />
        <path
          class="st0"
          d="M177.1,299.4c-0.1-0.2-0.2-0.6-0.4-0.7c-0.7-0.2-1.5-0.3-2.3-0.4c-0.1,0.3-0.2,0.6-0.3,0.8
			c0.4,0.2,0.8,0.3,1,0.4c-0.1,0.9-0.9,1.1-1.9,1.4c0.6,0.6,1.1,1,1.7,1.5c0.7-0.5,1.3-0.8,1.8-1.2c0.6-0.5,0.2-0.9,0-1.4
			C176.7,299.8,176.9,299.6,177.1,299.4z"
        />
        <path
          class="st0"
          d="M81.8,309.1c0.3,0.2,0.7,0.2,1.1,0.2c0.1,0,0.2,0,0.2,0c1.1-0.2,1.7-1,1.6-1.8c0-0.1,0-0.2-0.1-0.3
			c-0.1-0.2-0.2-0.4-0.4-0.5c-0.4-0.3-0.9-0.4-1.5-0.3c-1,0.2-1.7,1.1-1.6,1.8C81.1,308.6,81.4,308.9,81.8,309.1z"
        />
        <path
          class="st0"
          d="M128.3,327.4c-1,0.2-1.7,0.8-1.5,1.3c0.3,1.1,1.2,1.5,2.5,1.2c1.1-0.3,1.6-0.8,1.5-1.5
			C130.6,327.6,129.6,327.2,128.3,327.4z"
        />
        <path
          class="st0"
          d="M68.5,321.7c0.2,0.8,1.2,1.3,2.2,1c1-0.2,1.7-1.1,1.5-1.9c-0.2-0.7-1.2-1.2-2-1C69,320.3,68.3,321,68.5,321.7
			z"
        />
        <path
          class="st0"
          d="M183.3,326c-0.5,0.3-1,0.7-1.5,1c-0.4-0.9-1.2-1.2-2.3-1.4c-0.2,0.2-0.5,0.4-0.5,0.6
			c-0.1,0.3-0.1,0.7,0.2,0.8c0.8,0.4,1.7,0.8,2.5,1.2c0.3-0.3,0.5-0.5,0.7-0.8c0.7,0.1,1.4,0.3,2.3,0.4
			C184.7,326.9,184.3,326.4,183.3,326z"
        />
        <path
          class="st0"
          d="M46,306.2c-0.1-0.3-0.2-0.6,0-0.8c1-1.2,0.4-2-0.8-2.8c-0.5,0.8-1.8,1.4-1.4,2.2c0.3,0.6,0.1,1.6,0.8,2.1
			c0.2,0.2,0.5,0.3,0.9,0.4c0,0,0,0,0-0.1C46.1,306.6,46.1,306.6,46,306.2z"
        />
        <path
          class="st0"
          d="M199.7,281.9c-1,0.2-1.7,1.1-1.5,1.9c0.2,0.7,1.1,1.2,2,1c1-0.2,1.6-0.9,1.6-1.7
			C201.7,282.3,200.7,281.8,199.7,281.9z"
        />
        <path
          class="st0"
          d="M261.3,300c-0.9,0.2-1.6,1-1.6,1.7c0.1,0.8,1,1.3,2.1,1.1c0.9-0.2,1.6-0.9,1.6-1.7
			C263.2,300.3,262.2,299.8,261.3,300z"
        />
        <path
          class="st0"
          d="M18.1,338.8c-0.2,0.3-0.6,0.5-1.2,0.7h2.7C19.3,339,18.7,338.8,18.1,338.8z"
        />
        <path
          class="st0"
          d="M295.2,262.4c-0.9,0.3-1.5,1.1-1.2,1.8c0.1,0.4,0.4,0.6,0.7,1c0.6-0.1,1-0.1,1.4-0.3c1-0.3,1.5-1.1,1.3-1.8
			C297.1,262.4,296.1,262.1,295.2,262.4z"
        />
        <path
          class="st0"
          d="M40,294.5c0-0.3,0.1-0.6,0-0.9c-0.3,0.3-0.6,0.5-1,0.8C39.4,294.4,39.7,294.4,40,294.5z"
        />
        <path
          class="st0"
          d="M207,277.3c-1.1,0.2-1.8,0.9-1.6,1.8c0.2,0.7,1.1,1.2,2,1.1c0.9-0.2,1.6-1,1.5-1.7
			C208.8,277.6,208,277.1,207,277.3z"
        />
        <path
          class="st0"
          d="M85,325.8c-0.9,0.3-1.6,1.2-1.4,2c0.2,0.7,0.9,1.1,1.7,0.8c1.1-0.3,2-1.4,1.8-2.1
			C87,326.1,85.7,325.6,85,325.8z"
        />
        <path
          class="st0"
          d="M276.9,291.2c-0.1-0.2-0.1-0.4,0-0.5c-0.7-0.3-1.4-0.3-2.3,0c0,1.9,0.8,2.6,3.2,2.6c0.3-0.4,0.4-0.8,0.4-1.2
			C277.6,292,277,291.6,276.9,291.2z"
        />
        <path
          class="st0"
          d="M126.3,313.3c0.9-0.5,1.6-0.8,2.2-1.2c0.7-0.4,1.1-1,1.1-1.7c-0.1-0.8-0.8-1.1-1.6-0.7
			c-0.6,0.3-1.1,0.6-1.6,0.9C126.3,311.5,126.3,312.2,126.3,313.3z"
        />
        <path
          class="st0"
          d="M296.1,267.2c-0.6,0.1-1.1,0.5-1.4,1c-0.1,0.2-0.2,0.5-0.1,0.7c0.2,0.7,1.1,1.2,2.1,1l0,0
			c0.2,0,0.4-0.1,0.5-0.2c0,0,0.1,0,0.1-0.1c0.6-0.4,0.9-0.9,0.8-1.5S297,267,296.1,267.2z"
        />
        <path
          class="st0"
          d="M268.9,284.5c-0.3,1.8,0.6,2.6,3,2.7C272.6,285.2,271.6,284.3,268.9,284.5z"
        />
        <path
          class="st0"
          d="M244.7,296.8c-1,0.2-1.6,1-1.4,1.8c0.2,0.7,1,1.1,1.9,0.9c1-0.2,1.6-1,1.4-1.7
			C246.4,297,245.6,296.6,244.7,296.8z"
        />
        <path
          class="st0"
          d="M225.4,308.8c-0.9,0.2-1.4,0.9-1.3,1.6c0.1,0.7,0.9,1.1,1.8,1c1-0.2,1.6-0.9,1.5-1.7
			C227.3,309,226.4,308.6,225.4,308.8z"
        />
        <path
          class="st0"
          d="M248.9,252.2c-0.3,0-0.5,0-0.7,0.1c-0.7,0.1-0.9,0.2-1.3,0.9l0,0c0,0,0,0,0.1,0c1,0.2,1,0.3,1.5,1.3
			c0.2,0,0.4,0,0.6-0.1c0.1,0,0.2-0.1,0.2-0.1c0.2-0.1,0.4-0.3,0.6-0.5c0.1-0.1,0.2-0.2,0.4-0.3c0.5-0.3,0.8-0.6,0.6-1.1l0,0l0,0
			c0.1-0.2,0.1-0.4,0.2-0.6l-0.3-0.1c-0.1,0.1-0.2,0.3-0.3,0.5l0,0l0,0C249.9,252.2,249.4,252.2,248.9,252.2z"
        />
        <path
          class="st0"
          d="M214.6,308c-0.1-0.5-0.6-0.9-1.1-1c-0.2,0.2-0.4,0.3-0.7,0.4s-0.5,0-0.8,0c-0.5,0.3-0.8,0.9-0.7,1.3
			c0.1,0.7,1,1.1,1.9,1C214.1,309.5,214.7,308.8,214.6,308z"
        />
        <path
          class="st0"
          d="M216.3,312.3c0.4-0.2,0.8-0.2,1.2-0.2c-0.3-0.5-1-0.7-1.7-0.6c-0.9,0.2-1.5,0.8-1.4,1.6
			c0.1,0.7,0.9,1.2,1.8,1c0.2,0,0.4-0.1,0.6-0.2c-0.4,0.1-0.8,0.1-1.3,0.1C215.4,313,215.6,312.6,216.3,312.3z"
        />
        <path
          class="st0"
          d="M76,305.6c0.3,0.1,0.9,0,1.2-0.2c-0.5-0.4-0.9-0.9-1.2-1.4c-0.4,0-0.8-0.2-1.1-0.6c-0.7-0.8-1.2-0.7-2.1,0.3
			C73.4,304.8,74.7,305.2,76,305.6z"
        />
        <path
          class="st0"
          d="M292.2,262.7c-0.3-0.2-0.6-0.4-0.9-0.6c-0.5-0.3-1-0.7-1.5-1c-0.9,0.5-1.4,1.1-1.2,1.8c0,0.1,0,0.1,0.1,0.2
			c0.3,0.6,0.9,0.9,1.7,0.8C291.3,263.9,292,263.6,292.2,262.7z"
        />
        <path
          class="st0"
          d="M185.9,327.7C185.9,327.7,185.9,327.8,185.9,327.7c0.2,0.9,1.3,0.8,2.3,0.5c0.1-0.4,0.2-0.7,0.2-1.1
			c0.1-0.7-0.2-1.4-0.7-2.1C186.2,325.8,185.7,326.8,185.9,327.7z"
        />
        <path
          class="st0"
          d="M48.7,333.3c-0.6-0.3-1.3-0.1-1.8,0.3c-0.4,0.3-0.7,0.7-1,1.1c1.1,0.9,1.6,1.1,2.4,0.7
			c0.7-0.3,1.2-0.7,1.2-1.3C49.4,333.8,49.1,333.5,48.7,333.3z"
        />
        <path
          class="st0"
          d="M86.1,297.9c0.1,0.1,0.2,0.2,0.2,0.3c0,0,0,0,0-0.1c0.2-0.3,0.2-0.7,0.1-1l0,0l0,0c-0.2,0-0.4,0-0.6,0
			c-0.4,0-0.7-0.1-0.9-0.3c-0.2-0.1-0.3-0.2-0.4-0.3c-0.2,0.1-0.4,0.1-0.7,0.2v-0.1c0,0,0,0-0.1,0c-0.4-0.6-0.4-0.7-1-0.2
			c0.2,0.2,0.4,0.3,0.7,0.4c0.2,0.1,0.4,0.2,0.6,0.4l0,0C84.6,297.9,85.3,298.1,86.1,297.9z"
        />
        <path
          class="st0"
          d="M279.7,277.3c0.8,1.1,1.5,2.2,2.3,3.4c0.9-1,1.2-1.9,0.5-2.8C281.8,277.1,281.2,277,279.7,277.3z"
        />
        <path
          class="st0"
          d="M167.3,288.8c0,0,0.1-0.1,0.1-0.2h-0.1C167.3,288.7,167.3,288.8,167.3,288.8z"
        />
        <path
          class="st0"
          d="M247.6,277.8c0.2,0.6,1,1,1.8,0.8s1.3-1,1.1-1.5c-0.2-0.6-0.9-0.9-1.7-0.7
			C247.9,276.5,247.4,277.1,247.6,277.8z"
        />
        <path
          class="st0"
          d="M25.1,326.6c-0.1,0-0.2,0-0.2-0.1c-0.2,0-0.4,0-0.5,0c-0.8,0.1-1.5,0.8-1.4,1.4c0.1,0.7,0.9,1.1,1.7,0.9
			c0.8-0.2,1.3-0.7,1.3-1.4C26,327.1,25.6,326.7,25.1,326.6z"
        />
        <path
          class="st0"
          d="M64.4,312.7c-0.1,0.7-0.2,1.1-0.3,1.5c-0.3-0.2-0.6-0.4-0.8-0.5c-0.8,1.5-0.4,2.2,1.5,2.2
			c0.7,0,1.1-0.4,0.8-0.8c-0.3-0.4-0.5-0.8-0.4-1.4C65.3,313.4,64.8,313.2,64.4,312.7z"
        />
        <path
          class="st0"
          d="M187.8,283.9c0.8-0.2,1.4-0.8,1.3-1.5c-0.1-0.6-1-1-1.8-0.8c-0.7,0.2-1.3,0.8-1.2,1.4
			C186.3,283.6,187,284.1,187.8,283.9z"
        />
        <path
          class="st0"
          d="M260.8,269c0.1-0.1,0.1-0.1,0.2-0.2c0,0,0,0,0.1,0c0.2-0.7-0.2-1.3-0.9-1.6c-0.7-0.4-1.5-0.5-2.3,0.2
			C258.4,268.9,258.8,269.1,260.8,269z"
        />
        <path
          class="st0"
          d="M277.5,279.2c-0.1,1.6,0.4,2.1,2.6,2.3C280.3,279.7,279.6,279.1,277.5,279.2z"
        />
        <path
          class="st0"
          d="M283.2,260.5c-1.2,0.9-1.4,1.3-1.1,1.8c0.3,0.4,0.8,0.7,1.5,0.5c0.7-0.1,1.1-0.5,1.2-1.1
			C284.9,260.9,284.1,260.6,283.2,260.5z"
        />
        <path
          class="st0"
          d="M61.9,334.3c-0.1,0.7,0.1,1.3,1.2,1.7c0.1-1.1,2.1-0.7,2.2-2.1c-0.5-0.2-1-0.4-1.5-0.6
			C63.1,333.8,62.5,334.1,61.9,334.3z"
        />
        <path
          class="st0"
          d="M179.1,291.8c-0.1,0.8-0.1,1.4-0.2,2.2c0.6-0.3,1.2-0.5,1.7-0.8c0.6-0.2,1.1-0.5,1.7-0.7
			c-0.4-0.4-0.7-1-1.2-1.1C180.5,291.3,179.8,291.6,179.1,291.8z"
        />
        <path
          class="st0"
          d="M194,277.2c-0.6,0.4-0.8,1.2-0.2,1.7c0.6,0.6,1.5,0.3,2.8-0.8C195.6,276.9,194.9,276.6,194,277.2z"
        />
        <path
          class="st0"
          d="M300,258.8c0.1,0.6,0.9,0.9,1.6,0.8c0.7-0.2,1.3-0.8,1.2-1.4c-0.1-0.3-0.3-0.6-0.7-0.7
			c-0.3-0.1-0.7-0.2-1.1-0.1c-0.5,0.1-0.9,0.5-1,0.9C300,258.4,300,258.6,300,258.8z"
        />
        <path
          class="st0"
          d="M254.4,263.2c-0.7-0.5-1.6-0.6-2.5,0c0.5,1.5,1,1.8,2.9,1.6C255.4,264.1,255,263.6,254.4,263.2z"
        />
        <path
          class="st0"
          d="M208.8,289.1c0.2,0.6,0.9,0.9,1.7,0.7c0.7-0.2,1.1-0.7,1-1.3c-0.1-0.6-0.8-1-1.6-0.8
			C209.1,287.9,208.7,288.5,208.8,289.1z"
        />
        <path
          class="st0"
          d="M234.6,275.8c-0.8,0.1-1.3,0.7-1.2,1.3c0.1,0.6,0.8,0.9,1.6,0.8s1.3-0.8,1.2-1.3
			C236.1,276,235.3,275.6,234.6,275.8z"
        />
        <path
          class="st0"
          d="M76,315.2c-0.5,0.3-1,0.6-1.5,0.9c0.2,0.1,0.3,0.2,0.5,0.3c-0.2,0.2-0.3,0.5-0.5,0.7c0.3,0,0.6,0,0.9,0
			c0.8,0,1.2-0.2,1.5-0.7C77.1,315.8,76.7,315.4,76,315.2z"
        />
        <path
          class="st0"
          d="M72.9,316.1c0.1,0.2,0.2,0.3,0.4,0.5c0.3-0.3,0.5-0.6,0.7-0.6c0.1,0,0.3,0,0.4,0.1
			C74,315.7,73.4,315.7,72.9,316.1z"
        />
        <path
          class="st0"
          d="M190.4,305.9c0.7-0.6,0.4-1.3-0.8-1.9c-0.8,0.4-1.4,0.8-1.6,1.6C189,306.6,189.8,306.5,190.4,305.9z"
        />
        <path
          class="st0"
          d="M116.9,319.8c-0.1-0.5-0.8-0.8-1.5-0.7c-0.8,0.1-1.3,0.8-1.2,1.3c0.1,0.6,0.9,0.9,1.6,0.8
			C116.6,321,117.1,320.3,116.9,319.8z"
        />
        <path
          class="st0"
          d="M112.3,317.3c-0.4,0.1-0.8,0-1.1-0.1c-0.1,0.3,0.1,0.5,0.4,0.7c0.4,0.3,0.9,0.4,1.5,0.2
			c0.5-0.2,0.8-0.5,0.8-1c0-0.3-0.1-0.5-0.4-0.7C113.3,316.8,112.9,317.1,112.3,317.3z"
        />
        <path
          class="st0"
          d="M210.5,316.8c0.2,0,0.3-0.1,0.4-0.2c-0.3,0.1-0.6,0.2-0.9,0.2C210.1,316.8,210.3,316.8,210.5,316.8z"
        />
        <path
          class="st0"
          d="M209.9,314.7c-0.3,0.1-0.6,0.3-0.7,0.5c0.8-0.1,1.5-0.1,2.3-0.1C211.1,314.7,210.5,314.5,209.9,314.7z"
        />
        <path
          class="st0"
          d="M304.2,252.7c-0.6,0.1-1.2,0.8-1,1.3c0.1,0.5,0.7,0.8,1.4,0.7c0.7-0.1,1.2-0.6,1.1-1.2
			C305.6,252.9,304.9,252.6,304.2,252.7z"
        />
        <path
          class="st0"
          d="M209.6,303.8c-0.2-0.5-0.8-0.8-1.5-0.6c-0.7,0.2-1.2,0.8-1.1,1.3c0.1,0.5,0.9,0.9,1.5,0.7
			C209.2,305.1,209.7,304.3,209.6,303.8z"
        />
        <path
          class="st0"
          d="M293.3,315c-0.7,0.1-1.2,0.7-1.1,1.3c0.1,0.6,0.7,0.9,1.4,0.8c0.7-0.1,1.2-0.7,1.1-1.2
			C294.6,315.2,293.9,314.8,293.3,315z"
        />
        <path
          class="st0"
          d="M180.5,302.9c0.7-0.2,1.3-0.5,1.3-1.2c-0.5-0.5-1-0.9-1.5-1.4c-0.7,0-1.1,0.3-1,0.7
			C179.5,301.7,179.7,302.4,180.5,302.9z"
        />
        <path
          class="st0"
          d="M174.4,293.7c0.3,0.2,0.7,0.3,1.1,0.3c0.5-0.1,1-0.4,1-1c0-0.4-0.1-0.8-0.7-0.8c-0.6,0-1.1,0.1-1.7,0.1
			C174,292.8,173.9,293.3,174.4,293.7z"
        />
        <path
          class="st0"
          d="M219.2,328c-0.7,0.1-1.1,0.7-1,1.3c0.1,0.5,0.8,0.9,1.5,0.7c0.6-0.2,1-0.7,0.9-1.2
			C220.6,328.2,219.9,327.8,219.2,328z"
        />
        <path
          class="st0"
          d="M242.1,304.5c-0.7,0.1-1.2,0.7-1.1,1.2c0.1,0.5,0.6,0.8,1.3,0.7c0.7-0.1,1.2-0.7,1.1-1.2
			C243.4,304.7,242.7,304.4,242.1,304.5z"
        />
        <path
          class="st0"
          d="M111.4,319.1c-1.2,0.2-1.5,1-0.6,1.9c0.5-0.2,1.1-0.4,1.6-0.7c0.2-0.2,0.4-0.8,0.2-0.9
			C112.4,319.2,111.8,319,111.4,319.1z"
        />
        <path
          class="st0"
          d="M174,292.2C174,292.3,174,292.3,174,292.2C174.1,292.3,174.1,292.3,174,292.2
			C174.1,292.2,174.1,292.2,174,292.2C174.1,292.2,174,292.2,174,292.2z"
        />
        <path
          class="st0"
          d="M173.4,291.7c-0.5-0.1-0.9-0.2-1.1-0.6c-0.2-0.4-0.7-0.5-1.2-0.2c-0.4,0.2-0.4,0.8,0.1,1.1
			c0.5,0.3,1.1,0.5,1.7,0.9c0.4-0.2,0.8-0.4,1.1-0.6C173.8,292,173.6,291.8,173.4,291.7z"
        />
        <path
          class="st0"
          d="M235.7,253.2c0.2,0,0.5,0,0.6-0.1c0.4-0.3,0.9-0.8,1-1.2s-0.2-0.6-0.7-0.7c-0.3,0.6-0.4,1.2-0.3,1.9
			c-0.3,0-0.5,0-0.7,0C235.6,253.1,235.6,253.2,235.7,253.2z"
        />
        <path
          class="st0"
          d="M295.8,299.2c0.2-1.2,0.3-2.3,0.5-3.4C294.3,297.2,294.3,298.1,295.8,299.2z"
        />
        <path
          class="st0"
          d="M79.9,294.2c0,0.3,0,0.5,0,0.8c-0.1,0-0.1,0-0.2-0.1c0.1,0.3,0.3,0.4,0.4,0.6l0,0c0.6-0.3,1.3-0.3,1.7-0.1
			c0.1,0,0.1-0.1,0.2-0.1c-0.4-0.5-0.7-1.1-1.5-1.3C80.3,294,80.1,294.1,79.9,294.2z"
        />
        <path
          class="st0"
          d="M183,276.6c-0.7-0.2-1.2,0.1-1.9,1.4c1.6,0.5,2.1,0.4,2.4-0.2C183.8,277.3,183.6,276.7,183,276.6z"
        />
        <path
          class="st0"
          d="M271.6,273.7c0.3,1.3,0.4,1.3,2.2,1.7C273.8,273.8,273.2,273.4,271.6,273.7z"
        />
        <path
          class="st0"
          d="M183.9,323.1c-0.7,0.8-0.6,1.4,0,1.9c0.9-0.1,1.5-0.5,1.5-1.1C185.4,323.1,184.6,323.1,183.9,323.1z"
        />
        <path
          class="st0"
          d="M191,324.8c-0.1-0.5-0.7-0.9-1.2-0.8s-0.8,0.6-0.7,1.2s0.7,0.9,1.2,0.8C190.7,325.9,191.1,325.3,191,324.8z"
        />
        <path
          class="st0"
          d="M238.5,255.6c-0.1-0.2-0.3-0.3-0.4-0.5c0,0,0-0.1-0.1-0.1c-1.1,0.9-1,1,0,1.8c0.5-0.4,0.8-0.7,1-0.9
			C238.8,255.9,238.6,255.8,238.5,255.6z"
        />
        <path
          class="st0"
          d="M139.7,321.6c0.7,0.4,1.2,0,1.8-0.7c-0.5-0.4-1-0.8-1.5-1.2C139,320.8,139,321.2,139.7,321.6z"
        />
        <path
          class="st0"
          d="M108.7,319.7c0.8-0.2,1.3-0.6,1.5-1.5c-1.2,0.2-2.3,0.2-3.3,0.7C107.3,319.6,107.8,319.9,108.7,319.7z"
        />
        <path
          class="st0"
          d="M30.8,314.3c-0.3,0.1-0.7,0.3-0.8,0.6c-0.1,0.1-0.1,0.3-0.1,0.4c0,0.2,0.2,0.4,0.4,0.5
			c0.2,0.1,0.5,0.2,0.8,0.2c0.6-0.1,1.1-0.6,1-1.1C31.9,314.5,31.3,314.2,30.8,314.3z"
        />
        <path
          class="st0"
          d="M227.5,271.3L227.5,271.3L227.5,271.3L227.5,271.3L227.5,271.3L227.5,271.3c-0.5,0.2-1,0.4-1.6,0.6
			c-0.1-0.1-0.3-0.3-0.4-0.5c-0.1,0.3,0.3,0.6,1.3,1C227.3,271.9,227.5,271.6,227.5,271.3L227.5,271.3L227.5,271.3L227.5,271.3z"
        />
        <path
          class="st0"
          d="M56.8,337.4c-0.5,0.1-1,0.6-0.9,1.1s0.8,0.8,1.4,0.6c0.5-0.2,0.9-0.7,0.7-1.1
			C57.9,337.5,57.3,337.3,56.8,337.4z"
        />
        <path
          class="st0"
          d="M280.5,297.8c0.1,0.9,0.7,1.3,1.9,1.5C282.8,297.7,282.3,297.3,280.5,297.8z"
        />
        <path
          class="st0"
          d="M132.5,316.8c-0.5,0.1-1.1,0.7-0.8,1c0.2,0.3,0.7,0.5,1.1,0.6c0.5,0.1,1-0.5,1-0.9
			C133.6,317,133,316.7,132.5,316.8z"
        />
        <path
          class="st0"
          d="M140.9,313.7c-0.2,0.2-0.2,0.7-0.1,0.9c0,0.1,0.7,0.1,1,0c0.5-0.2,0.9-0.5,1.4-0.9
			C142,313,141.4,313,140.9,313.7z"
        />
        <path
          class="st0"
          d="M117.6,323.1c-0.4,0.2-0.7,0.5-1.3,1c0.6,0.3,1,0.6,1.5,0.6c0.6,0.1,1.1-0.6,1-1
			C118.7,323.3,118.1,322.9,117.6,323.1z"
        />
        <path
          class="st0"
          d="M133.4,305.5c-0.2,0.8-0.2,1.5,0.9,2.1c-0.1-1.1,0.8-2-0.2-3C133.8,305,133.4,305.2,133.4,305.5z"
        />
        <path
          class="st0"
          d="M232.8,283.2c0.1,0.4,0.7,0.7,1.2,0.6c0.4-0.1,0.8-0.5,0.8-0.8c0,0,0,0,0-0.1s0-0.1-0.1-0.2
			c-0.2-0.3-0.7-0.5-1.1-0.5C233.3,282.2,232.8,282.8,232.8,283.2z"
        />
        <path
          class="st0"
          d="M269.3,269.8c0.5-0.1,1-0.8,0.7-1.1c-0.2-0.3-0.7-0.4-1.1-0.5c-0.5,0-0.9,0.6-0.8,1
			C268.1,269.6,268.8,269.9,269.3,269.8z"
        />
        <path
          class="st0"
          d="M41.5,307.1c-0.2,0.3-0.4,0.7-0.7,1s-0.7,0.5-1,0.8c0.2,0.3,0.4,0.5,0.7,0.9l0,0c0,0,0-0.1,0.1-0.1
			c0.3-0.4,0.7-0.8,1.1-1.2c0.1-0.1,0.1-0.1,0.2-0.2c0.3-0.3,0.4-0.7,0.2-1.2C41.8,307.2,41.7,307.2,41.5,307.1z"
        />
        <path
          class="st0"
          d="M149.9,324.8c0.2,0.8,0.8,1.3,2.1,1C151.5,324.4,151.2,324.3,149.9,324.8z"
        />
        <path
          class="st0"
          d="M144,297.6c-0.3-1-0.5-1.2-1.2-0.9c-0.6,0.2-0.7,0.6-0.6,1C142.3,298.1,142.8,298.1,144,297.6z"
        />
        <path
          class="st0"
          d="M212.3,322c0.1,0.1,0.2,0.3,0.3,0.4c0.5-0.3,0.8-0.5,1-0.7c0.3-0.3,0.1-0.6-0.2-1.2
			C212.2,321.3,212,321.5,212.3,322z"
        />
        <path
          class="st0"
          d="M171.8,293.1c-0.1-0.1-0.2-0.2-0.3-0.2c0.2,0.2,0.3,0.5,0.4,0.7C172,293.5,172,293.3,171.8,293.1z"
        />
        <path
          class="st0"
          d="M206.9,315.5c-0.4-0.3-0.9-0.2-1.9,0.1c0.3,0.6,0.8,1,1.5,1c0.2,0,0.5-0.1,0.6-0.3c0.1-0.1,0.1-0.2,0.1-0.3
			c-0.2-0.1-0.4-0.3-0.6-0.5C206.7,315.5,206.8,315.5,206.9,315.5z"
        />
        <path
          class="st0"
          d="M73,320.6c-0.1,0.3-0.1,0.7,0.1,0.9c0.4,0.5,0.9,0.4,1.9-0.4c-0.4-0.3-0.7-0.6-1-0.7
			C73.7,320.4,73.1,320.5,73,320.6z"
        />
        <path
          class="st0"
          d="M190.7,297.5c-0.3,0.1-0.7,0.5-0.8,0.7c-0.1,0.4,0.4,0.7,1.1,0.6c0.1-0.2,0.5-0.4,0.6-0.7
			C191.8,297.7,191.2,297.3,190.7,297.5z"
        />
        <path
          class="st0"
          d="M191.1,336.8c-0.5,1-0.5,1,0.8,1.7C192.2,337.2,192.2,337.2,191.1,336.8z"
        />
        <path
          class="st0"
          d="M133.4,312.1c-0.6-0.3-1,0.1-1.5,0.6c0.6,0.6,0.6,0.6,1.4,0.7C133.9,312.9,134.1,312.5,133.4,312.1z"
        />
        <path
          class="st0"
          d="M68.7,310.6c0.2-0.6-0.3-0.7-0.8-0.9l0,0c-0.2,0-0.5-0.1-0.7-0.1c0.1,0.9,0.8,1.4,1.6,2.3
			C68.8,311.3,68.6,311,68.7,310.6z"
        />
        <path
          class="st0"
          d="M44.5,302.6c0.1-0.2-0.1-0.6-0.3-0.7c-0.9-0.3-1.1,0.3-1.4,0.9C43.9,303.2,44.4,303.2,44.5,302.6z"
        />
        <path
          class="st0"
          d="M181.5,328.7L181.5,328.7C181.4,328.7,181.4,328.7,181.5,328.7c-0.3,0.3-0.5,0.5-0.8,0.8
			c0.4,0.3,0.7,0.5,1,0.6c0.4,0.1,0.8-0.6,0.6-0.9C182.2,328.9,181.8,328.8,181.5,328.7z"
        />
        <path
          class="st0"
          d="M264,272.3c0.5,0.5,1,0.9,1.9,0.9C266,271.9,265.6,271.7,264,272.3z"
        />
        <path
          class="st0"
          d="M200.6,319.6c0,0.4-0.2,0.9,0,1c0.4,0.3,1,0.5,1.6,0C202.2,319.9,201.6,319.7,200.6,319.6z"
        />
        <path
          class="st0"
          d="M140.5,317.3c-0.3,0.5-0.8,1,0,1.2c0.5,0.2,1.3-0.1,1.3-0.5C141.9,317.2,141.1,317.4,140.5,317.3z"
        />
        <path
          class="st0"
          d="M142.6,309.7c0.6,0.4,1.1-0.1,1.6-0.7c-0.4-0.2-0.6-0.4-1-0.7C142.8,308.9,141.9,309.3,142.6,309.7z"
        />
        <path
          class="st0"
          d="M191.9,309.2c0.2,0.2,0.5,0.4,0.8,0.4c0.4,0,0.8-0.2,1.3-0.3c-0.3-0.3-0.6-0.6-0.9-0.7c-0.2-0.1-0.7,0-1,0.2
			C192,308.8,191.8,309.1,191.9,309.2z"
        />
        <path
          class="st0"
          d="M59.7,328.3c-0.3,0-0.6,0.4-1.1,0.8c0.5,0.2,0.9,0.5,1.2,0.5c0.3-0.1,0.7-0.5,0.7-0.7
			C60.5,328.6,60,328.3,59.7,328.3z"
        />
        <path
          class="st0"
          d="M191.5,323.3c0.2-0.1,0.2-0.6,0.1-0.7c-0.3-0.3-0.7-0.6-1.1-0.8c-0.2,0.1-0.3,0.2-0.5,0.4
			c0.2,0.4,0.3,0.9,0.6,1.2C190.7,323.5,191.3,323.5,191.5,323.3z"
        />
        <path
          class="st0"
          d="M65.1,311c0.3,0.8,1.4,0.5,1.9,1C67.4,310.9,66.9,310.7,65.1,311z"
        />
        <path
          class="st0"
          d="M198.2,325.6c-0.3,1-0.3,1.1,1.3,1.4C199.5,326.3,199.3,325.8,198.2,325.6z"
        />
        <path
          class="st0"
          d="M52.9,309.3c0.1,0.1,0.2,0.1,0.3,0.2c0-0.2,0-0.3,0-0.5c-0.2,0-0.3,0.1-0.5,0.1
			C52.8,309.2,52.8,309.3,52.9,309.3z"
        />
        <path
          class="st0"
          d="M295.7,272.4c-0.2,0.3-0.5,0.6-0.5,0.8c0,0.4,0.4,0.6,0.9,0.5s0.7-0.5,0.5-0.8S296,272.6,295.7,272.4z"
        />
        <path
          class="st0"
          d="M245.8,255.3c0.1,0.6,0.4,0.9,1.2,1.2c-0.3-0.3-0.7-0.6-0.6-0.8v-0.1C246.2,255.6,246,255.5,245.8,255.3z"
        />
        <path
          class="st0"
          d="M72.8,331.1c-0.3,0.1-0.4,0.4-0.7,0.8c0.5,0.1,0.9,0.3,1.2,0.2c0.2-0.1,0.5-0.5,0.4-0.7
			C73.7,330.9,73.2,330.9,72.8,331.1z"
        />
        <path
          class="st0"
          d="M218.4,276.4c0.2,0.1,0.5,0.1,0.8,0c0.1,0,0.2-0.4,0.1-0.5c-0.2-0.6-0.7-0.7-1.4-0.2
			C218.1,275.9,218.2,276.2,218.4,276.4z"
        />
        <path
          class="st0"
          d="M195.3,306.4c0,0.1,0,0.3,0.1,0.4c0.7,0.2,1.1,0,1.5-0.8C196.1,305.8,195.6,305.7,195.3,306.4z"
        />
        <path
          class="st0"
          d="M101.3,318.8c-0.2,0.2-0.4,0.4-0.8,0.7c0.5,0.2,0.8,0.4,1.1,0.4c0.1,0,0.5-0.5,0.5-0.6
			C102,319.2,101.6,319,101.3,318.8z"
        />
        <path
          class="st0"
          d="M165.5,326.5c-0.4,0.5-0.8,0.9-0.2,1.4C166.2,327,166.2,327,165.5,326.5z"
        />
        <path
          class="st0"
          d="M153.8,309.5c0.1,0.6-0.4,1.1,0.3,1.5C155.1,310,155.1,310,153.8,309.5z"
        />
        <path
          class="st0"
          d="M185.2,288.6c0,0.1,0,0.1,0,0.2c0.6,0.2,1.1,0.4,1.9,0.6c-0.1-0.6-0.4-0.9-0.8-1
			C186,288.4,185.6,288.5,185.2,288.6z"
        />
        <path
          class="st0"
          d="M202.3,318.1c-0.1,0-0.3,0.2-0.3,0.4c0.1,0.6,0.6,0.7,1.5,0.5C203.4,318.3,203,318,202.3,318.1z"
        />
        <path
          class="st0"
          d="M61.6,310.6c-0.1,0.1-0.2,0.1-0.4,0.2c0.1,1.1,0.1,1.1,1.2,1.4C62.1,311.6,61.9,311.1,61.6,310.6z"
        />
        <path
          class="st0"
          d="M118.4,310.9c-0.3-1-0.3-1-1.6-0.9C117.3,310.4,117.4,311,118.4,310.9z"
        />
        <path
          class="st0"
          d="M74,317.9c-0.1,0.8,0.1,1.2,0.8,1.5C75.2,318.5,75.2,318.5,74,317.9z"
        />
        <path
          class="st0"
          d="M144.3,314.6c0.4-0.3,0.8-0.5,1.2-0.7c-0.2-0.3-0.4-0.6-0.5-0.9c-0.3,0.4-0.6,0.7-0.9,1.1
			C144.1,314.3,144.2,314.4,144.3,314.6z"
        />
        <path
          class="st0"
          d="M225.7,289.4c-0.3,0.4-0.6,0.8-0.9,1.2c0.1,0.1,0.2,0.1,0.3,0.2c0.4-0.2,0.6-0.3,0.8-0.4
			C225.8,290.1,225.7,289.8,225.7,289.4z"
        />
        <path
          class="st0"
          d="M195.4,315.5c0.1,0.3,0.4,0.5,0.7,0.8c0.3-0.4,0.6-0.6,0.6-0.7c-0.2-0.3-0.5-0.4-0.8-0.6
			C195.7,315.1,195.3,315.4,195.4,315.5z"
        />
        <path
          class="st0"
          d="M187.3,329.2c-0.2,0-0.5,0.4-0.8,0.7c0,0-0.1,0-0.1,0.1c0.4,0.1,0.8,0.3,1.3,0.4
			C188,329.7,188,329.2,187.3,329.2z"
        />
        <path
          class="st0"
          d="M196.6,285.9c-0.2-0.2-0.5-0.3-0.8-0.4c-0.1,0-0.3,0.3-0.7,0.6c0.5,0.1,0.8,0.3,1.2,0.3
			C196.4,286.4,196.7,285.9,196.6,285.9z"
        />
        <path
          class="st0"
          d="M71.1,315c0.3,0.4,0.6,0.7,1.2,1.4c0.1-0.6,0.3-0.9,0.2-1.1C72.2,315,71.9,314.5,71.1,315z"
        />
        <path
          class="st0"
          d="M287.6,259.9c0.6-0.7,0.6-0.7,0-1.3C287.1,259.1,287.1,259.5,287.6,259.9z"
        />
        <path
          class="st0"
          d="M253.4,269c0,0.5,0.2,0.8,0.6,0.9c0.2,0.1,0.4,0.1,0.6,0.1c0.1-0.4,0-0.6-0.1-0.8
			C254.3,269,253.9,269,253.4,269z"
        />
        <path
          class="st0"
          d="M197.4,331.5c-0.4,0.9,0.2,1.1,1,1.2C198.4,332,198.4,331.5,197.4,331.5z"
        />
        <path
          class="st0"
          d="M185.1,280.9c-0.5-0.1-0.8-0.2-1.2-0.3c-0.1,0.1-0.2,0.2-0.3,0.3c0.3,0.4,0.5,0.7,0.9,1.3
			C184.8,281.5,184.9,281.2,185.1,280.9z"
        />
        <path
          class="st0"
          d="M136.8,305c-0.2-0.2-0.5-0.3-0.8-0.3c-0.2,0-0.4,0.3-0.6,0.5c0.3,0.2,0.6,0.3,1,0.6
			C136.6,305.4,136.8,305.1,136.8,305z"
        />
        <path
          class="st0"
          d="M46.8,295.5c-0.4,1.2-0.4,1.2,0.9,1.6C47.4,296.5,47.1,296.1,46.8,295.5z"
        />
        <path
          class="st0"
          d="M34.4,308.8c0.2,0.3,0.4,0.6,0.8,1.1C35.7,308.9,35.3,308.7,34.4,308.8z"
        />
        <path
          class="st0"
          d="M45.6,294.5c0.4,0.1,0.7,0.2,0.9,0.2c0.3-0.2,0.6-0.5,0.9-0.7c-0.1-0.1-0.2-0.2-0.3-0.3
			C46.5,293.9,45.9,293.9,45.6,294.5z"
        />
        <path
          class="st0"
          d="M135.5,307.1c0.2,0.1,0.6,0.3,0.7,0.2c0.2-0.2,0.4-0.4,0.5-0.7c0-0.1-0.3-0.2-0.6-0.4
			C135.9,306.6,135.7,306.9,135.5,307.1z"
        />
        <path
          class="st0"
          d="M184.4,302.5c0,0,0,0.1-0.1,0.3c1,0.3,1.1,0.3,1.3,0c0.1-0.1,0.1-0.3,0.1-0.4
			C185.2,302,184.8,302.2,184.4,302.5z"
        />
        <path
          class="st0"
          d="M182,289.3c-0.3,0-0.7,0-1-0.1c0,0.2-0.1,0.3-0.1,0.5c0.3,0,0.7,0.1,1,0.1C181.9,289.7,181.9,289.5,182,289.3
			z"
        />
        <path
          class="st0"
          d="M189.1,315.6c-0.1,0-0.4,0.1-0.4,0.2c-0.2,0.5,0.1,0.7,0.8,0.8C189.6,316.1,189.7,315.7,189.1,315.6z"
        />
        <path
          class="st0"
          d="M162.8,327.2c-0.1,0.2-0.3,0.5-0.4,0.7c0,0.1,0.3,0.2,0.6,0.4c0.1-0.4,0.3-0.6,0.3-0.9
			C163.3,327.4,163,327.3,162.8,327.2z"
        />
        <path
          class="st0"
          d="M149.7,321.2c0.4,0.1,0.7,0.2,0.7,0.2c0.2-0.2,0.4-0.5,0.5-0.7l-0.4-0.2C150.3,320.7,150.1,320.9,149.7,321.2
			z"
        />
        <path
          class="st0"
          d="M234.5,281.1c-0.7-0.3-1.1-0.1-1.4,0.6C233.8,281.8,234.2,281.6,234.5,281.1z"
        />
        <path
          class="st0"
          d="M185,299.3c-0.2,0.1-0.4,0.3-0.7,0.5c0.3,0.1,0.6,0.3,0.7,0.3c0.2-0.1,0.4-0.3,0.5-0.5
			C185.5,299.5,185.1,299.2,185,299.3z"
        />
        <path
          class="st0"
          d="M185.4,310.9c0.2,0.1,0.5,0.2,0.7,0.2s0.4-0.2,0.7-0.4c-0.2-0.1-0.4-0.3-0.6-0.3c-0.2,0-0.5,0-0.7,0.1
			C185.4,310.6,185.3,310.9,185.4,310.9z"
        />
        <path
          class="st0"
          d="M49.5,294.9c-0.6-0.2-1-0.7-1.5,0.1C48.4,295.3,48.8,295.5,49.5,294.9z"
        />
        <path
          class="st0"
          d="M127.5,304.9c0-0.1-0.4-0.3-0.5-0.2c-0.2,0.1-0.4,0.3-0.6,0.6c0.3,0.1,0.6,0.2,0.7,0.2
			C127.3,305.3,127.5,305.1,127.5,304.9z"
        />
        <path
          class="st0"
          d="M155.9,316.4c-0.8,0.6-0.8,0.6-0.5,0.8c0.2,0.1,0.5,0.1,0.9,0.3C156.1,317,156,316.7,155.9,316.4z"
        />
        <path
          class="st0"
          d="M149.1,308.7c0.7-0.5,1-1,0.6-1.5C149.4,307.6,149,308.1,149.1,308.7z"
        />
        <path
          class="st0"
          d="M160.9,317.8c-0.2,0.2-0.4,0.3-0.7,0.6c0.4,0.1,0.6,0.2,0.7,0.2c0.2-0.1,0.4-0.3,0.4-0.4
			C161.3,318.1,161,317.9,160.9,317.8z"
        />
        <path
          class="st0"
          d="M67.9,316.9c0-0.1-0.2-0.2-0.5-0.4c-0.3,0.3-0.4,0.5-0.6,0.7c0.2,0.1,0.4,0.3,0.5,0.2
			C67.6,317.3,67.8,317.1,67.9,316.9z"
        />
        <path
          class="st0"
          d="M188.8,301.3c-0.2,0.3-0.3,0.5-0.4,0.7c0.2,0.1,0.5,0.2,0.7,0.2c0.1,0,0.4-0.3,0.3-0.4
			C189.4,301.6,189.1,301.5,188.8,301.3z"
        />
        <path
          class="st0"
          d="M55.2,323c-0.1,0.2-0.2,0.5-0.2,0.7c0,0.1,0.4,0.3,0.4,0.3c0.2-0.1,0.4-0.3,0.5-0.5c0-0.1-0.2-0.2-0.3-0.4
			C55.5,323.1,55.4,323,55.2,323z"
        />
        <path
          class="st0"
          d="M145,313c1.1-0.2,1.2-0.3,0.7-1.3C145.5,312.1,145.3,312.5,145,313z"
        />
        <path
          class="st0"
          d="M287.1,256.7c0,0.2,0.3,0.3,0.7,0.5c0.2-0.3,0.3-0.5,0.3-0.7c0-0.1-0.4-0.3-0.5-0.3
			C287.4,256.3,287,256.5,287.1,256.7z"
        />
        <path
          class="st0"
          d="M224.5,326.3c0.3,0.1,0.6,0.1,0.8,0.2c0.1-0.2,0.2-0.3,0.2-0.5c-0.2-0.1-0.5-0.1-0.7-0.2
			C224.8,325.9,224.7,326.1,224.5,326.3z"
        />
        <path
          class="st0"
          d="M270.3,278.4c0.3-0.3,0.6-0.5,0.8-0.8c0,0-0.1-0.2-0.3-0.4c-0.3,0.4-0.6,0.7-0.8,1
			C270.1,278.3,270.2,278.4,270.3,278.4z"
        />
        <path
          class="st0"
          d="M293,255.3l0.2,0.2c0.3-0.2,0.5-0.4,0.8-0.6c-0.2-0.1-0.3-0.2-0.5-0.3C293.4,254.8,293.2,255,293,255.3z"
        />
        <path
          class="st0"
          d="M73.4,312.1c0-0.7-0.8-0.6-1.2-0.7C72.3,311.8,72.7,312.2,73.4,312.1z"
        />
        <path
          class="st0"
          d="M72.2,311.4C72.2,311.3,72.1,311.3,72.2,311.4C72.1,311.3,72.1,311.3,72.2,311.4
			C72.1,311.3,72.1,311.3,72.2,311.4C72.1,311.4,72.1,311.4,72.2,311.4z"
        />
        <path
          class="st0"
          d="M215.6,295.5c-0.3-0.4-0.4-0.6-0.7-1.1C214.6,295.2,214.7,295.5,215.6,295.5z"
        />
        <path
          class="st0"
          d="M191.7,312.5C191.8,312.5,191.8,312.5,191.7,312.5c0.1,0,0.1-0.1,0.1-0.1
			C191.8,312.5,191.8,312.5,191.7,312.5C191.8,312.5,191.7,312.5,191.7,312.5z"
        />
        <path
          class="st0"
          d="M191.7,312.5c-0.6,0.1-1.1,0.2-1.7,0.4C190.8,313.4,190.9,313.4,191.7,312.5z"
        />
        <path
          class="st0"
          d="M244.8,260.6c-0.1,0.1-0.2,0.1-0.3,0.2c0,0-0.1-0.1-0.2-0.2c-0.1,0.2-0.2,0.4-0.2,0.6
			C244.5,261,244.8,260.8,244.8,260.6z"
        />
        <path
          class="st0"
          d="M244.6,260c-0.1,0.2-0.1,0.3-0.2,0.5c0.2,0,0.3,0,0.4,0C244.8,260.3,244.7,260.2,244.6,260z"
        />
        <path
          class="st0"
          d="M189,303.2c0,0.1,0.2,0.3,0.4,0.5c0.3-0.3,0.4-0.5,0.6-0.7c-0.2-0.1-0.4-0.3-0.6-0.2
			C189.2,302.8,189,303,189,303.2z"
        />
        <path
          class="st0"
          d="M208.6,280.5c0.1,0.1,0.1,0.2,0.2,0.3c0.2-0.1,0.4-0.1,0.6-0.2c0.1-0.1,0.2-0.3,0.3-0.4
			c-0.1,0-0.1-0.1-0.2-0.1C209.2,280.2,208.9,280.3,208.6,280.5z"
        />
        <path
          class="st0"
          d="M291.5,252c-0.5,0.1-0.7,0.3-0.6,0.7c0,0.1,0.3,0.2,0.4,0.1C291.8,252.6,291.9,252.3,291.5,252z"
        />
        <path
          class="st0"
          d="M58,312.5c-0.1-0.4-0.1-0.6-0.2-0.7h-0.1C57.7,312.1,57.8,312.3,58,312.5C57.9,312.5,57.9,312.5,58,312.5z"
        />
        <path
          class="st0"
          d="M151.6,312.6c0.2-0.2,0.3-0.4,0.4-0.6c0,0-0.3-0.2-0.4-0.1c-0.2,0.1-0.4,0.3-0.7,0.5
			C151.2,312.5,151.5,312.7,151.6,312.6z"
        />
        <path
          class="st0"
          d="M144.6,299.2C144.6,299.2,144.6,299.3,144.6,299.2h0.1C144.7,299.2,144.7,299.2,144.6,299.2
			C144.7,299.2,144.6,299.2,144.6,299.2z"
        />
        <path
          class="st0"
          d="M143.8,298.6c-0.1,0-0.3,0.3-0.3,0.3c0.1,0.5,0.7,0.3,1.1,0.3C144.5,298.8,144.4,298.5,143.8,298.6z"
        />
        <path
          class="st0"
          d="M142.3,300.3c0.1-0.2,0.3-0.5,0.4-0.7c-0.2,0-0.4-0.1-0.4-0.1c-0.2,0.2-0.3,0.4-0.5,0.6
			C142,300.2,142.1,300.2,142.3,300.3z"
        />
        <path
          class="st0"
          d="M264.5,275.3c-0.3,0-0.6-0.1-0.8,0c-0.2,0-0.5,0.1-0.7,0.2c0,0.1,0,0.1,0,0.2c0.5,0,1-0.1,1.5-0.1
			C264.5,275.5,264.5,275.4,264.5,275.3z"
        />
        <path
          class="st0"
          d="M37.1,304.4c0.1,0.1,0.2,0.2,0.3,0.3c0.3-0.2,0.7-0.4,1-0.6c-0.1-0.1-0.1-0.2-0.2-0.2
			C37.8,304.1,37.4,304.2,37.1,304.4z"
        />
        <path
          class="st0"
          d="M255.9,252.5c0.1,0.1,0.3,0.3,0.4,0.4c0.1-0.1,0.2-0.1,0.3-0.2c-0.1-0.1-0.3-0.2-0.4-0.4
			C256.2,252.4,256.1,252.4,255.9,252.5z"
        />
        <path
          class="st0"
          d="M86.7,300.3c0.1-0.3,0-0.5-0.3-0.7c0,0.2,0,0.4,0,0.6C86.6,300.3,86.6,300.3,86.7,300.3z"
        />
        <path
          class="st0"
          d="M193.4,337c0.1,0.2,0.2,0.4,0.3,0.7c0.2,0,0.3-0.1,0.5-0.1c-0.1-0.2-0.3-0.4-0.4-0.6
			C193.6,336.9,193.5,336.9,193.4,337z"
        />
        <path
          class="st0"
          d="M242,249.2c-0.4-0.2-0.8-0.5-1.1,0.1c0,0.1,0.1,0.2,0.1,0.2C241.3,249.4,241.7,249.3,242,249.2z"
        />
        <path
          class="st0"
          d="M68,325.2c-0.3-0.5-0.5-0.7-0.7-1c-0.1,0.1-0.3,0.1-0.4,0.2C66.9,324.7,67,325.1,68,325.2z"
        />
        <path
          class="st0"
          d="M243.8,251.2c0.2,0.1,0.4,0.1,0.6,0.1c0.2,0,0.5-0.1,0.8-0.1C244.7,251.1,244.2,250.5,243.8,251.2z"
        />
        <path
          class="st0"
          d="M69,309.2c0.2,0.3,0.3,0.6,0.5,0.8c0.1,0,0.2-0.1,0.3-0.1c-0.2-0.3-0.4-0.5-0.6-0.8
			C69.1,309.1,69,309.1,69,309.2z"
        />
        <path
          class="st0"
          d="M189.9,311.6c-0.5,0.5-0.7,1,0,1.3c-0.1-0.2-0.1-0.4-0.1-0.6C189.8,312,189.9,311.8,189.9,311.6z"
        />
        <path
          class="st0"
          d="M178.2,298.8c0,0,0.4-0.2,0.4-0.3c0-0.5-0.4-0.5-1-0.3C177.8,298.4,178,298.6,178.2,298.8z"
        />
        <path
          class="st0"
          d="M152.5,315.1c0.1,0.1,0.3,0.3,0.4,0.3c0.2,0,0.3-0.2,0.6-0.4c-0.2-0.1-0.3-0.3-0.4-0.3
			C152.8,314.8,152.7,315,152.5,315.1z"
        />
        <path
          class="st0"
          d="M205.6,320c-0.4-0.2-0.7-0.4-1.2-0.7C204.5,320.2,204.8,320.2,205.6,320z"
        />
        <path
          class="st0"
          d="M141.7,338c0,0.1,0,0.2,0.1,0.2c0.5,0.2,0.7-0.1,0.9-0.4C142.2,337.5,141.9,337.5,141.7,338z"
        />
        <path
          class="st0"
          d="M102.7,309.7C102.7,309.8,102.6,309.8,102.7,309.7c-0.1,0.2-0.1,0.4-0.2,0.6c0,0,0,0.1-0.1,0.1l0.1-0.1
			c0.2-0.1,0.3-0.3,0.5-0.4C102.9,309.9,102.8,309.8,102.7,309.7z"
        />
        <path
          class="st0"
          d="M142.6,304.5c-0.3,0.1-0.5,0.2-0.8,0.3c0.1,0.2,0.2,0.5,0.3,0.7C142.7,305.2,142.8,304.9,142.6,304.5z"
        />
        <path
          class="st0"
          d="M184.6,295.4c-0.2,0-0.4,0.2-0.5,0.3c0,0.1,0.2,0.2,0.4,0.4c0.2-0.2,0.5-0.4,0.5-0.5
			C185,295.6,184.7,295.4,184.6,295.4z"
        />
        <path
          class="st0"
          d="M218.2,272c0.1,0.3,0.2,0.6,0.3,0.9C219,272.2,219,272.2,218.2,272z"
        />
        <path
          class="st0"
          d="M146.4,312.7c0,0.4,0,0.8-0.1,1.2c0.1,0,0.2,0,0.3,0c0.1-0.4,0.1-0.8,0.2-1.2
			C146.6,312.7,146.5,312.7,146.4,312.7z"
        />
        <path
          class="st0"
          d="M73.3,329c0.2,0.3,0.4,0.5,0.8,0.9C74.2,329.3,74,329,73.3,329z"
        />
        <path
          class="st0"
          d="M72.4,318.8c0.2-0.1,0.5-0.3,0.7-0.4c0,0-0.1-0.2-0.2-0.3c-0.2,0.2-0.5,0.4-0.7,0.5
			C72.3,318.7,72.4,318.7,72.4,318.8z"
        />
        <path
          class="st0"
          d="M183.4,294.5c0,0,0,0.2,0,0.3c0.3-0.1,0.6-0.1,0.9-0.2c0-0.1-0.1-0.2-0.1-0.3
			C184,294.3,183.7,294.4,183.4,294.5z"
        />
        <path
          class="st0"
          d="M140.4,302c-0.2,0.1-0.3,0.2-0.5,0.4c0.2,0.2,0.3,0.3,0.4,0.4c0.2-0.2,0.3-0.3,0.4-0.5
			C140.7,302.2,140.4,302,140.4,302z"
        />
        <path
          class="st0"
          d="M40.5,312.3c0.2,0.2,0.4,0.4,0.6,0.6c0.1,0,0.2-0.1,0.2-0.1c-0.2-0.2-0.3-0.5-0.5-0.7
			C40.7,312.2,40.6,312.2,40.5,312.3z"
        />
        <path
          class="st0"
          d="M30.8,302.4C30.7,302.4,30.7,302.3,30.8,302.4C30.7,302.4,30.7,302.4,30.8,302.4L30.8,302.4z"
        />
        <path
          class="st0"
          d="M178.4,300.9c-0.2,0-0.4,0.2-0.6,0.3c0.2,0.1,0.4,0.3,0.5,0.3c0.2-0.1,0.4-0.3,0.6-0.5
			C178.7,301,178.6,300.9,178.4,300.9z"
        />
        <path
          class="st0"
          d="M239.8,261.4c-0.1-0.2-0.2-0.5-0.3-0.7c-0.1,0.1-0.2,0.1-0.4,0.2c0.2,0.2,0.3,0.4,0.5,0.6
			C239.7,261.5,239.8,261.5,239.8,261.4z"
        />
        <path
          class="st0"
          d="M88.4,290.9c-0.1-0.1-0.1-0.1-0.2-0.2c-0.1,0-0.2,0-0.2,0C88.2,290.8,88.3,290.8,88.4,290.9z"
        />
        <path
          class="st0"
          d="M175.3,324c0.1,0,0.1,0,0.2,0c0-0.3,0-0.5,0-0.8c-0.1,0-0.3,0-0.4,0C175.2,323.5,175.3,323.8,175.3,324z"
        />
        <path
          class="st0"
          d="M195.9,328c0,0.1,0.2,0.2,0.3,0.3c0.1,0,0.4-0.2,0.3-0.2c-0.1-0.1-0.2-0.3-0.4-0.5
			C196,327.8,195.9,328,195.9,328z"
        />
        <path
          class="st0"
          d="M192.8,331.7c-0.2,0.4,0.1,0.6,0.7,0.6c-0.2-0.3-0.3-0.5-0.4-0.8C193.1,331.5,192.8,331.6,192.8,331.7z"
        />
        <path
          class="st0"
          d="M84,295.3c-0.4,0.1-0.4,0.2-0.7,0.7c0.3-0.2,0.5-0.3,0.7-0.4C84,295.5,84,295.4,84,295.3z"
        />
        <path
          class="st0"
          d="M286.9,267.3c0.1,0,0.2,0,0.3,0c0.1-0.3,0.1-0.5,0.2-0.8c-0.2,0-0.3,0-0.5,0
			C286.9,266.8,286.9,267,286.9,267.3z"
        />
        <path
          class="st0"
          d="M238,262.1c-0.1-0.1-0.3-0.1-0.4-0.2c-0.1,0.3-0.3,0.5-0.4,0.8c0.1,0,0.2,0.1,0.2,0.1
			C237.6,262.6,237.8,262.3,238,262.1z"
        />
        <path
          class="st0"
          d="M292.9,265v-0.1h-0.1h-0.1c-0.1,0.2-0.1,0.4-0.2,0.6c0.1,0,0.3,0,0.4,0C292.9,265.3,292.9,265.1,292.9,265z"
        />
        <path
          class="st0"
          d="M130.7,313.5c-0.2,0.1-0.3,0.2-0.5,0.4c0.2,0.1,0.4,0.2,0.5,0.2c0.1-0.1,0.3-0.2,0.3-0.3
			C130.9,313.7,130.8,313.6,130.7,313.5z"
        />
        <path
          class="st0"
          d="M192.4,335.7c0,0.3-0.1,0.4-0.1,0.6c0,0.1,0.2,0.1,0.4,0.2c0.1-0.2,0.2-0.3,0.2-0.5
			C193,335.9,192.7,335.9,192.4,335.7z"
        />
        <path
          class="st0"
          d="M156.2,322.9c0.2,0,0.4,0.1,0.5,0.1c0.1-0.1,0.2-0.2,0.2-0.3c-0.1,0-0.3-0.1-0.4-0.1
			C156.4,322.6,156.3,322.7,156.2,322.9z"
        />
        <path
          class="st0"
          d="M30.4,319.9c0.1,0,0.3,0,0.4,0.1c0.1-0.2,0.1-0.5,0.2-0.7c-0.1,0-0.2,0-0.3,0
			C30.7,319.4,30.6,319.7,30.4,319.9z"
        />
        <path
          class="st0"
          d="M148.9,315.2c0.1,0,0.2,0.1,0.3,0.1c0.1-0.2,0.2-0.4,0.3-0.6c-0.1,0-0.1,0-0.2,0
			C149.1,314.8,149,315,148.9,315.2z"
        />
        <path
          class="st0"
          d="M172.3,302.2L172.3,302.2c0.1,0.1,0.1,0.2,0.2,0.2c0.1-0.1,0.2-0.2,0.3-0.3c-0.2,0-0.5,0-0.7,0
			C172.1,302.1,172.2,302.2,172.3,302.2L172.3,302.2z"
        />
        <path
          class="st0"
          d="M166.1,322.2c0,0.1,0.2,0.2,0.2,0.3c0.2-0.1,0.3-0.2,0.6-0.4c-0.3-0.1-0.4-0.2-0.5-0.1
			C166.2,322,166.1,322.1,166.1,322.2z"
        />
        <path
          class="st0"
          d="M191.9,328.5c-0.1,0.1-0.2,0.2-0.4,0.3c0.2,0.1,0.4,0.1,0.5,0.2c0-0.1,0.1-0.2,0.1-0.4
			C192.2,328.6,192,328.5,191.9,328.5z"
        />
        <path
          class="st0"
          d="M76.3,321.3c-0.1,0.1-0.3,0.2-0.4,0.3c0.2,0.1,0.3,0.1,0.5,0.2c0.1-0.1,0.2-0.2,0.2-0.3
			C76.6,321.4,76.4,321.3,76.3,321.3z"
        />
        <path
          class="st0"
          d="M48.7,300.1c-0.2-0.2-0.3-0.5-0.5-0.7c-0.1,0.1-0.2,0.1-0.3,0.2c0.2,0.2,0.4,0.4,0.6,0.6
			C48.5,300.1,48.6,300.1,48.7,300.1z"
        />
        <path
          class="st0"
          d="M185.7,329.2c0.1,0.3,0,0.7,0.7,0.7C186.3,329.6,186.4,329.2,185.7,329.2z"
        />
        <path
          class="st0"
          d="M57.1,325c0-0.2,0-0.5,0-0.7c-0.1,0-0.2,0-0.3,0c0,0.2,0,0.5,0.1,0.7C56.9,325,57,325,57.1,325z"
        />
        <path
          class="st0"
          d="M190.4,310.9c0.3,0.2,0.5,0.3,0.7,0.4C191,311,191,310.7,190.4,310.9z"
        />
        <path
          class="st0"
          d="M191.3,311.5v-0.1l-0.1-0.1C191.1,311.4,191.1,311.4,191.3,311.5C191.2,311.5,191.2,311.5,191.3,311.5z"
        />
        <path
          class="st0"
          d="M236.9,285.1l-0.2,0.2c0.1,0.1,0.2,0.2,0.3,0.2c0.1-0.1,0.2-0.2,0.3-0.2C237.2,285.2,237.1,285.2,236.9,285.1
			z"
        />
        <path
          class="st0"
          d="M242.4,316.8c0.3,0.1,0.5,0.2,0.6,0.2s0.2-0.1,0.3-0.2c-0.1-0.1-0.2-0.3-0.4-0.3
			C242.8,316.5,242.6,316.7,242.4,316.8z"
        />
        <path
          class="st0"
          d="M46.3,309.7c0.1-0.1,0.3-0.3,0.4-0.4c-0.1,0-0.1-0.1-0.2-0.1c-0.2,0.1-0.4,0.3-0.5,0.4
			C46.1,309.6,46.2,309.6,46.3,309.7z"
        />
        <path
          class="st0"
          d="M174.6,297c0-0.1-0.2-0.2-0.4-0.4c-0.1,0.4-0.3,0.5-0.2,0.6c0,0.1,0.2,0.1,0.4,0.1
			C174.4,297.2,174.6,297.1,174.6,297z"
        />
        <path
          class="st0"
          d="M188.2,311.1c0.1,0,0.2-0.2,0.3-0.3c-0.1-0.1-0.2-0.2-0.4-0.2c-0.1,0-0.2,0.1-0.4,0.3
			C187.9,311,188.1,311.1,188.2,311.1z"
        />
        <path
          class="st0"
          d="M158.9,331.4c-0.1,0.2-0.2,0.3-0.2,0.4c0.1,0,0.3,0.1,0.4,0.1c0,0,0.2-0.2,0.1-0.2
			C159.2,331.6,159,331.5,158.9,331.4z"
        />
        <path
          class="st0"
          d="M244.4,254.6c0.1,0,0.1-0.1,0.2-0.1c-0.1-0.1-0.1-0.1-0.2-0.2c-0.1,0.1-0.1,0.1-0.2,0.2
			C244.3,254.5,244.4,254.6,244.4,254.6z"
        />
        <path
          class="st0"
          d="M94.7,313.1c0.2,0.1,0.5,0.2,0.7,0.3C95.3,313.2,95,313.1,94.7,313.1z"
        />
        <path
          class="st0"
          d="M148.5,334.4c0,0.1,0.1,0.2,0.1,0.2c0.1-0.1,0.2-0.1,0.2-0.2c0,0-0.1-0.1-0.1-0.2
			C148.7,334.3,148.6,334.3,148.5,334.4z"
        />
        <path
          class="st0"
          d="M96.3,313.7c-0.2,0-0.5-0.1-0.7-0.1c0.2,0.1,0.4,0.2,0.6,0.4C96.2,313.8,96.2,313.7,96.3,313.7z"
        />
        <path
          class="st0"
          d="M95.6,313.6c0,0-0.1,0-0.1-0.1c0,0,0,0-0.1,0c0,0,0,0,0,0.1C95.5,313.5,95.5,313.5,95.6,313.6z"
        />
        <path
          class="st0"
          d="M161.3,330.1c0.1,0.1,0.1,0.1,0.2,0.2c0.1-0.1,0.2-0.1,0.2-0.2s-0.1-0.1-0.1-0.2
			C161.5,330,161.4,330.1,161.3,330.1z"
        />
        <path
          class="st0"
          d="M241.9,254.2l-0.1,0.1c0.1,0.1,0.2,0.2,0.3,0.3c0.1-0.1,0.1-0.1,0.2-0.2C242.2,254.3,242.1,254.2,241.9,254.2
			z"
        />
        <path
          class="st0"
          d="M193.8,322.8c-0.1-0.1-0.3-0.2-0.4-0.3c-0.1,0.1-0.1,0.1-0.2,0.2c0.1,0.1,0.2,0.2,0.3,0.2
			C193.6,322.9,193.7,322.8,193.8,322.8z"
        />
        <path
          class="st0"
          d="M85,317.3c-0.2,0.1-0.4,0.2-0.6,0.2c0,0.1,0.1,0.1,0.1,0.2c0.2-0.1,0.4-0.1,0.7-0.2
			C85.1,317.4,85,317.3,85,317.3z"
        />
        <path
          class="st0"
          d="M50.4,298c0-0.4-0.1-0.7-0.1-0.9C49.8,297.4,50.1,297.6,50.4,298z"
        />
        <path
          class="st0"
          d="M52.2,310.1c0.1,0,0.2,0,0.3,0s0-0.2,0.1-0.2c-0.1,0-0.2,0-0.2,0C52.3,309.9,52.3,310,52.2,310.1z"
        />
        <path
          class="st0"
          d="M294.7,255.1c0.1,0.1,0.2,0.1,0.3,0.1c0.1,0,0.2,0,0.3-0.1c-0.1-0.1-0.1-0.2-0.2-0.2
			C294.9,255,294.8,255.1,294.7,255.1z"
        />
        <path
          class="st0"
          d="M195.7,290.5c0,0,0.1-0.1,0.2-0.1c-0.1,0-0.2-0.1-0.3-0.1l-0.1,0.1C195.5,290.4,195.6,290.4,195.7,290.5z"
        />
        <path
          class="st0"
          d="M141.4,306.4c0.1,0,0.2,0.1,0.3,0.1c0.1-0.2,0.2-0.4,0.3-0.6c0-0.1,0.1-0.1,0.1-0.2c-0.1,0.1-0.1,0.1-0.2,0.2
			C141.7,306,141.5,306.2,141.4,306.4z"
        />
        <path
          class="st0"
          d="M134.4,303.1c0,0.1,0,0.2,0.1,0.3c0,0,0.1,0,0.1-0.1C134.6,303.3,134.5,303.2,134.4,303.1z"
        />
        <path
          class="st0"
          d="M147,318.2c-0.1,0.1-0.3,0.1-0.4,0.2c0.1,0.1,0.1,0.2,0.1,0.2c0.1-0.1,0.2-0.1,0.3-0.2
			C147.1,318.3,147.1,318.2,147,318.2z"
        />
        <path
          class="st0"
          d="M133.7,302.8c0.2,0,0.4,0.1,0.6,0.1c-0.1-0.1-0.3-0.3-0.4-0.4C133.8,302.7,133.7,302.7,133.7,302.8z"
        />
        <path
          class="st0"
          d="M134.3,303L134.3,303c0.1,0.1,0.1,0.1,0.1,0.1V303C134.4,303,134.3,303,134.3,303z"
        />
        <path
          class="st0"
          d="M245.5,284.1c-0.2,0.1-0.3,0.2-0.5,0.3c0.2-0.1,0.4-0.1,0.6-0.2C245.6,284.1,245.6,284.1,245.5,284.1z"
        />
        <path
          class="st0"
          d="M245,284.3c-0.1,0-0.2,0-0.2,0.1v0.1c0,0,0,0,0.1-0.1C244.9,284.4,245,284.4,245,284.3z"
        />
        <path
          class="st0"
          d="M130.5,309.5c0.2,0,0.4,0,0.5-0.1s0.1-0.2,0.1-0.3c-0.2,0-0.3,0-0.5,0.1C130.5,309.2,130.5,309.4,130.5,309.5
			z"
        />
        <path
          class="st0"
          d="M288.6,269.1c0.1-0.1,0.2-0.2,0.3-0.3c-0.1,0-0.1-0.1-0.2-0.1c-0.1,0.1-0.2,0.1-0.2,0.2
			C288.5,268.9,288.6,269,288.6,269.1z"
        />
        <path
          class="st0"
          d="M160.2,313.4c0,0-0.1-0.1-0.2-0.2c-0.1,0.1-0.2,0.2-0.4,0.3c0.1,0.1,0.2,0.1,0.3,0.1
			C160,313.6,160.2,313.5,160.2,313.4z"
        />
        <path
          class="st0"
          d="M120.5,312.9c0-0.1-0.2-0.2-0.3-0.3c-0.1,0.2-0.2,0.3-0.2,0.5c0.1,0,0.3,0.1,0.4,0.1
			C120.4,313.2,120.6,313,120.5,312.9z"
        />
        <path
          class="st0"
          d="M70.5,314.2c-0.1,0.1-0.2,0.1-0.3,0.2c0,0.1,0.1,0.1,0.1,0.2C70.4,314.5,70.5,314.3,70.5,314.2
			C70.6,314.2,70.5,314.1,70.5,314.2z"
        />
        <path
          class="st0"
          d="M199.1,317.6c-0.1-0.1-0.2-0.1-0.3-0.1c0,0.1-0.1,0.2,0,0.3c0,0,0.2,0,0.3,0.1
			C199,317.7,199.1,317.6,199.1,317.6z"
        />
        <path
          class="st0"
          d="M199.3,296.2c0.1,0,0.3,0.1,0.4,0.1c0.1,0,0.1-0.2,0.2-0.3c-0.1,0-0.3-0.1-0.4-0.1
			C199.4,296,199.3,296.1,199.3,296.2z"
        />
        <path
          class="st0"
          d="M86.9,306.9c0-0.1-0.1-0.1-0.2-0.2c-0.1,0.1-0.2,0.2-0.3,0.3c0,0,0.1,0.1,0.3,0.4
			C86.8,307.1,86.9,307,86.9,306.9z"
        />
        <path
          class="st0"
          d="M82.3,293.1c0.1,0,0.2-0.1,0.2-0.1c-0.1-0.1-0.2-0.1-0.3-0.2c-0.1,0.1-0.1,0.1-0.2,0.2
			C82.2,293,82.2,293.1,82.3,293.1z"
        />
        <path
          class="st0"
          d="M205.3,313.6c-0.2-0.1-0.3-0.1-0.5-0.1l-0.1,0.1c0.1,0.1,0.2,0.2,0.3,0.2
			C205.1,313.8,205.2,313.7,205.3,313.6z"
        />
        <path
          class="st0"
          d="M100,336.6c0.1,0,0.2-0.1,0.3-0.1c-0.1-0.1-0.2-0.3-0.3-0.4C100,336.3,100,336.4,100,336.6z"
        />
        <path
          class="st0"
          d="M45.1,316.7c0.1,0,0.2,0,0.2,0c0-0.2,0.1-0.3,0.1-0.5c-0.1,0-0.2,0-0.2,0C45.2,316.5,45.2,316.6,45.1,316.7z"
        />
        <path
          class="st0"
          d="M134.5,317c0-0.2,0.1-0.3,0.1-0.5c-0.1,0-0.2,0-0.3,0C134.4,316.6,134.5,316.8,134.5,317z"
        />
        <path
          class="st0"
          d="M178.9,290.2c-0.1-0.1-0.2-0.2-0.2-0.2c-0.1,0-0.2,0.1-0.3,0.2c0.1,0,0.2,0.1,0.3,0.1
			C178.7,290.3,178.8,290.2,178.9,290.2z"
        />
        <path
          class="st0"
          d="M153.6,323h0.1c0-0.1,0.1-0.2,0.1-0.2c-0.1,0-0.2,0-0.2,0C153.6,322.9,153.6,323,153.6,323z"
        />
        <path
          class="st0"
          d="M79.1,296.2l0.1-0.1l-0.1-0.1l0,0C79.1,296.1,79.1,296.2,79.1,296.2z"
        />
        <path
          class="st0"
          d="M49.4,318.1c0-0.1-0.1-0.2-0.1-0.2c-0.1,0.1-0.2,0.1-0.2,0.2s0.1,0.1,0.1,0.2
			C49.3,318.3,49.4,318.2,49.4,318.1z"
        />
        <path
          class="st0"
          d="M297,249.2c-0.1,0-0.1,0-0.2,0c0,0.2,0.1,0.3,0.1,0.5c0.1,0,0.1,0,0.2-0.1C297.1,249.6,297,249.4,297,249.2z"
        />
        <path
          class="st0"
          d="M131.4,326.2c0,0,0.2,0.1,0.3,0.1c0.1-0.1,0.1-0.3,0.2-0.4c-0.1,0-0.3-0.1-0.3,0
			C131.5,326,131.5,326.1,131.4,326.2z"
        />
        <path
          class="st0"
          d="M31.8,321.7c-0.1,0.1-0.2,0.1-0.2,0.2s0.1,0.1,0.1,0.2c0.1-0.1,0.2-0.1,0.3-0.2
			C32,321.9,31.9,321.8,31.8,321.7z"
        />
        <path
          class="st0"
          d="M170.1,290.5c-0.1,0-0.2,0-0.4,0c0,0.1-0.1,0.2-0.1,0.3c0,0.1,0.1,0.1,0.2,0.2
			C169.9,290.8,170,290.7,170.1,290.5z"
        />
        <path
          class="st0"
          d="M151.6,309.2c0-0.2-0.1-0.3-0.1-0.5c-0.1,0-0.2,0-0.2,0.1c0.1,0.1,0.1,0.3,0.2,0.4
			C151.6,309.2,151.6,309.2,151.6,309.2z"
        />
        <path
          class="st0"
          d="M179.3,303.5L179.3,303.5C179.3,303.5,179.4,303.5,179.3,303.5c0.1,0,0.1-0.1,0-0.1
			C179.3,303.4,179.3,303.4,179.3,303.5z"
        />
        <path
          class="st0"
          d="M178.2,304.6c0.1,0,0.2-0.1,0.3-0.1c-0.1-0.1-0.1-0.1-0.2-0.2c-0.1,0.1-0.2,0.1-0.3,0.2
			C178.1,304.5,178.2,304.6,178.2,304.6z"
        />
        <path
          class="st0"
          d="M78.9,327.7c0,0.1-0.1,0.2-0.1,0.2c0.1,0.1,0.1,0.1,0.2,0.2c0-0.1,0.1-0.2,0.1-0.2
			C79.1,327.8,78.9,327.8,78.9,327.7z"
        />
        <path
          class="st0"
          d="M154.5,307.4c-0.1,0-0.2,0.1-0.3,0.2l0.1,0.1c0.1-0.1,0.2-0.1,0.3-0.2L154.5,307.4z"
        />
        <path
          class="st0"
          d="M136.3,317.5c0.1,0,0.2,0,0.3,0l0.1-0.1c-0.1,0-0.1-0.1-0.2-0.1C136.4,317.4,136.3,317.4,136.3,317.5z"
        />
        <path
          class="st0"
          d="M244.3,286.3l0.1-0.1c0-0.1-0.1-0.1-0.2-0.2c0,0.1-0.1,0.2-0.1,0.3C244.2,286.3,244.3,286.3,244.3,286.3z"
        />
        <path
          class="st0"
          d="M244.7,284.8c0.1,0,0.1-0.1,0.1-0.1c0-0.1,0-0.1,0-0.2c-0.1,0.1-0.1,0.1-0.1,0.2
			C244.6,284.7,244.7,284.8,244.7,284.8z"
        />
        <path
          class="st0"
          d="M245.3,262.1c0-0.1-0.1-0.1-0.1-0.2c-0.1,0.1-0.2,0.1-0.2,0.2s0.1,0.1,0.2,0.2
			C245.3,262.2,245.3,262.1,245.3,262.1z"
        />
        <path
          class="st0"
          d="M123.4,322.1c0,0.1,0.1,0.1,0.1,0.2l0.1-0.1c0-0.1-0.1-0.1-0.1-0.2C123.4,322,123.4,322.1,123.4,322.1z"
        />
        <path
          class="st0"
          d="M148.7,304.2c0,0,0,0.1,0.1,0.1c0,0,0.1,0,0.1-0.1v-0.1C148.8,304.2,148.7,304.2,148.7,304.2z"
        />
        <path
          class="st0"
          d="M208,306.1c0.1,0,0.2,0.1,0.2,0.1c0.1,0,0.1-0.1,0.2-0.2c-0.1,0-0.2,0-0.3,0C208.1,306,208,306.1,208,306.1z"
        />
        <path
          class="st0"
          d="M187.4,311.5c0,0-0.1,0-0.2,0c0,0,0,0.1,0.1,0.1C187.4,311.6,187.4,311.6,187.4,311.5
			C187.5,311.5,187.5,311.5,187.4,311.5z"
        />
        <path
          class="st0"
          d="M148.6,302.1l-0.1,0.1c0.1,0,0.2,0,0.3,0l0.1-0.1C148.8,302.1,148.7,302.1,148.6,302.1z"
        />
        <path
          class="st0"
          d="M171.6,296.9c0.1,0,0.1,0,0.1-0.1c0,0,0-0.1-0.1-0.1C171.6,296.8,171.6,296.8,171.6,296.9
			C171.5,296.9,171.6,296.9,171.6,296.9z"
        />
        <path
          class="st0"
          d="M180.1,313.4c0-0.1-0.1-0.3-0.1-0.4c-0.1,0.1-0.1,0.3-0.2,0.4C179.9,313.4,180,313.4,180.1,313.4z"
        />
        <path
          class="st0"
          d="M180,313C180,313,180.1,313,180,313C180.1,312.9,180.1,312.9,180,313C180,312.9,180,312.9,180,313
			C180,312.9,180,313,180,313z"
        />
        <path
          class="st0"
          d="M58.5,320.3l0.1,0.1l0.1-0.1c0,0-0.1-0.1-0.2-0.1C58.5,320.2,58.5,320.3,58.5,320.3z"
        />
        <path
          class="st0"
          d="M156.8,319c-0.1,0-0.2,0-0.3,0s-0.1,0.1-0.1,0.2c0.1,0,0.2,0,0.3,0C156.7,319.1,156.7,319.1,156.8,319z"
        />
        <path
          class="st0"
          d="M29.2,325.6c0-0.1,0.1-0.2,0.1-0.4c-0.1,0.1-0.2,0.2-0.2,0.3C29.1,325.5,29.1,325.6,29.2,325.6z"
        />
        <path
          class="st0"
          d="M289.5,267.7l-0.1,0.1c0,0.1,0.1,0.1,0.1,0.2l0.1-0.1C289.6,267.8,289.6,267.8,289.5,267.7z"
        />
        <path
          class="st0"
          d="M201.2,286.6c0.1,0,0.2,0,0.3,0l0.1-0.1c-0.1,0-0.2-0.1-0.3-0.1C201.3,286.4,201.3,286.5,201.2,286.6z"
        />
        <path
          class="st0"
          d="M288.5,266.9c0,0.1,0.1,0.1,0.1,0.2l0.1-0.1c0-0.1-0.1-0.1-0.1-0.2C288.5,266.8,288.5,266.8,288.5,266.9z"
        />
        <path
          class="st0"
          d="M132.1,300.3l-0.1,0.1c0.1,0.1,0.1,0.1,0.2,0.2l0.1-0.1C132.2,300.4,132.1,300.4,132.1,300.3z"
        />
        <path
          class="st0"
          d="M197.6,311.3c0,0-0.1-0.1-0.2-0.1c0,0.1-0.1,0.2-0.1,0.2c0.1,0,0.2,0,0.3,0.1
			C197.5,311.4,197.6,311.3,197.6,311.3z"
        />
        <path
          class="st0"
          d="M66.3,314.8c0-0.1-0.1-0.1-0.1-0.2l-0.1,0.1c0.1,0.1,0.1,0.1,0.2,0.2C66.2,314.8,66.3,314.8,66.3,314.8z"
        />
        <path
          class="st0"
          d="M74.8,312.7c-0.1,0-0.2-0.1-0.3-0.1c0,0.1-0.1,0.1-0.1,0.2c0.1,0,0.2,0,0.3,0
			C74.8,312.8,74.8,312.7,74.8,312.7z"
        />
        <path
          class="st0"
          d="M243.2,250.7c0.1,0,0.2,0,0.3-0.1c0-0.1-0.1-0.1-0.1-0.2C243.3,250.5,243.2,250.5,243.2,250.7
			C243.1,250.6,243.2,250.7,243.2,250.7z"
        />
        <path
          class="st0"
          d="M210.6,281.8c-0.1,0-0.1-0.1-0.2-0.1c-0.1,0-0.1,0.1-0.2,0.2C210.3,281.9,210.4,281.9,210.6,281.8
			C210.6,281.9,210.6,281.8,210.6,281.8z"
        />
        <path
          class="st0"
          d="M99.5,335.7c0.1,0.1,0.2,0.2,0.3,0.3c-0.1-0.1-0.1-0.2-0.2-0.4C99.6,335.6,99.5,335.7,99.5,335.7z"
        />
        <path
          class="st0"
          d="M99.9,335.9l0.1,0.1c0,0,0,0,0,0.1V336C99.9,336,99.9,335.9,99.9,335.9z"
        />
        <path
          class="st0"
          d="M248.3,272.7c0.1,0,0.1,0.1,0.2,0.1c0-0.1,0.1-0.2,0.1-0.3C248.6,272.6,248.4,272.6,248.3,272.7z"
        />
        <path
          class="st0"
          d="M248.8,272.4h-0.1c0,0,0,0,0,0.1C248.7,272.5,248.7,272.5,248.8,272.4C248.8,272.5,248.8,272.4,248.8,272.4z"
        />
        <path
          class="st0"
          d="M249.1,272.1c-0.1,0.1-0.2,0.2-0.3,0.3c0.2-0.1,0.3-0.1,0.5-0.2C249.2,272.2,249.2,272.1,249.1,272.1z"
        />
        <path
          class="st0"
          d="M243.7,251.4c0,0,0-0.1,0.1-0.2l0,0c0,0,0,0-0.1,0C243.7,251.3,243.7,251.4,243.7,251.4z"
        />
        <path
          class="st0"
          d="M159.8,328.5c0,0,0.1,0.1,0.2,0.1c0-0.1,0.1-0.2,0.1-0.3l-0.1-0.1C159.9,328.4,159.8,328.4,159.8,328.5z"
        />
        <path
          class="st0"
          d="M293.1,300.4l0.1-0.1c-0.1,0-0.2,0-0.3,0l-0.1,0.1C292.9,300.4,293,300.4,293.1,300.4z"
        />
        <path
          class="st0"
          d="M42.9,313.7c0.1,0.1,0.1,0.1,0.1,0.2l0.1-0.1c0-0.1-0.1-0.1-0.1-0.2C43,313.7,43,313.7,42.9,313.7z"
        />
        <path
          class="st0"
          d="M42.7,296.1l0.1-0.1c0-0.1-0.1-0.1-0.1-0.2c-0.1,0.1-0.1,0.1-0.2,0.2C42.6,296,42.6,296.1,42.7,296.1z"
        />
        <path
          class="st0"
          d="M175.4,326c0-0.1,0-0.1,0-0.2h-0.1C175.4,326,175.4,326,175.4,326z"
        />
        <path
          class="st0"
          d="M292.2,300.8c-0.1,0-0.1,0.1-0.2,0.1c0.1,0.1,0.2,0.1,0.3,0.2C292.3,301.1,292.2,301,292.2,300.8z"
        />
        <path
          class="st0"
          d="M292.4,301.3L292.4,301.3c-0.1-0.1-0.1-0.1-0.1-0.1C292.3,301.2,292.3,301.2,292.4,301.3L292.4,301.3z"
        />
        <path
          class="st0"
          d="M175.6,327.2l0.1,0.1l0.1-0.1l-0.1-0.1C175.6,327.1,175.6,327.1,175.6,327.2z"
        />
        <path
          class="st0"
          d="M223.3,318.3c0.1,0.1,0.2,0.1,0.2,0.2C223.5,318.4,223.4,318.3,223.3,318.3
			C223.4,318.3,223.3,318.3,223.3,318.3z"
        />
        <path
          class="st0"
          d="M223.5,318.5v0.1h0.1C223.7,318.6,223.6,318.6,223.5,318.5C223.6,318.5,223.6,318.5,223.5,318.5z"
        />
        <path
          class="st0"
          d="M147.1,335.9L147,336l0.1,0.1l0.1,0.1l0.1-0.1l0,0C147.2,336,147.1,336,147.1,335.9z"
        />
        <path
          class="st0"
          d="M251.4,253.9v-0.1c0,0,0-0.1-0.1-0.1c0,0-0.1,0.1,0,0.1C251.4,253.9,251.4,253.9,251.4,253.9z"
        />
        <path
          class="st0"
          d="M50.6,298.4C50.7,298.4,50.7,298.4,50.6,298.4c0-0.1-0.1-0.1-0.1-0.1S50.5,298.3,50.6,298.4L50.6,298.4z"
        />
        <path
          class="st0"
          d="M199.9,325.3l0.1,0.1c0-0.1,0.1-0.2,0.1-0.3L200,325C200,325.1,200,325.2,199.9,325.3z"
        />
        <path
          class="st0"
          d="M34.4,303.5L34.4,303.5c0,0.1-0.1,0.2-0.1,0.3C34.4,303.6,34.4,303.6,34.4,303.5z"
        />
        <path
          class="st0"
          d="M212.7,328.5l0.1,0.1c0,0,0.1,0,0.1-0.1c0,0,0-0.1-0.1-0.1C212.8,328.5,212.8,328.5,212.7,328.5z"
        />
        <path
          class="st0"
          d="M240.4,259.3l0.1,0.1c0.1,0,0.2-0.1,0.2-0.1l-0.1-0.1C240.6,259.2,240.5,259.3,240.4,259.3z"
        />
        <path
          class="st0"
          d="M254.4,335.7c0,0.1,0.1,0.1,0.2,0.2c0.1-0.1,0.2-0.2,0.2-0.2c-0.1-0.1-0.2-0.1-0.3-0.2
			C254.5,335.6,254.4,335.6,254.4,335.7z"
        />
        <path
          class="st0"
          d="M180.4,277.6c0.1,0,0.2,0,0.3-0.1c0-0.1-0.1-0.1-0.1-0.2c-0.1,0.1-0.2,0.1-0.3,0.2
			C180.3,277.5,180.3,277.6,180.4,277.6z"
        />
        <path
          class="st0"
          d="M243.5,248.8c0-0.1,0-0.1,0-0.2c-0.1,0-0.1,0.1-0.2,0.1C243.4,248.8,243.4,248.8,243.5,248.8z"
        />
        <path
          class="st0"
          d="M250.1,249.4L250.1,249.4c-0.1,0-0.1,0-0.2,0C250,249.5,250,249.5,250.1,249.4
			C250.1,249.5,250.1,249.4,250.1,249.4z"
        />
        <path
          class="st0"
          d="M242.6,251.7l0.1-0.1c0,0-0.1,0-0.1-0.1l-0.1,0.1C242.5,251.7,242.5,251.7,242.6,251.7z"
        />
        <polygon class="st0" points="46.9,297.7 46.8,297.7 46.8,297.8 		" />
        <path
          class="st0"
          d="M50.4,296.9c0,0.1-0.1,0.2-0.1,0.2l0,0l0,0C50.4,297,50.4,296.9,50.4,296.9z"
        />
        <path
          class="st0"
          d="M241,256.3c0-0.1-0.1-0.1-0.1-0.2c0,0.1-0.1,0.1-0.1,0.2C240.9,256.3,240.9,256.3,241,256.3z"
        />
        <path
          class="st0"
          d="M241.3,256.5c-0.1,0-0.1,0-0.2-0.1v0.1C241.1,256.5,241.2,256.5,241.3,256.5z"
        />
        <path
          class="st0"
          d="M241.1,256.4L241.1,256.4C241.1,256.3,241,256.3,241.1,256.4C241,256.4,241,256.4,241.1,256.4L241.1,256.4z"
        />
        <path
          class="st0"
          d="M46.9,299.3v0.1C47,299.4,47,299.4,46.9,299.3L46.9,299.3c0.1,0,0.1-0.1,0.1-0.1
			C47,299.2,47,299.3,46.9,299.3z"
        />
        <path
          class="st0"
          d="M236.9,261.5L236.9,261.5c-0.1-0.1-0.1-0.1-0.1-0.1C236.8,261.5,236.8,261.5,236.9,261.5
			C236.8,261.5,236.9,261.5,236.9,261.5z"
        />
        <path
          class="st0"
          d="M237.1,261.6c-0.1,0-0.2,0-0.2,0c0,0.1,0,0.1,0.1,0.2C237,261.6,237.1,261.6,237.1,261.6z"
        />
        <polygon class="st0" points="287.8,252.6 287.8,252.7 287.9,252.7 		" />
        <polygon class="st0" points="291.5,255.5 291.4,255.5 291.4,255.6 		" />
        <path
          class="st0"
          d="M45.9,310.7l-0.1,0.1c0.1,0,0.2,0,0.2-0.1C45.9,310.8,45.9,310.8,45.9,310.7z"
        />
        <path
          class="st0"
          d="M218.4,273.8c0-0.1,0.1-0.1,0.1-0.2s0-0.2,0.1-0.2c0,0.1-0.1,0.1-0.1,0.2
			C218.4,273.7,218.4,273.8,218.4,273.8z"
        />
        <polygon class="st0" points="77.7,306 77.6,306 77.6,306.1 		" />
        <path
          class="st0"
          d="M244.6,270.3l0.1-0.1l-0.1-0.1l-0.1,0.1C244.5,270.3,244.6,270.3,244.6,270.3z"
        />
        <polygon class="st0" points="74,312.2 74,312.3 74.1,312.3 		" />
        <path
          class="st0"
          d="M29.9,323.9c0.1,0,0.2,0,0.2-0.1c0,0-0.1,0-0.1-0.1C30,323.9,29.9,323.9,29.9,323.9z"
        />
        <path
          class="st0"
          d="M29.3,325.1c0-0.1,0-0.2,0.1-0.3C29.3,325,29.3,325,29.3,325.1L29.3,325.1z"
        />
        <path
          class="st0"
          d="M133.3,303.2c0,0.1-0.1,0.2-0.1,0.3C133.2,303.4,133.3,303.3,133.3,303.2c0.2-0.1,0.3-0.2,0.4-0.3l0,0
			c0,0,0,0-0.1,0C133.5,302.9,133.4,303.1,133.3,303.2z"
        />
        <path
          class="st0"
          d="M141.9,301.6l0.1-0.1l-0.1-0.1l-0.1,0.1C141.8,301.5,141.8,301.6,141.9,301.6z"
        />
        <polygon class="st0" points="216.8,286.2 216.9,286.2 216.8,286.1 		" />
        <path
          class="st0"
          d="M137.5,304.6c0.1,0,0.2,0,0.2-0.1l-0.1-0.1C137.6,304.5,137.5,304.5,137.5,304.6z"
        />
        <path class="st0" d="M182,295.1c0,0-0.1,0-0.1-0.1c0,0,0,0,0,0.1H182z" />
        <path
          class="st0"
          d="M142,305.7c0.1-0.1,0.1-0.1,0.2-0.2l0,0l0,0C142.1,305.5,142.1,305.6,142,305.7z"
        />
        <path
          class="st0"
          d="M111.7,313.6l-0.1,0.1c0,0,0.1,0,0.1,0.1C111.8,313.8,111.7,313.7,111.7,313.6z"
        />
        <path
          class="st0"
          d="M177.3,299.5h-0.1l0,0l0,0C177.2,299.4,177.2,299.4,177.3,299.5z"
        />
        <path
          class="st0"
          d="M245.8,284.8c0,0-0.1,0-0.1,0.1c0,0,0,0.1-0.1,0.1c0,0,0.1,0,0.1-0.1C245.8,284.8,245.8,284.8,245.8,284.8z"
        />
        <path
          class="st0"
          d="M112.2,314.2l-0.1,0.1c0,0,0.1,0,0.1,0.1l0.1-0.1C112.3,314.2,112.2,314.2,112.2,314.2z"
        />
        <polygon class="st0" points="77.3,323.9 77.4,323.9 77.3,323.8 		" />
        <path
          class="st0"
          d="M235.9,289.5c0,0,0.1-0.1,0.2-0.1c0.1-0.1,0.1-0.1,0.1-0.1l0,0c0,0-0.1,0.1-0.2,0.1
			C235.9,289.4,235.9,289.5,235.9,289.5z"
        />
        <path
          class="st0"
          d="M225.7,292c0,0.1,0,0.1,0,0.2h0.1c0,0,0.1-0.1,0-0.1C225.8,292,225.7,292,225.7,292z"
        />
        <polygon class="st0" points="292.8,277.5 292.7,277.5 292.8,277.6 		" />
        <polygon class="st0" points="77.7,324.4 77.8,324.4 77.8,324.3 		" />
        <path
          class="st0"
          d="M191.4,309.9l-0.1,0.1l0.1,0.1c0-0.1,0.1-0.1,0.1-0.2H191.4z"
        />
        <polygon class="st0" points="93,332.9 93.1,332.9 93,332.8 		" />
        <polygon class="st0" points="187.7,312.4 187.9,312.3 187.7,312.3 		" />
        <path
          class="st0"
          d="M124.8,326.7c0-0.1,0.1-0.2,0.1-0.2C124.8,326.6,124.7,326.6,124.8,326.7
			C124.7,326.6,124.8,326.7,124.8,326.7z"
        />
        <path
          class="st0"
          d="M124.9,326.4C124.9,326.4,125,326.4,124.9,326.4c0.1-0.1,0.1-0.2,0.1-0.3C125,326.2,125,326.3,124.9,326.4
			L124.9,326.4z"
        />
        <polygon class="st0" points="180.2,314.5 180.1,314.5 180.2,314.6 		" />
        <polygon class="st0" points="77.5,337.2 77.6,337.1 77.5,337.1 		" />
        <polygon class="st0" points="93.5,333.7 93.6,333.6 93.4,333.6 		" />
        <path
          class="st0"
          d="M204.9,309.8l-0.1-0.1l-0.1,0.1l0.1,0.1C204.8,309.9,204.9,309.8,204.9,309.8z"
        />
        <polygon class="st0" points="88.1,338.5 88.2,338.4 88.1,338.4 		" />
        <polygon class="st0" points="207.6,314.1 207.6,314 207.5,314 		" />
        <path
          class="st0"
          d="M249.6,305.6h0.1c0,0,0.1-0.1,0-0.1l-0.1-0.1C249.6,305.5,249.6,305.6,249.6,305.6z"
        />
        <path
          class="st0"
          d="M213.5,316.1c0,0-0.1,0-0.1-0.1l-0.1,0.1l0.1,0.1C213.4,316.2,213.4,316.1,213.5,316.1z"
        />
        <path
          class="st0"
          d="M160.7,328.7l0.1,0.1l0.1-0.1l-0.1-0.1C160.7,328.6,160.7,328.7,160.7,328.7z"
        />
        <polygon class="st0" points="198.7,320.8 198.8,320.7 198.6,320.7 		" />
        <polygon class="st0" points="180.7,325.3 180.6,325.3 180.7,325.4 		" />
        <path
          class="st0"
          d="M162.8,329.8l0.1,0.1l0.1-0.1c0,0-0.1,0-0.1-0.1C162.9,329.7,162.9,329.8,162.8,329.8z"
        />
        <path
          class="st0"
          d="M223.8,318.7v-0.1c-0.1,0-0.1,0-0.2,0C223.7,318.6,223.8,318.7,223.8,318.7z"
        />
        <polygon class="st0" points="185.2,328.9 185.3,328.8 185.2,328.8 		" />
        <path
          class="st0"
          d="M163.9,333.7L163.9,333.7c0.1-0.1,0.1-0.2,0.1-0.2l-0.1,0.1V333.7z"
        />
        <path
          class="st0"
          d="M388.5,99.1c-0.7-0.1-1.4,0.3-1.3,0.8c0,0.1,0.1,0.1,0.1,0.2h-0.1c0.1,0.4,0.3,0.9,1,1c0.9,0.1,1.5,0.4,1.9,1
			c0.1-0.1,0.1-0.2,0.2-0.3c0.1-0.1,0.4,0,0.7,0.1c0,0,0,0,0.1,0c-0.3,0.3-0.4,0.5-0.6,0.6c0.4,0.2,0.9,0.1,1.5-0.2
			c0.4-0.2,0.8-0.4,1.6-0.7c-0.9,1,0.2,0.8,0.3,1.2c-0.2,0.1-0.4,0.2-0.8,0.3c0.3,0.4,0.5,0.8,0.8,1.2c-0.2,0.1-0.5,0.2-0.7,0.2
			c-0.1,0.3-0.1,0.7-0.3,0.8c-0.1,0-0.1,0.1-0.1,0.1c0.2,0.1,0.3,0.2,0.4,0.5c0,0.1,0.1,0.3,0.1,0.5c-0.1-0.1-0.2-0.1-0.3-0.2
			c-0.3-0.2-0.5-0.3-0.7-0.4c-0.6,0.2-1,0.1-2.6-0.4h-0.1c-0.3,0.4-0.6,0.9-0.9,1.4c0.2,0.4,0.5,0.8,0.7,1.2c0,0.1,0.1,0.1,0.1,0.2
			c0.2,0,0.4,0,0.6,0l0.1-0.1c0.2-0.1,0.7-0.1,0.9,0c0.3,0,0.7,0.1,1,0.2c0.3,0.2,1.2-0.3,1.9-0.5c0.2-0.1,0.4-0.2,0.6-0.2
			c0.2-0.2,0.2-0.5,0.2-0.9c-0.1-0.1-0.2-0.3-0.3-0.4c-0.2-0.2-0.4-0.4-0.6-0.7c0.3-0.3,0.5-0.5,0.7-0.7c-0.2-0.1-0.3-0.2-0.4-0.3
			c-0.1-0.1-0.2-0.1-0.3-0.2c0.3-0.4,0.6-0.8,1-1.2c-0.1-0.2-0.2-0.4-0.3-0.8c1.2,0.3,1.3-0.5,1.6-1.1c-0.7-0.2-1.6-0.2-2.2-1
			c-0.3,0.4-0.7,0.8-1,1.3c-0.4-0.3-0.7-0.5-0.8-0.7c-0.4-0.5-0.8-0.8-1.5-1.1c-0.5-0.2-0.9-0.4-1.3-0.6l0,0l0,0
			C389.1,99.3,388.9,99.2,388.5,99.1z M390.1,106.4c-0.1-0.1-0.1-0.1-0.2-0.2l-0.1-0.1c0,0,0,0,0.1,0s0.2-0.1,0.2-0.1
			c0.1,0,0.1,0.1,0.1,0.2S390.2,106.4,390.1,106.4z"
        />
        <path
          class="st0"
          d="M600.6,170.2c-0.1,0-0.1,0-0.2,0.1c0.1,0.2,0.1,0.4,0.2,0.5c0.1,0,0.1,0,0.2-0.1
			C600.8,170.6,600.7,170.4,600.6,170.2z"
        />
        <path
          class="st0"
          d="M605.9,178.7c0.2-0.3,0.5-0.6,0.7-1c-3,0-3.7-0.3-5.4-2.2c0,0.4-0.2,0.7-0.1,1c0.5,1.1,0.4,2.1-0.1,3
			c0.1,0,0.1,0,0.1,0c0.8,0,1.5,0.3,1.8,0.9l0,0l0,0c0.1,0.3,0.1,0.6,0.3,0.9c0.1-0.4,0.3-0.7,0.4-1.1c0.1-0.4,0.1-0.7,0-1.1
			c0-0.1-0.1-0.2-0.2-0.4c0.5-0.3,0.9-0.5,1.5-0.9c0.1,0.3,0.2,0.5,0.3,0.9c0.1,0,0.3,0,0.4,0.1
			C605.8,178.8,605.8,178.7,605.9,178.7z"
        />
        <path
          class="st0"
          d="M456.6,69.5c-0.1,0.1-0.2,0.3-0.3,0.4C456.4,69.7,456.5,69.6,456.6,69.5L456.6,69.5z"
        />
        <path
          class="st0"
          d="M456.6,71.6c-0.8,0.7,0.3,1,0.2,1.5c0,0.3-0.1,0.6-0.1,0.9l0,0c0.8,0.7,2.2,1.1,4.1,1.2
			c-0.1,0.8-0.3,1.5-0.4,2.3c-0.9,0.1-1.8,0-2.7,0.2c-0.4,0.1-0.8,0.2-1.2,0.4c0.1,0.4,0.2,0.7,0.3,1.1c0.8-0.2,1.4-0.4,1.7-1
			c0-0.1,0.3-0.1,0.4-0.1c0,0.2,0,0.5,0.1,0.7c0,0.1,0,0.2,0,0.4c0,0.1,0,0.2,0,0.3c1.7-0.7,1.7-0.7,2.9,0.6
			c0.2-0.4,0.3-0.9,0.6-1.2c0.3-0.3,0.9-0.5,1.3-0.5c0.3,0,0.7,0.4,0.7,0.7c0,0.3-0.3,0.7-0.6,1c-0.2,0.2-0.6,0.1-0.9,0.3
			c-0.3,0.1-0.4,0.4-1,0.9c1.1-0.1,1.7-0.2,2.2-0.2c0.6-0.7,1.1-1.2,1.6-1.7c-0.3-0.2-0.7-0.4-1-0.6c0.5-0.9,1.9,0.5,2.2-0.9
			c-0.4-0.2-0.9-0.4-1.3-0.6c1.5-1.1,1.7-1.2,1.4-1.9c0-0.1-0.1-0.2-0.2-0.4c-1.8-0.3-3.7,0.3-5.6,0.3c-0.1,0-0.2,0-0.3,0l0,0
			c-0.1-0.5-0.2-0.9-0.3-1.2c-0.1-0.2-0.1-0.4-0.1-0.5c0-0.2,0-0.3,0-0.4c0-0.4,0.2-0.6,0.6-1c0.8,0.5,0.1,1.4,0.4,1.8
			c0.2,0.1,0.3,0.1,0.4,0.2c0.5,0.2,0.9,0.4,1.4,0.5c0.1-0.1,0.3-0.3,0.3-0.5c0,0,0,0,0-0.1c0-0.7,0.4-1.3,0.8-1.9l-0.1-0.2
			c-0.3,0.1-0.6,0.2-0.9,0.3c-0.6-0.7-1-1.5-2.3-1.3c-0.8,0.1-1.4-0.3-1.5-1c-0.1-0.5-0.4-0.9-0.7-1.3c-0.2-0.2-0.3-0.4-0.4-0.6
			c-0.6,0.2-1.1,0.5-1.6,1c-0.1,0.1-0.3,0.3-0.4,0.4l0,0c0.1,0.1,0.2,0.1,0.2,0.2s-0.1,0.2-0.1,0.3c-0.2,0-0.3,0-0.4,0
			c-0.1,0.2-0.3,0.4-0.3,0.6h0.1C456.3,71,456.7,71.5,456.6,71.6z M464.8,75.3c0-0.1,0.1-0.1,0.1-0.2c0.1,0.1,0.2,0.2,0.3,0.2
			c0.1,0.1,0.2,0.2,0.3,0.3c0,0.2-0.1,0.3-0.2,0.5c-0.2-0.1-0.4-0.2-0.5-0.3C464.6,75.7,464.7,75.5,464.8,75.3z M463.7,77.4
			L463.7,77.4c0,0.1,0,0.2-0.1,0.2C463.7,77.5,463.7,77.4,463.7,77.4S463.7,77.3,463.7,77.4z M462.1,73.6L462.1,73.6l-0.1,0.1
			L462.1,73.6z M457.8,72.9c0.3-0.2,0.7-0.2,0.9-0.7c0.5-0.9,0.6-0.9,1.7-0.2c-0.1,0.2-0.2,0.3-0.3,0.5c-0.2,0.3-0.4,0.7-0.6,1
			c-0.1,0.2-0.1,0.4-0.2,0.6s-0.1,0.3-0.2,0.5c0,0.1-0.1,0.3-0.1,0.4c-0.4-0.1-0.8-0.1-1.1-0.2c-0.3-0.2-0.7-0.4-0.8-0.7V74
			C457.1,73.6,457.5,73.2,457.8,72.9z"
        />
        <path
          class="st0"
          d="M563.5,181.1c-0.2-0.7-0.4-1.4-0.6-2.1c-1.1,0.7-2.2,1.4-3.6,0.9l0,0c0.1,0.1,0.2,0.2,0.4,0.3c0,0,0,0,0.1,0
			c0,0,0,0,0.1,0c1.3-0.2,2.4,0.3,3.4,1.2C563.3,181.3,563.4,181.2,563.5,181.1z"
        />
        <path
          class="st0"
          d="M523.7,180.5c-0.3,0.2-0.5,0.3-0.7,0.4c0.5,0.1,0.9,0.3,1.5,0.4c0.2-0.5,0.3-0.8,0.5-1.4
			c0.6,0.3,1.2,0.5,1.7,0.7c0.3-0.3,0.7-0.5,0.9-0.7c0.2,0,0.4,0.1,0.6,0.1c0.4,0,0.7,0.1,1,0.1l0,0c0.1,0.1,0.2,0.1,0.3,0.2
			c0.4,0.1,0.6-0.5,0.9-0.6c0,0,0,0,0.1,0c0,0,0.1,0,0.1,0.1c0,0,0,0,0.1,0.1c0.6,0.5,1.2,0.9,1.9,1.4c0.5-0.3,0.9-0.6,1.1-0.8
			c0.9,0.1,1.5,0.2,2.2,0.2c0.1,0,0.2,0.2,0.4,0.3c-0.4,0.2-0.8,0.4-1.2,0.6c0,0.1,0.1,0.1,0.1,0.2c0.5-0.2,1.1-0.4,1.6-0.6
			c0.2-0.4-0.3-0.9,0.5-1.2c1.4,0.7-0.6,1.7,0.2,2.4c-0.3,0.8-0.7,1.6-1,2.4c1.4-0.5,2-1.4,2.1-2.4c-0.5-0.3-0.9-0.5-0.9-1.1
			c0.8-0.1,1.5-0.3,2.3-0.4c0.1,0.3,0,0.5-0.2,0.7c0.5,0.2,1,0.6,1.5,0.8c0.1-0.2,0.2-0.3,0.4-0.4c0.5-0.6,1.7-0.3,2-1.2
			c0-0.1,0.2,0,0.4,0c0.2,0.1,0.4,0.3,0.4,0.5c-0.1,0.3-0.2,0.6-0.4,0.9c0.5-0.1,1-0.4,1.1-0.9s0.3-0.6,0.8-0.8
			c0.7-0.4,0.8-1,0.6-1.7c0,0,0,0,0-0.1l0,0c-1,0.4-2,0.6-2.8,0.2c-0.2,0-0.4,0-0.6,0c0.1-0.1,0.2-0.1,0.3-0.2
			c-0.1-0.1-0.1-0.1-0.2-0.2c0.2,0,0.4-0.1,0.6-0.1c0.1-0.1,0.3-0.2,0.5-0.3c0,0.1,0,0.2-0.1,0.3c0.5,0,1.1,0,1.6-0.3
			c0.1,0,0.1-0.1,0.2-0.1c0.2-0.1,0.9,0,1.3,0.5c0.1,0.2,0.3,0.4,0.5,0.5c0.2-0.3,0.5-0.5,0.8-0.8c0.1,0.2,0.4,0.5,0.3,0.5
			c-0.2,0.2-0.5,0.4-0.8,0.6c0.2,0.2,0.5,0.4,0.7,0.6c0.1,0.1,0.2,0.2,0.3,0.3c0.3,0.3,1.1-0.3,1,0.4l0,0c-0.1,0.2-0.1,0.4-0.2,0.6
			c0.3,0,0.7,0,0.6-0.4c0.4-0.1,0.8-0.3,1.2-0.4c0.1,0.1,0.2,0.2,0.2,0.3c0.6,1.3,2.2,1.4,3.4,0.3c0.2-0.2,0.3-0.3,0.4-0.5
			c0.2-0.5,0.7-0.8,1.2-1c0-0.2-0.1-0.4-0.1-0.6c-0.5,0.1-1,0.1-1.8,0.2c0.4-0.4,0.8-0.7,1-1c0.3-0.3,0.5-0.6,0.8-1
			c0.8,0.5,1.1,1.2,1.6,1.9c0.1,0,0.2-0.1,0.3-0.2c0.1-0.1,0.2-0.1,0.3-0.2l-0.1-0.1c-0.2-0.2-0.3-0.3-0.4-0.5
			c0.2-0.3,0.4-0.6,0.6-0.8c-0.4-0.3-0.7-0.4-0.8-0.6c0-0.1,0-0.1,0-0.2c0-0.3,0.2-0.5,0.6-0.7c0.1-0.1,0.3-0.1,0.4-0.2
			c0.2,0.3,0.4,0.5,0.5,0.8c0,0.1,0.1,0.1,0.1,0.2c0,0,0-0.1,0.1-0.1c0.4-0.4,0.4-0.5,0.7-1.6c0.2-0.6,0.5-1.1,1.3-1.2
			c0.7-0.1,1.4,0.2,1.6,0.7c0.1,0.2,0.1,0.3,0.1,0.5c0,0.4-0.2,0.7-0.6,1.1c-0.1,0.1-0.2,0.2-0.3,0.4c0.4,0.3,0.7,0.7,0.9,0.9
			c1.1-0.5,2.2-0.9,3.2-1.4c0.2-0.7,0.5-1.5,0.8-2.4c-1.6,0.2-2.4-0.6-3.2-1.4c-0.1-0.1-0.2-0.2-0.3-0.3s-0.1-0.1-0.2-0.2l0,0
			c-0.2-0.2-0.3-0.6-0.2-0.8c0-0.1,0.1-0.2,0.1-0.2c0.1-0.2,0.2-0.4,0.3-0.6c0.1-0.2,0.3-0.4,0.5-0.6c0.6-0.7,1.3-1.2,2.4-1.4
			c0.9-0.2,1.7-0.1,2.3,0.3c0.2,0.1,0.3,0.2,0.5,0.3c0.3,0.3,0.6,0.6,0.9,0.9c0,0.1,0.2,0.1,0.3,0.1c0.4-0.3,0.7-0.5,1.1-0.8
			c-1.8-1-2.3-2.2-1.6-3.5c0.1-0.1,0.2-0.3,0.3-0.4l0,0c0.9-1,2.4-1.2,4.7-0.5c0.1-0.5,0.2-1,0.4-1.8c-1.8,1.4-3.3,0.9-4.9,0.3h-0.1
			c-0.1,0.2-0.3,0.3-0.4,0.5c-0.9,0.9-2,1.2-3.3,1c-0.1,0.5-0.2,0.8-0.3,1.1c0.2,0.2,0.6,0.3,0.6,0.5c0,0.1,0,0.2-0.1,0.3v0.1
			c-0.4,1-2.1,1.9-3.2,1.4c-0.2-0.1-0.2-0.4-0.3-0.6c-0.2,0.2-0.5,0.4-0.5,0.5l0.1,0.1c0.4,0.6-0.1,1.1-0.6,1.5l0,0
			c-0.3,0.2-0.6,0.5-0.9,0.7c-0.3,0.3-0.6,0.5-1,0.8c-0.1,0-0.2,0-0.4,0c-0.1-0.3-0.3-0.6-0.4-0.8c-0.2,0-0.3,0.1-0.5,0.1
			c-0.1,0-0.2,0-0.2,0.1c0-0.1,0-0.1,0-0.2c0.1-0.4,0.2-0.7,0.2-1.1l0,0h-0.1c-0.1,0-0.1,0-0.2,0c-0.1,0-0.1,0-0.1-0.1
			c0.1,0,0.1,0,0.2,0c0.1,0,0.1,0.1,0.2,0.1h0.1l0,0c0.1-0.2,0.2-0.3,0.4-0.5c0.1-0.1,0.1-0.2,0.2-0.2c-0.2,0-0.4,0-0.7,0
			c0.2-0.3,0.3-0.5,0.5-0.8c0-0.1-0.2-0.2-0.3-0.3c-0.1,0.1-0.2,0.2-0.3,0.3v0.1h-0.1l-0.1,0.1v-0.1c0,0,0,0,0.1,0c0,0,0,0,0-0.1
			c0,0,0.1,0,0.1-0.1s0.1-0.2,0.1-0.4c0-0.3,0.1-0.6,0-0.9c-0.1-0.3-0.3-0.7-0.5-0.7c-1.2,0.1-1.6-0.8-2.5-1.1c-1,1.6-1.6,2-2.9,2.1
			c-0.1,0-0.2,0-0.3,0c-0.7,0.1-1.2,0.2-1.6,0.5c-0.4,0.2-0.8,0.5-1.4,0.9c-0.6,0.4-1.3,0.7-2.4,1.3c1-1.8,2.3-2.6,3.9-3
			c-0.3-0.3-0.6-0.7-1-1c-0.2-0.2-0.6-0.2-0.9-0.3c0.1,0.4,0.1,0.9,0.2,1.3c-0.5,0.2-1,0.5-1.4,0.7c-0.4-0.2-0.7-0.4-0.8-0.5
			c-0.9,0.2-1.4,0.3-2,0.4c-0.3,0.1-0.8,0-0.9,0.2c-0.2,0.2-0.1,0.6-0.1,1c-0.7,0.4-1.6,0.7-2.3,1.3c-0.6,0.5-1,1.1-1.5,1.8
			c0.6-0.1,1.1-0.1,1.8-0.2c-0.2,0.5-0.4,0.8-0.5,1.1c0.2,0.3,0.5,0.6,0.7,0.9c0.2-0.5,0.4-1.1,0.7-1.7c0.7,0.2,1.2,0.3,1.7,0.4
			c-0.5,0.6-0.5,1.1,0.1,1.5c0.8,0.6,0.8,1.4,0.5,2.2c-0.4,1.1-1.7,1.5-2.7,1.1c-0.2-0.1-0.3-0.2-0.5-0.3c-0.4-0.3-0.7-0.7-1.1-1.1
			c-1.8,0.1-2.9-0.2-3.5-0.9c-0.4-0.4-0.6-1-0.6-1.7c0-0.2,0.1-0.5,0.1-0.7c-0.8,0.2-0.5-0.2-0.4-0.5c0.5-0.1,0.5,0.2,0.5,0.5
			c0.9-0.3,1.8-0.6,2.5-0.8c0.5-1.2,0.8-2.1-0.4-2.8c-0.4,0.4-0.7,0.9-1.4,0.6c-0.4,0.4-0.7,0.8-1.1,1.3c0.7,0.4-0.6,0.9-0.1,1.3
			c-0.5,0-1,0-1.6,0c0,1,0,1.9,0,2.9c-0.7-0.1-1.1-0.2-1.4-0.2c-0.8,0.6-1.7,1-2.1,1.6c-0.3,0.6-0.6,1.4,0.1,1.9
			c-0.3,0.2-0.5,0.3-0.7,0.4c-0.2,0.1-0.4,0.3-0.7,0.5c0-0.8-0.2-1.3-1.1-1.4c0,0.4,0.1,0.9,0.1,1.3c0,0.5-0.1,1-0.8,1.4l0,0
			c-0.2-0.4-0.4-0.7-0.6-1.1c-0.2-0.3-0.3-0.6-0.5-0.9c-0.4,0.1-0.8,0.2-1.1,0.2c-1.6,0.2-1.3,0.1-1.9,1.3c0,0.1-0.3,0.1-0.5,0.2
			c0,0,0,0,0.1,0H525c0,0.1-0.1,0.2-0.1,0.2c-0.1,0.1-0.2,0.1-0.3,0.1c0,0-0.1-0.1-0.1-0.2c0.1,0,0.2-0.1,0.3-0.1s0.2,0,0.3-0.1
			c0,0,0,0,0-0.1l0,0c-0.3-0.2-0.6-0.4-0.7-0.4c-0.6,0.3-1.1,0.6-1.6,1v0.1C522.9,180.3,523.2,180.4,523.7,180.5z M544.4,179.2
			C544.4,179.2,544.4,179.3,544.4,179.2c-0.2,0.2-0.4,0.2-0.6,0.3c0-0.1,0-0.2,0-0.3C544,179.2,544.2,179.2,544.4,179.2z M565.1,174
			c0.1,0,0.2,0,0.3,0c-0.1,0.1-0.1,0.1-0.2,0.2c-0.1,0-0.1-0.1-0.2-0.1C565.1,174.1,565.1,174,565.1,174z M569.5,165.3
			c0.1,0,0.2,0.1,0.4,0.2c-0.2,0.2-0.3,0.2-0.4,0.3c-0.1-0.1-0.2-0.2-0.2-0.3S569.5,165.3,569.5,165.3z M569.2,167.4l-0.1,0.1
			c0-0.1,0-0.1-0.1-0.2C569.1,167.3,569.2,167.3,569.2,167.4z M548.4,173.2c-0.1,0-0.2,0-0.3,0l0.1-0.1
			C548.3,173.1,548.4,173.1,548.4,173.2C548.5,173.1,548.4,173.2,548.4,173.2z M552.5,181.1L552.5,181.1c-0.1,0-0.1,0.1-0.1,0.1
			s0,0-0.1,0C552.4,181.1,552.4,181.1,552.5,181.1C552.5,181,552.5,181,552.5,181.1C552.5,181,552.5,181,552.5,181.1z M552.2,177.5
			c-0.5-0.3-1.1-0.8-0.9-1.4c0.3-0.7,0.4-1.4,0.8-2c0.2-0.3,0.4-0.6,0.7-0.9l0,0l0,0c-0.3,0.1-0.6,0.1-0.9,0.2
			c0-0.1-0.1-0.1-0.1-0.2c0.3-0.2,0.6-0.4,1.2-0.7c-0.1,0.3-0.1,0.5-0.2,0.7l0,0l0,0c0.1,0,0.1,0,0.2,0c0.6-0.1,1,0.3,1.2,0.7
			c0,0.1,0.1,0.2,0.1,0.2c0.3,0.7,0.5,1.4,0.8,2.1c-0.2,0.2-0.4,0.3-0.6,0.5c-0.2,0.2-0.5,0.3-0.7,0.5
			C553.3,177.6,552.8,177.8,552.2,177.5z M555.2,178.9c-0.5,0.6-0.9,0.3-1.4-0.2c0.3-0.2,0.6-0.4,1-0.7
			C555,178.4,555.4,178.8,555.2,178.9z M555.2,173.2c0,0-0.1,0-0.1-0.1c0.1,0,0.2-0.1,0.3-0.1l0.1,0.1
			C555.4,173.1,555.3,173.2,555.2,173.2z M557,176.6c0-0.8,0.4-1.5,1.2-2.5C558.4,175.4,557.5,175.9,557,176.6z M555.3,167.5
			c0.5,0.2,0.9,0.2,1.4,0.4c-0.8,0.3-1.4,0.6-2,0.9c-0.1-0.1-0.1-0.1-0.2-0.2C554.7,168.3,555,168,555.3,167.5z M549.8,169.1
			c0.4-0.2,0.9-0.3,1.3-0.2c0.3,0,0.6,0.1,0.9,0.4c0,0,0.1,0.1,0.2,0.1c0.4,0.3,1,0.5,0.6,1.5c0.8-0.7,1.6-1,2.4-1.1
			c0.2,0,0.5,0,0.7,0c0.3,0,0.7,0,1,0.1c0.1,0,0.1,0,0.2,0c0.6,0.1,1.2,0.1,1.8,0.2l0,0l0.1-0.1v0.1l0,0c0,0.8,0,1.3-0.4,1.6
			s-1.1,0.5-2.2,0.7c0-0.2-0.1-0.4-0.1-0.7c-0.4,0.2-0.7,0.4-1,0.5c-0.1,0.1-0.2,0.1-0.4,0.2c-0.4,0-0.6-0.1-0.8-0.3
			c-0.4-0.3-0.6-0.7-0.7-1.3c-0.8,0.6-1.5,1.2-2.5,1.2c-0.2,0-0.4,0-0.6,0c-0.3-0.1-0.5-0.1-0.7-0.2c-0.8-0.4-1.2-1-1.4-1.9
			C548.5,169.7,549.1,169.4,549.8,169.1z M546.1,172.7c0,0-0.1,0-0.1-0.1l0.1-0.1l0.1,0.1C546.2,172.6,546.2,172.7,546.1,172.7z
	M546.4,169.1c-0.1-0.2,0.2-0.4,0.4-0.7c0.3,0.2,0.6,0.3,0.7,0.5c0,0.2-0.3,0.4-0.4,0.6C546.8,169.4,546.4,169.3,546.4,169.1z
	M541.6,179.2c0,0.1,0.1,0.2,0.1,0.4c-0.3,0.1-0.6,0.2-0.9,0.3c0-0.1-0.1-0.1-0.1-0.2C541,179.5,541.3,179.4,541.6,179.2z
	M539.5,177.9c0.3,0.1,0.5,0.2,0.8,0.3c-0.1,0.2-0.2,0.4-0.2,0.6l0,0c0.1,0,0.1,0.1,0.2,0.1c-0.1,0-0.1,0-0.2-0.1l0,0
			c-0.5,0.1-0.9,0.8-1.7,0.3C538.7,178.7,539.1,178.3,539.5,177.9z M537.4,176c0.1,0,0.1,0,0.2,0v0.1
			C537.5,176.1,537.5,176.1,537.4,176C537.4,176.1,537.4,176,537.4,176z M537.1,177L537.1,177c0.3-0.1,0.6-0.1,1.3-0.1
			c-0.4,0.6-1.1,0.7-1.8,0.8C536.8,177.3,536.9,177.1,537.1,177z M534.9,174.6c0.2,0.7,0.5,1.2-0.4,1.6l0,0h-0.1
			c-0.1,0.1-0.2,0.2-0.4,0.3c0-0.1-0.1-0.1-0.1-0.2c0.2,0,0.3-0.1,0.5-0.1c0,0,0,0,0.1-0.1l0,0c-0.1-0.1-0.2-0.3-0.4-0.4
			c-0.1-0.1-0.2-0.2-0.4-0.3C534.1,175.2,534.4,174.9,534.9,174.6z"
        />
        <path
          class="st0"
          d="M408.8,226.3c0.1,0,0.2-0.4,0.3-0.6c0.1-0.1,0.3-0.1,0.4-0.2c-0.1,0-0.1-0.1-0.2-0.1
			c-0.1,0.1-0.2,0.2-0.2,0.3c-0.8-1-1.3-1.3-2.2-1.4c0,0.2-0.1,0.4-0.3,0.5c0.5,0.1,1,0.1,1.6,0.2c-0.2,0.4-0.3,0.9-0.4,1.3
			C408,226.3,408.4,226.4,408.8,226.3z"
        />
        <path
          class="st0"
          d="M405.3,228.6c-0.3-0.1-0.6-0.2-0.9-0.2c-0.1,0.3-0.2,0.5-0.3,0.8v0.1c0.1,0,0.3-0.1,0.4-0.2
			C404.8,228.9,405,228.8,405.3,228.6z"
        />
        <path
          class="st0"
          d="M402.5,228.5c-0.1,0-0.1,0-0.2,0.1c-0.6,0.3-1.2,0.7-1.7,1.1l0,0l0,0c0.6,0.8,0.5,2-0.2,2.7
			c0,0-0.1,0-0.1,0.1c0.2,0.3,0.5,0.6,0.9,0.9c0-0.2,0-0.4-0.1-0.7c0.9-0.4,1.7-0.8,2.3-1c0.2-1,0.4-1.7,0.6-2.5
			c-0.5,0.1-1,0.2-1.6,0.3c0-0.1,0-0.1,0-0.2C402.5,229.1,402.5,228.8,402.5,228.5z"
        />
        <path
          class="st0"
          d="M410.2,231.1c-1.1,0.4-2.5,0.2-3.4,1.2c0.1,0.2,0.2,0.4,0.4,0.5c0.7,1,0.5,2.1-0.4,3
			c-0.8,0.8-2.3,1.2-3.4,0.9s-1.6-0.9-1.9-1.7c-0.1-0.2-0.1-0.4-0.1-0.6c-0.3,0.2-0.6,0.4-0.9,0.6c-0.3-0.7-0.8-1.3-1.4-1.7
			c-0.6,0.2-1.3,0.2-1.8,0c-0.4-0.1-0.7-0.4-1-0.6c-1.3,0.1-2.3,0.6-3.1,1.3c0.1,0.1,0.2,0.2,0.4,0.3c2-0.1,3.1,0.4,3.5,1.5
			c0.1,0.4,0.1,0.8-0.1,1.3s-0.6,0.9-1.1,1.2c-0.4,0.2-0.7,0.3-1.1,0.4c-0.2,0-0.4,0.1-0.6,0.1c0.6,0.3,1.3,0.4,1.9,0.7
			c-0.2,0.4-0.4,0.9-0.7,1.4c-0.1,0.3-0.3,0.6-0.4,0.9c0.2-0.1,0.5-0.3,0.8-0.4c0.4-0.2,0.8-0.3,1.3-0.5c0.1,0.7-0.1,1.2-0.5,1.5
			c-0.2,0.2-0.4,0.3-0.6,0.4c-0.7,0.3-1.3,0.2-1.7-0.5l0,0c-0.3,0.1-0.6,0.1-0.9,0.2c-2.1,0.5-3.5,2-3.7,3.7
			c-0.1,0.7,0.1,1.3,0.4,1.8c0.5-0.5,0.9-1,1.5-1.5c-0.3-0.2-0.5-0.4-0.9-0.7c0.4-0.2,0.7-0.4,1-0.4c1.5-0.3,2.1,0.2,2.8,1.6
			c0.4-0.1,0.7-0.1,1.1-0.2c0.3,0,0.5-0.1,0.8-0.1c0.2,0,0.5,0.2,0.7,0.4l0,0c0.4,0.5,0.2,1.2-0.4,1.6c-0.5,0.4-1,0.4-1.7,0
			c-0.3-0.1-0.5-0.3-0.9-0.6c-0.5,0.3-0.9,0.5-1.2,0.7c-0.7,0.3-1.2,0.3-1.7,0.1c0.4,0.3,0.9,0.5,1.4,0.6c1.9,0.5,4.2-0.1,5.5-1.5
			c0.3-0.3,0.5-0.6,0.7-0.9c0.5-0.6,1.2-1.2,2.1-1.4c-0.2-0.3-0.3-0.5-0.5-0.5c-0.1,0.1-0.3,0.1-0.4,0.2c-0.1,0.1-0.3,0.2-0.4,0.3
			c0-0.1,0-0.1-0.1-0.2c-0.2,0-0.3-0.1-0.5-0.1s-0.3,0-0.5-0.1c-0.3-0.1-0.5-0.3-0.6-0.6c-0.2-0.3-0.2-0.7-0.1-1
			c0-0.1,0.1-0.2,0.1-0.2c0.2-0.4,0.6-0.7,1.1-0.8c0.4-0.1,0.9-0.1,1.3,0l0.1,0.1c0.3,0.2,0.7,0.4,1,0.7c0.3-0.2,0.6-0.4,0.9-0.6
			c0.1-0.1,0.2-0.1,0.3-0.2c0.4-0.2,0.8-0.2,1.2-0.3c0.5-0.9,1.1-1.5,1.8-1.8c0.1,0,0.1,0,0.2-0.1c0-0.2,0-0.4-0.1-0.5
			c0-0.2-0.2-0.4-0.2-0.6c0-0.4,0.6-0.7,0.9-0.5c0.8,0.5,1.5,1.1,2.2,1.5c-0.1,0.2-0.3,0.3-0.4,0.5c0.1,0,0.1,0.1,0.2,0.1
			c0.2,0.2,0.4,0.5,0.4,0.7c0.5-0.3,1-0.5,1.7-0.3c0,0.1,0,0.3,0,0.4c0,0.3,0.1,0.5,0.1,0.8c0.1,0.4,0.4,0.8,0.8,1.1
			c0.1-0.1,0.3-0.1,0.4-0.1c1-0.2,1.9,0.1,2.3,0.7c0.8-0.1,1.4-0.5,2-0.9c-1.7,0-3.1-0.8-3.4-2.2c-0.1-0.5-0.1-1-0.1-1.6
			c-0.3,0.1-0.6,0.3-1,0.4c-0.8,0.3-1.5,0.3-2.2,0.2c-0.5-0.1-1.1-0.3-1.5-0.7c-0.3-0.2-0.5-0.4-0.8-0.6c-0.3-0.2-0.7-0.4-1.2-0.4
			c-0.1,0-0.1,0-0.1-0.1c-0.6-0.2-0.7-0.8-0.2-1.2c0.8-0.7,1.7-1.4,2.6-2.1c0.5-0.3,1.1-0.6,1.7-0.9c-0.1-0.5-0.4-1-0.3-1.5
			C409.6,232.1,409.9,231.6,410.2,231.1L410.2,231.1L410.2,231.1z M397,245.1c-0.1-0.1-0.3-0.1-0.4-0.2l0.1-0.2
			c0.1,0,0.3,0.1,0.4,0.1C397,245,397,245.1,397,245.1z M399,233.8c0.2,0.2,0.3,0.2,0.3,0.4c0,0-0.1,0.2-0.2,0.2s-0.3-0.1-0.4-0.1
			C398.7,234.1,398.9,234,399,233.8z M402.8,240.1c-0.3,0.8-1.1,1.4-2.1,1.6c-0.4,0.1-0.7,0.1-1.1,0.1h-0.1
			c-0.7-0.1-1.3-0.4-1.6-0.9c-0.2-0.2-0.3-0.5-0.3-0.9c-0.2-1.2,0.8-2.4,2.4-2.7c1.4-0.3,2.9,0.5,3.1,1.7
			C403,239.3,403,239.7,402.8,240.1z"
        />
        <path
          class="st0"
          d="M352.4,234.4c0.3-0.1,0.7-0.4,0.6-0.9c-0.2-0.6-0.6-1.2-0.9-1.8c-0.1,0-0.2,0.1-0.4,0.1c0,0.3,0,0.7,0,1.3
			c-0.5-0.5-0.7-0.9-1.1-1.3c-0.5,0-1.3,0.6-1.7-0.3c0.1-0.1,0.2-0.1,0.3-0.3c0,0,0,0-0.1-0.1c-0.5,0.3-0.7,0.6-0.8,0.9
			c0.1,0.5,0.3,1,1.3,1.1C350.7,233.3,351.4,233.9,352.4,234.4z"
        />
        <path
          class="st0"
          d="M333.4,240.2c-0.9-1-0.7-2.2,0.7-2.9c0.5-0.3,0.8-0.5,1.1-0.8c-0.2-0.1-0.3-0.2-0.4-0.4l0,0
			c-0.2-0.3,0.3-0.8,0.8-0.8c0.1,0,0.3,0,0.4,0.1c0-0.2,0-0.4-0.1-0.7c-0.3-1-1.2-1.4-3-1.3c-0.2,0-0.3,0-0.6,0c0-0.1,0-0.1,0-0.2
			c-0.3,0-0.6,0-0.9-0.1c-0.1,0.1-0.2,0.2-0.3,0.3c-0.4,0.5-0.8,0.8-1.4,0.8c0.2,0.4,0.5,0.7,0.7,1.1c0.8,1,1.2,2.1,1.2,3.3
			c0,0.7,0.1,1.2,0.5,1.7c0.2,0.3,0.5,0.5,0.9,0.8l0,0c0,0,0,0-0.1,0c-0.3,0.1-0.5,0.1-0.8,0.2c-0.3,0.1-0.5,0.1-0.7,0.2l0.1,0.1
			l-0.1,0.1l-0.1-0.1v-0.1c-1.6,0.6-2.4,2.2-1.7,3.4c0.6,1.1,2.4,1.5,3.9,1c1.7-0.7,2.5-2.2,1.8-3.4
			C334.8,241.8,334.1,241,333.4,240.2z M331.3,236.2c0-0.1,0-0.1,0-0.2c0.1,0,0.1,0.1,0.1,0.1S331.4,236.1,331.3,236.2z"
        />
        <path
          class="st0"
          d="M328,232.5c-1.2-0.2-1-1.1-1.2-1.8c0,0,0,0.1-0.1,0.1c-0.2,0-0.4-0.1-0.6-0.1c-0.3,0.1-0.5,0.1-0.8,0.2
			c0,0,0,0,0,0.1s0.1,0.4,0.2,0.4c1.2,0.2,1.2,1.6,2.4,1.8v-0.1C328.1,232.7,328.1,232.5,328,232.5z"
        />
        <path
          class="st0"
          d="M395,219.8c-0.6,0.3-1,0.8-1.4,0.8c-0.8,0.1-1.1,0.4-1.4,0.9c-0.2,0.3-0.3,0.6-0.6,0.8
			c-0.5,0.4-1,0.8-1.3,1.3v0.1h-0.1c0,0.1-0.1,0.1-0.1,0.2c0.1,0,0.1-0.1,0.2-0.1l0,0c0.2-0.1,0.5-0.2,0.7-0.1
			c0.9,0.1,0.9,0.1,1.9-0.2c0-0.4,0-0.7,0.1-1.2c0.1,0,0.2,0,0.3,0c0,0-0.1,0-0.1-0.1c0.9-0.3,1.5-0.6,2.3-0.9
			C395.3,220.7,395.1,220.2,395,219.8z"
        />
        <path
          class="st0"
          d="M357.7,225.1c-0.7-0.4-1.1-0.1-1.6,0.1c0,0,0,0,0,0.1l0,0c-0.1,0-0.1,0.1-0.2,0.1c-0.3,0.2-0.6,0.3-0.9,0.5
			c0,0.2,0,0.3-0.1,0.5c0.4,0,0.7,0.1,1.1,0.1C356.6,225.9,357.1,225.5,357.7,225.1z"
        />
        <path
          class="st0"
          d="M349.7,228.3c0.1-0.1,0.3-0.2,0.4-0.3c0.1,0.1,0.1,0.2,0.2,0.3s0.2,0.3,0.2,0.4c0,0.4,0,0.9-0.1,1.3
			c0.8-1.1,0.7-2.2-0.3-3.4c-0.3-0.3-0.6-0.7-0.9-1.1v-0.1c-0.3,0.3-0.6,0.5-1,0.7c0.1,0.2,0.3,0.4,0.5,0.5
			C349.4,227.1,349.6,227.7,349.7,228.3z"
        />
        <path
          class="st0"
          d="M387.5,94.5c0.6,0.1,1,0.5,0.9,1.1c0,0.3,0.3,0.6,0.4,1c0.4-0.2,0.7-0.3,1-0.4c0.5,0.2,0.3,1.1,1.4,0.7
			c0.1-0.2,0.2-0.4,0.4-0.7c0.2,0.4,0.4,0.6,0.4,0.8c0,0.4-0.2,0.9-0.3,1.3c-0.1,1.3,0.1,1.5,1.7,1.7c0.3,0,0.6,0.1,1.1,0.1
			c-0.1,0.2-0.2,0.3-0.4,0.5c0.6-0.1,1-0.1,1.5-0.1c0.4,0,0.4-0.2,0.5-0.4c-0.3-0.1-0.4-0.2-0.1-0.6l0,0c-0.1-0.2,0-0.3,0.2-0.4
			c0-0.1,0-0.2-0.1-0.3c-0.2-0.5,0.1-0.8,0.7-1c0.1-0.2,0.1-0.3,0.2-0.5c-0.1-0.1-0.1-0.1-0.2-0.2s-0.2-0.2-0.2-0.4
			c0-0.2,0.1-0.3,0.2-0.5c-0.1-0.1-0.2-0.3-0.3-0.5c-1.3,0.4-2,0-2.2-1.1c-0.2-0.6-0.6-0.7-1.5-0.9l-0.1,0.1
			c0.1,0.3,0.1,0.6,0.2,1.1c-0.2,0.1-0.7,0.5-0.9,0.5c-0.9-0.3-1.5,0.1-2,0.7c-0.3-0.3-0.5-0.5-0.7-0.8c0.3-0.2,0.6-0.4,0.9-0.6
			c0.2-0.5-0.6-1.4-1.1-1.3c-1,0.3-1.6-0.1-2.2-0.5c-0.2-0.2-0.7-0.1-1.2-0.1C386,93.6,386.3,94.3,387.5,94.5z M393.7,98.9
			c0.1,0,0.1,0,0.2-0.1c-0.2,0.3-0.5,0.5-0.7,0.9c0-0.1,0-0.1,0-0.1C393,99.1,393.1,99,393.7,98.9z"
        />
        <path
          class="st0"
          d="M563.4,187.7L563.4,187.7c-0.3,0.2-0.5,0.7-0.7,0.7c-0.9-0.1-1.2,0.3-1.8,0.8c0,0.1,0,0.3,0,0.5
			c-0.1,0-0.2-0.1-0.3-0.1c1.1,0.6,2,1.2,3.6,0.6c-0.2-0.3-0.3-0.5-0.5-0.8c0.1-0.2,0.3-0.4,0.5-0.6c-0.1-0.1-0.1-0.3-0.2-0.4
			c-0.1-0.3,0-0.7,0.1-1C564,187.5,563.7,187.6,563.4,187.7z"
        />
        <path
          class="st0"
          d="M399.8,99.7c0.4,0.6,0.7,0.5,0.9-0.1c0.2-0.4,0.5-0.5,0.8-0.5c0.1,0,0.1,0,0.2,0.1c0.4,0.2,0.8,0.2,1.1,0.2
			c0.8-0.1,1.5-0.6,2.4-1c-0.3-0.4-0.6-0.7-0.9-1c0-0.1-0.1-0.1-0.1-0.2c-0.2-0.3-0.5-0.6-0.7-1c-0.1-0.1-0.1-0.2-0.2-0.3v-0.1
			c0-0.1-0.1-0.2-0.1-0.2c-0.5-0.5-1-1-1.5-1.5c-0.6,0.3-1.1,0.5-1.6,0.7c-0.1,0.2-0.2,0.4-0.3,0.6c-0.3,0.2-0.6,0.3-1,0.5
			c0.1,0.1,0.1,0.2,0.1,0.3c0,0.1,0,0.2,0,0.2c0.2,0.2,0.4,0.4,0.5,0.6c0.3,0.4,0.5,0.8,0.6,1.3c0,0.1-0.3,0.2-0.5,0.3
			c-0.1-0.1-0.2-0.2-0.2-0.3c-0.2,0-0.4,0.1-0.7,0.2c0,0.1,0,0.2,0,0.2v0.1c0.1,0,0.2,0,0.3,0h0.1c-0.1,0.1-0.2,0.2-0.4,0.3
			c0,0,0,0-0.1,0l0,0C398.7,99.8,399.6,99.4,399.8,99.7L399.8,99.7z"
        />
        <path
          class="st0"
          d="M555.6,63.2c0.1-0.1,0.2-0.3,0.3-0.4c-0.2,0-0.3-0.1-0.5-0.1c0,0.1-0.1,0.3-0.1,0.4
			C555.4,63.1,555.5,63.1,555.6,63.2z"
        />
        <path
          class="st0"
          d="M572.6,49.3c-0.2,0-0.4,0.1-0.6,0.1c-0.4,0.1-0.7,0.3-1.1,0.5c0.3-0.1,0.6-0.1,0.9-0.2
			c0.5,0.5,0.9,0.9,0.2,1.5c-0.5,0.2-0.8-0.7-1.4-0.1c-0.1-0.1-0.4-0.2-0.4-0.3s0-0.2,0-0.3c-0.4,0.4-0.7,0.8-0.8,1.3
			c0,0.1,0,0.2-0.1,0.3c-0.1,0.5-0.2,1-0.3,1.6c0.2,0,0.5-0.1,0.5-0.1c0.2,0.2,0.3,0.5,0.4,0.9c-0.2,0.1-0.3,0.1-0.5,0.2l0.1,0.1
			c0.4,0.4,0.7,0.7,1.5,0.6c0.4-0.1,0.8,0.1,1.1,0.3c0.2,0.1,0.3,0.3,0.4,0.5c0.1,0.3,0.3,0.5,0.4,0.8c0.2,0,0.4-0.1,0.5-0.1
			c0.7-0.3,0.1-0.8,0.1-1.2c0.2,0,0.5-0.1,0.7-0.1c0-0.2,0-0.4,0-0.6c0.4-0.3,0.8-0.5,1.1-0.8c0.2-0.1,0.3-0.3,0.4-0.4l0,0
			c0.3-0.8,0.8-1.4,0.5-2.2c-0.1-0.2,0-0.3,0.1-0.5c0,0,0-0.1-0.1-0.1C575.7,49.7,574.2,49.1,572.6,49.3z M574.5,53.3L574.5,53.3
			l0.1,0.2C574.5,53.5,574.4,53.5,574.5,53.3C574.4,53.4,574.5,53.4,574.5,53.3z M573.9,50.6c0.1,0,0.2,0,0.3,0
			c0,0.1-0.1,0.2-0.1,0.2h-0.2C573.9,50.7,573.9,50.6,573.9,50.6z M573.6,51.4c0.3,0.3,0.7,0.6,0.2,1c-0.1,0.1-0.6,0-0.8-0.1
			l-0.1-0.1c-0.4-0.3-0.8-0.7,0.2-1.2c0.1,0.1,0.2,0.1,0.3,0.2C573.4,51.2,573.5,51.3,573.6,51.4z"
        />
        <path
          class="st0"
          d="M567.9,159.8c0.6-0.2,0.6-0.6,0.5-1.1c-0.5-0.1-1-0.2-1.4,0.2c-0.1,0.1-0.1,0.1-0.2,0.2
			c-0.1,0.1-0.2,0.3-0.3,0.4c-0.5,0.7-1,1.4-1.7,2c-0.5,0.5-1.2,1.1-1.9,1.3c-1.5,0.5-1.6,1.4-2,2.4c0.5,0,1-0.3,1,0.2
			c0.1,0,0.2,0,0.3-0.1c0.7-1.2,1.8-2,3.4-2.2c0.1-0.2,0.2-0.4,0.2-0.5C565.7,161.4,566.3,160.4,567.9,159.8z"
        />
        <path
          class="st0"
          d="M537.8,64.3c-0.1,0-0.1-0.1-0.2-0.1c0.1-0.1,0.2-0.2,0.3-0.2c0.2,0.2,0.4,0.4,0.5,0.6l0,0
			c0.5,0.1,1.1,0.1,1.8,0.1c1.6,0.8,0.2,2.4,1.2,3.4c0.8-0.1,1.4,0,2,0.5c0.4,0.3,1,0.6,1.4,0.9c0.1-0.1,0.2-0.2,0.3-0.3
			c1.3,0.1,1.4,0.1,3.4-0.5c0.2,0.2,0.4,0.4,0.6,0.6c0.3-0.3,0.6-0.5,1-0.8c0,0.1,0,0.2,0,0.3c0.1,0.6,0.4,0.8,0.8,0.9
			c0.5,0,1.2-0.2,1.8-0.2c0.2,0.9,0.3,1.9,0.9,2.6c0.2,0.2,0.5,0.4,0.8,0.5c-0.1,0.2-0.3,0.4-0.4,0.5c-0.1,0.1-0.2,0.2-0.2,0.4
			c0.6,0.1,1.1,0.2,1.6,0.3c-0.3,0.6-1.4,0-1.5,1c1.2,0.1,2.5,0,3.5,0.6c0.2,0.1,0.4,0.2,0.5,0.4c-0.2,0.3-0.3,0.5-0.3,0.8
			c0,0.2,0.2,0.4,0.5,0.5c0.1,0.1,0.4-0.1,0.6-0.1c-0.1-0.1-0.2-0.3-0.3-0.4s-0.2-0.2-0.3-0.3c0.5-0.3,1.1-0.5,1.6-0.8
			c0.3-0.2,0.6-0.3,1-0.5c-0.2,0-0.5,0-0.6-0.1c-0.1-0.4-0.3-0.8,0.4-1.1l0,0h0.1l0.1-0.1v0.1c0,0,0,0-0.1,0c0,0,0,0-0.1,0.1l0,0
			c0.2,0.3,0.4,0.5,0.6,0.8c1-0.1,1.2-0.8,1-1.3c-0.3-0.7,0.2-0.9,0.6-1.3c0.3,0.3,0.6,0.6,1.1,1.1c0-1,0-1.6,0-2.2
			c0.5,0.2,1,0.4,1.5,0.6c0.6,0.2,1.2,0.2,1.9,0.4c0.1-0.1,0.4-0.4,0.7-0.8c-0.6,0-1,0.1-1.7,0.1c0.6-0.4,0.9-0.6,1.2-0.8
			c-0.2-0.2-0.4-0.4-0.7-0.8c-0.4,0.7-1,0.8-1.6,0.7c-0.1,0-0.3,0-0.4,0c-0.2,0-0.3,0-0.4,0c-0.3,0-0.6,0.1-0.7,0.5
			c-0.6-0.4-1.3-0.8-2-1.3c-0.6,1-1.5,0.6-2.3,0.6c-0.3,0.9-0.9,1.4-1.8,1.8c-0.5,0.2-0.9,0.5-1.3,0.8l0,0h-0.1l0,0
			c-0.1-0.1-0.1-0.2-0.2-0.3c0-0.1-0.1-0.1-0.1-0.2c-0.1-0.1-0.1-0.2-0.2-0.3c0,0,0,0-0.1,0l-0.1-0.1c0,0,0,0-0.1,0
			c0.1,0,0.1,0,0.2,0.1l0,0c0.7-0.4,1.3-0.7,2.1-1.2c-0.6-0.6,0.1-1.2-0.2-1.8c-0.2-0.4,0.3-1.1,0.5-1.8c-1.5,0.6-1.3,1.5-1.2,2.5
			c-1.3-0.2-1.3-0.2-2-1.2c-0.1-0.1-0.4-0.3-0.6-0.3c-0.1,0-0.2,0-0.3-0.1c-0.1,0.1-0.2,0.3-0.3,0.4c-0.2-0.3-0.5-0.5-0.8-0.8
			c-0.3-0.4-0.7-0.7-1.1-1.1c0.3-0.5,0.5-1.1,0.5-1.6c0.1-0.8-0.1-1.5-0.5-2.2c-0.2,0-0.4-0.1-0.6-0.2c-0.4-0.1-0.8-0.2-1.2-0.3
			c0.3-0.3,0.5-0.6,0.7-0.8c-0.1-0.1-0.1-0.1-0.2-0.2c-0.3-0.3-0.7-0.6-1.1-1c-2.4-0.8-5-0.2-7.5,1.2c-1.7-1-2.9-1.2-4.1-0.4
			c-0.9,0.5-1.5,1.6-1.2,2.4C537,63.7,537.3,64,537.8,64.3z M558.9,72.8c-0.4,0.2-0.8,0.3-1.4,0.6C557.8,72.6,558.3,72.6,558.9,72.8
			z M555.1,71L555.1,71c-0.2,0.1-0.4,0.2-0.6,0.2v-0.1C554.7,71,554.9,71,555.1,71z M550.5,68C550.5,68,550.4,68,550.5,68
			c-0.1-0.2-0.1-0.3,0-0.4c0.1,0,0.2,0.1,0.2,0.1C550.6,67.8,550.5,67.9,550.5,68z M550.5,63.8c0.5-0.1,1.2,0.4,1.4,0.9
			c0,0.1,0.1,0.1,0.1,0.2c0.1,0.4-0.4,1-0.9,1.1c-0.4,0.1-0.9-0.1-1.2-0.5c-0.1-0.2-0.2-0.4-0.3-0.6C549.6,64.4,550,63.9,550.5,63.8
			z M541.9,65.8c0.5-0.3,0.8-0.5,1.3-0.8C542.8,65.6,542.8,65.6,541.9,65.8z M548.1,62.1c0.2-0.1,0.5-0.1,0.8-0.1
			c-0.3,0.2-0.6,0.4-0.8,0.6c-0.2,0.2-0.5,0.3-0.8,0.6C547.4,62.5,547.6,62.2,548.1,62.1z M547.4,64.6c0.1,0,0.2,0.1,0.2,0.2
			c-0.1,0.1-0.2,0.2-0.2,0.2c-0.1-0.1-0.2-0.1-0.3-0.2C547.2,64.7,547.3,64.6,547.4,64.6z M545.8,60.2L545.8,60.2
			c0.1,0.2,0,0.3,0,0.4c0,0-0.1,0-0.1-0.1C545.8,60.4,545.8,60.3,545.8,60.2z M547.1,66.6c-0.4,0.1-0.8,0.4-1.1,0.3
			c-0.8-0.2-1.1-0.8-1.5-1.3C546.2,64.8,546.3,64.9,547.1,66.6z M544.5,68.1c-0.1,0.1-0.1,0.2-0.2,0.2c-0.1-0.1-0.2-0.1-0.3-0.2
			c0.1-0.1,0.2-0.1,0.2-0.2C544.3,68,544.4,68,544.5,68.1z M543.3,63.7L543.3,63.7L543.3,63.7c0.3,0.1,0.5,0.2,0.8,0.3
			c-1,0.9-1,0.9-1.4,0.1c0,0,0,0-0.1,0V64c-0.4,0.1-0.7,0.2-1.1,0.3c-1.3,0.1-2-0.8-1.5-1.8c0.2-0.3,0.5-0.6,0.7-0.9
			C542.6,61.6,543.2,62.5,543.3,63.7z M540.7,61.5c-0.7-0.4-1.1-0.6-1-1.1C540.4,60.5,540.6,60.8,540.7,61.5z M539.2,64
			c0-0.1,0.1-0.1,0.1-0.2C539.3,63.8,539.2,63.9,539.2,64s0,0.2-0.1,0.2C539.1,64.1,539.1,64,539.2,64z"
        />
        <path
          class="st0"
          d="M535.2,79.3L535.2,79.3C535.1,79.3,535.1,79.4,535.2,79.3C535.1,79.4,535.2,79.3,535.2,79.3z"
        />
        <path
          class="st0"
          d="M574.6,61.1c0.4,0.1,0.7,0.2,0.9,0.2c-0.1,0.2-0.1,0.3-0.2,0.5c0.5,0,1-0.1,1.6-0.4c1.2-0.5,1.7-1.3,1.9-2.2
			c-0.6,0.3-1.1,0.8-2,0.7C576.1,59.8,575.2,60.4,574.6,61.1z"
        />
        <path
          class="st0"
          d="M398.7,98.8c-0.1,0-0.3,0.1-0.4,0.1c0.2,0,0.3,0.1,0.5,0.1C398.7,99,398.7,98.9,398.7,98.8z"
        />
        <path
          class="st0"
          d="M574.8,63.3c0,0.1-0.1,0.2-0.1,0.3c0.1,0.1,0.2,0.2,0.4,0.3C575,63.7,574.9,63.5,574.8,63.3z"
        />
        <path
          class="st0"
          d="M560.9,166L560.9,166c-0.1-0.1-0.2-0.1-0.2,0c0,0,0,0.1,0.1,0.1C560.8,166.1,560.9,166.1,560.9,166z"
        />
        <path
          class="st0"
          d="M561.8,165.8C561.9,165.7,561.9,165.7,561.8,165.8C561.9,165.7,561.9,165.7,561.8,165.8
			C561.8,165.7,561.9,165.7,561.8,165.8z"
        />
        <path
          class="st0"
          d="M549.9,164.7c0-0.1-0.1-0.1-0.1-0.2l-0.1,0.1C549.8,164.7,549.8,164.7,549.9,164.7z"
        />
        <path
          class="st0"
          d="M564.3,165.5c0,0.6,0,1.2-0.1,1.8c0.5-0.5,1-1,1.6-1.5C565.5,165.2,565,165,564.3,165.5z"
        />
        <path
          class="st0"
          d="M395.1,112.9c0-0.8-0.7-1.1-1.3-1.4c-0.1,0.7-1.3,1.1-1,1.8C393.6,113.2,394.3,113,395.1,112.9z"
        />
        <path
          class="st0"
          d="M470,189.7c0.3,0,0.7-0.1,1-0.1C470.7,189.4,470.4,189.2,470,189.7z"
        />
        <path
          class="st0"
          d="M574.2,65.8c0.3-0.2,0.5-0.4,0.6-0.7C574.6,65.3,574.4,65.5,574.2,65.8C574.2,65.7,574.2,65.7,574.2,65.8z"
        />
        <path
          class="st0"
          d="M366.9,115.6c-0.2,0-0.3,0-0.5,0c0.1,0.1,0.2,0.1,0.3,0.2C366.8,115.8,366.9,115.7,366.9,115.6z"
        />
        <path
          class="st0"
          d="M336.4,230.9c-0.2-0.1-0.3-0.2-0.5-0.3c-0.3,0.4-0.6,0.8-1,1.1C335.5,231.5,336,231.2,336.4,230.9z"
        />
        <path
          class="st0"
          d="M347.8,223.7c0,0.1,0,0.1,0,0.2c1.4-0.2,1.5-0.4,1-1.3C348.4,223.1,348.1,223.4,347.8,223.7z"
        />
        <path
          class="st0"
          d="M611,162.2c-0.2,0.2-0.5,0.5-0.7,0.7c-0.1,0.1-0.2,0.2-0.2,0.3c-0.3,0.4-0.6,0.7-0.7,1.1
			c-0.1,0.5-0.1,1,0.3,1.5c0.1,0.1,0.1,0.4,0,0.6c0,0.1,0,0.1,0,0.2c0,0.1-0.1,0.2-0.3,0.3c-0.3-0.1-0.6-0.2-0.8-0.3
			c-0.4,0.3-0.7,0.6-1,0.9c-0.8-0.4-1.3-1-1.1-1.5c0.1-0.3,0.7-0.5,1.1-0.8c-1.7-0.2-2.5,0.7-3.1,1.9c-0.4-0.2-0.8-0.4-0.8-0.6
			c0-0.3,0.3-0.6,0.4-0.8c-0.3-0.4-0.5-0.8-0.8-1.2c-0.1-0.2-0.2-0.3-0.3-0.5c-0.3-0.3-0.5-0.5-0.8-0.5c-0.2,0-0.5,0.1-0.9,0.2
			c-0.4,0.2-0.6,0.5-1,0.8c0.4,1.1,0.9,2.2,0.1,3.3c0,0.1-0.1,0.1-0.1,0.2l0,0l0,0c0,0.1,0,0.2,0.1,0.3c0.5,0.2,1,0.3,1.4,0.6
			c0.5,0.5,1.2,1,0.5,1.9c-0.1,0.2-0.1,0.4-0.1,0.6c1.3,0.1,1.3,0.1,2.1-1c1.1,0.5,2-0.5,3.3-0.4c0.6,0.3,1.2,0.6,1.6,1
			c0,0,0,0,0.1,0c0.6,0.5,1,0.9,1.2,1.4c0.3,0.7,0.2,1.6-0.3,2.6c-0.2,0.4-0.4,0.8-0.7,1.3c0.1,0,0.2,0,0.3,0
			c0.3-0.3,0.5-0.5,0.7-0.8c0.1-0.2,0.2-0.3,0.3-0.5c0.2-0.6,0.3-1.2,0.4-1.8c0-0.3,0-0.5-0.1-0.8c-0.1-0.2-0.1-0.3-0.2-0.5
			c0-0.1-0.1-0.3-0.1-0.4c0-0.1-0.1-0.2-0.1-0.3c-0.4-0.9-1.2-1.5-2.4-1.9c0.1-0.3,0.2-0.6,0.4-1c0.2,0.3,0.4,0.4,0.6,0.6
			c0.4-0.3,0.4-0.7,0.3-1c-0.1,0-0.2-0.1-0.2-0.1c0-0.1,0-0.1,0.1-0.3c0-0.2-0.1-0.3,0-0.5c0.3-0.2,0.6-0.3,0.8-0.5
			c0.2-0.1,0.4-0.2,0.6-0.4c0.1,0.2,0.1,0.5,0.2,0.8c0,0.1,0.1,0.3,0.1,0.4c0.1,0.4,0.1,0.9,0.7,1.1c0.2,0.1,0.3,0.4,0.4,0.6
			c0,0,0,0.1,0.1,0.1v-2V165l0,0c-0.1,0-0.2-0.1-0.3-0.2c0.1-0.1,0.2-0.2,0.3-0.3v-3.3h-0.1C611.6,161.5,611.3,161.8,611,162.2z
	M602.4,166.7v-0.1V166.7L602.4,166.7z M603.7,169.3c-0.1-0.2-0.1-0.4-0.1-0.5c0.1,0,0.2,0.1,0.2,0.1
			C603.8,169,603.8,169.1,603.7,169.3z M610.8,165.9c-0.1-0.1-0.3-0.2-0.3-0.3s0.1-0.3,0.1-0.6c0.3,0.3,0.4,0.4,0.4,0.5
			C611.1,165.7,610.9,165.8,610.8,165.9z M611.4,164.1c-0.4-0.2-0.9-0.4-0.9-0.4c0.1-0.3,0.3-0.7,0.6-0.8c0.5-0.2,0.8,0.2,0.9,0.5
			C612.1,163.6,611.7,163.8,611.4,164.1z"
        />
        <path
          class="st0"
          d="M535.1,75.1c-0.5,0.7-1.2,0.8-1.9,0.9c0.5,0.2,1,0.3,1.5,0.5l0,0h0.1c0.1-0.1,0.1-0.2,0.2-0.3
			c0.1,0,0.1,0.1,0.2,0.1c-0.1,0.1-0.3,0.1-0.4,0.2c0,0,0,0,0,0.1l0,0l0,0c0.1,0.1,0.1,0.2,0.2,0.2c0.1,0.1,0.1,0.1,0.1,0.2
			c0.4,0.7,0.3,1.5,0.3,2.2c0.5-0.1,1.1,0.1,1.6-0.3s1.1-0.5,1.7-0.5c-0.1-0.4-0.2-0.8-0.4-1.3c0.7-0.3,1.4-0.5,2.2-0.8v-0.1
			c-0.5-0.4-0.9-0.9-1.4-1.3l0,0c-0.3,0.3-0.4,0.9-0.9,1.2c-0.1,0-0.1,0.1-0.2,0.1l-0.1-0.1c-0.3-0.4-0.6-0.8-0.9-1.2
			c-0.2-0.3-0.4-0.6-0.6-0.9C535.9,74.3,535.4,74.7,535.1,75.1z"
        />
        <path
          class="st0"
          d="M312.2,138c0.5,0,1,0,1.6,0c0-0.1,0-0.1,0-0.2c0-0.6,0-1.2,0.1-1.8c0-0.5,0-1,0-1.4c0.7-0.4,1.2-0.7,1.8-1
			c0,0,0.1,0,0.1-0.1c0,0,0.1,0,0.1-0.1s-0.1-0.1-0.1-0.2c-0.3-0.4-0.7-0.6-1.1-0.7c-0.6-0.1-1.3,0.1-1.9-0.1
			c-0.2,0.2-0.3,0.3-0.3,0.5c-0.2,0.4,0,0.8,0.2,1.2c0.2,0.3,0.3,0.7,0.2,1.2c-0.3-0.4-0.5-0.7-0.6-1.1c-0.1-0.4-0.2-0.8-0.3-1.1
			c-0.1-0.3-0.1-0.6-0.2-0.9c-0.6-0.1-1.4-0.2-2.1-0.4c-0.1,0.3-0.2,0.6-0.3,0.7c-0.4-0.2-0.8-0.4-1.2-0.6c-0.1,0-0.1-0.1-0.2-0.1
			c-0.6-0.3-1.2-0.6-1.8-0.9h-0.1v3.4v0.2h0.1c0.1,0.2,0.1,0.3,0.2,0.5c-0.1,0-0.1,0-0.2,0.1c0-0.1-0.1-0.2-0.1-0.3v0.8v0.3
			c0.1,0,0.1-0.1,0.2-0.1s0.2,0.1,0.2,0.1c0,0.1-0.1,0.1-0.1,0.2c-0.1-0.1-0.2-0.1-0.3-0.2v1.9v2.1c0.2,0.1,0.3,0.2,0.5,0.3
			c0.4,0.2,0.9,0.4,1.4,0.5h0.1l0,0c0.1-0.1,0.1-0.1,0.2-0.2c0,0.1-0.1,0.2-0.1,0.2l0,0c0,0,0,0,0.1,0c0.4,0.3,0.8,0.5,0.9,0.9
			c0.1-0.1,0.3-0.3,0.4-0.4c1.3,0.3,2,0.2,2.3-0.4c0.1-0.2,0.2-0.5,0.3-0.9l0,0c-0.4,0.1-0.8,0-1.1,0c-0.3-0.1-0.6-0.2-0.8-0.5
			c-0.2-0.2-0.4-0.6-0.4-0.9c-0.7,0.2-1.3,0-1.8-0.3c0,0-0.1,0-0.1-0.1c-0.3-0.2-0.4-0.4-0.4-0.6c0-0.1-0.1-0.1,0-0.2
			c0-0.1,0-0.1,0.1-0.2c0-0.1,0-0.1,0.1-0.2c0.1-0.1,0.2-0.2,0.3-0.3c0,0,0.1,0,0.1-0.1c0,0,0,0,0.1,0l0,0l0,0
			c0.3-0.1,0.6-0.3,0.9-0.3c0.6-0.1,1.1,0.1,1.2,0.6l0,0c0.1,0.4,0,0.8,0,1.2C310.9,138,311.6,138,312.2,138z M306.6,133.1
			C306.6,133.1,306.6,133.2,306.6,133.1c-0.1,0.1-0.1,0.2-0.1,0.2C306.5,133.2,306.5,133.2,306.6,133.1
			C306.5,133.1,306.6,133.1,306.6,133.1c0-0.1,0.1-0.2,0.1-0.2l0.1,0.1C306.7,133,306.7,133,306.6,133.1z M309.9,134.1
			c0-0.2,0.2-0.4,0.4-0.6l0.1-0.1c0,0,0.1,0,0.2,0c0.2,0,0.5,0.2,0.8,0.4c-0.3,0.3-0.5,0.6-0.8,0.8
			C310.3,134.4,309.9,134.2,309.9,134.1z"
        />
        <path
          class="st0"
          d="M468.6,75.7l-0.1-0.1c-0.1,0-0.2,0.1-0.3,0.1c0,0,0.1,0,0.1,0.1C468.5,75.8,468.6,75.7,468.6,75.7z"
        />
        <path
          class="st0"
          d="M556,63.6c0.1,0.1,0.3,0.1,0.4,0.1c0,0,0.1-0.1,0.2-0.3c-0.2,0-0.3-0.1-0.4,0C556.1,63.5,556.1,63.6,556,63.6
			z"
        />
        <path
          class="st0"
          d="M393.8,111.4c-0.1-0.8,0-1.6-0.5-2.3c0.1-0.1,0.2-0.2,0.3-0.3c-0.1-0.1-0.2-0.2-0.3-0.3
			c-0.1,0.2-0.2,0.4-0.4,0.8c-0.1,0.2-0.2,0.3-0.3,0.6c-0.2-0.3-0.3-0.5-0.4-0.7v-0.1c-0.7,0.3-1.4,1.1-1.3,1.7
			c0.1-0.1,0.2-0.1,0.3-0.1c0.4-0.1,0.9,0,1.6,0.2c0,0.2,0,0.4,0,0.7C393.2,111.6,393.5,111.5,393.8,111.4z"
        />
        <path
          class="st0"
          d="M437,208.6C437,208.6,437,208.5,437,208.6c-0.1-0.1-0.1-0.1-0.2-0.1c0,0.1,0,0.1,0,0.2
			C436.9,208.6,437,208.6,437,208.6z"
        />
        <path
          class="st0"
          d="M545.9,163.7L545.9,163.7c0.1,0,0.1,0,0.2,0C546,163.8,546,163.8,545.9,163.7
			C545.9,163.8,545.9,163.7,545.9,163.7c-0.6,0.6-1.2,1.2-2.1,2.1c1.2-0.3,2.1-0.4,2.9-0.6c0.1-0.6,0.1-1.2,0.3-1.7
			c0.1-0.5,0.7-0.7,1.1-0.4c0.4,0.2,0.7,0.5,1.2,1c-0.2-0.9-0.3-1.5-0.5-2.3C547.9,162.4,546.6,162.7,545.9,163.7z"
        />
        <path
          class="st0"
          d="M375.9,117.1c0.1-0.1,0.1-0.2,0.2-0.3c0.2-0.3,0.4-0.6,0.6-0.8c0.2-0.2,0.4-0.4,0.6-0.6
			c-0.1-0.1-0.2-0.2-0.3-0.3c-0.2-0.1-0.9,0.1-0.9,0.2c-0.1,0.5-0.4,0.8-0.8,1.2c0.1,0.2,0.3,0.3,0.5,0.4
			C375.8,116.9,375.8,117,375.9,117.1z"
        />
        <path
          class="st0"
          d="M583.2,69.4c0,0.1,0.1,0.3,0.2,0.4c0.1-0.5,0.2-0.9,0.2-1.4c-0.1-0.1-0.2-0.3-0.4-0.4
			C583.3,68.5,583.2,69,583.2,69.4z"
        />
        <path
          class="st0"
          d="M576.8,70.5L576.8,70.5c-0.1-0.1-0.2-0.3-0.4-0.4C576.5,70.3,576.6,70.4,576.8,70.5z"
        />
        <path
          class="st0"
          d="M577.1,72.2c0.2-0.2,0.5-0.4,0.7-0.5c-0.2-0.2-0.4-0.4-0.6-0.7c0,0,0,0.1,0.1,0.1c0,0,0,0,0,0.1
			s0.1,0.2,0,0.3v0.1c-0.1,0.1-0.1,0.3-0.3,0.4C577.1,72.1,577.1,72.1,577.1,72.2z"
        />
        <path
          class="st0"
          d="M570.4,69.6c-0.4-0.2-1.3,0.1-0.5-0.6c-0.4-0.1-0.9-0.1-1.6-0.3c0.2,0.5,0.4,0.7,0.5,1c0,0.3,0,0.5-0.1,1
			C569.3,70.3,569.8,70,570.4,69.6z"
        />
        <path
          class="st0"
          d="M577,73.2c0,0.1,0.1,0.3,0.3,0.4c0.6,0.4,0.9,0.7,1.8,0.5c0.3-0.1,0.7,0.1,0.9,0.2c0.3,0.7,0.5,1.3,0.8,1.9
			c0.3-0.3,0.5-0.5,0.8-0.8c0.2,0.5,0.3,0.8,0.3,1.1c0.8,0,1.4-0.1,2.3-0.1c-0.2-1-0.3-2.1-0.5-3.1c-0.1,0.1-0.2,0.1-0.3,0.2
			c-1.8-1.7-1.8-1.7-4.4-1.2c-0.5,0.1-0.9,0.4-1.3,0.6C577.5,73,577.3,73.1,577,73.2z M583.5,74.2C583.5,74.2,583.6,74.2,583.5,74.2
			v0.2C583.5,74.4,583.4,74.4,583.5,74.2C583.5,74.2,583.5,74.2,583.5,74.2z M583.2,73.7c-0.1,0.1-0.2,0.2-0.4,0.3
			c-0.1,0-0.2-0.1-0.3-0.2c0.1-0.1,0.3-0.2,0.4-0.2C583,73.5,583.1,73.6,583.2,73.7z M581.3,72.4c0.7-0.1,1.2,0,1.5,0.5
			c-0.3,0.6-0.9,0.5-1.4,0.7l0,0c0,0,0,0-0.1,0c-0.1,0.1-0.1,0.3-0.2,0.4c0-0.1-0.1-0.2-0.1-0.3c0,0,0,0-0.1,0c0,0,0,0,0-0.1
			c-0.1-0.1-0.4-0.3-0.4-0.3C580.8,73,581,72.7,581.3,72.4z M579.4,72.9c0.1,0,0.1,0.1,0.2,0.1c-0.1,0.1-0.1,0.1-0.2,0.2
			c0,0-0.1,0-0.1-0.1C579.3,73,579.4,72.9,579.4,72.9z"
        />
        <path
          class="st0"
          d="M540,79.8c0.4,0,0.6-0.2,0.7-0.6c0.1-0.3,0.5-0.6,0.6-1c0.1-0.3,0.1-0.7-0.1-0.8c-0.1,0-0.1-0.1-0.1-0.1
			c-0.2,0.2-0.5,0.4-1,0.4c-0.4,0-0.8,0.4-1.2,0.7c0.2,0,0.5,0,0.7,0c-0.1,0.3-0.2,0.5-0.2,0.6C539.4,79.4,539.4,79.7,540,79.8z"
        />
        <path
          class="st0"
          d="M526.2,70.5c0.7-0.2,1.4-0.2,2-0.1c0.4-0.4,0.9-0.8,1.5-1c-0.2,0.5-0.3,0.9-0.5,1.4c0.4,0.2,0.7,0.6,0.8,1
			c0.2,0.5,0.1,1.1-0.1,1.6c-0.2,0.6-0.6,1-1.2,1.3c-0.5,0.3-1,0.5-1.6,0.7c0.9,0.7,1.7,0.6,2.6,0.4c0.5-0.1,1-0.3,1.4-0.2
			c0.4,0.1,0.8,0.2,1.1,0.3c-0.4-0.6-0.3-1.2,0.6-1.9c0.4-0.3,0.7-0.8,0.7-1.2c0.1-0.7,0.1-1.3,0-2c-0.1,0-0.2,0-0.3,0
			c-0.4-0.1-0.7-0.2-1.1-0.4c-0.4,0.1-0.7,0.2-1.1,0.3c0-0.5,0-0.9,0-1.4c0-0.1-0.1-0.1-0.1-0.2c-0.5,0.1-1,0.2-1.5,0.3
			c0.2-0.7,0.4-1.4,0.6-2.4c0.4-0.2,0.8-0.4,1.3-0.6c0.2-0.3,0.5-0.5,0.8-0.7l0.1-0.1c0-0.4-0.1-0.7-0.1-1.1s-0.1-0.7-0.2-1.1
			l-0.1,0.1c-0.4,0.5-1.1,1-1.8,1.3c-1.5,0.7-2.8,0.1-4-0.4c-0.1,0.5,0,1,0.4,1.5c0.1,0.2,0.2,0.3,0.4,0.5c-0.6,0.6-1.3,0.7-2.1,0.8
			c-0.1,0.4-0.2,0.8-0.3,1.2c0.6,0.1,1.1,0.2,1.6,0.2C525.6,69.4,526,69.9,526.2,70.5z"
        />
        <path
          class="st0"
          d="M596.1,70.8c0.1-1.3,0.5-2.5,0.2-3.5c-0.2-0.7-0.3-1.4-0.4-2.1c-0.6,0.1-0.8,0-0.5-0.7c0-0.1-0.2-0.1-0.4-0.2
			c-0.7,0.3-1.5,0.4-2.3,0.4c-0.2-0.2-0.6-0.5-0.8-0.7c-0.3-0.4-0.5-0.8-0.5-1.2c-0.6,0.2-1,0.2-1.4-0.1c-0.3,0.5-1.1,0.3-1.5,0.6
			c-0.5,0.4-0.9,0.8-1.6,1c-0.2,0-0.3,0.5-0.5,0.7c-0.3,0.2-0.6,0.3-1.1,0.5c0.2,0.5,0.1,1.1-0.8,1.6c-0.2-0.2-0.4-0.4-0.7-0.7
			c-0.1,0.1-0.2,0.2-0.2,0.3c0.1,0.2,0.3,0.4,0.6,0.6c0.7,0.5,0.9,1.1,0.9,1.9c0,0.1,0,0.2,0,0.3c1,0.6,1.8,1.5,3.6,1.6
			c-1.2,0.5-1.4,1.5-2.5,1.8c0.2,0.3,0.3,0.5,0.5,0.7c1.6,0.2,3,0.2,4-1.3c-0.3-0.1-0.5-0.2-0.8-0.2l0,0c-0.6,0.2-1.2,0.4-1.5-0.3
			c-0.1-0.2,0-0.5,0.2-0.6c0.4-0.2,0.9-0.4,1.1-0.4c0.6-1,1-1.9,1.5-2.7C593.3,68.4,594.1,70.1,596.1,70.8z M588,64.5
			c0.3,0.1,0.6,0.1,0.9,0.2c0,0.1-0.1,0.2-0.1,0.3c-0.3,0-0.6-0.1-0.9-0.1C587.9,64.7,588,64.6,588,64.5z M587,64.6L587,64.6
			L587,64.6c0-0.1,0.1-0.2,0.1-0.3C587.1,64.4,587,64.5,587,64.6s0,0.2-0.1,0.3c-0.1,0-0.1-0.1-0.2-0.1
			C586.8,64.7,586.9,64.6,587,64.6z M589.6,67.7C589.6,67.7,589.7,67.7,589.6,67.7C589.7,67.8,589.6,67.8,589.6,67.7
			C589.6,67.8,589.6,67.8,589.6,67.7c-1.4,0.8-1.4,0.8-2.9,0.2c-0.5-0.5,0.4-1.4-0.5-1.9c-0.3-0.2,0.4-0.8,0.7-0.7
			c0.8,0.6,2.2,0,3,0.9C589.8,66.7,589.7,67.2,589.6,67.7C589.6,67.8,589.6,67.8,589.6,67.7z M591.6,65.6c0.9,0,1.2,0.4,1.1,1
			c-0.1,0.7-0.7,0.9-1.9,1.2C591.1,66.8,591.3,66.2,591.6,65.6z"
        />
        <path
          class="st0"
          d="M586,71.7c-0.2,0-0.3,0.1-0.5,0.1c0.1,0.2,0.2,0.5,0.4,0.7C585.9,72.3,586,72.1,586,71.7z"
        />
        <path
          class="st0"
          d="M581,73.7L581,73.7L581,73.7c0.1,0,0.2,0,0.3,0l0,0h0.1h-0.1l0,0C581.2,73.7,581.1,73.6,581,73.7
			C581,73.5,581,73.6,581,73.7z"
        />
        <path
          class="st0"
          d="M318.6,237.1c0.2,0.1,0.3,0.2,0.5,0.4c0-0.1,0-0.1,0.1-0.2l0,0c0-0.1-0.1-0.3-0.2-0.5
			C318.9,236.9,318.8,237,318.6,237.1z"
        />
        <path
          class="st0"
          d="M319.5,237.9c0-0.4,0.1-0.7,0.1-0.9c-0.1,0.1-0.3,0.2-0.4,0.3l0,0c0,0.1-0.1,0.1-0.1,0.2
			C319.2,237.6,319.4,237.8,319.5,237.9z"
        />
        <path
          class="st0"
          d="M511.8,235.3c-0.1-0.7-0.1-1.4-0.2-2c2.3-0.2,2.3-0.2,3.1-2.2c-0.6-1.3-2-1.4-3.5-1.4
			c0.1-2.2,0.2-4.3,0.2-6.4c1.2-0.4,2.2-1,2.2-2.2c0-1-0.9-1.5-2.1-1.6c-0.2-0.9-0.4-1.8-0.5-2.6c0-0.3,0.1-0.7,0.3-1
			c0.6-0.9,0.5-0.8-0.2-1.6c-0.3-0.3-0.4-0.9-0.4-1.3c0-1,0.1-2.1,0.3-3.1c0.1-0.4-0.1-0.7-0.3-1.1c-0.6-1,0-2,1.4-2.3
			c0.3-0.1,0.7-0.2,0.9-0.1c1.7,0.5,3.6,0,5.4,0.2c0.3,0.3,0.5,0.7,0.8,1.1c0.4,0.5,1.1,0.5,1.8,0.3c0.8-0.2,1.3-0.6,1.3-1.2
			c0-0.3,0-0.5,0-0.8c-0.6-0.2-0.6-0.4-0.7-1.3c0.3,0.4,0.5,0.6,0.8,0.9c0.1-0.4,0.3-0.8,0.5-1.2c0.1-0.1-0.1-0.4-0.2-0.6
			c0.2,0,0.3,0,0.5,0c0-0.1-0.1-0.1-0.1-0.2c0.8-1.3,0.8-1.3,0.6-2.6c0.3,0.3,0.7,0.5,0.7,0.7c0,0.9,0.4,1.5,0.9,2.3
			c0.3-0.1,0.6-0.3,0.9-0.8c0.7,0.2,1.4,0.4,2,0.2c-0.2-0.5-0.3-1-1-1.1c0.6-0.7-0.7-0.4-0.5-0.8c0.4-0.9-0.1-0.7-0.8-0.7
			c-0.8,0-1.2-0.9-1.5-1.6c0.7-0.1,1.4-0.2,2.3-0.3c-0.5-0.2-0.8-0.3-0.9-0.5c-0.2-0.2-0.2-0.5-0.3-0.7c-0.8,0.2-1.2,0.4-1.7,0.8
			c-0.8,0.7-1.3,0.7-2-0.1c-0.1-0.2-0.2-0.4-0.4-0.5c-0.3-0.2-0.6-0.5-1-0.5c-1.7-0.2-1.9-0.3-2.2-1.6c0-0.2-0.1-0.4-0.1-0.5
			c-0.4,0.1-0.8,0.1-1.2,0.2c0.1,0.5,0.1,1,0.2,1.4c-0.6,0.1-1.5,0.4-1.7,0.3c-0.6-0.8-2-0.3-2.5-1.2c-0.3-0.6-1-1.2-1.6-1.5
			c-0.3-0.1-0.5-0.3-0.7-0.5c-0.3-0.3-0.4-0.6-0.5-1.1c0.8-0.5,1.7-1,2.5-1.4l0,0c0.1,0,0.3,0.1,0.5,0.1c0.3,0,0.7,0,1,0
			c1,0,1.4-0.8,2.3-1c-0.1-0.3-0.2-0.5-0.3-0.7c-0.3,0.1-0.5,0.1-0.9,0.2c0.1-0.2,0.2-0.4,0.4-0.6c0.4-0.7,0.8-1.4,1.2-2.1
			c-0.2-0.2-0.3-0.3-0.5-0.5s-0.5-0.5-0.7-0.8c1-0.2,1.5-0.8,1.9-1.4c0.4-0.6,0.8-1.4,1.7-1.8c0.6-0.2,0.5-1,1.2-1.2
			c0.1,0-0.1-0.6-0.1-0.9c0-0.1-0.1-0.3-0.1-0.4c-0.1,0.1-0.2,0.1-0.3,0.2c-0.6,0.3-1.2,0.6-1.9,0.9c0,0,0-0.1-0.1-0.1
			c0.2-0.2,0.5-0.4,1-0.9c-1.4,0.5-2.3,0.8-3.4,1.2c0.4,0.3,0.6,0.5,0.8,0.7c-1,0-1.8-0.8-2.7,0c-0.5-0.9-0.4-1.6,0.3-2.2
			c0.1,0.4,0.3,0.8,0.9,0.6c0.3-0.1,0.7-0.6,0.7-0.8c0-0.4-0.3-0.7-0.5-1.1c-0.3-0.5-0.7-1-1.2-1.6c1.4-0.1,0.5-1,1.1-1.4
			c0.4-0.3-0.2-0.5-0.3-0.7c-0.3-0.8-0.8-1.2-2-0.9c-0.4,0.1-0.9-0.2-1.3-0.3c-0.3-0.9,0.1-2.2-1.4-2.6h0.1l0,0
			c0.1,0.2,0.3,0.5,0.5,0.8c-0.3,0.1-0.6,0.2-0.9,0.4c-0.2-0.5-0.3-0.9,0.4-1.2l0,0c-1.1-0.1-2.2-0.2-3.2-0.3c-0.6,2.1,0.1,4,0.3,6
			c0,0,0.1,0,0.2,0.1c0.3-0.3,0.6-0.5,1.1-0.9c0.1,0.5,0.4,0.9,0.2,1.3c-0.1,0.2-0.8,0.3-1.1,0.4c-0.2,0.6-0.4,1.2-0.6,1.7
			c-0.3,0.6-0.4,1.2,0.2,1.7c1,1.1,1.5,2.3,1.3,3.8l0,0c-0.1,0.4-0.1,0.8-0.4,1.1c-0.1,0.1-0.2,0.3-0.3,0.4c-0.7,0.7-1.3,1.2-2,1.4
			c0.4,0.4,0.7,0.7,1,0.9c0.2-0.1,0.3-0.1,0.4-0.2c0.3-0.1,0.5-0.2,0.8-0.3c0.3,0.6,0.6,1.1,0.9,1.7c0.2-0.2,0.5-0.3,0.5-0.5
			c0-0.3-0.2-0.6-0.1-0.9c1.1,0.7,1.4,1.7,1.3,2.8c0,0.2-0.6,0.5-0.9,0.7c-0.9-1.2-0.9-1.2-3.4-2l0,0c-0.8-0.3-1-0.8-0.5-2.1
			c-0.8,0.2-1.8-0.1-2.9-1l-0.1-0.1c0.6-1.2,0.6-1.2,2.1-1.2c0.5,0,1-0.1,1.4-0.3c0.9-0.3,1.1-0.6,0.9-1.5c-0.1-0.8-0.4-1.5-1.1-2
			s-0.8-1.2-0.7-1.9c0.1-2.1-0.5-4.1-1.6-5.9c-0.5,0-0.9,0.2-1.2,0c-1.3-0.6-2.2,0.2-3.2,0.7c-0.7,0.4-0.5,0.9,0,1.2
			c1.2-0.5,1.6-0.6,2-0.2c0.4,0.4,0.3,0.7-0.7,1.5c-0.3-0.1-0.7-0.1-1.2-0.3c0.1,0.7-0.2,1.3-0.6,1.8c-0.4,0.6-1,1.1-1.3,1.9
			c-0.5-0.4-1-0.7-1.5-1.1c-1.3-1-2.6-1.9-4-2.9c-0.1,0.4-0.2,0.7-0.3,1c0,0.1,0,0.1-0.1,0.2c-0.4,1.5-0.8,3-0.2,4.6
			c0.4,0.9,0.2,1.9-0.2,2.9l0,0l0,0c1.2-0.7,2.4-1.2,4-0.9c0.2,0.2,0.6,0.5,0.9,1c0.7,0.9,0.5,2.1-0.4,2.9c-0.8,0.8-2.3,1.1-3.4,0.8
			c-1.2-0.4-1.9-1.4-1.6-2.6c0.1-0.4,0.2-0.8,0.4-1.2l0,0l0,0c-0.5,0.5-1,1-1.6,1.6c0.1,1,1,2-0.4,2.9c0,0.2,0,0.3,0.1,0.4
			c0.7,1.9,0.2,2.8-2,3.8c-0.4,0.2-0.9,0.4-1,0.5c-1,1.4-0.7,2.4,0,3.4c0,0.1,0.1,0.1,0.1,0.2c0.1,0.1,0.2,0.3,0.3,0.4
			c0.6,0.7,1,1.5,1.3,2.3c0.1,0.2,0.1,0.4,0.2,0.5c0.2,0.6,0.1,1.2-0.2,1.8c-0.1,0.1-0.1,0.2-0.2,0.3c-0.4,0.6-1,1.1-1.7,1.4
			c-0.2,0.1-0.5,0.2-0.8,0.3s-0.6,0.1-1,0.1c-1.7,0-3.1-0.8-3.5-2.2c-0.3-1.3,0.4-2.7,1.8-3.4c0.3-0.2,0.6-0.3,1-0.4l0,0
			c0.5-0.1,1-0.2,1.8-0.4c-0.8-0.6-1.2-1.2-1.3-1.8c-0.1-0.5-0.1-1-0.1-1.5c0.1-1.4-0.2-2.8-1.1-4.1c-0.2-0.3-0.4-0.7-0.6-1
			c-0.3-0.6-0.6-1.1-0.9-1.7c-0.1-0.1-0.1-0.2-0.2-0.3c-0.7-0.1-1.3-0.3-1.8-0.6l-0.1-0.1c-0.3-0.3-0.6-0.7-0.7-1.2
			c0-0.2-0.5-0.4-0.7-0.5l0,0c-0.4-0.2-0.6-0.5-0.5-0.8c0-0.1,0.1-0.3,0.3-0.5c0.4,0.2,0.8,0.4,1.2,0.6h0.1l0,0
			c0.4-0.4,0.7-0.7,0.7-0.7c-0.2-1.1-1-1-1.8-1c-0.2,0-0.4,0-0.6,0c0-0.4,0.1-0.7,0.1-1.1c0-0.2,0-0.3,0-0.5
			c-0.4,0.2-0.8,0.3-1.2,0.4c-0.2,0.1-0.3,0.1-0.5,0.2c-0.1,0.5-0.2,0.9-0.3,1.4c-0.1,0.4-0.2,0.9-0.4,1.3c-0.1,0.3-0.4,0.6-0.6,1
			c-0.3,0.5-0.7,1-1,1.6c-0.5,0.9-1.7,1.3-2.5,2.1c0.2,0.4,0.5,0.3,0.8,0c1-1.1,2.3-1.4,3.6-0.8c0.4,0.2,0.7,0.2,1.2,0.1
			c0.2,0,0.4-0.1,0.6-0.1c1.2-0.1,1.9,0.5,2,1.5c0,0,0,0,0,0.1c0,1-1.2,2.1-2.4,1.9c-0.6-0.1-0.8,0.1-1.2,0.3
			c-1,0.6-2.2,0.8-3.1,0.2c-0.8-0.6-1.7-0.7-2.7-0.5c-0.1,0.4-0.2,0.7-0.3,1.4c-0.5-0.7-0.7-1.1-1.1-1.4c-0.3-0.3-0.7-0.4-1.1-0.6
			c0-0.1,0.1-0.1,0.1-0.2c0.1-0.1,0.2-0.2,0.3-0.3c0.4-0.2,0.9-0.1,1.3-0.3c0.1-0.3,0.1-0.5,0.1-0.8c0-0.4-0.2-0.8-0.6-1
			c-0.2-0.1-0.3-0.2-0.5-0.3c-0.4,0.3-0.8,0.6-1.3,0.8c-0.4,0.3-0.9,0.5-1.3,0.7c-0.1,0-0.1,0.1-0.2,0.1c-1,0.3-1.3,0.8-1.9,1.5
			c0.4,0.1,0.8,0.3,1.1,0.4c0.4,0.2,0.8,0.4,1.2,0.6c0.4,0.2,0.9,0.3,1.4,0.2c1.6-0.2,2.7,0.7,2.8,2c0,0.7,0.4,1,0.9,1.3
			c0.1,0,0.1,0.1,0.2,0.1c1.2,0.8,2.3,1.5,3.5,2.3c0.9,0.6,1.4,1.5,1.1,2.5c-0.3,1.1-1,2-2.3,2.4c-1.5,0.4-3,0.7-4.6,1.1
			c0.1,0.6,0.1,1.2-0.1,1.8c-0.1,0.4-0.4,0.8-0.7,1.1c-0.9,1-2.1,1.3-3.5,1.4c-0.1,0.6-0.3,1.1-0.4,1.7c-0.1,0.5-0.3,1-0.4,1.6
			c0.8,0.2,1.6,0.5,2.5,0.7c-0.1-0.4-0.1-0.7-0.1-1.1c0-1.4,0.6-2.7,2.3-3.5c0.1,0,0.2-0.1,0.3-0.1c1.5-0.7,3-0.5,4.2,0.2
			c0.7,0.4,1.6,1,1.7,1.6c0.2,0.9-0.3,2-0.5,3c0.6,0,1.2-0.1,1.8-0.1c1.4,0,2.6,0.5,3.4,1.3c0.3,0.3,0.6,0.7,0.8,1.1
			c0.1,0.3,0.2,0.7,0.2,1c0.1,2.1-1.6,3.9-4,4.4c0,0.1-0.1,0.2-0.3,0.4c-0.1,0.1,0.3,0.6,0.6,1.1c0.4,0.2,1-0.8,1.6-0.2
			c0.2,0.2,0.4,0.4,0.7,0.7c0-0.7,0.6-1.4,1.4-1.7c1-0.3,2,0.1,2.2,1c1-0.4,1.9-0.8,3-1.3c0.1,0,0.4,0.2,0.7,0.2
			c0.4,0,0.9,0,1.2-0.1c1-0.4,2.3-2.7,1.9-3.5c-0.7-1.3-1.1-2.7-2.4-3.8c-0.3-0.3-0.6-0.6-0.8-1c-0.1,0.2-0.2,0.3-0.2,0.5
			c-0.3,0.6-0.8,1.1-1.4,1.5c-0.4,0.2-0.8,0.4-1.3,0.5s-1.1,0.1-1.6,0c-0.7-0.1-1.4-0.5-1.9-0.9c-0.4-0.4-0.7-0.8-0.8-1.3
			c-0.3-1.7,1.1-3.4,3.1-3.8c1.7-0.3,3.3,0.3,3.9,1.6v-0.1c-0.4-0.6-0.1-1.2,0.1-1.9c0.1-0.4,0-0.8,0.1-1.3c0-0.2,0.2-0.4,0.3-0.6
			c0-0.1,0.1-0.1,0.1-0.2l0,0c0.7,0.2,1.3,0.4,1.9,0.6c0.1-0.4,0.5-0.9,1-1c0.7-0.2,1.4,0.1,1.5,0.7c0.1,0.5-0.1,0.9-0.6,1.2
			c0.8,0.4,1.5,0.9,2.3,1.3c0.7-0.6,1.3-1.3,2-1.9c1.3,0.3,2.6,0.4,2.6,1.9c0.5-0.3,0.7-0.5,1-0.6c0.4-0.2,0.9-0.4,1.3-0.5
			s1.8-0.6,2.2-0.7c1.3-0.5,2.7-0.8,4.2-0.6c0.7,0.1,1.3,0.2,2.1,0.3c-0.4,0.1-0.7,0.2-0.9,0.3c-0.6,0.3-0.7,0.7-0.3,1.1
			c0.4,0.4,1,0.8,1.3,1.1c0.2,1.2,0.4,2.2,0.5,3.2c0.1,0.3,0.2,0.7,0.1,1c-0.3,1.3,0.1,2.5,0.5,3.6c0.5,1.2,0.6,2.4-0.5,3.6
			c-0.2,0-0.4-0.1-0.6,0c-0.3,0.1-0.6,0.3-0.8,0.5c0.2,0.2,0.4,0.5,0.7,0.7c0.1,0.1,0.5-0.1,0.7-0.1c0.8-0.1,1.2,0.1,1.2,0.7
			c0.2,2,0.4,4.1,0.6,6.2c-1.1-0.1-2.2-0.1-2.9,0.7c-0.3,0.4-0.6,0.9-0.7,1.4c-0.1,1.3,1.2,1.9,3.6,1.6
			C510.9,233.9,510.7,234.9,511.8,235.3z M516,203.3c-0.1-0.1-0.2-0.2-0.2-0.4c0-0.1,0.1-0.2,0.2-0.2c0.1,0,0.2,0,0.3,0
			C516.1,202.9,516.1,203.1,516,203.3z M516.4,200.9c0.2-0.1,0.7-0.1,0.8,0c0.3,0.5,0.5,1,0.8,1.5h0.1c0,0,0,0,0,0.1
			c0.3,0,0.9,0,0.9,0.1c0.3,0.8,0.9,0,1.4,0.1c0.1,0.2,0.2,0.6,0.1,0.8c-0.1,0.4-0.3,1-1.1,0.5c-0.1,0-0.5,0.2-0.8,0.4
			c-0.9-0.5-0.8-1.2-0.6-1.9l0,0c0,0,0,0,0-0.1c-1.1,0.1-1.7-0.2-1.8-0.9C516.2,201.3,516.3,201,516.4,200.9z M515.8,199.4
			c0.1,0,0.2,0.1,0.2,0.2c-0.1,0.1-0.2,0.1-0.3,0.1s-0.1-0.1-0.2-0.2C515.6,199.4,515.7,199.4,515.8,199.4z M515.4,185.5
			L515.4,185.5c0,0,0-0.1,0.1-0.1h0.1C515.5,185.4,515.5,185.4,515.4,185.5L515.4,185.5L515.4,185.5z M514.4,186.1L514.4,186.1
			C514.5,186.1,514.5,186.1,514.4,186.1c0.1,0,0.1,0.1,0.1,0.1l0,0c0.2,0,0.3,0,0.6-0.1c0,0.1-0.1,0.2-0.1,0.2
			c-0.1,0.2-0.2,0.4-0.2,0.6c-0.1,0.2-0.1,0.5-0.1,0.8c-0.2-0.3-0.2-0.5-0.3-0.6c-0.1-0.2,0-0.4,0.1-0.9l0,0
			C514.5,186.2,514.5,186.2,514.4,186.1C514.5,186.1,514.4,186.1,514.4,186.1L514.4,186.1C514.4,186.1,514.4,186.1,514.4,186.1z
	M507.5,179.5c0,0-0.1,0-0.1-0.1l0.1-0.1c0,0,0.1,0,0.1,0.1C507.6,179.4,507.6,179.5,507.5,179.5z M510.5,189.4
			c-0.1,0-0.1,0-0.2,0c0.1-0.2,0.1-0.4,0.2-0.6c0.1,0,0.2,0.1,0.3,0.1C510.7,189.1,510.6,189.2,510.5,189.4z M510.5,187.1
			c0-0.1,0.1-0.1,0.1-0.2C510.6,186.9,510.6,187,510.5,187.1C510.6,187.1,510.6,187.1,510.5,187.1
			C510.6,187.1,510.6,187.1,510.5,187.1C510.6,187.1,510.5,187.1,510.5,187.1z M512.4,190.3c-0.1,0-0.3-0.1-0.4-0.1v-0.1
			c0-0.1,0.1-0.2,0.1-0.2l0,0c0.1,0,0.3,0.1,0.5,0.1C512.6,190.1,512.5,190.3,512.4,190.3z M513.8,189.1c0,0-0.1,0-0.1-0.1l0.1-0.1
			c0,0,0.1,0,0.1,0.1C513.9,189.1,513.9,189.1,513.8,189.1z M514,183.5c-0.8,0.8-0.8,0.8-1.8,0.1C512.8,182.7,513.3,183.4,514,183.5
			z M513.1,176.2L513.1,176.2c0-0.1,0-0.1,0-0.1c0-0.1,0-0.1,0-0.2v-0.1l0.1,0.1c0,0.1-0.1,0.1-0.1,0.2
			C513.2,176.1,513.2,176.2,513.1,176.2C513.2,176.2,513.2,176.2,513.1,176.2c0.1,0.5,0.3,1.1-0.4,1.5
			C512,176.8,512,176.7,513.1,176.2z M511.9,175.1c0.1,0,0.2,0.1,0.4,0.2c-0.1,0.2-0.3,0.3-0.4,0.4l-0.2-0.1
			C511.7,175.4,511.8,175.3,511.9,175.1z M511.9,189.2c0.1,0.1,0.2,0.1,0.3,0.2c-0.1,0.1-0.2,0.2-0.4,0.2c-0.1,0-0.2-0.1-0.3-0.1
			C511.7,189.4,511.8,189.3,511.9,189.2z M511.5,186.2c-0.2,0-0.3,0.1-0.4,0.1c-0.5,0-0.6-0.4-0.8-0.7c-0.3-0.5,0-0.8,0.3-1.3
			c0-0.1,0.1-0.2,0.1-0.3C511,184.9,511.3,185.5,511.5,186.2z M506.9,173.6l0.1-0.1c0.1,0,0.2,0,0.3,0c-0.1,0.1-0.1,0.2-0.2,0.2
			C507.1,173.7,507,173.6,506.9,173.6z M507.1,174.5c0.2-0.2,0.3-0.4,0.5-0.6c0.2-0.1,0.4-0.1,0.7-0.1
			C508.2,174.6,507.8,174.6,507.1,174.5z M508,174.8c0.6-0.1,1.2-0.3,1.7-0.4l0,0c0,0,0,0,0.1,0c0-0.2,0.1-0.3,0.1-0.5
			c0.1,0.1,0.2,0.1,0.4,0.2c-0.2,0.1-0.3,0.2-0.5,0.3c0,0,0,0,0,0.1l0,0c0,0.5,0.5,0.2,0.9,0.3c-0.3,0.4-0.6,0.9-0.9,1.2
			C508.3,175.7,508.3,175.7,508,174.8z M509.8,177.4h-0.1l0.1-0.1V177.4z M510,182.8L510,182.8L510,182.8c-0.1,0.1-0.3,0.2-0.6,0.4
			c0.1-0.3,0.1-0.6,0.2-0.8c0.2,0,0.5,0,0.7,0.1l0,0l0,0c0.1-0.2,0.3-0.3,0.4-0.5c0.6,0.6,0.6,0.6-0.5,1.4
			C510.1,183.2,510.1,183,510,182.8z M505.6,184.1c0.1,0,0.3,0,0.4,0.1c-0.1,0.2-0.1,0.4-0.2,0.6c-0.1,0-0.2,0-0.2,0
			C505.5,184.5,505.6,184.3,505.6,184.1z M504.2,180.1C504.2,180.1,504.2,180.2,504.2,180.1c0,0.1-0.1,0.1-0.2,0.2
			c0-0.1,0-0.1,0-0.2C504.1,180.1,504.1,180.1,504.2,180.1z M488,219.3L488,219.3l-0.1,0.1L488,219.3z M487.5,218.5
			c0.1,0,0.2,0,0.3,0c-0.1,0.1-0.1,0.2-0.2,0.2s-0.2,0-0.2-0.1C487.5,218.5,487.5,218.5,487.5,218.5z M487,219.8
			c-0.2,0.3-0.4,0.7-0.6,1.1C486,220.3,486.4,220,487,219.8z M486.1,219.4v0.1H486L486.1,219.4z M476.1,196.2c0.2-1.1,1.2-2,2.5-2.3
			c0.6-0.1,1.2-0.1,1.7,0c1.1,0.2,1.9,0.9,2.2,1.8c0.1,0.4,0.1,0.7,0,1.1c-0.3,1.1-1.3,2-2.6,2.3c-0.5,0.1-1,0.1-1.5,0
			c-1.2-0.2-2.1-0.9-2.3-2C476,196.8,476,196.5,476.1,196.2z M478.1,210.1c-2.2,0.5-4.3-0.5-4.6-2.3c-0.4-2,0.7-3.4,3.1-4
			c0.6-0.1,1.1-0.2,1.6-0.1c0.8,0.1,1.6,0.4,2.1,0.9c0.2,0.2,0.3,0.3,0.5,0.5c0.1,0.2,0.2,0.3,0.3,0.5c0.1,0.2,0.1,0.3,0.2,0.5
			C481.7,207.8,480.3,209.6,478.1,210.1z M502.8,197.5l0.1-0.1C502.9,197.4,502.9,197.5,502.8,197.5v0.1V197.5z M499,181.2
			C498.9,181.2,498.9,181.2,499,181.2c-0.1,0-0.1-0.1-0.1-0.1C498.9,181,498.9,181.1,499,181.2C499,181.1,499,181.1,499,181.2
			c0.1-0.1,0.2-0.1,0.3-0.2c0.8-0.6,1.7-0.9,2.7-0.4c0.8,0.4,0.9,0.9,0.5,2.2c0.1,0.1,0.3,0.2,0.4,0.3l0,0c0.1,0.1,0.2,0.1,0.3,0.2
			c-0.3,0.5-0.5,0.8-0.7,0.8s-0.4-0.1-0.7-0.3l0,0c-0.2-0.1-0.3-0.2-0.5-0.2C498.8,183.4,498.5,183,499,181.2z M502.1,184.8
			c0,0.3-0.1,0.3-0.4,0.5c-0.1,0-0.1,0.1-0.2,0.1c0.2-0.3,0.4-0.6,0.6-0.9C502.1,184.6,502.1,184.7,502.1,184.8z M499.5,189
			c-0.3-0.2-0.5-0.6-0.6-1c0-0.2,0.3-0.5,0.6-0.7c0,0,0,0,0.1,0c0.2,0,0.5,0.1,0.7,0.2c0,0,0,0,0,0.1c0.2,0.2,0.3,0.5,0.5,0.8
			C500.4,189,499.9,189.3,499.5,189z M500.6,189.4l-0.1,0.1c0,0-0.1,0-0.1-0.1l0.1-0.1L500.6,189.4z M499.2,184.7
			c0.9-0.4,1.3-0.2,1.8,0.5C500.3,185,499.9,184.8,499.2,184.7z M495.3,182.7c-0.1-0.4,0-0.9,0.6-1.2c0.5-0.2,1.1-0.7,1.6,0
			c-0.3,0.6-0.6,1.3-0.9,2C495.7,183.7,495.4,183.1,495.3,182.7z M491.8,192.6c-0.7-0.4-1.1-0.6-1.5-0.8
			C491.1,191.6,491.5,191.7,491.8,192.6z M490.2,199.2c-1-0.5-1.5-1.5-1.1-2.5c0.3-0.8,1.3-1.6,2.3-1.7c1.3-0.1,2.3,0.4,2.8,1.5
			c0.2,0.4,0,1,1,0.9c-0.7,0.5-1.2,0.9-1.7,1.3C492.4,199.5,491.3,199.7,490.2,199.2z M494.7,193.3c0-0.1,0.1-0.1,0.2-0.2
			c0.1,0.1,0.1,0.1,0.2,0.2c0,0.1-0.1,0.1-0.2,0.2C494.8,193.4,494.7,193.4,494.7,193.3z M495,201.2c0-0.6-1.2-0.9,0.1-1.7
			C495.1,200.1,496.3,200.4,495,201.2z M499.6,194.3l0.1-0.1l0.1,0.1H499.6z M499.5,192.9c-0.3,0-0.7,0.1-1.1,0.1
			c-0.3-0.4-0.5-0.8-0.8-1.2c-0.5,0.1-0.9,0.2-1.3,0.3c-0.9,0.2-1.6,0-1.9-0.5c-0.3-0.6-0.4-1.3,0.2-1.9c0.5-0.6,1.2-0.8,2-0.7
			c0.9,0.2,1.9,0.3,2.7,0.6c0.5,0.2,1.1,0.6,1.2,1c0.2,0.6,0.7,0.8,1.4,1.2c-0.5,0.6-0.9,1.1-1.2,1.6
			C500.1,193.1,499.8,193,499.5,192.9z M501.7,204.9L501.7,204.9L501.7,204.9c-0.1,0-0.2,0-0.2,0c0-0.1,0-0.2,0.1-0.3
			c0.1,0,0.2,0,0.2,0.1C501.8,204.8,501.7,204.8,501.7,204.9z M502.1,205.7c-0.1,0-0.3,0-0.3-0.1s0-0.2,0-0.4c0.2,0,0.4,0,0.4,0.1
			C502.2,205.4,502.2,205.6,502.1,205.7z M503.7,199.6c-0.6,0.7-1.2,1.3-2,2.2c-0.4-0.6-0.6-1-0.9-1.5c0.5-0.1,0.9-0.2,1.3-0.3
			c0.3-0.5,0.7-1,1.1-1.6C504.1,198.7,504.1,199.1,503.7,199.6z M504.3,207.1l-0.1-0.1c0-0.1,0.1-0.3,0.2-0.4
			c0.1,0.1,0.2,0.2,0.2,0.2C504.5,206.9,504.4,207,504.3,207.1z M504.8,196.9c0,0-0.1,0-0.1-0.1s0-0.2,0.1-0.3c0,0,0.1,0,0.1,0.1
			S504.8,196.8,504.8,196.9z M510.7,198.4c0,0,0.1,0,0.2,0c-0.1,0-0.1,0.1-0.2,0.1s-0.1,0-0.2,0
			C510.6,198.5,510.6,198.5,510.7,198.4z M505.7,193.5c-0.4-0.1-0.5-0.5-0.3-0.9s0.5-0.7,1.1-0.7c0.3,0,0.6,0.2,1.1,0.3
			c-0.2,0.4-0.3,0.8-0.6,1C506.7,193.5,506.1,193.6,505.7,193.5z M506.2,206.7c0,0-0.1,0-0.1-0.1l0.1-0.1l0.1,0.1
			C506.3,206.7,506.2,206.7,506.2,206.7z M506.6,207.2l0.1-0.1v0.1H506.6z M508.1,203.5c0-0.1-0.1-0.1-0.1-0.2l0.1-0.1
			c0.1,0,0.1,0.1,0.2,0.1C508.2,203.4,508.2,203.5,508.1,203.5z M508.8,201.8c-0.1,0-0.3,0-0.5,0c0.1-0.1,0.2-0.3,0.4-0.3
			c0.1-0.1,0.3,0,0.6-0.1C509,201.7,508.9,201.8,508.8,201.8z M509.3,195.4c-0.1,0.4-0.2,0.8-0.7,1.3c-0.2,0.3,0,0.8,0,1.2
			s0,0.9-0.5,1.1c-0.6,0.2-1-0.1-1.3-0.5l0,0c-0.2-0.4-0.3-0.7-0.4-1.1c0-0.1,0-0.1,0-0.2v-0.1c-0.9-1.6,0.3-2.8,1.7-3.9
			c0.3,0.3,0.5,0.6,0.8,0.9C509.2,194.4,509.4,194.9,509.3,195.4z M509.5,200.2c0.5-0.6,1-1.1,2-1.2c0.5-0.1,1-0.6,1.4-0.9
			c1.2,0.6,1.3,0.8,0.8,1.7c-0.3,0.6-0.7,1.1-0.2,1.8c0.3,0.4-1.1,1.6-1.8,1.6c-0.4,0-0.7-0.3-0.9-0.5c-0.3-0.4-0.5-0.8-0.7-1.2
			C509.8,201.2,509.7,200.7,509.5,200.2z"
        />
        <path
          class="st0"
          d="M367.9,239.8L367.9,239.8c-0.4-0.4-0.9-0.8-1.3-1.2c-0.3,0.7-0.3,0.7,0.2,1.4c0.1,0.1,0.1,0.2,0.2,0.3
			c0.1,0,0.2,0.2,0.2,0.2c0.2,0.9,1.3,1.2,1.7,2c0.1,0.1,0.3,0.2,0.5,0.3c0.3-0.4,0.7-0.7,1-1.1c0.5,0.4,1,0.8,1.5,1.2
			c0.5-0.3,1-0.5,1.4-0.8l-0.1,0.1c0,0,0,0,0.1,0c0,0,0,0,0-0.1c0.3-0.3,0.6-0.6,1-1c-0.2-0.2-0.4-0.4-0.6-0.6
			c-0.6,0.1-1.2,0.1-1.8-0.2c-0.3-0.1-0.6-0.3-0.9-0.6l-0.1-0.1c-0.1-0.2-0.3-0.3-0.4-0.5c-0.5,0.5-1,1-1.6,1.5
			C368.6,240.5,368.3,240.2,367.9,239.8z M366.6,239L366.6,239l0.1-0.1L366.6,239z"
        />
        <path
          class="st0"
          d="M518.3,193.9c-0.3,0.3-0.5,0.6-0.7,0.9C518.6,194.7,518.6,194.7,518.3,193.9z"
        />
        <path
          class="st0"
          d="M482.1,223.7c0.1,0,0.2,0.1,0.3,0.1c0-0.2-0.1-0.4-0.1-0.6C482.3,223.4,482.2,223.5,482.1,223.7z"
        />
        <path
          class="st0"
          d="M574.8,196.9c-0.1,1.1,0.5,1.9,1.3,2.6c0.2,0.2,0.4,0.3,0.6,0.5l0,0c0.2,0.1,0.4,0.2,0.6,0.3
			c0.6,0.2,1.3,0.2,2,0.1c0.4-1,1.4-1.7,2.7-1.8c0.4,0,0.7,0,1,0.1c0.4-0.5,0.7-1.1,0.9-1.8c0-0.3,0.1-0.5,0.3-0.8
			c0.3-0.6,0.8-1.1,1.5-1.5c1.9-1.2,2.7-2.6,2.2-4.4c0-0.1,0-0.2,0-0.3l0.1-0.1c0.9-0.2,0.9-0.2,1.3,1.2c0.5-0.1,1.1-0.2,1.8-0.3
			c-0.2-0.6-0.8-1-1.4-1.2c0.7-0.9,1.5-1.7,2-2.5c0.5-1,0.2-1.9-0.7-2.9c1.3,0,2.4-0.2,3.2-0.8c-0.3-0.2-0.5-0.5-0.5-0.7
			c0.1-0.4,0.1-0.7,0-1c-0.2-0.5-0.6-1-0.9-1.5c-0.5-0.9-0.6-1.8-0.3-2.7c-0.2-0.1-0.3-0.3-0.5-0.4c0.4-0.3,0-0.6-0.1-0.8
			c-0.2-0.5-0.3-1,0.8-1.4c0.3,0.4,0.6,0.8,0.8,1.2c1.2-1.2,2.8-1.8,4.6-1.5c1,0.2,1.9,0.3,2.9-0.1c0.2-0.9,0.7-1.8-0.7-2.5
			c-0.5-0.2-0.7-0.9-1-1.5c0,0,0,0-0.1,0c-0.1,0.3-0.1,0.7-0.7,0.6c-0.1,0-0.2-0.2-0.2-0.3s0-0.1,0.1-0.1c0,0,0,0,0-0.1
			c0.2-0.3,0.6,0,0.8-0.1c0,0,0,0,0-0.1h0.1c-0.1-0.2-0.1-0.4-0.2-0.6c0.3-0.1,0.6-0.1,0.9-0.2c0.1-0.4,0.2-0.8,0.3-1.3
			c-0.3,0-0.3-0.1-0.1-0.3l0,0c-0.1-0.2-0.1-0.4-0.2-0.7c0-0.1-0.1-0.2-0.1-0.3c-0.4,0.7-0.7,1.1-1,1.6c0.1,0.4,0.2,0.8,0.2,1.2
			c-0.2,0-0.4,0.1-0.8,0.1h-0.1c0-0.1,0-0.1,0.1-0.1c0.2-0.5,0.4-0.9,0.6-1.2v0.1c0-0.5,0.1-0.9,0.1-1.4c0-0.6,0-1.2,0-1.8
			c-0.1,0-0.3,0-0.4-0.1c-0.2,0.3-0.5,0.7-0.7,1s-0.2,0.7-0.3,1.1c-0.4,1.1-1,1.3-2.3,1c-0.7-0.2-1.5-0.3-2-0.3
			c-0.9,0.7-1.5,1.2-2.3,1.8c-0.1,0.6-0.3,1.3-0.4,2c1.1,0.4,0.6-0.9,1.4-0.9c0.8,0.3,0.8,0.9,0.5,1.7c-0.9,0-2,1-2.6-0.3
			c-0.9,0.2-1.4,1.1-2.4,0.8c-0.1,0-0.4,0.3-0.5,0.4c-0.3,0.3-0.5,0.8-0.8,0.9c-0.7,0.2-0.9,0.4-0.8,1c0,0.1,0,0.2,0,0.3
			c-0.1,0.2-0.3,0.4-0.5,0.6c-0.2,0.1-0.3,0.2-0.5,0.4c-0.3,0.2-0.7,0.4-1,0.5s-0.6,0.2-0.9,0.1c-0.6,0-1.1-0.2-1.6-0.4
			c-0.4-0.2-0.7-0.6-0.9-1.1c-0.1-0.3-0.2-0.6-0.3-0.9c-0.4,0.1-0.8,0.1-1.1,0.3c-0.4,0.2-0.6,0.4-1.2,0.8c0.1-0.5,0-0.8,0.1-1.1
			c0.1-0.2,0.4-0.4,0.8-0.7c-0.5-0.3-0.9-0.5-1.3-0.7c-0.4-0.2-0.7-0.4-1-0.6c-0.7,0.3-0.5,0.6-0.4,1c0.2,0.8,0.2,1.4-0.1,2
			c-0.1,0.3-0.3,0.7-0.6,0.9c-0.1,0.1-0.3,0.2-0.4,0.4c-0.6,0.4-1.5,0.7-2.6,0.8c-0.4,0-0.8,0.1-1.3,0.2c0.1,0.4-0.1,0.7,0.1,1
			c0.1,0.1,0.2,0.2,0.4,0.2l0,0c0.1,0,0.1-0.1,0.2-0.1c0.1-0.2,0.3-0.4,0.4-0.6c0.1,0.1,0.1,0.1,0.2,0.2c-0.2,0.1-0.4,0.3-0.6,0.4
			l-0.1,0.1c0,0,0,0-0.1,0c-0.4,0.6-0.7,1.2-1.2,1.8c-0.6,0.8-1.5,1.3-2.5,1.5c-0.8,0.2-1.6,0.1-2.4-0.1c-0.1,0-0.2-0.1-0.4-0.1
			c-0.3-0.1-0.7-0.3-1.1-0.4c-0.2,0.1-0.3,0.3-0.5,0.4c-0.1-0.1-0.1-0.3-0.2-0.4c-0.2,0.2-0.3,0.3-0.4,0.4c0.1,0.1,0.2,0.2,0.3,0.4
			l0,0c0.1,0.2,0.3,0.3,0.4,0.4c0.1,0.1,0.2,0.1,0.2,0.2c-0.1,0.1-0.1,0.2-0.2,0.3c0.4,0.8,1.2,1.2,2.4,1.1l0,0
			c-0.1,0.6-0.2,1.2-0.4,1.7c0.1,0,0.2-0.1,0.3-0.1c1.2-0.2,2.3,0.3,2.4,1.2c1.1,1.2,3,1.2,4.6,1.5c0.7,0.1,0.8,0.4,0.9,0.8
			c-0.1,0.1-0.1,0.2-0.2,0.2c-0.3,0.2-0.7,0.5-0.9,0.7c-0.9,1.1-2.4,1.8-2.4,3.3c0,0.3,0,0.6,0.1,0.8c0.3,0.9,1,1.3,2.4,1.3
			c0.6,0,1.2-0.1,1.9-0.1C574.7,196.4,574.8,196.7,574.8,196.9z M591.8,176.9L591.8,176.9L591.8,176.9
			C591.8,176.9,591.8,176.9,591.8,176.9z M585.9,184.2c0.2-1.1,0.5-2.3,0.8-3.5c0.5,0,1,0,1.3,0.1c0.4,0.1,0.7,0.3,0.9,0.5
			s0.4,0.4,0.5,0.5c0.4,0.4,0.4,1.1-0.1,1.4c-0.8,0.6-1.7,1.1-2.6,1.5C586.3,185,585.8,184.6,585.9,184.2z M584,178.4
			c0,0,0.1,0,0.1,0.1c-0.1,0-0.2,0.1-0.3,0.1c0,0-0.1,0-0.1-0.1C583.8,178.5,583.9,178.5,584,178.4z M584,186.5
			c0.9-0.2,2.1,0.4,2.3,1c0.1,0.8-0.7,1.8-1.7,2c-0.9,0.2-1.8-0.4-1.9-1.2C582.4,187.5,583,186.8,584,186.5z M575.5,184.8
			c0,0-0.1,0-0.1-0.1s0-0.2,0-0.3c0.1,0,0.2,0.1,0.2,0.1C575.6,184.6,575.5,184.7,575.5,184.8z M578.9,198.6c-0.1,0-0.1,0.1-0.2,0.1
			l0,0c-0.2-0.2-0.3-0.4-0.5-0.6l-0.1-0.1c0.1-0.1,0.2-0.1,0.3-0.2c0,0,0,0.1,0.1,0.1C578.7,198.1,578.9,198.3,578.9,198.6
			C579,198.6,579,198.6,578.9,198.6z M580.4,180.8c0.1,0.1,0.1,0.3,0.2,0.4l0,0l0,0l0,0c0.1,0,0.2,0,0.3,0.1s0,0.2,0,0.4
			c-0.1-0.1-0.2-0.1-0.3-0.2c0-0.1,0-0.2,0-0.2l0,0l0,0c0,0,0,0,0-0.1c-0.1-0.1-0.2-0.2-0.4-0.2
			C580.3,180.9,580.4,180.9,580.4,180.8z M581.5,195.6c0.1,0.3,0.1,0.6,0,0.9c-0.1,0.4-0.4,0.7-0.8,0.9c-0.1,0.1-0.2,0.1-0.4,0.1
			c-0.4,0.1-0.8,0.1-1.2-0.1c-0.4-0.2-0.7-0.4-0.8-0.8c-0.1-0.2-0.1-0.5,0-0.8c0.1-0.2,0.2-0.5,0.4-0.7s0.5-0.4,0.8-0.5
			c0,0,0,0,0.1,0C580.4,194.6,581.3,195,581.5,195.6z M578.1,184.2c-0.1-0.1,0.2-0.4,0.3-0.6c0.3,0.1,0.6,0.2,1,0.4
			c-0.2,0.2-0.4,0.5-0.5,0.5C578.6,184.5,578.3,184.3,578.1,184.2z M578.4,176.5C578.4,176.5,578.4,176.4,578.4,176.5L578.4,176.5
			c0.1-0.2,0.2-0.3,0.3-0.4l0,0c0-0.1,0-0.1,0.1-0.2c0.1,0,0.1,0.1,0.2,0.1c-0.1,0-0.2,0.1-0.2,0.1l0,0
			C578.7,176.2,578.6,176.3,578.4,176.5L578.4,176.5c0,0.1,0,0.1,0,0.2c-0.1,0-0.1-0.1-0.2-0.1C578.3,176.5,578.4,176.5,578.4,176.5
			z M576.6,177.2L576.6,177.2c1.5-0.3,2.9,0.5,3.1,1.7c0,0.2,0,0.3,0,0.5c0,0.1,0,0.3-0.1,0.4c-0.2,0.6-0.7,1.2-1.4,1.5
			c-0.2,0.1-0.4,0.2-0.7,0.2c-0.3,0.1-0.7,0.1-1,0c-1-0.1-1.9-0.8-2-1.7c0-0.1,0-0.1,0-0.2C574.6,178.6,575.5,177.5,576.6,177.2z
	M573.6,179.4c0.1,0,0.2,0,0.3,0.1l-0.1,0.1c-0.1,0-0.2,0-0.3-0.1L573.6,179.4z M574.5,182.7L574.5,182.7
			c-0.2,0.2-0.3,0.5-0.4,0.7c0,0.2-0.1,0.3-0.1,0.5c-0.3,1.1-1.1,1.6-2.7,1.8c-0.3,0-0.6,0.1-1,0.1c-0.3-0.3-0.6-0.7-0.8-1.1
			c-0.5-0.9-0.2-1.9,0.6-2.5c0.2-0.2,0.4-0.3,0.7-0.4c0.7-0.2,1.5-0.2,2.2,0.1C573.6,182.1,574,182.4,574.5,182.7l-0.1-0.1
			C574.5,182.6,574.5,182.7,574.5,182.7l0.1,0.1c0,0,0,0.1,0.1,0.1c0,0-0.1,0-0.1-0.1L574.5,182.7z"
        />
        <path
          class="st0"
          d="M380.9,233.2c0.3-0.3,0.6-0.6,0.8-0.9c-0.1-0.2-0.3-0.3-0.4-0.4c-0.2-0.3-0.5-0.5-0.7-0.8
			c-0.4-0.1-0.8-0.1-1.3,0.1l0,0c-0.2,0.3-0.4,0.6-0.6,0.9c0,0.1,0,0.2,0,0.3c0,0.2,0,0.5,0.1,0.7c0.2-0.1,0.3-0.2,0.5-0.3
			C379.7,232.9,380.3,233.1,380.9,233.2z"
        />
        <path
          class="st0"
          d="M459.8,222.7c1,0,2.1-0.1,3.2-0.1c0.2-0.7,0.3-1.4,0.5-1.9c-1.3-0.3-2.6-0.6-3.7-0.9
			C459.8,220.7,459.8,221.7,459.8,222.7z"
        />
        <path
          class="st0"
          d="M538.3,188.6c0.1-0.1,0.2-0.1,0.2-0.2c-0.1,0-0.2,0-0.3,0C538.3,188.5,538.3,188.5,538.3,188.6z"
        />
        <path
          class="st0"
          d="M478.2,227.2c0,0.1,0,0.2,0,0.4c0,0.3-0.1,0.6-0.2,0.9c0.2,0,0.5-0.1,0.7-0.2
			C478.6,227.9,478.4,227.6,478.2,227.2z"
        />
        <path
          class="st0"
          d="M358,236.7c0.4,0,0.7,0,1.1,0.1c0.1-0.1,0.3-0.1,0.5-0.1c0.1,0.1,0.1,0.3,0.2,0.4c0,0,0.1,0,0.1,0.1
			c0.3,0.1,0.5,0.3,0.8,0.5c0.2-0.4,0.5-0.8,0.7-1.1c-0.1,0-0.3-0.1-0.4-0.1c-0.4-0.1-0.7-0.2-1-0.4c-0.1,0.1-0.1,0.1-0.2,0.1
			s-0.3-0.1-0.5-0.1c0.1-0.1,0.2-0.2,0.2-0.2c-0.7-0.5-1-1.1-0.8-1.9c0.3-1.4,1.4-1.9,3.9-2.1c0.3-1-0.2-2-0.4-2.7
			c-0.8-0.4-1.4-0.6-1.8-0.8c-0.8,0-1.6,0.2-2.2,0.2c-0.3,0.4-0.6,0.7-1,1.2c0.1,0.1,0.4,0.3,0.8,0.7c-0.3,0.7-0.6,1.4-0.9,2.1
			c0.2,0.1,0.5,0.1,0.9,0.2c-0.6,0.7-1.4,1.3-2.2,1.2c-1-0.2-1.5,0.5-2.1,0.7c-0.9,0.3-0.9,1.1-0.2,1.6c0.5,0.4,1.1,0.7,1.6,1.1
			c0.3,0.2,0.5,0.4,0.8,0.5c0.2-0.2,0.5-0.4,0.9-0.6c0,0,0.1,0,0.1-0.1C357.3,236.9,357.7,236.8,358,236.7z M358.8,228.9
			c0,0.1,0.1,0.1,0.1,0.2l-0.1,0.1c0-0.1-0.1-0.1-0.1-0.2C358.7,229,358.8,229,358.8,228.9z"
        />
        <path
          class="st0"
          d="M527,200.5c0.1,0.1,0.1,0.1,0.2,0.2c0.2-0.1,0.4-0.3,0.6-0.4c-0.1-0.1-0.2-0.1-0.2-0.2
			C527.4,200.2,527.2,200.4,527,200.5z"
        />
        <path
          class="st0"
          d="M538.6,189.4c-0.1,0-0.1-0.1-0.2-0.1c0,0.1,0,0.2,0,0.3C538.5,189.5,538.6,189.4,538.6,189.4z"
        />
        <path
          class="st0"
          d="M385.8,242.1c0.1-0.2-0.1-0.6-0.3-0.7c-0.2-0.1-0.7,0.1-1,0.2c-0.3,0.2-0.5,0.4-0.8,0.7
			c-0.2-0.1-0.4-0.2-0.7-0.4c0.4-0.8,1.5-1.4,1.3-2.4c-0.9,0.2-1.1,0.9-1.6,1.3c-0.7-0.2-1.8,0.6-2.1-0.5c-0.4,0.3-0.6,0.4-0.9,0.7
			c-0.1-0.8,0.2-1.8-1.2-2c-1,0.5-0.1,1-0.2,1.5c-0.9,0-0.8-0.8-1.5-1.1c0.5-0.4,0.9-0.7,1.3-1c-0.3-0.1-0.5-0.1-0.9-0.2
			c0.3-0.5,0.6-1,1-1.6c-0.1-0.1-0.2-0.2-0.3-0.4c-0.4-0.1-0.8-0.2-1.3-0.2c-0.1,0-0.1,0-0.2,0c0,0.1,0,0.1,0,0.2
			c-0.1,0.7-0.7,1.4-0.8,2c0,0.1,0,0.1,0,0.2c0.2-0.1,0.4-0.1,0.7-0.2c-0.3,1-0.5,1.9-0.9,3c0.1,0.3,0.2,0.9,1.4,0.7
			c0.3-0.1,0.7,0.4,1.1,0.7c-0.7,0.4-1.3,0.8-1.8,1.1c0.5,0.9,0.5,0.9,1.9,0.6c0-0.4-0.1-0.7-0.1-1.1c0.4,0.1,0.8,0.2,1.4,0.4
			c-0.2-0.5-0.3-0.8-0.4-1.2c0.5-0.1,0.9-0.2,1.4-0.3c0.4-0.1,0.8-0.4,1.5-0.7c-0.3,0.6-0.5,0.9-0.6,1.3c0.3,0.5,0.6,1,1.7,0.7
			c0.5-0.1,1.2,0.3,1.9,0.5C385.3,243.1,385.6,242.6,385.8,242.1z"
        />
        <path
          class="st0"
          d="M487.7,257.5c0.1,0.2,0.3,0.6,0.4,0.9c0.1,0,0.2,0,0.3,0c0-0.2,0.2-0.6,0.1-0.6c-0.9-0.5-0.7-1.3-0.8-2.1
			c1.5-0.7,2.9-0.1,4.4-0.4c-0.8-0.2-1.6-0.5-2.3-0.7c-0.1-0.8-0.2-1.5-0.2-2.3c0.4-0.2,0.8-0.2,1.1,0.3c0.3,0.7,0.9,1,1.9,0.8
			c0.6-0.8,0-1.3-0.5-2c0.3-0.2,0.6-0.6,1-1c-0.3-0.3-0.5-0.6-0.8-0.9c-1.3,1.1-1.4,1.1-2.6,0.7c-1.7-0.6-1.7-0.6-3.5-0.2
			c-0.3-0.6-0.6-1.3-0.9-2c-0.5,0-1.1-0.1-2.1-0.1c0.5-0.4,0.8-0.6,1.3-0.9c-0.8,0-1.6,0.4-1.8-0.3c0.2-0.2,0.3-0.4,0.5-0.7
			c-0.1,0-0.1-0.1-0.2-0.1c-0.3,0.2-0.7,0.5-1.1,0.8c-0.9-0.3-1.8-0.5-2.7-0.9c-0.2-0.1-0.3-0.3-0.3-0.4c0.1-0.2,0.4-0.4,0.6-0.5
			c0.2,0,0.4,0.1,0.7,0.2c0.6-1.2-0.9-1.7-0.9-2.8c0.8-0.2,1.2-1.3,2.5-1c-0.5,0.6-1,1.1-1.5,1.7c0.8,0.5,1.4,1,2.4,1
			c0.1-0.5,0.3-1,0.4-1.7c0.4,0.8,0.8,1.4,0.3,2.2c-0.1,0.2,0.1,0.6,0.2,1c0.6-0.3,1.1-0.5,1.7-0.8c0.4,0.4,0.7,0.7,1,1.1
			c0.6,0.2,1.3,0.4,1.9,0.6c-0.2,0.4-0.5,0.8-0.5,1.1c0,0.4,0.2,0.8,1,0.8c0.4,0,0.6,0.6,1,1c0.2-0.2,0.6-0.4,0.7-0.6
			c0.1-0.2-0.1-0.6-0.2-0.6c-1.1-0.2-0.2-1.1-0.7-1.5c-0.1-0.1,0.4-0.6,0.6-1c1,0.5,1.6,0.2,2.2-0.7c-1-0.4-2-0.8-2.9-1.2
			c0-2.1-0.8-2.7-3.5-2.5c-0.3-0.3-0.6-0.6-0.8-0.9c-1.3,0-1,1.7-2.5,1.3c0.1-0.3,0.2-0.5,0.3-0.7c0.5-1.1,0.5-2.1-1.2-2.5
			c0.5-0.7,1-1.4,1.5-2.1c-0.4-0.5-1.1-0.6-1.7-0.4c-1.3,0.4-2.5,0.9-3.9,1.4c-0.3-0.8,0.7-1.6,0.7-2.5c0,0,0,0,0.1,0
			c0,0,0,0-0.1-0.1v0.1c-0.2-1.4-0.6-1.6-2.9-1.8c1.6-0.7,1.8-1.6,1.7-2.7l0,0c-1.3,1.3-3.1,1.5-4.9,1.5c-0.1,0.7-0.2,1.3-0.2,1.9
			c0,0,0,0,0-0.1l0,0c0.4-0.4,0.7-0.7,1.2-1.2c0.4,0.5,0.6,0.9,1,1.3c-0.4,0.4-0.8,0.9-1.3,1.5c-0.4-0.7-0.7-1.1-0.9-1.6l0,0l0,0
			c-0.2,0.3-0.4,0.6-0.6,0.9c-1.1,1.6-2.8,2.6-4.9,2.7c-2.3,0.1-4-0.7-5-2.3c-0.7-1.1-0.6-2.2-0.3-3.5c-2-0.1-3.6-0.7-4.5-2.1
			c-1-1.4-0.6-3,0.1-4.5c-0.6,0-1,0-1.5-0.1c-2.4-0.3-3.7-2-3.1-4v-0.1c0.2-0.5,0.5-1,0.9-1.4c1-1,2.7-1.5,4.3-1.2
			c0.4,0.1,0.8,0.2,1.1,0.3c0.1,0,0.2,0,0.2,0.1c0.1,0.1,0.1,0.2,0.2,0.3c0-0.1,0.1-0.1,0.1-0.2c-0.1-0.1-0.2-0.1-0.3-0.2
			c0,0,0,0,0-0.1c-0.1-0.8-0.1-1.5-0.2-2.2c-1.7,0.2-3.3,0.3-5,0.5c-0.7,1.1-1.8,1.8-3.4,1.6c-1.1-0.1-1.9-0.7-2.1-1.6
			c-0.4-1.5,0.7-2.4,2.1-3.2c-0.2-0.4-0.3-0.7-0.4-1.1c-0.3-1.5,0.3-2.9,0.7-4.4c-0.3-0.3-0.5-0.5-0.8-0.8s-0.4-0.7-0.5-1.1
			c-0.1-0.6,0.1-1.3,0.4-1.9c0.3-0.4,0.6-0.9,1.1-1.2c0.3-0.2,0.5-0.2,0.8-0.3c0.7-0.3,1.5-0.4,2.2-0.2c0.8,0.1,1.5,0.5,2,1
			c0.1,0.2,0.2,0.4,0.4,0.5c1,1.1,2.1,1.3,3.8,0.7c0.1,0,0.2,0,0.4,0c0.3,0.3,0.6,0.7,1,1.1c0.5-1.5,1.7-2.3,3-2.8
			c0-0.9-0.1-1.6-0.1-2.4c0-0.5-0.4-0.7-0.9-0.6c-0.1,0.4-0.1,0.7-0.3,1.1c-0.5,1.4-1.9,2.3-3.5,2.2s-2.8-1-2.9-2.2
			c0-0.3,0-0.6,0.1-0.9c0.3-1,1.2-1.9,2.4-2.2c0.2,0,0.4-0.1,0.5-0.1c0.3-0.1,0.6-0.1,0.9-0.2c-0.1-0.1-0.1-0.3-0.1-0.4
			c-0.2-0.5-0.2-1-0.1-1.4c0.1-1.2,0.9-2.3,1.5-3.4c-0.8-0.1-1.3-0.3-1.8-0.7c-0.3-0.2-0.6-0.6-0.7-1c0-0.1-0.1-0.2-0.1-0.3
			c-0.1-0.2-0.5-0.4-0.8-0.5c-1.9-0.4-3.4,0.5-4,2.5c0.2,0,0.4,0,0.5,0c0.6,0,1.1,0.1,1.5,0.3s0.7,0.5,0.9,0.8
			c0.1,0.2,0.2,0.3,0.2,0.5c0.3,0.9-0.1,1.9-1.1,2.5c-1.1,0.7-2.3,0.8-3.4,0.2c0,0,0,0-0.1,0c-0.3-0.1-0.6-0.2-0.9-0.4
			c-0.3,0.3-0.4,0.5-0.6,0.7c-0.3,0.2-0.8,0.2-1.1,0.1c-0.2-0.1-0.3-0.2-0.3-0.3c0.2-1.4-1.1-2.4-1.1-3.7c0-0.2,0.1-0.3,0.2-0.5
			c1.2,0.4,1.1,1.5,1.6,2.1c0.2-0.7,0.4-1.3,0.7-1.9c0.3-0.6,0.6-1.3,0.8-1.9c0.2-0.5,0.4-1,0.5-1.5c0-0.1,0-0.1,0.1-0.2
			c0.2-0.5-0.2-0.7-0.7-0.8c0,0.1,0,0.1-0.1,0.2v0.1c0.1,1.1-0.5,1.9-1.7,2.4c-0.9,0.4-2.1,0.1-2.7-0.5c-0.7-0.8-0.8-1.6-0.1-2.6
			c0.1-0.1,0.1-0.1,0.1-0.2c0.2-0.3,0.2-0.5,0-0.8c-0.2-0.2-0.2-0.4-0.1-0.5c0.1-0.2,0.3-0.3,0.6-0.5c0.1,0,0.2-0.1,0.2-0.1
			c0.4-0.1,0.7-0.3,1.2-0.4c0-0.1-0.1-0.2-0.2-0.3c-0.3-0.5-0.7-0.9-1.2-1.2c-0.4-0.2-0.8-0.4-1.2-0.5c-0.1,0-0.3-0.1-0.4-0.2
			c0,0.4,0,0.6-0.1,0.8c0.5,0.1,0.5,0.3,0.3,0.5c-0.1,0.1-0.2,0.1-0.3,0.1c-0.7,0.2-1.4,0.5-2.1,0.5s-1.3-0.3-2.2-0.5
			c0.1,0.5,0,1,0.2,1.5c0,0.1,0,0.1,0.1,0.2c0.1,0.2,0.3,0.3,0.5,0.5s0.5,0.3,0.8,0.5c-0.2,0.2-0.5,0.4-0.7,0.6l0,0
			c-0.4,0.3-0.8,0.6-1.1,0.9l-0.1,0.1c0.2,0.5,0.5,0.8,0.9,1c0.2,0.1,0.4,0.2,0.6,0.3s0.4,0.2,0.6,0.2c0.1,0,0.2,0.1,0.3,0.1
			c0.4,0.2,0.7,0.3,1,0.6c-0.5,0.8-0.2,1.4,0.6,2.1c0.3-0.1,0.7-0.2,1.3-0.3c-0.6,0.9-1.9,1.1-2.1,2.2c0,0.1,0,0.1,0,0.2h0.1
			c0.2,0,0.5,0.1,0.7,0.1c0.5,0.1,1,0.2,1.3,0.5c0.2,0.2,0.3,0.3,0.4,0.6c0.1,0.2,0.7,0.1,1,0.2c0.6,0.1,1.1,0.3,1.5,0.6
			c0.3,0.2,0.6,0.5,0.7,0.9c0,0,0,0,0,0.1c0.4,1,0.1,2.2-0.9,3c-1.1,0.9-2.3,1.1-3.6,0.7c-0.1,0-0.2-0.1-0.3-0.1
			c-0.1,0-0.2-0.1-0.3-0.1c-1-0.3-1.2-0.1-2.1,0.8c-0.1,0.1-0.3,0.2-0.4,0.3l0,0c-0.2,0-0.4,0-0.6,0c-0.4,0-0.8,0-1.2,0
			c0.1,0.3,0.1,0.5,0.1,0.8c0.1,0.8,0,0.9-0.6,1.7c0.1,0,0.1,0.1,0.1,0.1c1.2,0.8,1.4,1.2,0.8,1.9c-0.6,0.6-1.2,0.5-2.6-0.5
			c-0.4,0.3-0.8,0.6-1.2,0.9v0.2c0.4,0,0.8,0,1.3,0.1c-1.1,0.5-2.2,0.8-3.3,1.1l0,0c-2.1,0.5-2.8,0.6-2.9,2v0.1c0,0.4,0,0.8,0.1,1.4
			c0.1,1.1,0.5,2.2,0.9,3.2v0.1c0.2,0.5,0.2,0.9,0.2,1.3c-0.1,0.5-0.4,0.9-0.9,1.4c0-0.2,0-0.4-0.1-0.7c0-0.5-0.1-1-0.1-1.5
			c-0.1-1-0.2-1.9-0.6-2.7c-0.2-0.1-0.4-0.1-0.5-0.2c-0.2-0.1-0.4-0.1-0.6-0.2c0.4-0.6,0.5-1.1,0.4-1.5s-0.3-0.7-0.7-1
			c-0.2-0.1-0.3-0.3-0.5-0.4c-1.8,1.1-3.2,3.1-5.7,1.8c-0.7,0.7-1.5,1.2-2.6,0.8c-0.9-0.4-1-1-0.8-1.8c0-0.2,0-0.5-0.1-0.5
			c-1.4-0.5-0.5-1.5-0.5-2.3c-1.2,0.1-2.3-0.4-3.5,0h-0.1c-0.4,0-0.9-0.3-1.2-0.6l0,0c-0.4-0.4-0.3-1,0.2-1.4
			c0.2-0.2,0.5-0.5,0.8-0.6c0.5-0.2,0.7-0.6,0.3-0.9c-0.4-0.3-0.9-0.2-1.3,0.2s-0.8,0.8-1.2,1.2c-0.1,0.1-0.1,0.2-0.1,0.2
			c0.1,0.3,0.3,0.5,0.5,0.9c-0.8-0.1-1.4-0.2-2-0.2c-0.1,0.4-0.1,0.6-0.2,1c-0.1,0-0.2-0.1-0.3-0.1c-0.2-0.1-0.5-0.2-0.7-0.3
			s-0.3-0.1-0.5-0.2c-0.3,0.2-0.5,0.4-0.9,0.6c-0.3-0.1-0.6-0.5-0.8-0.4c-1,0.3-1.7,0.1-2.3-0.3c0,0-0.1,0-0.1-0.1
			c-0.3-0.2-0.6-0.5-1-0.8c-0.2-1.2,1-1.7,1.7-2.4c-0.5-0.5-1-1-1.4-1.5c-1,0.4-1.9,0.8-2.5,1.6s-2,0.7-2.7-0.1
			c-0.2-0.3-0.4-0.6-0.6-1c-0.9,0.5-0.6,1.2-1,1.7c0.3,0.1,0.6,0.2,1.1,0.3c-0.5,0.3-0.7,0.4-0.9,0.5l0,0c0,0-0.1,0.1-0.2,0.1
			c-0.2,0.1-0.4,0.3-0.7,0.5c0.9,0,1.2,0,1.7,0c-0.6,0.7-1.2,1.4,0.1,1.9c0.4-0.2,0.8-0.4,1.3-0.6c0.1-0.1,0.3-0.1,0.4-0.2
			c0.4-0.2,0.9-0.4,1.3-0.6c0.2,0,0.4,0.2,0.6,0.3c-0.2,0.1-0.3,0.3-0.5,0.4c-0.2,0.1-0.4,0-0.7,0c0,0.2,0,0.4,0,0.6
			c0,0.4,0.1,0.9,0.1,1.2c0.1,0,0.3,0,0.5,0c1.2,0,2.5,0.7,3.2-0.7c0.4,0.4,0.6,1.2,1.1,1.3c0.6,0.2,1,0.4,1.2,0.7
			c0.3,0.4,0.3,0.9,0.2,1.4c0,0.1,0,0.2,0,0.3l0,0c0,0.1,0.1,0.3,0.2,0.6c0.4-0.2,0.8-0.3,1.2-0.4c0.6-0.2,1.1-0.4,1.6-0.7
			c0.2-0.1,0.3-0.5,0.5-0.8c0-0.1,0-0.1,0.1-0.2c0,0,0.1,0,0.1,0.1c0.2,0.2,0.5,0.3,0.7,0.4c-0.8,0.7-1.1,1.4-0.2,2.2
			c0.4,0.4,0.8,1.2-0.1,1.9c2.1-0.2,2.3-0.2,3,1.3c0.1,0.3,0.2,0.7,0.3,0.9c1.3-0.6,1.7-2.3,3.7-1.9c-0.2,0.3-0.3,0.6-0.4,0.9
			c-0.1,0.4,0,0.9,0.6,0.9c0.2,0,0.4,0.1,0.6,0.2c0.5,0.2,0.6,0.6,0.7,1c0,0.2,0,0.3,0,0.5c-1.4,0.6-1.4,0.6-1.8,1.8
			c0.3,0.2,0.6,0.5,0.9,0.7c0.2,0.1,0.4,0.2,0.6,0.3c-0.3,0.4-0.6,0.7-0.9,1.1c2.6,0,2.6,0,3.6-0.8c-0.1,0.2-0.1,0.3-0.1,0.4
			c0,0.5,0.7,0.2,1.1,0.2c0,0.2,0,0.4,0,0.6c0.2-0.1,0.4-0.1,0.5-0.1c0.3-0.1,0.6-0.1,0.8-0.2c0.5,0.4,0.9,0.7,1.4,1
			c0.1,0,0.1,0.1,0.2,0.1c0.1-0.1,0.2-0.2,0.3-0.2c0.6-0.5,1.2-0.8,2.1-0.6c0.9,0.1,1.5-0.3,1.6-1.2c0.5,0.2,0.8,0.3,1.1,0.4
			c-0.1,0.2-0.1,0.4-0.2,0.6c0,0.1-0.1,0.2-0.1,0.4c0.3,0.2,0.7,0.4,0.9,0.7c0.1,0.1,0.2,0.4,0.1,0.5c-0.1,0.2-0.4,0.3-0.6,0.3
			c-0.3,0-0.7-0.2-1-0.3c-0.2-0.1-0.5,0-0.9-0.1c0.3,0.5,0.5,1,0.9,1.3s0.9,0.4,1.4,0.6c-0.7,0.3-1.4,0.6-2.2,0.9
			c0.3,0.5,0.5,0.9,0.8,1.2c0,0,0,0,0.1,0c0,0,0,0.1,0.1,0.1c0.4,0.1,0.9,0,0.6,0.8c-0.3-0.3-0.4-0.6-0.6-0.8h-0.1l0,0
			c-0.7,0.1-1.4,0.1-2.2,0.2c0.1,0.3,0.2,0.6,0.3,1c-1-0.3-2,0-2.8-0.6c-0.2-0.2-0.9-0.3-1.2-0.1c-1,0.5-2.2-0.1-3.2,1
			c-0.4-0.8-0.7-1.3-0.9-1.9c-1.4,0.2-1.5,0.1-2.1-1c0-0.1-0.1-0.1-0.1-0.2c-0.1-0.1-0.2-0.2-0.4-0.3c-0.4,0.3-0.8,0.6-1.1,0.8
			c-0.3,0-0.5,0-0.8-0.1c-0.2,0-0.4,0-0.6,0c-0.1,0-0.1,0-0.2,0c-0.2,0.3-0.3,0.6-0.4,0.8l-0.1,0.1c-0.1,0-0.1-0.1-0.2-0.1
			c-0.2-0.1-0.2-0.1-0.2-0.2c-0.1-0.1-0.1-0.2-0.2-0.3c-0.3-1-0.3-1-1.6-0.7c-0.3,0-0.6,0-0.8-0.1c-0.2-0.1-0.3-0.3-0.5-0.5
			c-0.1-0.1-0.3-0.3-0.4-0.4c0.1-0.4,0.2-0.8,0.2-1.1c0,0,0,0,0-0.1c0,0,0,0-0.1,0c-0.9-0.2-1.1,0.7-1.7,0.7c-0.3,0-0.7,0-1-0.1
			s-0.7-0.1-1.2-0.2c0.3,0.2,0.4,0.3,0.6,0.5c0.2,0.1,0.3,0.2,0.4,0.3c0.4,0.3,0.6,0.6,0.7,1s0.1,0.8,0,1.2
			c-0.2,0.6-0.9,1.2-1.3,1.8l0,0l0,0c0.4,0.1,0.8,0.2,1.3,0.4c0.3-0.5,0.6-1,1-1.6c0.4-0.1,0.8-0.3,1.3-0.4c1.1-0.3,2.1-0.1,2.9,0.4
			c0,0,0.1,0,0.1,0.1c0.1,0.1,0.2,0.2,0.4,0.3c0.2,0.2,0.2,0.3,0.3,0.5c0.4,0.7,0.3,1.6-0.2,2.4c-0.1,0.2-0.3,0.3-0.4,0.4
			c-0.7,0.7-1.7,1.1-2.9,1c-0.4,0-0.7-0.1-1.1-0.1h-0.1c-0.1-0.1-0.2-0.1-0.4-0.2c-0.2-0.2-0.4-0.4-0.6-0.7
			c-0.2-0.2-0.3-0.4-0.5-0.6c-0.2,0.5-0.4,0.8-0.6,1.2c0.1,0,0.2,0,0.3,0c0.4,0.1,0.8,0.1,1.2,0.2c0.1,0.1,0.2,0.1,0.3,0.2
			c0,0,0.1,0,0.1,0.1c0.8,0.8,1.4,1.6,1.2,2.7c0,0.2-0.1,0.3-0.1,0.5c0.2-0.1,0.5-0.2,0.7-0.2c0.4-0.1,0.8-0.2,1.1-0.3
			c0.1,0,0.1,0,0.2-0.1c2.1-0.4,3.9,0.6,4.2,2.4c0,0.1,0,0.2,0,0.4c0.2,0.1,0.4,0.1,0.5,0.1c0.6-0.3,1.2-0.6,1.8-0.9
			c0.5,0.3,0.8,0.6,1.2,0.9c0.2,0.1,2.2-0.5,2.3-0.6c0.4-0.6,0.1-1.3-0.8-1.9c-0.3,0.4-0.5,0.8-0.8,1.3c-0.3-0.1-0.5-0.1-0.7-0.2
			c0.3-0.9,0.6-1.7,0.9-2.6c1-0.3,2-0.6,2.4-1.7c1,0.1,2,0.1,3,0.6s2,0.1,2.5-0.9c0.2-0.4,0.3-0.9,0.5-1.3c0.3-0.5,0.7-0.9,1.1-1.6
			c0.4,1.6,0.4,1.8-1.2,5.8c0.4-0.3,0.8-0.4,0.9-0.6c0.2-0.5,0.2-1,0.4-1.5c0.2-0.5,0.6-1,1-1.6c0.3,0.5,0.5,0.8,0.8,1.2
			c0.6-1.4,0.8-2.7,0-3.9c0.2-0.2,0.4-0.4,0.7-0.6c1.5-1,2.2-0.9,2.9,0.4c0.3,0.6,0.6,1.1,1,1.8c0,0-0.2,0.1-0.4,0.3
			c-0.4,0.4-0.5,0.7,0,1s1,0,1.3-0.5c0.7-1.2,1.7-1.5,3.4-1.1c-0.5,0.3-1.4,0-1.5,0.6c0,0.6,0.1,1.2,0.3,1.7
			c0.2,0.4,0.8,0.4,1.2,0.1c0.3-0.3,0.6-0.6,0.9-0.9c0.2,0.2,0.6,0.4,1.1,0.8c0.3-0.8,0.5-1.4,0.2-1.9c-0.4-0.7-0.7-1.4,0.6-1.9
			c0.1-1.5,2.1-1.9,3-3c0.2,0.1,0.5,0.2,0.8,0.3c-0.3,0.3-0.5,0.5-0.8,0.8c0.2,0.1,0.4,0.1,0.6,0.2c-0.1,0.8-0.2,1.5-0.3,2.3
			c0.5,0,0.9,0,1.2,0c-0.1,0.2-0.1,0.4-0.2,0.5c-0.3,0.2-0.7,0.3-1,0.5c0.4,0.2,0.7,0.4,1.2,0.6c0.3-1.3,1.4-1.5,3-1.8
			c-0.5,0.4-0.8,0.7-1,0.9c0.3,0.1,0.6,0.1,1.2,0.3c-0.7,0.2-1,0.3-1.3,0.4c-0.9,0.3-1.6,0.7-1.9,1.6c-0.1,0.4-0.5,0.7-0.9,1.3
			c1.1-0.4,1.9-0.8,2.7-1.1c0.8-0.3,1.6-0.4,2.6-0.7c0.3,0.1,0.7,0.2,0.4,0.8c-0.3,0.7,0,1.6-0.9,2.2c0.2,1.1-1.1,2.2,0,3.2
			c0.1,0,0.2,0,0.4,0c0.1,0.1,0.1,0.2,0.2,0.5c0.9-0.6,2-1,1.9-2.2c0.2,0,0.4,0.1,0.6,0.1c-0.3-0.2-0.6-0.4-0.7-0.6
			c-0.1-0.2,0.3-0.6,0.6-0.8c0.4-0.2,1.1,0.1,1,0.5c0,0.3-0.3,0.6-0.6,1c0.4,0.2,0.8,0.4,1.4,0.3c0.3-0.1,1,0.4,1,0.7
			c0.1,0.8,0.9,0.9,1.5,1.4c-0.2,0.3-0.4,0.7-0.7,1.1c0.6-0.1,1-0.1,1.6-0.2c-0.6,0.4-1,0.7-1.5,1.1c0.1,0.1,0.3,0.1,0.4,0.1
			c0.1-0.4,0.5-0.8,1-0.9c0.6-0.1,1.4,0.2,1.5,0.8c0.1,0.4-0.3,1-0.8,1.2c0.4,0.3,1,0.3,1.5,0.5c0.6-0.4,1.1-1.3,2-1l-0.1-0.1
			c0.1-0.1,0.1-0.1,0.2-0.2c0.1,0.1,0.2,0.2,0.3,0.2c-0.1,0-0.1,0.1-0.2,0.1c0.1,0.1,0.2,0.1,0.4,0.2c-0.5,0.6-1,1.2-1.6,1.9
			c0.1,0.2,0.2,0.5,0.3,0.9c0.1,0.7,0.3,1.2,1.4,1c0.4-0.1,0.9,0.3,1.4,0.5c-0.2,0.6-0.4,1-0.6,1.5c0.7,0.5,1-0.3,1.5-0.4l0,0
			c0-0.1,0-0.3,0-0.4c0.1,0.1,0.2,0.2,0.3,0.3l0,0c0.5,0.3,0.9,0.5,1.4,0.8c0.7-0.2,1.3-0.4,2-0.6c0,0.8,0,1.5,0.1,2.1
			c0.2,0.8,1.1,0.8,2,0.9c-0.6,0.8-0.7,1.6-0.5,2.3c0.7,0.5,1.3,0,2-0.1c0.2,0.2,0.4,0.4,0.6,0.7c1.5-0.3,2.4,0,3.2,1.1
			c0.5,0.7,1.5,1,2.4,1.5c0.1-0.5,0.2-0.9,0.3-1.4C486.1,256.8,486.8,257.1,487.7,257.5z M447.7,195.9c0,0-0.1,0-0.1-0.1l0.1-0.1
			c0,0,0.1,0,0.1,0.1C447.8,195.8,447.8,195.9,447.7,195.9z M415.2,210.2c-0.1-0.1-0.2-0.1-0.3-0.2c0.1-0.1,0.2-0.2,0.2-0.2
			c0.1,0,0.2,0.1,0.3,0.1C415.3,210,415.2,210.1,415.2,210.2z M425.4,217.1c-0.1-0.1-0.1-0.1-0.2-0.2l-0.1-0.1c0,0,0-0.1,0.1-0.1
			c0,0,0.1,0,0.2,0.1c0.1,0,0.2,0.1,0.3,0.1C425.5,217,425.4,217,425.4,217.1z M420.9,230.3l0.1,0.1l-0.1,0.1c0,0-0.1,0-0.1-0.1
			C420.8,230.4,420.9,230.4,420.9,230.3z M420.7,229.5c0,0,0.1,0,0.1,0.1c-0.1,0.1-0.2,0.1-0.3,0.2c0,0-0.1,0-0.2-0.1
			C420.5,229.6,420.6,229.5,420.7,229.5z M420.8,235.5c-0.3,0-0.7-0.2-0.8-0.4c-0.1-0.2,0.3-0.5,0.5-0.9c0.3,0.3,0.7,0.4,0.7,0.7
			C421.2,235.1,420.9,235.5,420.8,235.5z M428.2,230.8c-0.1-0.1-0.1-0.2-0.2-0.2l0.1-0.1c0.1,0.1,0.1,0.1,0.2,0.2
			C428.3,230.6,428.2,230.7,428.2,230.8z M444.5,217.6c-0.7-0.5-0.7-0.5-0.8-1.3c0.8-0.4,1.4-0.3,1.7,0.2
			C445.7,217,445.1,217.3,444.5,217.6z M445.9,211.7c-0.7,0.2-1.4,0-1.9-0.4c-0.2-0.2-0.4-0.4-0.4-0.7c0-0.1,0-0.2,0-0.3
			s0-0.1,0-0.2c0.1-0.7,0.7-1.3,1.6-1.4c0.2,0,0.3,0,0.5,0s0.4,0,0.6,0c0.6,0.1,1,0.5,1.1,1.1c0,0.1,0,0.2,0,0.3
			C447.4,210.8,446.8,211.5,445.9,211.7z M450.5,225.4l-0.1-0.1c0.1,0,0.2-0.1,0.3-0.1c0,0,0.1,0,0.1,0.1
			C450.7,225.3,450.6,225.4,450.5,225.4z M456.6,239.7c-0.1,0.1-0.2,0.1-0.3,0.1c0-0.1-0.1-0.2-0.1-0.2c0.1-0.1,0.2-0.2,0.3-0.3
			l0.3,0.1C456.8,239.4,456.7,239.6,456.6,239.7z M468.3,242.9c-0.1,0-0.2,0-0.2-0.1s0-0.2,0-0.3c0.1,0,0.1,0.1,0.2,0.1
			C468.3,242.7,468.3,242.8,468.3,242.9z M472,240L472,240c-1.1,0.3-2.3-0.2-2.5-1.1c-0.3-1,0.5-2.1,1.6-2.4
			c1.1-0.3,2.3,0.3,2.6,1.2c0,0.1,0,0.1,0,0.2C473.8,238.7,473.1,239.7,472,240z M474.6,233.2c-0.1,0-0.1-0.1-0.2-0.1
			c0.1-0.1,0.1-0.1,0.2-0.2C474.6,233,474.6,233.1,474.6,233.2z"
        />
        <path
          class="st0"
          d="M389.6,115.7C389.6,115.7,389.6,115.8,389.6,115.7C389.6,115.8,389.6,115.8,389.6,115.7
			C389.6,115.8,389.7,115.8,389.6,115.7C389.7,115.7,389.7,115.7,389.6,115.7L389.6,115.7z"
        />
        <path
          class="st0"
          d="M572.5,57.7C572.6,57.7,572.6,57.7,572.5,57.7c0.2,0.1,0.3,0.2,0.4,0.3c0.1-0.1,0.2-0.2,0.4-0.4
			c-0.1,0-0.2-0.1-0.2-0.1c-0.1,0-0.2-0.1-0.3-0.1C572.7,57.5,572.6,57.6,572.5,57.7z"
        />
        <path
          class="st0"
          d="M334.4,116.4c0.1,0,0.2,0,0.2-0.1c2.6-1.3,3.7-0.9,4.5,1.2c0.2,0.6,0.7,1.1,1,1.7c0.8-0.2,0.9-0.6,0.9-0.9
			c0,0,0,0,0-0.1c-0.4-0.7-1-1.2-0.9-2c-0.3-0.3-0.6-0.6-1-0.7c-0.8-0.3-1.1-0.8-1.3-1.3c-1.7-0.4-3.2,0.3-3.7,1.6
			C334.2,116.1,334.3,116.3,334.4,116.4z"
        />
        <path
          class="st0"
          d="M323.7,125.1c0.1,0.1,0.1,0.2,0.2,0.3c0.1,0.1,0.2,0.3,0.4,0.4c0.1-0.2,0.1-0.3,0.2-0.5s0.1-0.3,0.2-0.5
			c-0.5-0.2-1-0.4-1.3-0.7c-0.3,0.8-0.3,1.5,0.1,2.1c-0.1-0.2-0.1-0.5,0-0.8C323.5,125.3,323.6,125.2,323.7,125.1z"
        />
        <path
          class="st0"
          d="M320,115c0,0.1-0.1,0.3-0.2,0.4c-0.1,0-0.2,0-0.3,0c0-0.1,0-0.3,0-0.4c-0.4,0.3-0.7,0.7-1,1.1
			c-0.3,0.5-0.7,0.9-0.9,1.2c0.1,0.3,0.3,0.4,0.3,0.7c0.1,1.2,1,2.9,1.8,3.5c0.7,0.1,1.5,0.2,2.2,0.3c-0.1-0.4-0.3-0.7-0.2-1
			c0-0.3,0.1-0.6,0.1-0.9s0.1-0.5,0.2-0.8c0.1-0.2,0.1-0.5,0.3-0.7c0.4-0.7,1.2-1.4,2-1.9s1.3-1,1.7-1.8c0.5,0.1,1,0.2,1.3,0.2
			c0.1,0.4,0.2,0.6,0.3,0.9c0.2-0.1,0.4-0.2,0.6-0.3c-0.4-0.8-1.2-1.4-2.2-1.8c-2-0.8-4.4-0.4-6.1,0.9C320,114.7,320,114.8,320,115z
			"
        />
        <path
          class="st0"
          d="M541.7,44.1c0.8,0.6,1.2,1.5,1.3,2.5c0.5,0,1.1,0,1.7,0c0.2,0.3,0.4,0.7,0.7,0.9c0.5,0.5,1.4,0.5,2,0.2
			c0.7-0.4,1-0.8,1.2-1.2c0.2-0.6-0.1-1.2-1-1.7c-0.1,0-0.1-0.1-0.1-0.2c1-0.9,1.2-1.1,0.9-1.8c-0.1-0.2-0.2-0.4-0.3-0.6
			c0,0,0-0.1-0.1-0.1c0,0.2,0,0.4-0.1,0.6c-0.3,0.8-1,1.5-2,1.6c-0.4,0.1-0.9,0-1.2-0.1c-0.7-0.2-1.3-0.7-1.5-1.4
			c-0.1-0.4,0-0.7,0.1-1.1c-0.6,0-1.2-0.1-1.9-0.1c0,0.3,0,0.6-0.1,0.8c0,0.2,0.1,0.6,0,0.6c-0.3,0.2-0.4,0.3-0.5,0.5
			C541,43.6,541.4,43.9,541.7,44.1L541.7,44.1z M541.2,42.6c0.2-0.1,0.4-0.2,0.7-0.2c0,0.1,0.1,0.1,0.1,0.2
			c-0.2,0.1-0.4,0.2-0.6,0.2C541.3,42.7,541.2,42.7,541.2,42.6z"
        />
        <path
          class="st0"
          d="M566,18.7c1.7,0,2.7-0.7,3.7-1.9c0.7-0.9,0.8-2,0.2-2.8c-0.6,0.1-1.2,0.1-1.8,0.2c0.3-0.4,0.7-0.7,1.1-1
			c-0.6-0.5-1.5-0.7-2.6-0.7c-0.4,0-1,0.2-1.3,0.5c-0.9,0.8-1.7,1.6-2.4,2.4c-0.3,0.3-0.3,0.7-0.4,0.9c0.1,0.3,0.2,0.5,0.2,0.6
			C563.3,18,564.4,18.7,566,18.7z M566.2,15.2c0.2,0.7-0.1,1.3-0.9,1.5c-0.7,0.3-1.3,0.1-1.7-0.4C564.2,15.5,565.1,15.3,566.2,15.2z
			"
        />
        <polygon class="st0" points="313.5,122.4 313.6,122.5 313.6,122.4 		" />
        <path
          class="st0"
          d="M311.1,122c0.3,0.1,0.7,0.1,1,0.1c0.9,0.1,1.1,0,1.4-0.9c0.1-0.2,0.1-0.4,0.2-0.7c0.9,0.6,1.1,1.3,0.8,2.2
			c0.5-0.2,0.8-0.3,1.1-0.4c1.1-0.4,1.8-0.5,2.5-0.3c0.1-0.1,0.3-0.2,0.4-0.3c0.1,0-0.1-0.3-0.1-0.6c-0.2,0.2-0.3,0.3-0.4,0.4
			c-0.2-0.3-0.3-0.6-0.5-0.9s-0.6-0.6-0.9-0.8c-0.1,0.3-0.1,0.5-0.2,0.7c-0.7-0.3-1.1-0.7-1.3-1.2c-0.6,0-1.2,0.1-1.8,0.3
			C312,120.1,311.3,121,311.1,122z M317.6,121L317.6,121c0,0.1-0.1,0.1-0.1,0.2c0,0,0-0.1-0.1-0.1C317.4,121.1,317.5,121,317.6,121z
	M314.5,119.6c0,0,0.1,0,0.1,0.1l-0.1,0.1h-0.1C314.5,119.7,314.5,119.7,314.5,119.6z"
        />
        <path
          class="st0"
          d="M480,30.6c1.8-0.3,2.9-1.5,2.6-2.9c-0.2-1.4-1.7-2.2-3.4-1.8c-1.6,0.3-2.8,1.7-2.6,3
			C476.9,30.1,478.4,30.9,480,30.6z"
        />
        <path
          class="st0"
          d="M395.3,74.1c0.4,0.4,0.9,0.6,1.7,0.7c0.6,0.1,1.1,0.1,1.5,0.6c0.1,0.1,0.3,0.3,0.5,0.4c0-0.1,0-0.1,0-0.2
			s0-0.1,0-0.2c0-0.3,0.2-0.7,0.4-0.9c0.1-0.2,0.3-0.4,0.5-0.5c0.2-0.4,0.3-0.7,0.4-1c0.2-0.9-0.2-1.7-1-2.1
			c-0.4,0.8-1.3,1.5-2.3,1.7c-0.7,0.2-1.5,0.1-2.1-0.2C394.7,73,394.8,73.7,395.3,74.1z"
        />
        <path
          class="st0"
          d="M308.3,117.2c0.2,0.1,0.4,0.2,0.6,0.2c0-0.1,0-0.1,0.1-0.2c0.2,0.1,0.4,0.2,0.5,0.3c0.3,0,0.5,0,0.8-0.1
			c1.1-0.2,1.9-1,2.2-1.9c-0.1-0.1-0.1-0.1-0.2-0.2c-0.5-0.8-1-1.6-1.7-2.3l0,0c-0.5-0.1-1-0.1-1.5,0c-0.3,0.1-0.6,0.2-0.9,0.4
			c-1,0.6-1.5,1.6-1.3,2.5C307.2,116.5,307.7,116.9,308.3,117.2z"
        />
        <path
          class="st0"
          d="M402.6,72.7c0.5,0.1,1,0.2,1.5,0.2c-0.1,0.4-0.2,0.7-0.2,1.1c0.3,0.3,0.5,0.7,0.5,1.2
			c0.2,0.2,0.4,0.4,0.7,0.5c1.3-1.2,0.4-2-0.3-2.9c0.4-0.4,0.8-0.7,1.1-1c-0.2-0.6-0.6-1.1-1.1-1.6c-0.1-0.1-0.3-0.2-0.4-0.4
			c-0.1,0-0.1-0.1-0.2-0.1c-0.5-0.4-1-0.7-1.5-1.1c-0.7-0.1-1.1,0.2-1.5,0.7h0.1c-0.2,0.2-0.3,0.5-0.5,0.7c-0.2,0.5-0.2,0.9,0,1.3
			C401.2,72,401.8,72.5,402.6,72.7z"
        />
        <path
          class="st0"
          d="M319.7,112.1c0,0.2,0,0.5,0.1,0.7c1.2-0.4,1.9-1.4,1.7-2.5c-0.2-1.2-1.7-2-3.2-1.7c-0.4,0.1-0.7,0.2-1,0.4
			c0.1,0,0.1,0,0.2,0.1C318.8,109.8,319.6,110.8,319.7,112.1z M320.3,110.4c0.1,0,0.1-0.1,0.2-0.1
			C320.4,110.4,320.4,110.4,320.3,110.4c0,0.1,0,0.2-0.1,0.3C320.2,110.6,320.3,110.5,320.3,110.4z"
        />
        <path
          class="st0"
          d="M532.6,61.7c0.4,0.1,0.8,0.1,1.3,0c0.7-0.1,1.3-0.4,1.7-0.9c-1.8-0.1-2.8-1.1-3.4-2.5
			c-0.4,0.3-0.8,0.5-1.2,0.8c-0.1,0.1-0.1,0.3-0.1,0.4C531.8,60.3,532.4,61,532.6,61.7z M534.4,61.2c0.1,0,0.2,0,0.3,0.1
			c-0.1,0.1-0.1,0.2-0.2,0.2c-0.1,0-0.2,0-0.3-0.1C534.3,61.4,534.4,61.3,534.4,61.2z"
        />
        <path
          class="st0"
          d="M536.5,65.5L536.5,65.5c0.4,0.3,0.8,0.6,1.2,0.9C537.5,66,537.1,65.7,536.5,65.5z"
        />
        <path
          class="st0"
          d="M538,67.6c0-0.3,0-0.6-0.1-0.9c0,0.3,0,0.6-0.1,0.9c-0.1,0.4-0.2,0.9-0.4,1.3c0,0,0.1,0,0.1-0.1
			c0.1-0.4,0.3-0.7,0.4-1.1C538,67.7,538,67.7,538,67.6z"
        />
        <path
          class="st0"
          d="M537.7,52.7c0.6,0,1.2-0.2,1.9-0.3c0.6,1.4,1.3,1.8,2.8,1.5c-0.4-0.2-0.6-0.6-0.7-1c-0.2-0.9,0.5-1.7,1.5-1.9
			c0.3,0,0.5,0,0.8,0c-0.3-0.3-0.6-0.5-0.8-0.6c-0.9-0.5-1.7-0.2-3.1,0.7l0,0c-0.2-0.2-0.4-0.3-0.6-0.4l0,0
			c-0.5,0.1-1.1,0.2-1.5,0.3c-0.2,0.4-0.4,0.8-0.5,1.2c0,0.1-0.1,0.1-0.1,0.2C537.4,52.6,537.5,52.7,537.7,52.7L537.7,52.7z"
        />
        <path
          class="st0"
          d="M543.5,70C543.5,69.9,543.5,69.9,543.5,70c-0.3-0.8-0.9-1.2-1.8-1.3c-0.5,0-1,0.1-1.4-0.1
			c-0.4-0.1-0.7-0.2-1.1-0.2c-0.6,0-1.1,0.2-1.6,0.5c-0.1,0.2-0.2,0.4-0.3,0.7l0,0c0.6,0.2,1.1,0.3,1.6,0.4c0.1,0.4,0.1,0.9,0.3,1.3
			c0.1,0.2,0.2,0.3,0.3,0.4c0.1,0,0.2,0,0.3,0c0-0.5,0-0.9,0.1-1.2c0.9-0.3,0.9-0.3,1.9-0.2c0.2,0,0.5-0.1,0.7-0.1l0,0
			c0.2-0.1,0.5-0.3,0.6-0.3C543.2,69.9,543.4,69.9,543.5,70z"
        />
        <path
          class="st0"
          d="M542.6,70.7c0.5-0.3,0.3-0.5-0.1-0.5C542.5,70.4,542.6,70.5,542.6,70.7z"
        />
        <path
          class="st0"
          d="M379.5,100.3c-0.2,0-0.4,0.1-0.5,0.1c0.1,0,0.2,0.1,0.2,0.1c0.8,0.3,1.2,0.8,1.6,1.7c0.7,0.1,1.3,0.3,2,0.4
			c0.4-0.2,0.6-0.4,0.6-0.8c0.1-0.3,0-0.7,0-1.2c0-0.1,0-0.2,0-0.3c-0.2,0-0.4,0-0.6,0s-0.4,0-0.5,0c0,0.1-0.1,0.2-0.1,0.3
			c0,0.1-0.1,0.2-0.1,0.3c-0.1-0.1-0.2-0.3-0.2-0.4s0-0.2,0-0.2c0-0.2-0.1-0.3-0.1-0.6c-0.3,0.1-0.6,0.2-0.9,0.3
			c-0.4,0.1-0.7,0.2-1.1,0.3C379.6,100.3,379.5,100.3,379.5,100.3z"
        />
        <path
          class="st0"
          d="M611.7,11.3c-0.3,0.1-0.6,0.2-0.9,0.3c-0.7,0.4-1.1,1.2-1,1.9c0.1,0.3,0.2,0.6,0.4,0.8
			c0.4,0.4,1.1,0.7,1.9,0.6v-3.8C612,11.3,611.8,11.3,611.7,11.3z"
        />
        <path
          class="st0"
          d="M375.6,85.8c-0.3,0.7,0,1.6,0.9,1.8h0.1c0.3,0.1,0.7,0.1,1,0c0.1,0,0.1,0,0.2,0c1.2-0.3,2.3-1.2,2.2-2.3
			c0-0.5-0.2-1,0.2-1.7c-0.9,0.2-1.6,0.3-2.2,0.5s-1.3,0.5-1.8,0.8C375.9,85.3,375.7,85.5,375.6,85.8z"
        />
        <path
          class="st0"
          d="M605.6,20.3c0.3,0.4,0.7,0.2,1,0c-0.1-0.1-0.1-0.2-0.2-0.4c-0.2-0.8,0.6-1.7,1.6-1.9c0.6-0.1,1.1,0.1,1.5,0.4
			c-0.3-1-1.6-1.6-2.9-1.2c-1,0.3-1.7,1.1-1.6,1.9C605.1,19.6,605.4,19.9,605.6,20.3z"
        />
        <path
          class="st0"
          d="M332.1,111.6c-1.3,0.2-2.1,1.2-1.9,2.1c0,0.1,0,0.1,0.1,0.2c0.3,0.2,0.8,0.4,1.3,0.4c0.8,0,1.1-0.4,1.3-0.9
			c0.2-0.5,0.6-0.9,0.9-1.4C333.2,111.6,332.7,111.5,332.1,111.6z"
        />
        <path
          class="st0"
          d="M333.7,113.5c-0.3,0.4-0.3,0.8-0.3,1.1c0.6-0.4,1-1,0.9-1.7c0-0.2-0.1-0.5-0.3-0.7
			C334,112.7,333.9,113.2,333.7,113.5z"
        />
        <path
          class="st0"
          d="M373,113.8c0.5,0.3,0.8,0.7,1.1,1.1c0.2-0.6,0-1.3-0.6-1.6c-0.8-0.5-1.9-0.4-2.7,0.2
			C371.6,113.8,372.3,114,373,113.8z"
        />
        <path
          class="st0"
          d="M368.7,109c-0.4-0.2-1-0.3-1.5-0.2c-0.1,0-0.2,0.1-0.3,0.1c0,0.1,0,0.1,0,0.2c0.5,0,0.9,0,1.3,0.2
			c0.7,0.3,1.2,0.8,1.4,1.7c0.1-0.3,0.2-0.6,0.1-0.9C369.5,109.6,369.2,109.3,368.7,109z"
        />
        <path
          class="st0"
          d="M381.9,110.4c-0.1-0.1-0.2-0.1-0.3-0.2c-0.2-0.1-0.4-0.2-0.6-0.1c-1.1,0.3-2.3,0.4-3.4,1.2
			c0.7-0.1,1.1-0.1,1.4-0.2c0.3,0.6,0.5,0.9,0.8,1c0.2,0.1,0.6,0.2,1.2,0.3c0.3,0,0.5,0.2,0.7,0.3c0.2,0.2,0.4,0.3,0.6,0.3
			c0.1-0.2,0.4-0.2,0.6-0.2l0,0c0,0,0,0,0.1,0c0-0.1,0-0.1,0-0.2c0.1,0,0.1,0.1,0.2,0.1c-0.1,0-0.1,0.1-0.2,0.1c0,0,0,0,0,0.1
			c0,0,0,0-0.1,0v0.1c0.2-0.1,0.5-0.2,0.7-0.4C383.6,111.6,382.8,110.9,381.9,110.4z"
        />
        <path
          class="st0"
          d="M585.9,31.6c-0.3,0.1-0.6,0.2-0.9,0.4c-0.6,0.4-0.9,1-0.8,1.6c0.2,0.8,1.2,1.3,2.3,1s1.8-1.1,1.5-2
			c-0.1-0.5-0.5-0.8-1.1-1C586.7,31.5,586.3,31.5,585.9,31.6z"
        />
        <path
          class="st0"
          d="M585,17.4c1-0.3,1.9-1.2,1.7-2c-0.2-0.7-1.3-1.1-2.4-0.8c-1,0.2-1.9,1.2-1.8,1.8
			C582.7,17.1,583.9,17.6,585,17.4z"
        />
        <path
          class="st0"
          d="M589.1,27.6c0.1,0.8,1.1,1.3,2.1,1.1c1.1-0.2,1.8-1,1.7-1.8s-1.2-1.4-2.2-1.2C589.7,26,588.9,26.8,589.1,27.6
			z"
        />
        <path
          class="st0"
          d="M607,60.2c-0.2,0-0.4,0-0.6,0c0,0.1,0,0.2,0,0.3c0.2,0.8,1.2,1.3,2.2,1.1c0.8-0.2,1.4-0.7,1.5-1.4
			c-0.3,0.1-0.6,0.1-0.9,0C608.4,60.1,607.7,60.1,607,60.2z"
        />
        <path
          class="st0"
          d="M596.1,22.9c0.4-0.1,0.7-0.2,0.9-0.4c0.2-0.2,0.4-0.4,0.5-0.6c0.1-0.3,0.1-0.5,0-0.8c-0.2-0.7-1.1-1.2-2-1
			s-1.7,1.1-1.6,1.9C594.1,22.6,595.1,23.1,596.1,22.9z"
        />
        <path
          class="st0"
          d="M600.7,17.1c0.6-0.1,1-0.4,1.3-0.7c0.2-0.3,0.4-0.7,0.3-1c-0.1-0.8-1.1-1.3-2.1-1.1l0,0
			c-0.9,0.2-1.7,1.1-1.5,1.9C598.9,16.8,599.8,17.2,600.7,17.1z"
        />
        <path
          class="st0"
          d="M406,89c-0.8-1.3-0.8-1.3-2.3-1.4c-0.8-0.1-1.3,0.3-1.1,1c0.1,0.4,0.5,0.8,0.4,1c-0.3,0.6,0,1,0.4,1.3
			c0-0.1,0.1-0.1,0.1-0.2c0.1-0.2,0.3-0.2,0.4-0.3c0.1-0.1,0.2-0.2,0.3-0.2c0-0.1-0.1-0.3-0.1-0.4c0.2,0.1,0.4,0.2,0.6,0.2
			c0.3-0.1,0.6-0.1,0.9,0C405.7,89.7,405.8,89.3,406,89z"
        />
        <path
          class="st0"
          d="M407.2,66.1c0.5-0.2,1.1-0.4,1.6-0.7c0.1-0.1,0.2-0.1,0.4-0.2c0.1-0.4,0-0.7-0.1-1c-0.2-0.4-0.5-0.7-0.9-1
			c-0.6,0.3-1.1,0.5-1.5,0.7c0.1,0.2,0.1,0.3,0.2,0.5c0.1,0.6,0,1.2-0.4,1.7C406.7,66.1,407,66.2,407.2,66.1z"
        />
        <path
          class="st0"
          d="M343.3,80c0.1,0,0.3-0.1,0.4-0.1c0.1-0.3,0.3-0.5,0.6-0.8c0.1,0.1,0.1,0.2,0.2,0.3c0.2-0.3,0.3-0.6,0.3-0.9
			c-0.1-0.7-0.9-1.2-1.7-1.1c-0.9,0.1-1.7,0.9-1.6,1.7C341.6,79.7,342.4,80.2,343.3,80z"
        />
        <path
          class="st0"
          d="M414.9,52.3c1.4,0.1,2.8,0.1,4.3,0c0.7-0.1,1.4-0.1,2.2-0.2c-0.5-0.5-1.1-0.8-1.7-1c-0.3-0.1-0.5-0.2-0.8-0.2
			c-1.1-0.1-2.1,0.1-3.2,0.9C415.4,51.9,415.2,52.1,414.9,52.3z"
        />
        <path
          class="st0"
          d="M349.5,77.8c1-0.2,1.6-1,1.4-1.7c-0.2-0.6-1.2-1.1-2-0.9c-0.9,0.2-1.4,0.9-1.3,1.7
			C347.8,77.6,348.6,78,349.5,77.8z"
        />
        <path
          class="st0"
          d="M514.3,51.6c0.1-0.1,0.2-0.2,0.3-0.3c0.3,0.1,0.5,0.1,0.8,0.2c0-0.5,0.1-1,0.1-1.4c0.2-0.2,0.4-0.3,0.6-0.5
			c-0.2,0-0.4,0-0.6,0c-0.9,0.2-1.5,1-1.3,1.6C514.2,51.4,514.2,51.5,514.3,51.6z"
        />
        <path
          class="st0"
          d="M414.4,49.8C414.4,49.9,414.4,49.9,414.4,49.8c0.2,0.2,0.4,0.4,0.5,0.6c0.4,0.2,0.9,0.3,1.4,0.2
			c0.8-0.2,1.3-0.9,1.2-1.5c-0.1-0.7-1-1.1-1.9-1c-0.2,0-0.4,0.1-0.6,0.2c-0.5,0.3-0.8,0.9-0.7,1.4
			C414.3,49.8,414.4,49.8,414.4,49.8z"
        />
        <path
          class="st0"
          d="M331.1,109.2c0.3-0.3,0.5-0.5,0.7-0.7c0.2,0.1,0.3,0.2,0.4,0.3c0.1,0.1,0.1,0.2,0.1,0.3
			c0.5-0.1,0.9-0.4,1.2-1.1c-0.3-0.3-0.5-0.7-0.8-0.9c-0.3-0.2-0.6-0.3-0.9-0.2c-0.3,0-0.6,0.1-0.9,0.3c-0.5,0.3-0.8,0.6-0.7,1.1
			C330.3,108.8,330.6,109.1,331.1,109.2z M332.4,107.3l0.1,0.1c0,0,0,0,0,0.1c0,0-0.1,0-0.1,0.1c0,0-0.1,0-0.1,0.1
			C332.4,107.5,332.4,107.5,332.4,107.3L332.4,107.3z"
        />
        <path
          class="st0"
          d="M389.2,111.8c0.1,0,0.1,0,0.2,0c0.6-0.4,0.6-0.8,0.1-1.4c-0.1-0.2-0.3-0.3-0.4-0.4c-0.4-0.4-0.8-0.5-1.4-0.2
			c-0.7,0.3-0.8,0.7-0.7,1.4c0.1,0.2,0.3,0.4,0.5,0.6s0.5,0.3,0.8,0.4c0.2-0.1,0.4-0.1,0.6-0.2C388.9,111.9,389,111.8,389.2,111.8z"
        />
        <path
          class="st0"
          d="M368.9,107.8c0.2-0.3,0.4-0.6,0.3-0.9c0-0.3-0.2-0.5-0.4-0.6c-0.3,0.1-0.5,0.2-0.8,0.3
			c-0.1,0-0.1,0.1-0.2,0.1s-0.2,0.1-0.2,0.1c-0.2,0.1-0.3,0.3-0.4,0.4s-0.1,0.3-0.1,0.4c-0.1,0.2-0.1,0.4-0.2,0.6
			c0.3,0.1,0.6,0.2,0.9,0.1C368.3,108.3,368.6,108.1,368.9,107.8z"
        />
        <path
          class="st0"
          d="M589.3,19.3c0.7-0.2,1.3-0.8,1.2-1.4s-1-1-1.7-0.9c-0.7,0.2-1.2,0.8-1.1,1.4
			C587.7,19.1,588.5,19.5,589.3,19.3z"
        />
        <path
          class="st0"
          d="M585.6,24.3c0.4-0.7,0-1.2-1.4-1.6c-0.4,0.7-0.7,1.4-1.1,2.1c0,0,0,0,0,0.1c0.2,0.1,0.4,0.1,0.5,0.1
			C584.6,25.2,585.2,25,585.6,24.3z"
        />
        <path
          class="st0"
          d="M349.4,81.3c1.4-0.1,2.6-0.3,4-0.4c-0.7-1.2-1.1-1.4-2.2-1.2C350.2,79.9,349.6,80.4,349.4,81.3z"
        />
        <path
          class="st0"
          d="M415.5,61.9c0.7-0.1,1.2-0.7,1.2-1.2c0-0.6-0.8-1-1.5-0.8c-0.7,0.1-1.2,0.7-1.1,1.3
			C414.2,61.7,414.8,62,415.5,61.9z"
        />
        <path
          class="st0"
          d="M600.8,23.7c-0.6,0.6-0.8,1.3-0.2,2.1l0.1-0.1c0,0,0.1,0,0.1-0.1c0.4-0.4,0.9-0.8,1.3-1.2
			c0.5-0.4,0.9-0.9,1.4-1.3c-0.7-0.1-1.2-0.2-1.6-0.1C601.4,23.2,601.1,23.4,600.8,23.7z"
        />
        <path
          class="st0"
          d="M611.2,54.8c-0.2,0.5,0,0.9,0.5,1.1c0.1,0.1,0.3,0.1,0.4,0.1v-2C611.7,54.2,611.4,54.5,611.2,54.8z"
        />
        <path
          class="st0"
          d="M411.6,55.3c0.7-0.3,0.8-0.6,0.8-1.3c0-0.1,0-0.2,0-0.3l0,0c-1.2-0.1-2.2,0.2-3.1,1.2
			C409.9,55.5,410.7,55.6,411.6,55.3z"
        />
        <path
          class="st0"
          d="M365.6,97.6c0.4,0.1,0.7,0,1-0.1c0.5-0.3,0.5-0.9,0.1-1.5c-0.1-0.2-0.3-0.3-0.5-0.3c-0.2-0.1-0.4-0.1-0.6,0
			c-0.1,0-0.2,0.1-0.4,0.1c-0.2,0.1-0.3,0.2-0.5,0.3c-0.2,0.1-0.4,0.3-0.7,0.4c0.2,0.3,0.3,0.4,0.4,0.6
			C364.8,97.3,365.2,97.5,365.6,97.6z"
        />
        <path
          class="st0"
          d="M344.3,100.4c0.1,0.3,0.3,0.5,0.6,0.6c0.1-0.2,0.2-0.3,0.3-0.5c0.2-0.3,0.4-0.6,0.7-0.9
			c0.1-0.1,0.2-0.2,0.3-0.3c-0.3-0.2-0.6-0.2-0.9-0.1C344.7,99.3,344.2,99.9,344.3,100.4z"
        />
        <path
          class="st0"
          d="M542.9,47.5L542.9,47.5c-0.1,0.6-0.4,1.2-0.8,1.7l0,0c0.6-0.1,1.1-0.7,1.1-1.1
			C543.2,47.8,543.1,47.6,542.9,47.5L542.9,47.5z"
        />
        <path
          class="st0"
          d="M322.5,81.5c0.7-0.1,1.2-0.7,1.1-1.2c-0.1-0.4-0.8-0.8-1.4-0.7c-0.7,0.1-1.2,0.7-1.1,1.3
			C321.3,81.4,321.8,81.6,322.5,81.5z"
        />
        <path
          class="st0"
          d="M393.4,81.4c-0.2-0.2-0.3-0.4-0.4-0.6c-0.1-0.3,0.1-0.7,0.3-1.1c-0.6,0-1.1,0.1-1.3,0.8
			c0.3,0.3,0.6,0.6,1.1,0.8C393.1,81.4,393.3,81.4,393.4,81.4z"
        />
        <path
          class="st0"
          d="M603.1,26.4c1.6-0.7,1.8-0.9,1.4-2.4l0,0c-0.7,0.3-1.2,0.6-1.5,0.9C602.7,25.3,602.7,25.7,603.1,26.4z"
        />
        <path
          class="st0"
          d="M394.8,94.1c0.7-0.2,1.5-0.2,1.8-1c-0.2-0.3-0.4-0.6-0.6-0.8c-0.5,0-0.9,0-1.2,0
			C393.7,93.1,394.3,93.6,394.8,94.1z"
        />
        <path
          class="st0"
          d="M548.4,17.6c0.5-0.1,1.1-0.8,0.9-1.1c-0.2-0.3-0.7-0.5-0.9-0.6c-0.9,0.1-1.2,0.6-1.2,1
			C547.3,17.4,547.8,17.7,548.4,17.6z"
        />
        <path
          class="st0"
          d="M461.3,64.4c-0.1-0.1-0.1-0.2-0.2-0.3l0,0c-0.1,0.1-0.2,0.2-0.2,0.3C461.1,64.5,461.2,64.5,461.3,64.4z"
        />
        <path
          class="st0"
          d="M379.3,47c-0.2-0.7-0.5-1.4-0.8-2.2c-0.1,1.3-0.2,2.5-0.4,3.8C379.3,47.9,379.5,47.7,379.3,47z"
        />
        <path
          class="st0"
          d="M398.4,92.4c-0.1,0.3,0,0.6,0,0.9s-0.1,0.7-0.2,1.1c0.5,0,0.9,0,1.3,0c-0.1,0.2-0.3,0.4-0.5,0.8
			c0.5-0.2,0.8-0.3,1.1-0.4C399.8,93.8,399.2,93.1,398.4,92.4z"
        />
        <path
          class="st0"
          d="M573.2,19c0.5-0.2,0.8-0.5,0.7-0.9c-0.1-0.5-0.6-0.8-1.1-0.6c-0.5,0.1-0.9,0.6-0.8,1.1
			C572.2,18.9,572.7,19.2,573.2,19z"
        />
        <path
          class="st0"
          d="M567.2,6.2c0.6-0.1,0.8-0.5,0.8-0.9s-0.6-0.7-1.2-0.6c-0.5,0.1-0.9,0.7-0.8,1C566.2,6.2,566.6,6.3,567.2,6.2z
			"
        />
        <path
          class="st0"
          d="M551.4,41c-0.3,0.2-0.7,0.4-1,0.6c0.4,0.2,0.8,0.2,1.1,0.3C551.2,41.6,551.2,41.4,551.4,41z"
        />
        <path
          class="st0"
          d="M551.7,40.8c0.4,0.2,0.6,0.4,0.6,0.8c0.4-0.3,0.6-0.8,0.8-1.6C552.6,40.3,552.1,40.6,551.7,40.8z"
        />
        <path
          class="st0"
          d="M599.9,30.2c-1.5,0.4-1.7,0.8-1.2,1.9C599.8,31.4,599.8,31.4,599.9,30.2z"
        />
        <path
          class="st0"
          d="M412,72c0-0.4-0.2-0.6-0.6-0.7c-0.2,0.5-0.6,0.9-1.1,1.2c0.2,0.2,0.5,0.4,0.9,0.3C411.7,72.7,412,72.5,412,72
			z"
        />
        <path
          class="st0"
          d="M410.1,88.2c0.2-0.5,0.2-0.9,0.2-1.4c-0.2-0.1-0.5-0.2-0.9-0.3C409.4,87.1,409.5,87.7,410.1,88.2z"
        />
        <path
          class="st0"
          d="M375.9,83.7c0.1,0,0.1-0.1,0.2-0.1c-0.1-0.1-0.2-0.2-0.2-0.3c-0.1-0.3,0-0.7,0.2-1c-0.2,0-0.4,0-0.6,0.1
			c-0.3,0.2-0.5,0.5-0.9,0.9C375.2,83.4,375.6,83.8,375.9,83.7z"
        />
        <path
          class="st0"
          d="M395.9,67.4c0.1,0,0.2,0,0.3,0c-0.2-0.2-0.6-0.3-1-0.2c-0.5,0.1-0.9,0.5-0.7,0.8
			C394.9,67.7,395.4,67.5,395.9,67.4z"
        />
        <path
          class="st0"
          d="M400.3,93.1c0.6,0.3,1.3,0.5,2,0.7c0.1,0,0.5-0.3,0.5-0.4c-0.1-0.2-0.3-0.4-0.5-0.5c-0.5-0.2-1.1-0.4-1.8-0.6
			C400,92.6,399.8,92.9,400.3,93.1z"
        />
        <path
          class="st0"
          d="M394.2,86.7c-1-0.3-1.1-1.6-2.7-1.1c0.3,0.5,0.6,1,0.9,1.4C393,86.9,393.5,86.8,394.2,86.7z"
        />
        <path
          class="st0"
          d="M598.8,62c-0.2-0.2-0.5-0.3-0.7-0.5c-0.7,0.3-1,0.6-0.8,0.9C597.7,62.2,598.3,62.1,598.8,62z"
        />
        <path
          class="st0"
          d="M340.5,91c-0.6-0.6-0.6-1.4-2-1.2C339.1,91.1,339.1,91.1,340.5,91z"
        />
        <path
          class="st0"
          d="M556.7,15.8c0-0.4-0.3-0.7-0.8-0.5c-0.3,0.1-0.6,0.4-1.1,0.8c0.5,0.2,0.8,0.5,1.2,0.5
			C556.5,16.6,556.7,16.2,556.7,15.8z"
        />
        <path
          class="st0"
          d="M553,49.9c0.5,0.1,0.9,0.2,1.2,0.3c0-0.1,0.1-0.1,0.2-0.2c0-0.1,0-0.3,0-0.4c-0.4-0.2-0.7-0.3-0.9-0.2
			C553.3,49.4,553.1,49.6,553,49.9z"
        />
        <path
          class="st0"
          d="M553,49.9c-0.1,0.1-0.1,0.2-0.2,0.3c0.1,0.1,0.2,0.1,0.4,0.2C553.1,50.2,553,50.1,553,49.9z"
        />
        <path
          class="st0"
          d="M552.5,20.3c0.3-0.5,0.5-0.8,0.6-1.1c0-0.4-0.7-0.6-1.1-0.4c-0.3,0.2-0.6,0.6-0.5,0.8
			C551.5,19.9,552,20,552.5,20.3z"
        />
        <path
          class="st0"
          d="M395.5,88.7c0.5-0.9,0-1.3-0.3-1.6c-0.1-0.1-0.5-0.1-0.8,0c-0.1,0-0.2,0.4-0.2,0.5
			C394.5,87.9,394.9,88.2,395.5,88.7z"
        />
        <path
          class="st0"
          d="M387.1,102.6c0.1,0.1,0.3,0.2,0.4,0.2c0.2,0,0.3,0,0.6-0.1l-0.1-0.1c0.1-0.1,0.1-0.1,0.2-0.2
			c0.1,0,0.1,0.1,0.2,0.1c-0.5-0.5-0.4-1.2-1.4-1.2l0,0c0,0,0,0-0.1,0l0,0C386.5,101.8,387.6,102.1,387.1,102.6z"
        />
        <path
          class="st0"
          d="M376.8,91.7c0-0.1-0.6-0.4-0.7-0.4c-0.3,0.2-0.6,0.5-0.7,0.8c0,0.1,0.4,0.3,0.8,0.5
			C376.5,92.3,376.8,92,376.8,91.7z"
        />
        <path
          class="st0"
          d="M548.4,35.3c0.1,0.2,0.5,0.3,0.8,0.4c0.2-0.2,0.5-0.5,0.4-0.7c0-0.2-0.4-0.3-0.8-0.5
			C548.6,34.8,548.3,35.1,548.4,35.3z"
        />
        <path
          class="st0"
          d="M571.2,8.6c0.2-0.1,0.5-0.5,0.5-0.6c-0.1-0.2-0.5-0.4-1-0.7c-0.2,0.5-0.4,0.9-0.3,1.1
			C570.4,8.6,570.9,8.7,571.2,8.6z"
        />
        <path
          class="st0"
          d="M548.6,41.2C548.6,41.2,548.6,41.3,548.6,41.2C548.6,41.3,548.6,41.3,548.6,41.2c0.2,0.3,0.5,0.5,0.8,0.8
			c0.3-0.4,0.8-0.7,0.7-0.8c-0.1-0.3-0.5-0.4-0.8-0.6C549.1,40.8,548.6,41.1,548.6,41.2z"
        />
        <path
          class="st0"
          d="M386.2,107.3c-1.1-0.1-1.6,0.2-1.9,0.9C385.2,108.4,385.6,107.9,386.2,107.3z"
        />
        <path
          class="st0"
          d="M581.6,39.3L581.6,39.3c0.2,0,0.3-0.4,0.5-0.6c-0.1,0-0.1-0.1-0.2-0.1c-0.2-0.1-0.4-0.2-0.6-0.2
			c-0.1,0-0.3,0.3-0.6,0.6C581,39.2,581.3,39.3,581.6,39.3z"
        />
        <path
          class="st0"
          d="M560.5,18.5c-0.2-0.1-0.5-0.4-0.8-0.4c-0.1,0-0.4,0.3-0.6,0.6c0.3,0.1,0.6,0.3,0.8,0.3
			C560.1,19,560.3,18.7,560.5,18.5z"
        />
        <path
          class="st0"
          d="M349.4,93.7L349.4,93.7c0.2,0.1,0.5,0.1,0.9,0.1c-0.5-0.4-0.4-1-1.2-1.2c0.1,0.1,0.2,0.3,0.2,0.5
			C349.4,93.2,349.4,93.4,349.4,93.7C349.4,93.6,349.4,93.6,349.4,93.7z"
        />
        <path
          class="st0"
          d="M368.6,89.4c0.3-0.2,0.5-0.4,0.9-0.7c-0.7,0-1.3,0-1.8,0c-0.1,0-0.3,0-0.4,0c0.2,0.1,0.3,0.2,0.5,0.3
			C368,89.1,368.3,89.3,368.6,89.4z"
        />
        <path
          class="st0"
          d="M421.4,45.6l-0.1,0.1l0,0c0.1,0.4,0.4,0.7,1,0.9c0.1-0.7-0.2-1.1-1-1.6c0,0.2,0,0.3,0,0.5
			C421.3,45.6,421.3,45.6,421.4,45.6z"
        />
        <path
          class="st0"
          d="M415.8,78.5c-0.1-0.1-0.3-0.1-0.4-0.2c-0.2,0.2-0.5,0.5-0.6,0.7c0,0.1,0.3,0.3,0.6,0.5
			c0.2-0.3,0.5-0.6,0.5-0.8c0,0,0,0,0-0.1c0,0,0,0,0-0.1C415.9,78.5,415.9,78.5,415.8,78.5c0,0,0,0-0.1,0
			C415.9,78.7,415.8,78.6,415.8,78.5C415.8,78.6,415.8,78.5,415.8,78.5z"
        />
        <path
          class="st0"
          d="M545.9,38.4c-0.2-0.1-0.5-0.3-0.7-0.3s-0.4,0.3-0.7,0.6c0.3,0.2,0.7,0.4,0.8,0.4
			C545.6,38.9,545.8,38.6,545.9,38.4z"
        />
        <path
          class="st0"
          d="M338.7,95.9c0.2,0.2,0.5,0.3,0.7,0.5c0.2-0.2,0.5-0.4,0.4-0.4c-0.2-0.2-0.4-0.4-0.8-0.6
			C338.8,95.6,338.6,95.9,338.7,95.9z"
        />
        <path
          class="st0"
          d="M376.5,105.9c0.1-0.7-0.3-1-1.2-1.2C375.5,105.4,375.6,105.9,376.5,105.9z"
        />
        <path
          class="st0"
          d="M321.6,125.3c0.1-0.4,0.1-0.7,0.2-1c-0.3,0.1-0.7,0-0.9,0.2C320.4,125,321,125.1,321.6,125.3z"
        />
        <path
          class="st0"
          d="M393,91.4c-0.1,0.1-0.2,0.2-0.3,0.3c0,0.1,0.1,0.1,0.2,0.2c0.3,0.3,0.7,0.5,1.4,0.2c-0.2-0.1-0.3-0.2-0.5-0.3
			C393.5,91.7,393.2,91.6,393,91.4z M394,92.1L394,92.1L394,92.1L394,92.1z"
        />
        <path
          class="st0"
          d="M580.7,29.3c-0.2,0.5-0.4,0.9-0.7,1.6C581.1,30.1,581.1,30.1,580.7,29.3z"
        />
        <path
          class="st0"
          d="M596.3,62.6C596.2,62.6,596.2,62.6,596.3,62.6c-0.1,0.2,0,0.4,0,0.6c0.2-0.1,0.4-0.3,0.5-0.4
			C596.7,62.6,596.4,62.6,596.3,62.6z"
        />
        <path
          class="st0"
          d="M552.5,37.9c0.1,0.2,0.5,0.3,0.7,0.3s0.4-0.4,0.4-0.5c0-0.2-0.4-0.3-0.7-0.4
			C552.7,37.5,552.4,37.7,552.5,37.9z"
        />
        <path
          class="st0"
          d="M598.4,44c-0.8,0.2-0.9,0.5-0.6,1.2C598.3,44.8,598.6,44.5,598.4,44z"
        />
        <path
          class="st0"
          d="M444.7,86.1c0.3-0.5,0.5-0.8,0.7-1.2C444.8,85.1,444.4,85.3,444.7,86.1C444.6,86.1,444.6,86.1,444.7,86.1z"
        />
        <path
          class="st0"
          d="M310.3,118.8c0,0.1,0,0.3,0,0.5c0.1,0,0.1,0.1,0.3,0.1C310.6,119,310.6,118.9,310.3,118.8z"
        />
        <path
          class="st0"
          d="M316.1,83.7c0-0.3,0-0.6,0.1-0.9c-0.1,0-0.2,0-0.4,0c0,0.4-0.1,0.9-0.1,1.3l0,0c0.1,0,0.3,0,0.4,0
			C316.1,84,316.1,83.8,316.1,83.7z"
        />
        <path
          class="st0"
          d="M582.8,46.1c0.2-0.1,0.3-0.2,0.5-0.3c-0.1-0.1-0.3-0.2-0.5-0.4c-0.1,0.3-0.3,0.4-0.3,0.6
			C582.4,46,582.7,46.2,582.8,46.1z"
        />
        <path
          class="st0"
          d="M596.6,29c-0.3,0.3-0.7,0.6-1,0.9c0.1,0.1,0.1,0.1,0.2,0.2c0.3-0.3,0.7-0.6,1-0.9
			C596.8,29.1,596.7,29.1,596.6,29z"
        />
        <path
          class="st0"
          d="M373.1,109.7l0.1-0.1c-0.2-0.1-0.3-0.1-0.5-0.2C372.8,109.5,372.9,109.7,373.1,109.7z"
        />
        <path
          class="st0"
          d="M338.3,110.6c-0.2-0.3-0.3-0.5-0.5-0.7c0.1,0.4,0.3,0.7-0.4,0.9c0.2,0,0.4,0,0.6,0
			C338.1,110.8,338.2,110.7,338.3,110.6z"
        />
        <path
          class="st0"
          d="M549.1,46.9c-0.2,0.1-0.4,0.3-0.4,0.5c0,0.1,0.4,0.3,0.5,0.2c0.2-0.1,0.3-0.3,0.5-0.5
			C549.5,47,549.2,46.8,549.1,46.9z"
        />
        <path
          class="st0"
          d="M560.9,43.9c0.3-0.7,0.3-0.7-0.7-0.7C560.5,43.5,560.7,43.7,560.9,43.9z"
        />
        <path
          class="st0"
          d="M319.6,121.6C319.7,121.6,319.7,121.6,319.6,121.6C319.7,121.5,319.7,121.5,319.6,121.6
			C319.7,121.5,319.7,121.5,319.6,121.6C319.7,121.5,319.6,121.6,319.6,121.6z"
        />
        <path
          class="st0"
          d="M318.7,122.3c0.1,0.1,0.2,0.2,0.4,0.3c0.2-0.4,0.4-0.7,0.6-1C319,121.7,318.7,121.9,318.7,122.3z"
        />
        <path
          class="st0"
          d="M535,73.5c0,0.1,0.2,0.2,0.4,0.2c0.1-0.1,0.3-0.3,0.3-0.4c0,0-0.3-0.1-0.4-0.2C535.2,73.3,535,73.4,535,73.5z
			"
        />
        <path
          class="st0"
          d="M320.1,101.5c0.1-0.1,0.2-0.3,0.2-0.4c-0.2,0-0.3,0-0.5,0c-0.1,0.1-0.2,0.2-0.3,0.4
			C319.8,101.5,320,101.5,320.1,101.5z"
        />
        <path
          class="st0"
          d="M545.2,32.8c0,0,0.3-0.2,0.3-0.3s-0.2-0.3-0.4-0.5c-0.2,0.3-0.4,0.5-0.4,0.6C544.8,32.6,545,32.7,545.2,32.8z
			"
        />
        <path
          class="st0"
          d="M556.6,21.7c-0.3,0-0.5,0-0.8,0c0.2,0.1,0.5,0.2,0.8,0.4C556.7,21.8,556.7,21.7,556.6,21.7z"
        />
        <path
          class="st0"
          d="M375,108.8c-0.1-0.1-0.1-0.1-0.2-0.2c-0.2,0.1-0.4,0.3-0.6,0.4l-0.1,0.1c0.1,0.1,0.1,0.1,0.2,0.2
			C374.5,109.2,374.8,109,375,108.8z"
        />
        <path
          class="st0"
          d="M324.8,85.2c-0.2-0.1-0.3-0.3-0.5-0.2c-0.2,0-0.3,0.2-0.5,0.5c0.3,0.1,0.4,0.2,0.5,0.1
			C324.5,85.5,324.6,85.4,324.8,85.2z"
        />
        <path
          class="st0"
          d="M328.3,94.3c0.1-0.2,0.2-0.3,0.3-0.5c0-0.1-0.2-0.1-0.4-0.3c-0.1,0.2-0.2,0.4-0.2,0.6
			C327.9,94.2,328.1,94.2,328.3,94.3z"
        />
        <path
          class="st0"
          d="M322.5,127.6L322.5,127.6c0.1-0.1,0.1-0.1,0.1-0.1C322.5,127.5,322.5,127.5,322.5,127.6L322.5,127.6z"
        />
        <path
          class="st0"
          d="M602,36c-0.1,0-0.2,0.1-0.4,0.1c0.2,0.3,0.3,0.5,0.5,0.8c0.1,0,0.1-0.1,0.2-0.1C602.2,36.6,602.1,36.3,602,36
			z"
        />
        <path
          class="st0"
          d="M544.1,49.6c0.1,0,0.2,0,0.3-0.1c-0.1-0.2-0.1-0.4-0.2-0.6c-0.1,0-0.2,0-0.3,0.1
			C544,49.2,544.1,49.4,544.1,49.6z"
        />
        <path
          class="st0"
          d="M397.3,95.4c0,0.1,0.2,0.1,0.2,0.1c0.1-0.1,0.3-0.2,0.3-0.3c0-0.1-0.2-0.1-0.4-0.3
			C397.4,95.2,397.3,95.3,397.3,95.4z"
        />
        <path
          class="st0"
          d="M427,37.3c-0.2-0.2-0.4-0.4-0.5-0.6C426.4,37,426.1,37.4,427,37.3z"
        />
        <path
          class="st0"
          d="M426.5,36.7L426.5,36.7c0-0.1-0.1-0.1-0.1-0.1C426.4,36.6,426.4,36.7,426.5,36.7
			C426.4,36.7,426.4,36.7,426.5,36.7z"
        />
        <path
          class="st0"
          d="M535,64.6c0-0.1-0.2-0.1-0.4-0.1c-0.1,0-0.2,0.2-0.2,0.2c0.1,0.1,0.2,0.2,0.3,0.3
			C534.9,64.8,535.1,64.7,535,64.6z"
        />
        <path
          class="st0"
          d="M398.9,53.3c-0.2-0.1-0.4-0.1-0.6-0.2c0,0.1-0.1,0.2-0.1,0.2c0.2,0,0.4,0.1,0.6,0.1
			C398.8,53.5,398.8,53.4,398.9,53.3z"
        />
        <path class="st0" d="M306.2,118.3c0-0.1,0.1-0.1,0.1-0.2h-0.1V118.3z" />
        <path
          class="st0"
          d="M444.2,82.5c-0.1-0.1-0.2-0.2-0.3-0.2c-0.1,0.1-0.2,0.2-0.3,0.3C443.8,82.5,443.9,82.5,444.2,82.5
			C444.1,82.5,444.2,82.5,444.2,82.5z"
        />
        <path
          class="st0"
          d="M597,55.2c0,0.1,0,0.2-0.1,0.2c0.1,0,0.2,0,0.3,0c0-0.1,0.1-0.2,0.1-0.3C597.2,55.2,597.1,55.2,597,55.2z"
        />
        <path
          class="st0"
          d="M383,105.1c-0.1,0.1-0.3,0.2-0.4,0.3c0.2,0,0.4,0,0.7,0C383.2,105.2,383.1,105.1,383,105.1z"
        />
        <path
          class="st0"
          d="M389.1,76.3l-0.1-0.1c-0.1,0-0.2,0.1-0.3,0.1c0.1,0.1,0.1,0.1,0.2,0.2C389,76.4,389.1,76.4,389.1,76.3z"
        />
        <path
          class="st0"
          d="M336.5,110c-0.1,0-0.1,0.1-0.2,0.1c0.1,0.1,0.2,0.2,0.3,0.4C336.6,110.3,336.6,110.2,336.5,110z"
        />
        <path
          class="st0"
          d="M569,53.8C569,53.7,569,53.7,569,53.8C569.1,53.7,569.1,53.7,569,53.8L569,53.8C569,53.7,569,53.7,569,53.8z"
        />
        <path
          class="st0"
          d="M568.9,54.2c0-0.1,0-0.3,0.1-0.4c-0.1,0.1-0.2,0.2-0.3,0.3C568.8,54.1,568.8,54.1,568.9,54.2z"
        />
        <path
          class="st0"
          d="M498.1,32.7c0.1,0,0.2-0.1,0.2-0.1c-0.1-0.1-0.1-0.2-0.2-0.2s-0.2,0.1-0.3,0.1
			C497.9,32.6,498,32.7,498.1,32.7z"
        />
        <path
          class="st0"
          d="M396.9,94.7c0.1,0,0.2,0.1,0.3,0.1c0.1,0,0.2-0.1,0.2-0.2c-0.1,0-0.2-0.1-0.4-0.1
			C397.1,94.5,397,94.6,396.9,94.7z"
        />
        <path
          class="st0"
          d="M335.1,109.9c0.1-0.1,0.2-0.1,0.2-0.2s-0.1-0.2-0.1-0.2c-0.1,0.1-0.1,0.1-0.2,0.2
			C335,109.8,335.1,109.9,335.1,109.9z"
        />
        <path
          class="st0"
          d="M323,127c-0.1,0-0.2-0.1-0.3-0.1c0,0.2-0.1,0.3-0.1,0.5C322.7,127.3,322.8,127.2,323,127z"
        />
        <path
          class="st0"
          d="M376,111.5c0-0.1-0.1-0.2-0.2-0.3c-0.1,0.1-0.2,0.1-0.2,0.2c0.1,0.1,0.1,0.2,0.2,0.2
			C375.8,111.6,376,111.5,376,111.5z"
        />
        <path
          class="st0"
          d="M564.9,46c0.1-0.1,0.2-0.2,0.3-0.3c-0.1,0-0.2-0.1-0.3-0.1s-0.2,0.2-0.3,0.2C564.7,45.9,564.8,45.9,564.9,46z
			"
        />
        <path
          class="st0"
          d="M329.7,110.5c0.1,0,0.1-0.2,0.1-0.2c-0.1,0-0.2,0-0.2,0c-0.1,0.1-0.1,0.2-0.1,0.2S329.6,110.6,329.7,110.5z"
        />
        <path
          class="st0"
          d="M335.9,109c-0.1-0.1-0.2-0.2-0.2-0.2c-0.1,0.1-0.2,0.1-0.2,0.2c0.1,0.1,0.1,0.2,0.2,0.2
			C335.8,109.1,335.9,109,335.9,109z"
        />
        <path
          class="st0"
          d="M334.1,84.4c-0.1,0-0.2,0-0.3,0c-0.1,0.1-0.1,0.2-0.2,0.3c0.1,0,0.2,0.1,0.3,0.1
			C334,84.6,334,84.5,334.1,84.4z"
        />
        <path
          class="st0"
          d="M571,1.9c-0.1,0-0.2-0.1-0.4-0.1c0,0.1-0.1,0.2-0.1,0.3l0.2,0.1C570.8,2.2,570.9,2,571,1.9z"
        />
        <path
          class="st0"
          d="M378.4,100C378.4,100,378.4,100.1,378.4,100C378.3,100.1,378.3,100.1,378.4,100
			C378.4,100.1,378.4,100.1,378.4,100C378.4,100.1,378.4,100.1,378.4,100z"
        />
        <path
          class="st0"
          d="M378.6,99.8c-0.1,0.1-0.1,0.2-0.2,0.2c0.1,0,0.2-0.1,0.4-0.1C378.7,99.9,378.7,99.8,378.6,99.8z"
        />
        <path
          class="st0"
          d="M546.5,8.5l-0.1-0.1c0,0-0.1,0-0.1,0.1v0.1C546.4,8.6,546.5,8.6,546.5,8.5z"
        />
        <path
          class="st0"
          d="M587.9,54.6c-0.1,0-0.2,0-0.2,0v0.1c0.1,0,0.1,0.1,0.2,0.1C587.9,54.8,587.9,54.7,587.9,54.6z"
        />
        <path
          class="st0"
          d="M426.2,36.2c-0.1,0.1-0.1,0.1-0.2,0.2c0.1,0.1,0.2,0.1,0.3,0.2C426.3,36.5,426.3,36.4,426.2,36.2z"
        />
        <path
          class="st0"
          d="M423.6,57.3c0-0.1-0.1-0.2-0.1-0.2c-0.1,0-0.1,0.1-0.2,0.1c0.1,0.1,0.1,0.1,0.2,0.2
			C423.5,57.3,423.6,57.3,423.6,57.3z"
        />
        <path
          class="st0"
          d="M401.9,90.3c-0.1,0-0.1,0-0.2,0c0,0,0,0,0.1,0C401.8,90.4,401.9,90.3,401.9,90.3z"
        />
        <path
          class="st0"
          d="M446.4,80.4c-0.1,0-0.2-0.1-0.2-0.1c-0.1,0-0.1,0.1-0.2,0.2c0.1,0,0.2,0,0.3,0
			C446.3,80.5,446.4,80.4,446.4,80.4z"
        />
        <path
          class="st0"
          d="M401.8,89.1c0-0.1,0-0.3,0-0.4l0,0l0,0c-0.1,0-0.1,0-0.2,0c0,0.1,0.1,0.3,0.1,0.4
			C401.7,89.2,401.7,89.2,401.8,89.1C401.8,89.2,401.8,89.2,401.8,89.1L401.8,89.1z"
        />
        <path
          class="st0"
          d="M391.6,90.6c0-0.1-0.2-0.1-0.2-0.1c0,0.1-0.1,0.2-0.1,0.3l0.2,0.1C391.5,90.8,391.6,90.7,391.6,90.6z"
        />
        <path
          class="st0"
          d="M397.6,87.5c0,0,0-0.1-0.1-0.1c0,0,0,0-0.1,0.1C397.5,87.5,397.6,87.6,397.6,87.5
			C397.6,87.6,397.6,87.6,397.6,87.5z"
        />
        <path
          class="st0"
          d="M306.6,107.1L306.6,107.1c0-0.1-0.1-0.1-0.2-0.1v0.1v0.1l0.1,0.1C306.5,107.3,306.6,107.2,306.6,107.1z"
        />
        <path
          class="st0"
          d="M387.3,103.7c-0.1,0-0.2,0-0.3,0l-0.1,0.1c0.1,0,0.2,0,0.3,0C387.3,103.8,387.3,103.8,387.3,103.7z"
        />
        <path
          class="st0"
          d="M602.4,56.9L602.4,56.9h-0.2c0,0.1,0.1,0.1,0.1,0.2C602.4,57,602.4,57,602.4,56.9z"
        />
        <path
          class="st0"
          d="M411.3,82.8c0,0,0.1,0.1,0.2,0.1c0-0.1,0-0.2,0-0.2C411.4,82.7,411.3,82.7,411.3,82.8
			C411.3,82.7,411.3,82.7,411.3,82.8z"
        />
        <path
          class="st0"
          d="M384.4,113.1l0.1-0.1c0,0,0-0.1-0.1-0.1c0,0,0,0.1-0.1,0.1C384.3,113,384.4,113,384.4,113.1z"
        />
        <path
          class="st0"
          d="M389.6,77c-0.1,0-0.2,0-0.3,0l-0.1,0.1c0.1,0,0.2,0,0.3,0L389.6,77z"
        />
        <path
          class="st0"
          d="M405.1,83.7L405.1,83.7l0.1,0.1C405.2,83.8,405.2,83.7,405.1,83.7C405.2,83.7,405.2,83.7,405.1,83.7z"
        />
        <path
          class="st0"
          d="M315.9,103C315.9,103,315.8,103,315.9,103c-0.1,0.1-0.1,0.1,0,0.2C315.9,103.1,315.9,103,315.9,103z"
        />
        <path
          class="st0"
          d="M404.6,83.1c0.1,0,0.2,0,0.3,0C404.8,83.1,404.8,83.1,404.6,83.1C404.7,83,404.7,83.1,404.6,83.1z"
        />
        <path
          class="st0"
          d="M576.8,44.6L576.8,44.6c-0.2-0.1-0.3,0-0.4,0C576.5,44.6,576.6,44.6,576.8,44.6
			C576.8,44.7,576.8,44.7,576.8,44.6z"
        />
        <path
          class="st0"
          d="M376.1,113.2c0-0.1,0-0.1,0-0.2c-0.1,0.1-0.3,0.1-0.7,0.3C375.7,113.2,375.9,113.2,376.1,113.2z"
        />
        <path
          class="st0"
          d="M307.2,122h-0.1c-0.1,0.1-0.2,0.1-0.1,0.2c0,0,0.1,0.1,0.2,0.1C307.1,122.1,307.2,122.1,307.2,122z"
        />
        <path
          class="st0"
          d="M384.3,110.4L384.3,110.4c-0.2-0.1-0.4-0.1-0.6,0c0,0.1,0,0.1,0,0.2C384,110.6,384.2,110.5,384.3,110.4z"
        />
        <path
          class="st0"
          d="M366.7,88.5L366.7,88.5c0.1,0.1,0.3,0.2,0.4,0.2h0.1c0,0-0.1,0-0.1-0.1C367,88.6,366.9,88.5,366.7,88.5
			C366.7,88.4,366.7,88.4,366.7,88.5C366.6,88.4,366.7,88.5,366.7,88.5L366.7,88.5z"
        />
        <path
          class="st0"
          d="M366.5,88.1c-0.1,0-0.1,0.1-0.2,0.1c0.1,0,0.2,0.1,0.3,0.1C366.6,88.3,366.6,88.2,366.5,88.1z"
        />
        <path
          class="st0"
          d="M582.4,69.6C582.4,69.6,582.5,69.6,582.4,69.6c0.1,0,0.2,0,0.2-0.1L582.4,69.6
			C582.5,69.5,582.4,69.5,582.4,69.6z"
        />
        <polygon class="st0" points="381.6,105.2 381.5,105.3 381.6,105.3 		" />
        <path
          class="st0"
          d="M537.7,70.9c-0.1,0-0.2,0-0.3,0C537.5,71,537.6,71,537.7,70.9C537.7,71,537.7,71,537.7,70.9z"
        />
        <polygon class="st0" points="336.7,113.2 336.8,113.2 336.7,113.1 		" />
        <path
          class="st0"
          d="M386.7,101.2c0.1,0,0.2,0,0.3,0c0-0.1-0.1-0.1-0.1-0.2C386.8,101.1,386.7,101.1,386.7,101.2z"
        />
        <path
          class="st0"
          d="M581.7,58.1C581.7,58,581.7,58,581.7,58.1L581.7,58.1C581.6,58.1,581.6,58.1,581.7,58.1z"
        />
        <path
          class="st0"
          d="M337.2,110.8c0.1,0,0.2,0,0.3,0C337.4,110.8,337.3,110.8,337.2,110.8c-0.1-0.1-0.3-0.2-0.4-0.3l-0.1-0.1
			c0,0.1,0,0.1,0.1,0.2C336.9,110.7,337,110.8,337.2,110.8z"
        />
        <polygon class="st0" points="585.3,56 585.4,56 585.3,55.9 		" />
        <path
          class="st0"
          d="M337.3,109.6h-0.1C337.3,109.6,337.3,109.6,337.3,109.6c0.1,0.1,0.2,0.2,0.4,0.3c0,0,0,0.1,0.1,0.1
			c0-0.1,0-0.1,0-0.2C337.6,109.7,337.5,109.6,337.3,109.6z"
        />
        <path
          class="st0"
          d="M387,98.6l-0.1,0.1c0.1,0,0.2-0.1,0.3-0.1C387.1,98.6,387.1,98.6,387,98.6z"
        />
        <path
          class="st0"
          d="M378.3,100.1c-0.1,0-0.1,0.1-0.2,0.1h0.1L378.3,100.1C378.3,100.2,378.3,100.2,378.3,100.1z"
        />
        <polygon class="st0" points="542.4,60.3 542.4,60.2 542.3,60.2 		" />
        <polygon class="st0" points="445.8,79.6 445.8,79.7 445.9,79.6 		" />
        <path
          class="st0"
          d="M391.8,91.3c0.1,0,0.2-0.1,0.3-0.1l-0.1-0.1C391.9,91.2,391.8,91.3,391.8,91.3z"
        />
        <path
          class="st0"
          d="M335.7,100.7l-0.1-0.1l-0.1,0.1l0.1,0.1C335.6,100.8,335.7,100.8,335.7,100.7z"
        />
        <polygon class="st0" points="557.7,51.7 557.7,51.8 557.8,51.8 		" />
        <path class="st0" d="M335.2,100l-0.1-0.1L335,100l0.1,0.1L335.2,100z" />
        <path class="st0" d="M314.7,104.4l-0.1,0.1L314.7,104.4z" />
        <polygon class="st0" points="390,87.5 389.9,87.4 389.9,87.5 		" />
        <path
          class="st0"
          d="M349.8,83.5c-0.1,0-0.2-0.1-0.2-0.1h-0.1c0,0,0,0,0,0.1C349.7,83.5,349.7,83.5,349.8,83.5z"
        />
        <path
          class="st0"
          d="M583.5,32.3L583.5,32.3h0.2C583.6,32.3,583.6,32.3,583.5,32.3C583.5,32.2,583.5,32.3,583.5,32.3z"
        />
        <path
          class="st0"
          d="M402.9,68.5L402.9,68.5C402.8,68.6,402.8,68.6,402.9,68.5C402.8,68.6,402.8,68.6,402.9,68.5L402.9,68.5z"
        />
        <path
          class="st0"
          d="M424.2,51.5l-0.1-0.1l-0.1,0.1C424.1,51.5,424.1,51.6,424.2,51.5C424.2,51.6,424.2,51.5,424.2,51.5z"
        />
        <path
          class="st0"
          d="M398.6,54l0.1,0.1l0.1-0.1l-0.1-0.1C398.7,53.9,398.6,53.9,398.6,54z"
        />
        <polygon class="st0" points="577.8,12.4 577.8,12.5 577.9,12.5 		" />
        <polygon class="st0" points="434.2,34.5 434.1,34.5 434.2,34.6 		" />
        <path
          class="st0"
          d="M399.4,98c-0.1,0.1-0.1,0.2-0.2,0.2l0,0l0,0C399.4,98.2,399.4,98.1,399.4,98z"
        />
        <path
          class="st0"
          d="M568.6,215.8c-0.6-0.6-1.4-0.6-2.3-0.4c-1.9,0.5-3.2,2-3.1,3.5c0,0.4,0.2,0.8,0.3,1.3
			c-3.2-0.2-5.1,0.5-6.1,2.2c-0.9,1.5-0.5,3.2,0.9,4.1c1.4,0.9,3.5,1,5.1,0.1c2.1-1.1,2.7-2.6,1.9-5.2c0.7,0,1.2,0.1,1.7,0
			c1.9-0.2,3.3-1.2,3.8-2.6c0.2-0.6,0.2-1-0.4-1.5C569.8,216.9,569.2,216.4,568.6,215.8z"
        />
        <path
          class="st0"
          d="M505,224c-0.8,0.3-1.6,0.5-2.4,0.9c-1.1,0.6-0.6,1.5-0.9,2.4c-1.6-0.1-2.7-0.8-4-1.2c-0.1,0-0.1-0.4-0.1-0.7
			c0.8,0.3,1.4,0.5,2.3,0.8c-0.5-1.4-0.9-2.6-1.3-3.8c1.7-0.3,2.6-1,2.4-2c-0.2-0.8-1.2-1.3-2.2-1c-1.2,0.3-1.7,1.2-1.4,2.8
			c-1-0.1-2-0.1-3.2-0.2c1,1.1,1,1.1,0.6,2.3c-1.8-0.5-3.6-1-5.6-1.6c0,0.4-0.1,0.5,0,0.6c0.4,0.9,1.2,1.6,1.1,2.7
			c-0.1,0.9,1.3,1.3,2.4,0.8c0.8-0.5,1.5-0.4,2.3-0.3c2,0.3,3.6,1.2,5.5,2c-0.6,0.2-0.9,0.3-1.7,0.5c1.8,0.3,3.1,0.6,4.5,0.7
			c0.7,0.1,1.3-0.4,1.3-1.2c0-0.5,0.4-0.6,0.7-0.8c1.3-0.9,1.5-1.8,0.6-2.9C505.7,224.5,505.4,224.3,505,224z"
        />
        <path
          class="st0"
          d="M543.3,237.3c-0.4-1.9-2.4-2.9-4.8-2.4c-2.4,0.5-3.9,2.3-3.6,4.1c0.3,1.8,2.6,3,4.8,2.5
			C542.3,240.9,543.7,239,543.3,237.3z"
        />
        <path
          class="st0"
          d="M433,249.9c-0.8-0.8-1.5-1.8-3.1-1.9c-0.2,0-0.4-0.2-0.5-0.3c0-0.8,0.3-1.3,1.1-1.7c1.2-0.8,1.3-1.9,0.4-2.7
			c-0.8-0.6-1.9-0.6-2.8,0.2s-0.9,1.7-0.1,2.2c0.4,0.3,0.8,0.5,1.3,0.8c-0.4,1-1,1.7-1.9,2.3c-0.4,0.3-0.8,0.7-1.1,1.1
			c-0.6,0.7-0.6,1.9,0,2.3c0.6,0.5,1.4,0.9,2.1,1.2c1,0.4,2.1,0.3,3.2-0.1C433,252.7,433.9,250.8,433,249.9z"
        />
        <path
          class="st0"
          d="M445.4,249.7c-0.4-0.7-0.3-1.4-0.1-2.1c0.1-0.2,0-0.5-0.1-1c-0.3,0.7-0.4,1.1-0.6,1.6
			c-0.9-1.1,0.2-2.3-0.3-3.3c-0.3,0.2-0.5,0.4-0.7,0.6c-0.2-0.4-0.2-0.9-0.5-1.1c-1-0.6-1.7-1.3-1.3-2.5c0-0.2-0.5-0.4-0.8-0.6
			c-0.2,0.3-0.6,0.6-0.6,0.8c0,0.3,0.2,0.7,0.4,1c-0.1,0.1-0.2,0.2-0.3,0.2c-0.1-0.1-0.2-0.2-0.3-0.3c-0.8-1.3-1.6-2.5-2.5-3.7
			c-0.4-0.5-0.6-1-0.1-1.6c0.5-0.7,0-1.2-0.4-1.7s-0.9-0.9-1.9-0.6c-0.1,0.4-0.2,0.8-0.4,1.2c-0.2,0-0.4,0-0.8,0c0,0.4-0.2,0.7,0,1
			c0.4,0.8,0.3,1.9,1.5,2.2c0.2,0.8,0.8,1.3,1.7,1.7c0.1,0-0.1,0.3-0.1,0.4c0.9,0.3,1.1,1,1.5,1.6c0.2,0.2,0.5,0.5,0.8,0.5
			c1.2,0.2,2.1,0.8,2.4,1.6c0.2,0.6,0.6,1.2,0.8,1.9c0.1,0.3,0.4,0.5,0.3,0.8c-0.4,1.5,0.8,2.2,1.7,3.1
			C445.5,250.7,445.7,250.2,445.4,249.7z M435.1,236.6c0.5,0.4,0.6,0.9,0.8,1.4C435.3,237.6,435.3,237.5,435.1,236.6z"
        />
        <path
          class="st0"
          d="M537.8,232.5c-0.1-0.1-0.1-0.2-0.1-0.3s0-0.1,0.1-0.2c0-0.1,0-0.2-0.1-0.4c-0.6-1.5-2.4-2.3-4.3-1.9
			c-0.1,0-0.3,0.1-0.4,0.1c-0.1,0.1-0.1,0.3-0.2,0.4c-0.4,0.5-0.8,1-1.6,0.9l0,0l-0.1,0.1v-0.1l0,0c0,0-0.1,0-0.1-0.1
			c-0.6,0.7-0.9,1.6-0.9,2.7c-0.3,0.1-0.6,0.3-0.9,0.4c0,0.1,0.1,0.1,0.1,0.2c0.3,0,0.7-0.1,1-0.1c1.7,1.6,3.4,2,5.3,1
			C537,234.7,537.7,233.6,537.8,232.5z"
        />
        <path
          class="st0"
          d="M561.8,217.2c2.1-0.5,3.4-2,3.1-3.7c-0.3-1.6-2.2-2.6-4.3-2.2c-0.9,0.2-1.7,0.6-2.3,1.2
			c0.2,0.6,0,1.3-0.6,1.8c-0.1,0.1-0.2,0.1-0.3,0.2c0,0.2,0,0.3,0,0.5c0.1,0.3,0.2,0.6,0.4,0.9c0.1-0.1,0.2-0.1,0.3-0.1
			c0.3-0.1,0.7,0.2,1.3,0.5c-0.2,0.2-0.4,0.5-0.6,0.6C559.6,217.3,560.7,217.5,561.8,217.2z"
        />
        <path
          class="st0"
          d="M399.3,223c-0.1,0-0.3,0-0.4,0c-0.1,0.1-0.2,0.2-0.2,0.3c-0.4,0.6-1.1,1.1-1.5,1.5c-0.7,0-1.2-0.2-1.6-0.4
			c-0.6,0.9-0.7,1.9-0.7,2.8c0.5,0.4,1,0.7,1.5,1c1.1,0.6,2.6,0.5,3.7-0.2c0-0.8-0.1-1.5,0-2.2c0-0.4,0.3-1,0.7-1.2
			c0.2-0.1,0.3-0.3,0.5-0.4C400.8,223.5,400.1,223.2,399.3,223z M395.7,225.4c-0.1-0.1-0.1-0.1-0.1-0.2c0-0.1,0.1-0.1,0.2-0.2
			c0.1,0.1,0.1,0.1,0.2,0.2C395.8,225.3,395.8,225.3,395.7,225.4z M396,227.6L396,227.6c0.1,0,0.2,0,0.3,0
			C396.2,227.6,396.1,227.6,396,227.6z M398.4,225.4c-0.2-0.1-0.5-0.2-0.4-0.2c0-0.2,0.2-0.3,0.3-0.5c0.1,0.1,0.4,0.1,0.4,0.3
			C398.7,225.1,398.6,225.2,398.4,225.4z"
        />
        <path
          class="st0"
          d="M528.7,235.2c-0.2,0.2-0.4,0.3-0.6,0.4c-0.7,0.3-1.3,0.6-2.3,1.1c-0.3-0.1-0.5-0.3-0.6-0.5s-0.3-0.3-0.3-0.5
			c-1.1,0.8-2,1.9-2.1,2.6c0,0.7,0.4,1.2,1.2,1.4c0.7,0.2,1.5,0.3,2.3,0.4c1.3,0.1,2.4-0.4,3.2-1.4s0.7-2.1,0-2.9
			C529.2,235.6,529,235.4,528.7,235.2z"
        />
        <path
          class="st0"
          d="M327.8,250.4c0.8-0.3,1.5-0.7,1.9-1.4c0.1-0.2,0.2-0.4,0.3-0.6c0.1-0.3,0.1-0.6,0.1-0.9l0,0
			c-0.1-1.1-1-2-2.5-2.2c-1.6-0.3-3.9,1-4.1,2.5c-0.1,0.9,0.5,1.4,0.7,2.2c0.5,0.2,0.9,0.3,1.4,0.5
			C326.4,250.7,327.1,250.6,327.8,250.4z"
        />
        <path
          class="st0"
          d="M529.4,230L529.4,230c-0.1-0.2-0.3-0.4-0.5-0.6c-0.3-0.3-0.6-0.7-0.8-1.1c0-0.1-0.1-0.2-0.2-0.3
			c0.2-0.2,0.4-0.4,0.6-0.6c0.2-0.2,0.3-0.3,0.5-0.5c0-0.1-0.1-0.1-0.1-0.2c-0.4-0.5-0.8-1.1-0.8-1.7c-1.6,0.4-2.8,1.9-2.6,3.2
			C525.8,229.5,527.6,230.3,529.4,230z"
        />
        <path
          class="st0"
          d="M530.3,226.7c0.4,0,0.7,0.1,1.1,0.2c0.3,0.1,0.5,0.2,0.7,0.3c0-0.2,0-0.4,0-0.6c-0.2-0.9-1.1-1.5-2.1-1.8
			c0.2,0.5,0.2,1.1,0,1.7C530,226.7,530.1,226.7,530.3,226.7z"
        />
        <path
          class="st0"
          d="M522.2,234.7c1.7-0.4,2.8-1.8,2.6-3.1c-0.3-1.5-1.8-2.3-3.7-1.9c-1.8,0.4-3,1.7-2.7,3.2
			C518.8,234.3,520.4,235.1,522.2,234.7z"
        />
        <path
          class="st0"
          d="M407.9,244.1c-0.7,0.6-1.7,0.7-2.8,0.3c-1,0.5-1.7,1.4-1.7,2.4c0,0,0.1,0,0.1,0.1h-0.1c0,0.1,0,0.2,0,0.4
			c0.3,1.3,2,2.1,3.7,1.8c1.7-0.4,2.9-1.7,2.6-3.1C409.6,245,408.8,244.3,407.9,244.1z"
        />
        <path
          class="st0"
          d="M534.8,223.7c0.3,0,0.6,0.2,0.7,0.4c0.3,0.5,0.9,0.5,1.5,0.6c0.2,0,0.3,0.1,0.5,0.1c1.2-0.6,1.9-1.7,1.6-2.8
			c-0.3-1.3-2-2.1-3.6-1.8c-1.3,0.3-2.3,1.3-2.5,2.3c0.1,0.2,0.1,0.4,0,0.7v0.1c0.1,0.5,0.4,0.9,0.7,1.2c-0.1-0.2,0-0.6,0.2-0.7
			C534.1,223.7,534.5,223.7,534.8,223.7z"
        />
        <path
          class="st0"
          d="M586.2,201.3c1.2,1.2,2.1,1.4,3.4,0.9c0.9-0.4,1.5-1.4,1.3-2.2c-0.2-0.6-0.6-0.9-1.3-1.1c0,0.5-0.5,0.9-1,1
			c-0.6,0.1-1.2-0.1-1.4-0.7c-0.1-0.3-0.1-0.6,0.1-0.8c-0.4-0.4-0.8-0.6-1.2-0.7c-0.5-0.1-1-0.1-1.5,0.1c-0.4,0.2-0.8,0.5-1,0.8
			c0.2,0.1,0.5,0.2,0.7,0.4c0.6,0.4,0.9,1.1,1,2.1c-0.2,0-0.5,0-0.7,0C584.9,201.3,585.4,201.3,586.2,201.3z"
        />
        <path
          class="st0"
          d="M516.4,229c1.2-0.1,2.1-0.6,2.6-1.6c0.2-0.3,0.1-0.8,0.8-0.8c-0.2-0.2-0.4-0.3-0.8-0.6c0.9-0.4,2.1-0.5,2-1.5
			c0-0.5-0.3-0.8-0.9-0.9c-1.1-0.1-1.6,0.5-1.9,1.1c-0.7,0-1.2-0.1-1.8-0.1c-1.6,0.1-2.7,1.2-2.6,2.4
			C513.8,228.3,514.9,229.1,516.4,229z"
        />
        <path
          class="st0"
          d="M333.2,249.9c-1.4-0.6-3-0.2-4.1,0.9c-0.9,0.9-0.5,1.8-0.3,2.6c-0.7-0.1-1.3-0.3-2.1-0.4
			c-0.7-0.1-1.4,0-2.3,0.2c0.6-1.3,0.4-2.4-0.2-3.3c-0.3-0.1-0.6-0.2-0.8-0.3c-0.5-0.2-0.9-0.3-1.4-0.4c-0.7-0.1-1.3,0-2,0.3
			c-0.2,0.1-0.4,0.2-0.6,0.3c-1.2,0.8-1.7,1.8-1.5,2.9v0.1c0,0.2,0.1,0.4,0.1,0.6c-0.7-0.1-1.4-0.3-2.1-0.4l0,0
			c0.1-0.8,0.3-1.7,0.4-2.5c1.8-0.6,2.7-1,3.1-1.9c0.2-0.5,0.3-1.1,0.3-1.9c0.5-0.1,0.9-0.3,1.4-0.4l0,0c0.3-0.1,0.6-0.2,1-0.3
			s0.8-0.2,1.2-0.4c1.1-0.4,1.7-1.1,1.8-2.1c0.1-0.9-0.4-1.6-1.3-2c-1.1-0.5-2.2-1.1-3.2-1.7c-0.3-0.2-0.5-0.6-0.6-1
			c-0.3-1-1.2-1.4-2.4-1.4c-0.1,0-0.2,0-0.2,0c-0.5,0-0.8,0-1.1-0.1c-0.5-0.1-0.9-0.3-1.9-0.8c0.3-0.4,0.7-0.8,1.2-1.1
			c0.3-0.2,0.6-0.3,0.9-0.5c0.6-0.3,1.1-0.6,1.6-1l0,0c0.3-0.4,0.8-0.7,1.4-0.7c0.8-0.1,1.4,0.2,1.8,0.8v0.1l0,0l0,0
			c0.3,0.5,0.2,1.2-0.5,1.7c-0.3,0.2-0.6,0.4-0.9,0.6c0.8-0.1,1.5-0.1,2.1,0.3c0.1,0.1,0.3,0.1,0.5,0.1c0.5,0,1.1,0,1.4-0.2
			c0.9-0.8,2.6-0.4,3.2-1.5c0.2-0.4,0.3-0.9,0.1-1.3c-0.2-0.5-0.8-0.8-1.4-0.6c-0.8,0.2-1.4,0.1-2.1,0c-0.2-0.1-0.5,0-0.7,0
			c-0.1,0.2-0.3,0.2-0.6,0.2c-0.3,0.1-0.7,0.3-1,0.5c0.4-0.5,0.7-0.9,1.1-1.4c0.5-0.6,0.9-1.2,1.1-1.9c-1,0.1-1.7-0.9-1.2-1.7
			c0.1-0.2,0.2-0.3,0.3-0.5c0.2-0.2,0.3-0.3,0.4-0.4c0-0.2-0.1-0.4-0.1-0.6c-0.2-1.1-0.5-2.2-0.7-3.2c0-0.1-0.1-0.3-0.2-0.4
			c-0.6-0.8-1.5-0.9-2.4-0.2c-0.4,0.3-0.7,0.5-1.2,0.6c-0.8,0.2-1.6,0.5-2.5,0.7c-0.7,0.2-1.6,0.3-1.8,1.2c0,0.1-0.5,0.3-0.8,0.4
			c-0.1,0-0.1,0-0.2,0s-0.3,0-0.4-0.1c-0.5,0-0.9,0.2-1.3,0.4c-0.6,0.3-1.3,0.6-2,1c0,0.9-0.2,1.6-1.2,2c-0.4,0.2-0.8,0.2-1.1,0.2
			c-0.2,0-0.3-0.1-0.5-0.1c-0.2-0.1-0.3-0.2-0.5-0.3V228c-0.1-0.1-0.3-0.1-0.3,0c-0.4,0.3-0.7,0.6-1,0.9c-0.2,0.2-0.5,0.5-0.7,0.7
			c-0.1,0.1-0.2,0.2-0.2,0.3c-0.3,0.4-0.6,0.7-0.7,1.1c-0.1,0.5-0.1,1,0.3,1.5c0.1,0.1,0.1,0.4,0,0.6c0,0.1,0,0.1,0,0.2
			c0,0.1-0.1,0.2-0.3,0.3c-0.3-0.1-0.6-0.2-0.8-0.3c-0.4,0.3-0.7,0.6-1,0.9c-0.8-0.4-1.3-1-1.1-1.5c0.1-0.3,0.7-0.5,1.1-0.8
			c-1.7-0.2-2.5,0.7-3.1,1.9c-0.4-0.2-0.8-0.4-0.8-0.6c0-0.3,0.3-0.6,0.4-0.8c-0.3-0.4-0.5-0.8-0.8-1.2c-0.1-0.2-0.2-0.3-0.3-0.5
			c-0.3-0.3-0.5-0.5-0.8-0.5c-0.2,0-0.5,0.1-0.9,0.2c-0.4,0.2-0.6,0.5-1,0.8c0.4,1.1,0.9,2.2,0.1,3.3c0,0.1-0.1,0.1-0.1,0.2l0,0l0,0
			c0,0.1,0,0.2,0.1,0.3c0.5,0.2,1,0.3,1.4,0.6c0.5,0.5,1.2,1,0.5,1.9c-0.1,0.2-0.1,0.4-0.1,0.6c1.3,0.1,1.3,0.1,2.1-1
			c1.1,0.5,2-0.5,3.3-0.4c0.6,0.3,1.2,0.6,1.6,1c0,0,0,0,0.1,0c0.6,0.5,1,0.9,1.2,1.4c0.3,0.7,0.2,1.6-0.3,2.6
			c-0.2,0.4-0.4,0.8-0.7,1.3c0.1,0,0.2,0,0.3,0c0.3-0.3,0.5-0.5,0.7-0.8c0.1-0.2,0.2-0.3,0.3-0.5c0.2-0.6,0.3-1.2,0.4-1.8
			c0-0.3,0-0.5-0.1-0.8c-0.1-0.2-0.1-0.3-0.2-0.5c0-0.1-0.1-0.3-0.1-0.4c0-0.1-0.1-0.2-0.1-0.3c-0.4-0.9-1.2-1.5-2.4-1.9
			c0.1-0.3,0.2-0.6,0.4-1c0.2,0.3,0.4,0.4,0.6,0.6c0.4-0.3,0.4-0.7,0.3-1c-0.1,0-0.2-0.1-0.2-0.1c0-0.1,0-0.1,0.1-0.3
			c0-0.2-0.1-0.3,0-0.5c0.3-0.2,0.6-0.3,0.8-0.5c0.2-0.1,0.4-0.2,0.6-0.4c0.1,0.2,0.1,0.5,0.2,0.8c0,0.1,0.1,0.3,0.1,0.4
			c0.1,0.4,0.1,0.9,0.7,1.1c0.2,0.1,0.3,0.4,0.4,0.6c0.1,0.1,0.2,0.3,0.3,0.4v3.3v0.2c0.2,0.1,0.4,0.1,0.6,0.3l0.1,0.1l0.1,0.1
			c0.2,0.2,0.4,0.4,0.6,0.7c0.4-0.1,0.8-0.2,1.2-0.5c0.8-0.5,1.1-1.2,0.9-1.9v-0.1c-1.1,0.2-2.2-0.3-2.4-1.2V237c0,0,0,0-0.1,0
			s-0.2,0-0.3,0h-0.1c0,0,0,0,0-0.1c0.1-0.2,0.2-0.5,0.3-0.7c0-0.1,0.1-0.2,0.2-0.2c0.3-0.6,0.9-1.2,1.7-1.4
			c1.2-0.3,2.3,0.3,2.6,1.3l0,0c0.4,0.3,0.9,0.5,1.3,0.8c-0.7,1.2-1.2,2.5-0.7,3.8c-0.8,0.5-1.7,0.8-2.3,1.4
			c-0.3,0.3-0.4,0.7-0.5,1.1c0,0.1,0,0.2,0,0.3v0.1c0.1-0.1,0.2-0.2,0.3-0.3c0.3-0.2,0.7-0.4,1.1-0.5c1.3-0.3,2.7,0.4,2.9,1.5
			c0,0,0,0,0,0.1s0,0.2,0,0.3c0.7-0.5,1-1.3,1.1-2.3c1.3,0.6,0.4,1.8,1,2.2c-0.7,0.7-1.5,1.3-2.2,2c-0.1,0.1-0.2,0.2-0.4,0.3
			c-0.1-0.1-0.3-0.2-0.6-0.4c-0.3,0.2-0.8,0.4-1.2,0.5c0,0,0,0-0.1,0c-0.3,0-0.6,0.1-0.8,0c-0.4,0-0.7-0.2-1.1-0.3
			c-0.4-0.3-0.8-0.6-0.9-1.1c-0.5-0.4-1-0.6-1.7-0.7c-0.1,0-0.2,0-0.3,0l0,0c-0.2,0-0.3,0-0.5,0v0.5v3.2v0.3
			c0.1-0.1,0.3-0.1,0.4-0.2c0.1,0,0.2,0,0.4-0.1c0.4,0,0.8,0.1,1.1,0.3c0.3,0.2,0.6,0.5,0.7,0.8c0.1,0.5-0.1,1-0.5,1.3
			c-0.2,0.2-0.5,0.4-0.8,0.5h-0.1c-0.1,0-0.3,0-0.4,0.1c-0.3,0-0.5,0-0.7-0.1v2.6v0.9v1.5c0.2,0,0.5,0,0.7,0.1
			c0.1,0,0.1,0.1,0.2,0.1c0.3-0.2,0.6-0.5,0.8-0.8c0.6,0,1.3,0,2-0.1c0.6-0.1,1.2-0.3,1.9-0.5c0.1,0.7,0.3,1.3,0.4,2
			c-1.6-0.5-3.1-0.5-4.4,0.7c-0.5,0.4-0.8,0.9-1,1.4c-0.1,0.3-0.1,0.6,0,0.9c0,0.2,0.1,0.4,0.2,0.6c0.7,1.3,2.1,1.7,3.9,1.4
			c-1.1,3.2,0,4.6,4,5.1c-0.1,1.1,0,2.2,0.9,2.9c0.1,0.1,0.2,0.2,0.3,0.2c0.4,0.3,0.9,0.5,1.3,0.7h0.2h0.7h2.8
			c0.4-0.2,0.7-0.4,1.1-0.6c-0.1-0.8,0.3-1.4,1.3-1.8c0.1-0.1,0.3-0.1,0.4-0.2l0,0l0,0l0.1-0.1l0,0c0.3,0.3,0.5,0.5,0.8,0.8
			c1.1-0.9,1.1-1,0.1-1.8c0,0,0,0-0.1,0c-0.2,0.1-0.4,0.2-0.7,0.4c-0.1-0.3-0.1-0.6-0.2-1c0.4-0.1,0.7-0.1,0.9-0.1
			c0.3,0,0.5,0,0.8-0.1c0.7-0.2,1.4-0.5,2-1c1.1-1,1.7-2.4,0.8-3.8c-0.5-0.8-1.3-1.2-2.4-1.3c-0.1,0-0.2,0-0.3-0.1
			c-0.4,0-0.8,0-1.3,0c0.1-0.6,0.1-1.2,0.2-1.9c0.4,0,0.7-0.1,1.1-0.1l0,0c1.4,0,2.5-0.6,3.2-1.4c1-1,1.3-2.4,0.6-3.4
			c-0.1-0.2-0.2-0.4-0.2-0.6c0.4,0.1,0.7,0.2,1.1,0.3c1.5,0.3,3.1-0.3,3.8-1.4C334.9,251.8,334.5,250.5,333.2,249.9z M322,242.6
			c0.4,0.2,0.6,0.4,0.6,0.8c0,0.1,0,0.2-0.1,0.3c-0.2,0.5-0.8,0.9-1.4,0.9c-0.2,0-0.3-0.1-0.4-0.1c-0.6-0.2-0.8-0.7-0.8-1.3
			C320.5,242.6,321.1,242.2,322,242.6z M320.2,244.9c0.1,0.1,0.2,0.2,0.4,0.3c0.1,0.1,0.2,0.2,0.3,0.2l-0.1,0.1
			c-0.1,0.1-0.2,0.2-0.2,0.2c-0.2-0.2-0.4-0.4-0.5-0.6C320,245,320.1,244.9,320.2,244.9z M317.3,225.6c0.8-0.2,1.6,0.3,1.8,0.9
			c0.1,0.6-0.4,1.2-1.2,1.4c-0.9,0.2-1.6-0.2-1.7-0.9C316.1,226.4,316.6,225.8,317.3,225.6z M316.5,228.4c0.1,0.1,0.2,0.3,0.3,0.4
			c0,0-0.2,0.2-0.3,0.2c-0.2-0.1-0.3-0.2-0.4-0.4C316.2,228.6,316.3,228.5,316.5,228.4z M296.3,234v-0.1V234L296.3,234z
	M297.5,236.6c-0.1-0.2-0.1-0.4-0.1-0.5c0.1,0,0.2,0.1,0.2,0.1C297.7,236.3,297.6,236.4,297.5,236.6z M304.7,233.2
			c-0.1-0.1-0.3-0.2-0.3-0.3s0.1-0.3,0.1-0.6c0.3,0.3,0.4,0.4,0.4,0.5C304.9,233,304.8,233.1,304.7,233.2z M305.3,231.4
			c-0.4-0.2-0.9-0.4-0.9-0.4c0.1-0.3,0.3-0.7,0.6-0.8c0.5-0.2,0.8,0.2,0.9,0.5C305.9,230.8,305.5,231.1,305.3,231.4z M306.2,232.2
			c-0.1,0-0.1,0.1-0.1,0.1c-0.1,0-0.2-0.1-0.4-0.2c0.1-0.1,0.2-0.2,0.3-0.3c0.1,0,0.1,0,0.2,0V232.2z M317.1,249l-0.1-0.1
			c0.1-0.1,0.2-0.1,0.3-0.2l0.1,0.1C317.2,248.9,317.2,248.9,317.1,249z M315.2,230.1L315.2,230.1L315.2,230.1L315.2,230.1z
	M311.6,232.4c-0.1-0.8,0.6-1.6,1.5-1.8c0.2,0,0.4-0.1,0.6,0c0.3,0,0.6,0.1,0.9,0.3c0.4,0.2,0.6,0.5,0.7,0.9
			c0.1,0.3,0,0.7-0.2,0.9c-0.1,0.2-0.3,0.4-0.5,0.5c-0.3,0.2-0.6,0.3-0.9,0.4C312.7,233.8,311.8,233.2,311.6,232.4z M315.6,242.3
			c-1.2,0.2-2.3-0.3-2.5-1.3c-0.2-1.1,0.6-2.1,1.9-2.4c0.6-0.1,1.1,0,1.5,0.2c0.6,0.3,1,0.7,1,1.3c0.1,0.5-0.1,1-0.4,1.4
			C316.8,241.9,316.2,242.1,315.6,242.3z M316.2,260.3c0,0.3-0.1,0.5-0.2,0.8c-0.9,0.1-1.7,0.1-2.6,0.2c0-0.7-0.1-1.5-0.1-2.2
			c0.4,0,0.8,0.1,1.2,0.1c0.6,0.1,1.2,0.1,1.8,0.2C316.3,259.7,316.3,260,316.2,260.3z M318.1,260c-0.5-0.8-0.5-1.3,0.2-1.9
			C319,258.7,318.8,259.2,318.1,260z"
        />
        <path
          class="st0"
          d="M400.8,249.1c-0.8-0.3-1.7-0.3-2.4,0c-0.4,0.4-1,0.8-1.4,1.1l0,0c-0.5,0.7-0.6,1.5-0.2,2.2
			c0.3,0.4,0.6,0.8,0.9,1.2c0.6,0,1.3,0,2-0.1c1.3-0.1,2.3-0.9,2.6-2C402.6,250.5,402,249.5,400.8,249.1z M399.7,250.8
			c-0.2,0-0.4-0.2-0.5-0.3c0-0.1,0.2-0.3,0.3-0.3c0.2,0,0.4,0.1,0.7,0.1C399.9,250.5,399.8,250.8,399.7,250.8z"
        />
        <path
          class="st0"
          d="M600.8,223.6c-0.2-1.2-1.8-2-3.3-1.7c-1.4,0.3-2.5,1.6-2.3,2.8s1.7,1.9,3.2,1.6
			C599.8,226.1,601,224.8,600.8,223.6z"
        />
        <path
          class="st0"
          d="M533.5,216.8c-0.1-0.5-0.4-1.1-0.6-1.7c-0.1,0.1-0.2,0.1-0.3,0.1c-0.4,0-0.8,0-1.2-0.1
			c-1.4,0-2.7,0.6-3.1,1.7c-0.4,0.9-0.1,1.8,0.8,2.4c0.9,0.5,2.1,0.6,3.1,0.1C533.2,218.7,533.7,217.8,533.5,216.8z M529.1,216.2
			c-0.1,0-0.1,0-0.2,0C529,216.2,529.1,216.2,529.1,216.2C529.2,216.1,529.1,216.2,529.1,216.2z"
        />
        <path
          class="st0"
          d="M526.3,221.4c-0.3-1.1-1.8-1.8-3.2-1.4c-1.4,0.4-2.4,1.6-2.1,2.7c0.3,1.1,1.7,1.8,3.1,1.5
			C525.6,223.9,526.7,222.6,526.3,221.4z"
        />
        <path
          class="st0"
          d="M591.2,216c-0.5,0.2-1.1,0.4-0.7,1c0,0.1-0.2,0.4-0.3,0.4c-1.1,0.2-0.7,0.8-0.7,1.2c0.1,0.6,0.5,1,1,1.3
			c0.1,0,0.2-0.1,0.3-0.1c0.6-0.1,1.2,0.1,1.5,0.4c0.2,0,0.3,0,0.5-0.1c1.5-0.4,2.5-1.7,2.1-2.9C594.4,216.1,592.7,215.5,591.2,216z
			"
        />
        <path
          class="st0"
          d="M567,225.7c-1.6,0.3-2.6,1.5-2.4,2.7c0.2,1.1,1.6,1.9,3.1,1.6c1.5-0.3,2.6-1.5,2.4-2.7
			C569.8,226.1,568.5,225.4,567,225.7z"
        />
        <path
          class="st0"
          d="M325.8,239.7c-0.2,0-0.4,0-0.5,0h-0.1c0,0.1,0,0.2,0,0.3c0.2,1.2,1.5,1.9,3,1.6c0,0,0,0,0.1,0c0,0,0,0,0.1,0
			c1.4-0.3,2.4-1.4,2.2-2.6c-0.2-1.2-1.6-1.8-3.1-1.5h-0.1c0,0.1,0.1,0.1,0.1,0.2c0.1,0.3,0,0.5-0.1,0.8
			C327,239.1,326.5,239.5,325.8,239.7z"
        />
        <path
          class="st0"
          d="M415.3,255.3c-0.8,0.1-1.6,0.1-2.3,0.3c-0.9,0.3-1.3,1.2-1.1,1.9c0.1,0.8,0.9,1.3,1.8,1.3s2.1-0.6,2.4-1.3
			c0.2-0.5,0.3-1,0.4-1.4c0.3-0.1,0.7-0.2,0.9-0.4c0.9-0.6,0.9-1.3,0.1-1.9c-0.2-0.1-0.3-0.2-0.5-0.3
			C415.8,253.9,415.3,254.5,415.3,255.3z"
        />
        <path
          class="st0"
          d="M523.4,212.2c0,0.5,0.3,0.9,0.8,1.3c0.4,0.2,0.8,0.3,1.3,0.5c0,0.4-0.3,0.9,0.4,1c0.9,0.2,1.4-0.1,2.3-1.2
			c-0.2-0.3-0.5-0.6-0.7-0.9c0.1-0.1,0.2-0.1,0.2-0.2c0.3,0.1,0.6,0.2,0.9,0.4c0.1,0,0.2-0.1,0.3-0.1c-0.4-0.7-0.8-1.5-1.3-2.1
			s-1.3-0.8-2.2-0.6c-0.6,0.1-1,0.4-1.4,0.7c0.4,0.4,0.5,1,0.5,1.6C523.9,212.5,523.6,212.3,523.4,212.2z"
        />
        <path
          class="st0"
          d="M606.9,196.2C606.9,196.2,606.8,196.3,606.9,196.2c-0.5,0.3-0.9,0.7-1.5,1.1c0.4,0.7,0.6,1.4,1.1,2
			c0.3,0.4,0.7,0.5,0.4,1.1c-0.2,0.4,0.2,0.8,0.7,0.8s1-0.3,1-0.7c0,0,0,0,0-0.1c-0.2-0.6,0.2-0.9,0.6-1.3c0.9-0.8,1-1.7,0.5-2.6
			C609.2,195.6,608.1,195.5,606.9,196.2z"
        />
        <path
          class="st0"
          d="M560.6,182.1c-0.2-0.4-0.7-0.8-1.5-1.2c-0.5,0.7-1.3,1.2-1.4,2l-0.1,0.1c0.1,0.8,0.9,1,1.6,1.3
			c-0.4,0.3-0.6,0.5-0.7,0.7l0,0l0,0c-0.2,0.4-0.1,0.6,0.3,1.2c0,0.1,0.1,0.2,0,0.2c-0.2,0.2-0.3,0.3-0.3,0.4c0,0.2,0.2,0.4,0.4,0.6
			c0.3,0.2,0.8,0.4,1.2,0.5c0.6,0.1,1.3-0.4,1.1-0.8c-0.2-0.4-0.3-0.9-0.3-1.3c0-0.2-0.1-0.4-0.2-0.6c-0.2-0.1-0.4-0.1-0.6-0.3
			c-0.3-0.2-0.4-0.4-0.6-0.7l0,0l0,0c-0.2-0.5-0.1-1.2,0.4-1.7C560.1,182.5,560.3,182.3,560.6,182.1z M560.7,186.9
			c-0.8,0.1-1.2,0.1-1.9,0.2C559.5,186.4,560,186.7,560.7,186.9z"
        />
        <path
          class="st0"
          d="M555.1,193.4c0.8-0.7,1.6-1.4,2.6-2.3c-1-0.2-1.9-0.3-2.5-0.6c-0.5-0.2-1.1-0.3-1.6-0.3
			c-0.3,0-0.5,0.1-0.8,0.3c-1-1.2-1-1.2-2.6-0.9c-0.1,0.5-0.2,0.9-0.3,1.5c0.5,0.1,0.9,0.2,1.4,0.2c0.2,0,0.5,0.1,0.7,0.1
			C552.4,192.8,553.1,193.2,555.1,193.4z"
        />
        <path
          class="st0"
          d="M393,254c0.1,0.5,0.1,0.9,0.2,1.4s0.3,0.9-0.4,1.2c-0.1,0.1,0,0.4,0,0.6s0,0.3,0,0.5c1.3-0.3,2.2-1.3,2-2.4
			C394.6,254.7,393.9,254.2,393,254z"
        />
        <path
          class="st0"
          d="M379.3,260.5c0.2-0.8-0.3-1.5-1.2-1.7c-0.9-0.2-1.8-0.3-2.6-0.8c-0.1-0.1-0.6,0.1-0.8,0.2
			c-0.1,0.1-0.2,0.4-0.1,0.5c0.6,0.5,0.3,1.1,0.2,1.8c-0.3,1.2,1.1,2.1,2.6,1.8C378.4,262.1,379.1,261.4,379.3,260.5z"
        />
        <path
          class="st0"
          d="M517.3,218.3c0.4,0.2,0.9,0.2,1.4,0.3c0.7,1.1,0.7,1.1,2.3,1.1c-0.5-1-1-1.8-0.4-2.9c0.5-0.8-0.5-1.7-1.6-1.9
			s-2.1,0.3-2.6,1.2C516,217,516.3,218,517.3,218.3z"
        />
        <path
          class="st0"
          d="M386.8,248.6c-1.3,0.2-2.3,1.4-2.1,2.4c0.1,0.5,0.5,1,1,1.2c0.2-0.2,0.5-0.5,0.8-0.7c0.6-0.3,1.5-0.3,2,0.2
			c0,0,0,0.1,0.1,0.1l0,0c0.6-0.5,1-1.2,0.8-1.9C389.2,249,388,248.4,386.8,248.6z"
        />
        <path
          class="st0"
          d="M359.1,267c-0.8,0.3-1.5,0.7-2.2,1.1c0.2,1.1,0.4,1.5,0.9,2.1s1.2,0.7,1.9,0.4c0.6-0.2,1.2-0.5,1.7-0.9
			c0.7-0.6,0.8-1.4,0.3-2.1C361.2,267,359.8,266.7,359.1,267z"
        />
        <path
          class="st0"
          d="M337.1,231.4c-0.2-0.2-0.4-0.3-0.7-0.5c0,0.2,0.1,0.5,0.2,0.7c0.1,0.6,0.4,0.9,0.8,1.2c0-0.1,0-0.1-0.1-0.2
			v-0.1C337.6,232,337.4,231.7,337.1,231.4z"
        />
        <path
          class="st0"
          d="M338.4,233.1c-0.1-0.1-0.2-0.1-0.5-0.1C338.1,233.1,338.2,233.1,338.4,233.1z"
        />
        <path
          class="st0"
          d="M500.1,249.2c-0.7-0.2-1.5-0.3-2.2-0.4c-0.5,0-1,0.2-1.5,0.4c-0.3,0.1-0.6,0.4-0.8,0.6
			c-1.1,0.8-1.2,1.4-0.6,2.6c0.4-0.2,1-0.7,1.3-0.6c1.6,0.4,2.8-0.1,3.9-1.1c0.2-0.2,0.5-0.3,0.8-0.4
			C500.9,249.6,500.7,249.3,500.1,249.2z"
        />
        <path
          class="st0"
          d="M561.1,231.2c-1.3,0.3-2.1,1.4-1.8,2.4s1.6,1.6,2.8,1.3s2.1-1.4,1.8-2.4S562.3,230.9,561.1,231.2z"
        />
        <path
          class="st0"
          d="M543.9,241.7c-1.2,0.3-2.1,1.4-1.9,2.3c0.2,1,1.5,1.6,2.8,1.3c1.2-0.3,2.1-1.5,1.8-2.4
			C546.3,242,545.1,241.4,543.9,241.7z"
        />
        <path
          class="st0"
          d="M340.7,235.3c0.2,0,0.3,0,0.5,0c-0.2-0.1-0.3-0.2-0.5-0.2C340.7,235.2,340.7,235.2,340.7,235.3z"
        />
        <path
          class="st0"
          d="M345.9,234.6c-0.2,0.1-0.4,0.3-0.6,0.5c-0.4,0.3-1.2,0-1.5,0.6c-0.3-0.2-0.6-0.3-0.9-0.3
			c0.5,0.5,1.6,0.2,2.4,0.4c0.3-0.4,0.5-0.8,0.8-1.1C346,234.7,345.9,234.7,345.9,234.6z"
        />
        <path
          class="st0"
          d="M555.3,227.1c-1.3,0.2-2.2,1.3-2,2.3c0.2,0.9,1.3,1.5,2.6,1.3s2.1-1.1,2-2.1
			C557.7,227.5,556.5,226.9,555.3,227.1z"
        />
        <path
          class="st0"
          d="M531.5,205.9c-0.7,0.4-1,1.1-0.9,1.8c0.2,1.1,1.2,1.7,2.6,1.4c1.2-0.2,2.1-1.2,1.9-2.1
			c-0.1-0.9-1.1-1.5-2.2-1.5c0.2,0.1,0.4,0.1,0.6,0.2c0.4,0.2,0.3,0.4,0.1,0.7c-0.1,0.1-0.1,0.1-0.2,0.2c-0.1,0-0.2-0.1-0.3-0.1
			C532.5,206.3,532,206.1,531.5,205.9C531.6,205.9,531.6,205.9,531.5,205.9z M532,208.6C532.1,208.6,532.1,208.6,532,208.6
			L532,208.6L532,208.6z"
        />
        <path
          class="st0"
          d="M371.7,260.5c0.2-0.9-0.1-1.7-1.2-2.1c-0.6,1.2-0.6,1.2,0.5,2.4c-0.9,0.9-1,1-0.6,1.4
			c0.8,0.8,1.6,1.7,3.1,1.9C375.3,262.1,374.7,260.9,371.7,260.5z"
        />
        <path
          class="st0"
          d="M340.3,239.3c-0.1-0.2-0.1-0.5-0.3-0.7c-0.6-1-2.6-1.1-3.5-0.3s-0.9,1.9-0.1,2.6c0.8,0.7,2.2,0.6,3.1-0.2
			c0.4-0.3,0.8-0.7,1.2-1C340.6,239.5,340.4,239.4,340.3,239.3z"
        />
        <path
          class="st0"
          d="M599.9,211c-1.2,0.3-2.1,1.2-1.9,2.2c0.2,0.9,1.4,1.5,2.5,1.3c1.2-0.2,2.2-1.4,2-2.3
			C602.3,211.3,601.1,210.7,599.9,211z"
        />
        <path
          class="st0"
          d="M548.4,233.1c-0.3-1.3-1.4-1.9-3.4-1.7c0.4,1.6,0,3.3,0.7,4.8C547.9,235.5,548.7,234.5,548.4,233.1z"
        />
        <path
          class="st0"
          d="M592.2,207.2c0.3,1,1.3,1.4,2.6,1.1c1.2-0.3,2-1.3,1.8-2.2s-1.5-1.5-2.6-1.3
			C592.8,205.1,592,206.2,592.2,207.2z"
        />
        <path
          class="st0"
          d="M582.7,201.6v-0.1C582.7,201.6,582.6,201.6,582.7,201.6c-0.4,0.6-0.7,1-0.9,1.5c-0.3,0-0.6,0.1-0.9,0.1
			c-0.3,0.1-0.5,0.2-0.7,0.3c-0.4,0.2-0.7,0.5-0.8,1c-0.3,1.1,0.7,1.5,1.4,2.1c0.9-0.4,1.6-0.7,2.4-1.1
			C583,204.2,583.2,202.9,582.7,201.6z"
        />
        <path
          class="st0"
          d="M540.1,229.6c0.4,0.1,0.9,0.2,1.3,0.1c1.2-0.2,2-1.3,1.8-2.2c-0.2-0.8-1.5-1.4-2.5-1.1
			c-1.1,0.3-1.9,1.2-1.7,2.1c0,0.1,0.1,0.3,0.2,0.4c0-0.1-0.1-0.2-0.1-0.4C539.8,228.7,540,229.1,540.1,229.6z"
        />
        <path
          class="st0"
          d="M364.5,246.5c0,0.2-0.1,0.5-0.2,0.7c-0.1,0.4-0.4,0.8-0.7,1.2h0.1c-0.2,0.5-0.5,0.7-0.8,1
			c-0.4,0.3-0.8,0.7-0.3,1.1c0.4,0.3,0.9,0,1.3-0.3c0.3-0.3,0.6-0.5,0.9-0.8c0.4,0.2,0.7,0.3,1.6,0.6c-0.6-1.2-0.3-1.9,0.5-2.6
			c0.3-0.3,0.2-0.7,0.4-1.4c-0.9,0.4-1.5,0.7-2.2,1.1C364.9,246.9,364.7,246.7,364.5,246.5z"
        />
        <path
          class="st0"
          d="M356.2,241.5c-0.3-0.1-0.6-0.3-0.9-0.5c-0.2-0.1-0.3-0.2-0.5-0.3c0-0.4,0.1-0.8,0.2-1.2
			c-0.1,0.1-0.2,0.1-0.3,0.2c-0.5,0.3-1,0.6-1.5,0.9c-0.1,0.1-0.2,0.1-0.3,0.2c0.6,0.9,1.2,1.7,1.8,2.5c0.6-0.2,1.1-0.5,1.4-0.7
			s0.4-0.4,0.3-0.7C356.2,241.8,356.2,241.6,356.2,241.5z"
        />
        <path
          class="st0"
          d="M536,210.8c0.1,0.2,0.2,0.5,0.3,0.7l0,0c0,0,0,0.1,0.1,0.1l0,0c0.2,1,0.1,2,1.3,2.8c0.6-0.4,1.2-0.7,1.5-1.1
			c0.3-0.3,0.6-0.9,0.4-1.2l-0.1-0.1c-0.2,0.1-0.6,0.1-0.7,0c-0.1-0.1-0.3-0.3-0.4-0.5c-0.1-0.2-0.2-0.4-0.1-0.8l0,0
			C537.6,210.4,536.8,210.2,536,210.8z"
        />
        <path
          class="st0"
          d="M556,220.8c0.8-0.5,1.4-0.4,2.2-0.4c0.2,0,0.4-0.1,0.9-0.3c-1-0.7-1.9-1.3-2.9-1.9c-0.6-0.3-1.4-0.1-2,0.4
			s-0.7,1.3-0.2,1.8C554.4,220.9,555.4,221.2,556,220.8z"
        />
        <path
          class="st0"
          d="M567.8,191.3c0.8-0.2,1.1-0.8,1-1.3c-0.1-0.4-0.4-0.9-0.8-1.2c0,0-0.1,0-0.1-0.1c-0.3,0.4-0.7,0.7-1.2,0.9
			c0.2,0.2,0.4,0.5,0.2,0.8c0.3,0.1,0.5,0.3,0.5,0.5s0,0.4-0.2,0.7C567.3,191.5,567.5,191.4,567.8,191.3z"
        />
        <path
          class="st0"
          d="M565.4,190.3c-0.3,0-0.7,0-1.1,0.4c0,0.3,0.1,0.5,0.2,0.6C564.6,190.9,565,190.5,565.4,190.3z"
        />
        <path
          class="st0"
          d="M483.3,232.1c-0.1-0.2-0.2-0.6-0.4-0.7c-0.7-0.2-1.5-0.3-2.3-0.4c-0.1,0.3-0.2,0.6-0.3,0.8
			c0.4,0.2,0.8,0.3,1,0.4c-0.1,0.9-0.9,1.1-1.9,1.4c0.6,0.6,1.1,1,1.7,1.5c0.7-0.5,1.3-0.8,1.8-1.2c0.6-0.5,0.2-0.9,0-1.4
			C482.9,232.5,483.1,232.3,483.3,232.1z"
        />
        <path
          class="st0"
          d="M388,241.8c0.3,0.2,0.7,0.2,1.1,0.2c0.1,0,0.2,0,0.2,0c1.1-0.2,1.7-1,1.6-1.8c0-0.1,0-0.2-0.1-0.3
			c-0.1-0.2-0.2-0.4-0.4-0.5c-0.4-0.3-0.9-0.4-1.5-0.3c-1,0.2-1.7,1.1-1.6,1.8C387.3,241.3,387.6,241.6,388,241.8z"
        />
        <path
          class="st0"
          d="M434.5,260.1c-1,0.2-1.7,0.8-1.5,1.3c0.3,1.1,1.2,1.5,2.5,1.2c1.1-0.3,1.6-0.8,1.5-1.5
			C436.8,260.3,435.7,259.9,434.5,260.1z"
        />
        <path
          class="st0"
          d="M374.7,254.4c0.2,0.8,1.2,1.3,2.2,1c1-0.2,1.7-1.1,1.5-1.9c-0.2-0.7-1.2-1.2-2-1
			C375.1,253,374.5,253.7,374.7,254.4z"
        />
        <path
          class="st0"
          d="M489.5,258.7c-0.5,0.3-1,0.7-1.5,1c-0.4-0.9-1.2-1.2-2.3-1.4c-0.2,0.2-0.5,0.4-0.5,0.6
			c-0.1,0.3-0.1,0.7,0.2,0.8c0.8,0.4,1.7,0.8,2.5,1.2c0.3-0.3,0.5-0.5,0.7-0.8c0.7,0.1,1.4,0.3,2.3,0.4
			C490.8,259.6,490.4,259.1,489.5,258.7z"
        />
        <path
          class="st0"
          d="M352.2,239c-0.1-0.3-0.2-0.6,0-0.8c1-1.2,0.4-2-0.8-2.8c-0.5,0.8-1.8,1.4-1.4,2.2c0.3,0.6,0.1,1.6,0.8,2.1
			c0.2,0.2,0.5,0.3,0.9,0.4c0,0,0,0,0-0.1C352.2,239.3,352.2,239.3,352.2,239z"
        />
        <path
          class="st0"
          d="M505.9,214.6c-1,0.2-1.7,1.1-1.5,1.9c0.2,0.7,1.1,1.2,2,1c1-0.2,1.6-0.9,1.6-1.7
			C507.9,215,506.9,214.5,505.9,214.6z"
        />
        <path
          class="st0"
          d="M567.4,232.7c-0.9,0.2-1.6,1-1.6,1.7c0.1,0.8,1,1.3,2.1,1.1c0.9-0.2,1.6-0.9,1.6-1.7
			C569.4,233.1,568.4,232.5,567.4,232.7z"
        />
        <path
          class="st0"
          d="M324.3,271.5c-0.2,0.3-0.6,0.5-1.2,0.7h2.7C325.5,271.7,324.9,271.5,324.3,271.5z"
        />
        <path
          class="st0"
          d="M601.3,195.1c-0.9,0.3-1.5,1.1-1.2,1.8c0.1,0.4,0.4,0.6,0.7,1c0.6-0.1,1-0.1,1.4-0.3c1-0.3,1.5-1.1,1.3-1.8
			C603.3,195.2,602.3,194.8,601.3,195.1z"
        />
        <path
          class="st0"
          d="M346.1,227.2c0-0.3,0.1-0.6,0-0.9c-0.3,0.3-0.6,0.5-1,0.8C345.5,227.1,345.8,227.1,346.1,227.2z"
        />
        <path
          class="st0"
          d="M513.2,210c-1.1,0.2-1.8,0.9-1.6,1.8c0.2,0.7,1.1,1.2,2,1.1c0.9-0.2,1.6-1,1.5-1.7
			C514.9,210.3,514.2,209.8,513.2,210z"
        />
        <path
          class="st0"
          d="M391.2,258.5c-0.9,0.3-1.6,1.2-1.4,2c0.2,0.7,0.9,1.1,1.7,0.8c1.1-0.3,2-1.4,1.8-2.1
			C393.2,258.8,391.8,258.3,391.2,258.5z"
        />
        <path
          class="st0"
          d="M583.1,223.9c-0.1-0.2-0.1-0.4,0-0.5c-0.7-0.3-1.4-0.3-2.3,0c0,1.9,0.8,2.6,3.2,2.6c0.3-0.4,0.4-0.8,0.4-1.2
			C583.7,224.7,583.2,224.3,583.1,223.9z"
        />
        <path
          class="st0"
          d="M432.5,246c0.9-0.5,1.6-0.8,2.2-1.2c0.7-0.4,1.1-1,1.1-1.7c-0.1-0.8-0.8-1.1-1.6-0.7
			c-0.6,0.3-1.1,0.6-1.6,0.9C432.5,244.2,432.5,244.9,432.5,246z"
        />
        <path
          class="st0"
          d="M602.2,199.9c-0.6,0.1-1.1,0.5-1.4,1c-0.1,0.2-0.2,0.5-0.1,0.7c0.2,0.7,1.1,1.2,2.1,1l0,0
			c0.2,0,0.4-0.1,0.5-0.2c0,0,0.1,0,0.1-0.1c0.6-0.4,0.9-0.9,0.8-1.5C604.1,200.2,603.2,199.7,602.2,199.9z"
        />
        <path
          class="st0"
          d="M575,217.2c-0.3,1.8,0.6,2.6,3,2.7C578.8,217.9,577.8,217,575,217.2z"
        />
        <path
          class="st0"
          d="M550.8,229.5c-1,0.2-1.6,1-1.4,1.8c0.2,0.7,1,1.1,1.9,0.9c1-0.2,1.6-1,1.4-1.7
			C552.6,229.7,551.7,229.3,550.8,229.5z"
        />
        <path
          class="st0"
          d="M531.6,241.5c-0.9,0.2-1.4,0.9-1.3,1.6c0.1,0.7,0.9,1.1,1.8,1c1-0.2,1.6-0.9,1.5-1.7
			C533.5,241.8,532.6,241.3,531.6,241.5z"
        />
        <path
          class="st0"
          d="M555,184.9c-0.3,0-0.5,0-0.7,0.1c-0.7,0.1-0.9,0.2-1.3,0.9l0,0c0,0,0,0,0.1,0c1,0.2,1,0.3,1.5,1.3
			c0.2,0,0.4,0,0.6-0.1c0.1,0,0.2-0.1,0.2-0.1c0.2-0.1,0.4-0.3,0.6-0.5c0.1-0.1,0.2-0.2,0.4-0.3c0.5-0.3,0.8-0.6,0.6-1.1l0,0l0,0
			c0.1-0.2,0.1-0.4,0.2-0.6l-0.3-0.1c-0.1,0.1-0.2,0.3-0.3,0.5l0,0l0,0C556.1,184.9,555.6,184.9,555,184.9z"
        />
        <path
          class="st0"
          d="M520.7,240.7c-0.1-0.5-0.6-0.9-1.1-1c-0.2,0.2-0.4,0.3-0.7,0.4c-0.3,0.1-0.5,0-0.8,0
			c-0.5,0.3-0.8,0.9-0.7,1.3c0.1,0.7,1,1.1,1.9,1C520.3,242.2,520.9,241.5,520.7,240.7z"
        />
        <path
          class="st0"
          d="M522.5,245c0.4-0.2,0.8-0.2,1.2-0.2c-0.3-0.5-1-0.7-1.7-0.6c-0.9,0.2-1.5,0.8-1.4,1.6c0.1,0.7,0.9,1.2,1.8,1
			c0.2,0,0.4-0.1,0.6-0.2c-0.4,0.1-0.8,0.1-1.3,0.1C521.6,245.7,521.7,245.3,522.5,245z"
        />
        <path
          class="st0"
          d="M382.1,238.3c0.3,0.1,0.9,0,1.2-0.2c-0.5-0.4-0.9-0.9-1.2-1.4c-0.4,0-0.8-0.2-1.1-0.6
			c-0.7-0.8-1.2-0.7-2.1,0.3C379.5,237.6,380.8,237.9,382.1,238.3z"
        />
        <path
          class="st0"
          d="M598.4,195.4c-0.3-0.2-0.6-0.4-0.9-0.6c-0.5-0.3-1-0.7-1.5-1c-0.9,0.5-1.4,1.1-1.2,1.8c0,0.1,0,0.1,0.1,0.2
			c0.3,0.6,0.9,0.9,1.7,0.8C597.5,196.6,598.1,196.3,598.4,195.4z"
        />
        <path
          class="st0"
          d="M492.1,260.4C492.1,260.4,492.1,260.5,492.1,260.4c0.2,0.9,1.3,0.8,2.3,0.5c0.1-0.4,0.2-0.7,0.2-1.1
			c0.1-0.7-0.2-1.4-0.7-2.1C492.4,258.5,491.9,259.5,492.1,260.4z"
        />
        <path
          class="st0"
          d="M354.9,266c-0.6-0.3-1.3-0.1-1.8,0.3c-0.4,0.3-0.7,0.7-1,1.1c1.1,0.9,1.6,1.1,2.4,0.7
			c0.7-0.3,1.2-0.7,1.2-1.3C355.6,266.5,355.2,266.2,354.9,266z"
        />
        <path
          class="st0"
          d="M392.2,230.6c0.1,0.1,0.2,0.2,0.2,0.3c0,0,0,0,0-0.1c0.2-0.3,0.2-0.7,0.1-1l0,0l0,0c-0.1,0-0.1,0-0.2,0
			c-0.2,0-0.3,0-0.4,0c-0.4,0-0.7-0.1-0.9-0.3c-0.2-0.1-0.3-0.2-0.4-0.3c-0.2,0.1-0.4,0.1-0.7,0.2v-0.1c0,0,0,0-0.1,0
			c-0.4-0.6-0.4-0.7-1-0.2c0.2,0.2,0.4,0.3,0.7,0.4c0.2,0.1,0.4,0.2,0.6,0.4l0,0c0.1,0.1,0.2,0.1,0.3,0.2
			C391,230.6,391.6,230.7,392.2,230.6z"
        />
        <path
          class="st0"
          d="M585.8,210c0.8,1.1,1.5,2.2,2.3,3.4c0.9-1,1.2-1.9,0.5-2.8C588,209.9,587.3,209.7,585.8,210z"
        />
        <path
          class="st0"
          d="M473.4,221.5c0,0,0.1-0.1,0.1-0.2h-0.1C473.5,221.4,473.4,221.5,473.4,221.5z"
        />
        <path
          class="st0"
          d="M553.7,210.5c0.2,0.6,1,1,1.8,0.8s1.3-1,1.1-1.5c-0.2-0.6-0.9-0.9-1.7-0.7
			C554.1,209.2,553.6,209.8,553.7,210.5z"
        />
        <path
          class="st0"
          d="M331.3,259.3c-0.1,0-0.2,0-0.2-0.1c-0.2,0-0.4,0-0.5,0c-0.8,0.1-1.5,0.8-1.4,1.4c0.1,0.7,0.9,1.1,1.7,0.9
			c0.8-0.2,1.3-0.7,1.3-1.4C332.1,259.8,331.8,259.4,331.3,259.3z"
        />
        <path
          class="st0"
          d="M370.5,245.4c-0.1,0.7-0.2,1.1-0.3,1.5c-0.3-0.2-0.6-0.4-0.8-0.5c-0.8,1.5-0.4,2.2,1.5,2.2
			c0.7,0,1.1-0.4,0.8-0.8c-0.3-0.4-0.5-0.8-0.4-1.4C371.4,246.1,371,245.9,370.5,245.4z"
        />
        <path
          class="st0"
          d="M494,216.6c0.8-0.2,1.4-0.8,1.3-1.5c-0.1-0.6-1-1-1.8-0.8c-0.7,0.2-1.3,0.8-1.2,1.4
			C492.4,216.3,493.2,216.8,494,216.6z"
        />
        <path
          class="st0"
          d="M567,201.7c0.1-0.1,0.1-0.1,0.2-0.2c0,0,0,0,0.1,0c0.2-0.7-0.2-1.3-0.9-1.6c-0.7-0.4-1.5-0.5-2.3,0.2
			C564.5,201.6,565,201.9,567,201.7z"
        />
        <path
          class="st0"
          d="M583.7,211.9c-0.1,1.6,0.4,2.1,2.6,2.3C586.5,212.4,585.8,211.8,583.7,211.9z"
        />
        <path
          class="st0"
          d="M589.3,193.2c-1.2,0.9-1.4,1.3-1.1,1.8c0.3,0.4,0.8,0.7,1.5,0.5c0.7-0.1,1.1-0.5,1.2-1.1
			C591.1,193.6,590.3,193.3,589.3,193.2z"
        />
        <path
          class="st0"
          d="M368,267c-0.1,0.7,0.1,1.3,1.2,1.7c0.1-1.1,2.1-0.7,2.2-2.1c-0.5-0.2-1-0.4-1.5-0.6
			C369.2,266.5,368.6,266.8,368,267z"
        />
        <path
          class="st0"
          d="M485.3,224.5c-0.1,0.8-0.1,1.4-0.2,2.2c0.6-0.3,1.2-0.5,1.7-0.8c0.6-0.2,1.1-0.5,1.7-0.7
			c-0.4-0.4-0.7-1-1.2-1.1C486.7,224,485.9,224.3,485.3,224.5z"
        />
        <path
          class="st0"
          d="M500.2,209.9c-0.6,0.4-0.8,1.2-0.2,1.7c0.6,0.6,1.5,0.3,2.8-0.8C501.7,209.6,501,209.3,500.2,209.9z"
        />
        <path
          class="st0"
          d="M606.2,191.5c0.1,0.6,0.9,0.9,1.6,0.8c0.7-0.2,1.3-0.8,1.2-1.4c-0.1-0.3-0.3-0.6-0.7-0.7
			c-0.3-0.1-0.7-0.2-1.1-0.1c-0.5,0.1-0.9,0.5-1,0.9C606.1,191.1,606.1,191.3,606.2,191.5z"
        />
        <path
          class="st0"
          d="M560.6,195.9c-0.7-0.5-1.6-0.6-2.5,0c0.5,1.5,1,1.8,2.9,1.6C561.6,196.8,561.2,196.3,560.6,195.9z"
        />
        <path
          class="st0"
          d="M515,221.8c0.2,0.6,0.9,0.9,1.7,0.7c0.7-0.2,1.1-0.7,1-1.3s-0.8-1-1.6-0.8C515.3,220.7,514.8,221.2,515,221.8
			z"
        />
        <path
          class="st0"
          d="M540.7,208.5c-0.8,0.1-1.3,0.7-1.2,1.3s0.8,0.9,1.6,0.8c0.8-0.1,1.3-0.8,1.2-1.3
			C542.2,208.7,541.5,208.3,540.7,208.5z"
        />
        <path
          class="st0"
          d="M382.1,247.9c-0.5,0.3-1,0.6-1.5,0.9l0.1,0.1c0.1,0.1,0.2,0.1,0.3,0.2c-0.2,0.2-0.3,0.5-0.5,0.7
			c0.3,0,0.6,0,0.9,0c0.8,0,1.2-0.2,1.5-0.7C383.2,248.5,382.9,248.1,382.1,247.9z"
        />
        <path
          class="st0"
          d="M379.1,248.8c0.1,0.2,0.2,0.3,0.4,0.5c0.3-0.3,0.5-0.6,0.7-0.6c0.1,0,0.3,0,0.4,0.1
			C380.1,248.4,379.6,248.4,379.1,248.8z"
        />
        <path
          class="st0"
          d="M496.6,238.7c0.7-0.6,0.4-1.3-0.8-1.9c-0.8,0.4-1.4,0.8-1.6,1.6C495.1,239.3,495.9,239.2,496.6,238.7z"
        />
        <path
          class="st0"
          d="M423.1,252.5c-0.1-0.5-0.8-0.8-1.5-0.7c-0.8,0.1-1.3,0.8-1.2,1.3c0.1,0.6,0.9,0.9,1.6,0.8
			C422.7,253.7,423.3,253,423.1,252.5z"
        />
        <path
          class="st0"
          d="M418.5,250c-0.4,0.1-0.8,0-1.1-0.1c-0.1,0.3,0.1,0.5,0.4,0.7c0.4,0.3,0.9,0.4,1.5,0.2c0.5-0.2,0.8-0.5,0.8-1
			c0-0.3-0.1-0.5-0.4-0.7C419.5,249.5,419,249.9,418.5,250z"
        />
        <path
          class="st0"
          d="M516,247.4c-0.3,0.1-0.6,0.3-0.7,0.5c0.8-0.1,1.5-0.1,2.3-0.1C517.3,247.4,516.6,247.2,516,247.4z"
        />
        <path
          class="st0"
          d="M516.1,249.5c0.2,0,0.3,0,0.5,0s0.3-0.1,0.4-0.2h-0.1C516.7,249.4,516.4,249.5,516.1,249.5z"
        />
        <path
          class="st0"
          d="M610.4,185.4c-0.6,0.1-1.2,0.8-1,1.3c0.1,0.5,0.7,0.8,1.4,0.7s1.2-0.6,1.1-1.2
			C611.7,185.6,611,185.3,610.4,185.4z"
        />
        <path
          class="st0"
          d="M515.7,236.5c-0.2-0.5-0.8-0.8-1.5-0.6s-1.2,0.8-1.1,1.3c0.1,0.5,0.9,0.9,1.5,0.7
			C515.3,237.8,515.9,237,515.7,236.5z"
        />
        <path
          class="st0"
          d="M599.4,247.7c-0.7,0.1-1.2,0.7-1.1,1.3c0.1,0.6,0.7,0.9,1.4,0.8c0.7-0.1,1.2-0.7,1.1-1.2
			C600.8,247.9,600.1,247.5,599.4,247.7z"
        />
        <path
          class="st0"
          d="M486.7,235.6c0.7-0.2,1.3-0.5,1.3-1.2c-0.5-0.5-1-0.9-1.5-1.4c-0.7,0-1.1,0.3-1,0.7
			C485.7,234.4,485.9,235.1,486.7,235.6z"
        />
        <path
          class="st0"
          d="M480.6,226.4c0.3,0.2,0.7,0.3,1.1,0.3c0.5-0.1,1-0.4,1-1c0-0.4-0.1-0.8-0.7-0.8s-1.1,0.1-1.7,0.1
			C480.1,225.5,480.1,226,480.6,226.4z"
        />
        <path
          class="st0"
          d="M525.4,260.7c-0.7,0.1-1.1,0.7-1,1.3c0.1,0.5,0.8,0.9,1.5,0.7c0.6-0.2,1-0.7,0.9-1.2
			C526.8,260.9,526.1,260.5,525.4,260.7z"
        />
        <path
          class="st0"
          d="M548.3,237.2c-0.7,0.1-1.2,0.7-1.1,1.2c0.1,0.5,0.6,0.8,1.3,0.7s1.2-0.7,1.1-1.2
			C549.5,237.4,548.9,237.1,548.3,237.2z"
        />
        <path
          class="st0"
          d="M417.6,251.8c-1.2,0.2-1.5,1-0.6,1.9c0.5-0.2,1.1-0.4,1.6-0.7c0.2-0.2,0.4-0.8,0.2-0.9
			C418.6,251.9,418,251.7,417.6,251.8z"
        />
        <path
          class="st0"
          d="M479.5,224.4c-0.5-0.1-0.9-0.2-1.1-0.6c-0.2-0.4-0.7-0.5-1.2-0.2c-0.4,0.2-0.4,0.8,0.1,1.1s1.1,0.5,1.7,0.9
			c0.4-0.2,0.8-0.4,1.1-0.6C480,224.8,479.8,224.5,479.5,224.4z"
        />
        <path
          class="st0"
          d="M541.8,185.9c0.2,0,0.5,0,0.6-0.1c0.4-0.3,0.9-0.8,1-1.2s-0.2-0.6-0.7-0.7c-0.3,0.6-0.4,1.2-0.3,1.9
			c-0.3,0-0.5,0-0.7,0C541.8,185.8,541.8,185.9,541.8,185.9z"
        />
        <path
          class="st0"
          d="M601.9,231.9c0.2-1.2,0.3-2.3,0.5-3.4C600.5,229.9,600.4,230.9,601.9,231.9z"
        />
        <path
          class="st0"
          d="M386,226.9c0,0.3,0,0.5,0,0.8c-0.1,0-0.1,0-0.2-0.1c0.1,0.3,0.3,0.5,0.4,0.6l0,0c0.6-0.3,1.2-0.3,1.7-0.1l0,0
			c0.1,0,0.1-0.1,0.2-0.1c-0.4-0.5-0.7-1.1-1.5-1.3C386.5,226.7,386.3,226.8,386,226.9z"
        />
        <path
          class="st0"
          d="M489.1,209.3c-0.7-0.2-1.2,0.1-1.9,1.4c1.6,0.5,2.1,0.4,2.4-0.2C490,210,489.7,209.4,489.1,209.3z"
        />
        <path
          class="st0"
          d="M577.8,206.4c0.3,1.3,0.4,1.3,2.2,1.7C580,206.5,579.4,206.1,577.8,206.4z"
        />
        <path
          class="st0"
          d="M490,255.8c-0.7,0.8-0.6,1.4,0,1.9c0.9-0.1,1.5-0.5,1.5-1.1C491.5,255.8,490.7,255.8,490,255.8z"
        />
        <path
          class="st0"
          d="M497.1,257.5c-0.1-0.5-0.7-0.9-1.2-0.8s-0.8,0.6-0.7,1.2c0.1,0.6,0.7,0.9,1.2,0.8S497.2,258,497.1,257.5z"
        />
        <path
          class="st0"
          d="M544.6,188.3c-0.1-0.2-0.3-0.3-0.4-0.5c0,0,0-0.1-0.1-0.1c-1.1,0.9-1,1,0,1.8c0.5-0.4,0.8-0.7,1-0.9
			C545,188.6,544.8,188.5,544.6,188.3z"
        />
        <path
          class="st0"
          d="M445.9,254.3c0.7,0.4,1.2,0,1.8-0.7c-0.5-0.4-1-0.8-1.5-1.2C445.2,253.5,445.1,253.9,445.9,254.3z"
        />
        <path
          class="st0"
          d="M414.8,252.4c0.8-0.2,1.3-0.6,1.5-1.5c-1.2,0.2-2.3,0.2-3.3,0.7C413.5,252.3,414,252.6,414.8,252.4z"
        />
        <path
          class="st0"
          d="M337,247c-0.3,0.1-0.7,0.3-0.8,0.6c-0.1,0.1-0.1,0.3-0.1,0.4c0,0.2,0.2,0.4,0.4,0.5c0.2,0.1,0.5,0.2,0.8,0.2
			c0.6-0.1,1.1-0.6,1-1.1C338.1,247.2,337.5,246.9,337,247z"
        />
        <path
          class="st0"
          d="M533.7,204c-0.5,0.2-1,0.4-1.6,0.7c0-0.1-0.1-0.1-0.1-0.2c-0.1-0.1-0.2-0.2-0.3-0.3c-0.1,0.3,0.3,0.6,1.3,1
			C533.4,204.6,533.7,204.3,533.7,204L533.7,204L533.7,204C533.6,204,533.7,204,533.7,204z"
        />
        <path
          class="st0"
          d="M362.9,270.1c-0.5,0.1-1,0.6-0.9,1.1s0.8,0.8,1.4,0.6c0.5-0.2,0.9-0.7,0.7-1.1
			C364.1,270.2,363.5,270,362.9,270.1z"
        />
        <path
          class="st0"
          d="M586.7,230.5c0.1,0.9,0.7,1.3,1.9,1.5C589,230.4,588.4,230,586.7,230.5z"
        />
        <path
          class="st0"
          d="M438.6,249.5c-0.5,0.1-1.1,0.7-0.8,1c0.2,0.3,0.7,0.5,1.1,0.6c0.5,0.1,1-0.5,1-0.9
			C439.8,249.7,439.2,249.4,438.6,249.5z"
        />
        <path
          class="st0"
          d="M447.1,246.4c-0.2,0.2-0.2,0.7-0.1,0.9c0,0.1,0.7,0.1,1,0c0.5-0.2,0.9-0.5,1.4-0.9
			C448.2,245.7,447.6,245.7,447.1,246.4z"
        />
        <path
          class="st0"
          d="M423.8,255.9c-0.4,0.2-0.7,0.5-1.3,1c0.6,0.3,1,0.6,1.5,0.6c0.6,0.1,1.1-0.6,1-1
			C424.8,256,424.3,255.7,423.8,255.9z"
        />
        <path
          class="st0"
          d="M439.5,238.2c-0.2,0.8-0.2,1.5,0.9,2.1c-0.1-1.1,0.8-2-0.2-3C439.9,237.7,439.6,237.9,439.5,238.2z"
        />
        <path
          class="st0"
          d="M539,215.9c0.1,0.4,0.7,0.7,1.2,0.6c0.4-0.1,0.8-0.5,0.8-0.8c0,0,0,0,0-0.1s0-0.1-0.1-0.2
			c-0.2-0.3-0.7-0.5-1.1-0.5C539.4,214.9,538.9,215.5,539,215.9z"
        />
        <path
          class="st0"
          d="M575.4,202.5c0.5-0.1,1-0.8,0.7-1.1c-0.2-0.3-0.7-0.4-1.1-0.5c-0.5,0-0.9,0.6-0.8,1
			C574.3,202.4,574.9,202.6,575.4,202.5z"
        />
        <path
          class="st0"
          d="M347.7,239.9c-0.2,0.3-0.4,0.7-0.7,1c-0.3,0.3-0.7,0.5-1,0.8c0.2,0.3,0.4,0.5,0.7,0.9l0,0c0,0,0-0.1,0.1-0.1
			c0.3-0.4,0.7-0.8,1.1-1.2c0.1-0.1,0.1-0.1,0.2-0.2c0.3-0.3,0.4-0.7,0.2-1.2C348,239.9,347.8,239.9,347.7,239.9z"
        />
        <path
          class="st0"
          d="M456.1,257.5c0.2,0.8,0.8,1.3,2.1,1C457.7,257.1,457.4,257,456.1,257.5z"
        />
        <path
          class="st0"
          d="M450.1,230.3c-0.3-1-0.5-1.2-1.2-0.9c-0.6,0.2-0.7,0.6-0.6,1S449,230.8,450.1,230.3z"
        />
        <path
          class="st0"
          d="M518.5,254.7c0.1,0.1,0.2,0.3,0.3,0.4c0.5-0.3,0.8-0.5,1-0.7c0.3-0.3,0.1-0.6-0.2-1.2
			C518.3,254,518.1,254.2,518.5,254.7z"
        />
        <path
          class="st0"
          d="M478,225.8c-0.1-0.1-0.2-0.2-0.3-0.2c0.2,0.2,0.3,0.5,0.4,0.7C478.1,226.2,478.1,226,478,225.8z"
        />
        <path
          class="st0"
          d="M513,248.2c-0.4-0.3-0.9-0.2-1.9,0.1c0.3,0.6,0.8,1,1.5,1c0.2,0,0.5-0.1,0.6-0.3c0.1-0.1,0.1-0.2,0.1-0.3
			c-0.2-0.1-0.4-0.3-0.6-0.5C512.8,248.2,512.9,248.2,513,248.2z"
        />
        <path
          class="st0"
          d="M379.2,253.3c-0.1,0.3-0.1,0.7,0.1,0.9c0.4,0.5,0.9,0.4,1.9-0.4c-0.4-0.3-0.7-0.6-1-0.7
			C379.9,253.1,379.3,253.2,379.2,253.3z"
        />
        <path
          class="st0"
          d="M496.9,230.2c-0.3,0.1-0.7,0.5-0.8,0.7c-0.1,0.4,0.4,0.7,1.1,0.6c0.1-0.2,0.5-0.4,0.6-0.7
			C497.9,230.4,497.3,230,496.9,230.2z"
        />
        <path
          class="st0"
          d="M497.3,269.5c-0.5,1-0.5,1,0.8,1.7C498.4,269.9,498.4,269.9,497.3,269.5z"
        />
        <path
          class="st0"
          d="M439.6,244.8c-0.6-0.3-1,0.1-1.5,0.6c0.6,0.6,0.6,0.6,1.4,0.7C440,245.7,440.3,245.2,439.6,244.8z"
        />
        <path
          class="st0"
          d="M374.9,243.4c0.2-0.6-0.3-0.7-0.8-0.9l0,0c-0.2,0-0.5-0.1-0.7-0.1c0.1,0.9,0.8,1.4,1.6,2.3
			C374.9,244,374.8,243.7,374.9,243.4z"
        />
        <path
          class="st0"
          d="M350.7,235.3c0.1-0.2-0.1-0.6-0.3-0.7c-0.9-0.3-1.1,0.3-1.4,0.9C350.1,235.9,350.5,235.9,350.7,235.3z"
        />
        <path
          class="st0"
          d="M487.7,261.4C487.7,261.4,487.6,261.4,487.7,261.4C487.6,261.4,487.6,261.4,487.7,261.4
			c-0.3,0.3-0.5,0.5-0.8,0.8c0.4,0.3,0.7,0.5,1,0.6c0.4,0.1,0.8-0.6,0.6-0.9C488.3,261.6,488,261.5,487.7,261.4z"
        />
        <path
          class="st0"
          d="M570.2,205.1c0.5,0.5,1,0.9,1.9,0.9C572.1,204.6,571.8,204.4,570.2,205.1z"
        />
        <path
          class="st0"
          d="M506.8,252.3c0,0.4-0.2,0.9,0,1c0.4,0.3,1,0.5,1.6,0C508.3,252.6,507.7,252.4,506.8,252.3z"
        />
        <path
          class="st0"
          d="M446.7,250c-0.3,0.5-0.8,1,0,1.2c0.5,0.2,1.3-0.1,1.3-0.5C448,250,447.3,250.1,446.7,250z"
        />
        <path
          class="st0"
          d="M448.7,242.4c0.6,0.4,1.1-0.1,1.6-0.7c-0.4-0.2-0.6-0.4-1-0.7C448.9,241.6,448,242,448.7,242.4z"
        />
        <path
          class="st0"
          d="M498.1,241.9c0.2,0.2,0.5,0.4,0.8,0.4c0.4,0,0.8-0.2,1.3-0.3c-0.3-0.3-0.6-0.6-0.9-0.7c-0.2-0.1-0.7,0-1,0.2
			C498.1,241.5,498,241.8,498.1,241.9z"
        />
        <path
          class="st0"
          d="M365.9,261c-0.3,0-0.6,0.4-1.1,0.8c0.5,0.2,0.9,0.5,1.2,0.5c0.3-0.1,0.7-0.5,0.7-0.7
			C366.7,261.3,366.2,261,365.9,261z"
        />
        <path
          class="st0"
          d="M497.7,256c0.2-0.1,0.2-0.6,0.1-0.7c-0.3-0.3-0.7-0.6-1.1-0.8c-0.2,0.1-0.3,0.2-0.5,0.4
			c0.2,0.4,0.3,0.9,0.6,1.2C496.8,256.2,497.5,256.2,497.7,256z"
        />
        <path
          class="st0"
          d="M371.2,243.7c0.3,0.8,1.4,0.5,1.9,1C373.5,243.7,373.1,243.5,371.2,243.7z"
        />
        <path
          class="st0"
          d="M504.4,258.3c-0.3,1-0.3,1.1,1.3,1.4C505.6,259,505.4,258.5,504.4,258.3z"
        />
        <path
          class="st0"
          d="M359.1,242c0.1,0.1,0.2,0.1,0.3,0.2c0-0.2,0-0.3,0-0.5c-0.2,0-0.3,0.1-0.5,0.1C358.9,241.9,359,242,359.1,242
			z"
        />
        <path
          class="st0"
          d="M601.8,205.1c-0.2,0.3-0.5,0.6-0.5,0.8c0,0.4,0.4,0.6,0.9,0.5s0.7-0.5,0.5-0.8
			C602.6,205.3,602.2,205.3,601.8,205.1z"
        />
        <path
          class="st0"
          d="M552,188c0.1,0.6,0.4,0.9,1.2,1.2c-0.3-0.3-0.7-0.6-0.6-0.8v-0.1C552.4,188.3,552.2,188.2,552,188z"
        />
        <path
          class="st0"
          d="M378.9,263.8c-0.3,0.1-0.4,0.4-0.7,0.8c0.5,0.1,0.9,0.3,1.2,0.2c0.2-0.1,0.5-0.5,0.4-0.7
			C379.9,263.6,379.4,263.6,378.9,263.8z"
        />
        <path
          class="st0"
          d="M524.6,209.1c0.2,0.1,0.5,0.1,0.8,0c0.1,0,0.2-0.4,0.1-0.5c-0.2-0.6-0.7-0.7-1.4-0.2
			C524.2,208.6,524.3,208.9,524.6,209.1z"
        />
        <path
          class="st0"
          d="M501.4,239.1c0,0.1,0,0.3,0.1,0.4c0.7,0.2,1.1,0,1.5-0.8C502.3,238.5,501.7,238.5,501.4,239.1z"
        />
        <path
          class="st0"
          d="M407.5,251.6c-0.2,0.2-0.4,0.4-0.8,0.7c0.5,0.2,0.8,0.4,1.1,0.4c0.1,0,0.5-0.5,0.5-0.6
			C408.1,251.9,407.7,251.7,407.5,251.6z"
        />
        <path
          class="st0"
          d="M471.7,259.2c-0.4,0.5-0.8,0.9-0.2,1.4C472.4,259.7,472.4,259.7,471.7,259.2z"
        />
        <path
          class="st0"
          d="M460,242.2c0.1,0.6-0.4,1.1,0.3,1.5C461.3,242.7,461.3,242.7,460,242.2z"
        />
        <path
          class="st0"
          d="M491.4,221.3c0,0.1,0,0.1,0,0.2c0.6,0.2,1.1,0.4,1.9,0.6c-0.1-0.6-0.4-0.9-0.8-1
			C492.1,221.1,491.7,221.2,491.4,221.3z"
        />
        <path
          class="st0"
          d="M508.4,250.9c-0.1,0-0.3,0.2-0.3,0.3c0.1,0.6,0.6,0.7,1.5,0.5C509.5,251,509.2,250.7,508.4,250.9z"
        />
        <path
          class="st0"
          d="M367.8,243.3c-0.1,0.1-0.2,0.1-0.4,0.2c0.1,1.1,0.1,1.1,1.2,1.4C368.3,244.3,368,243.8,367.8,243.3z"
        />
        <path
          class="st0"
          d="M424.5,243.6c-0.3-1-0.3-1-1.6-0.9C423.5,243.1,423.5,243.8,424.5,243.6z"
        />
        <path
          class="st0"
          d="M380.2,250.6c-0.1,0.8,0.1,1.2,0.8,1.5C381.4,251.2,381.4,251.2,380.2,250.6z"
        />
        <path
          class="st0"
          d="M451.1,245.8C451.1,245.8,451.2,245.7,451.1,245.8C451.2,245.7,451.2,245.7,451.1,245.8
			C451.2,245.7,451.1,245.7,451.1,245.8C451.1,245.7,451.1,245.7,451.1,245.8z"
        />
        <path
          class="st0"
          d="M450.5,247.4c0.4-0.3,0.8-0.5,1.2-0.7c-0.2-0.3-0.4-0.6-0.5-0.9c-0.3,0.4-0.6,0.7-0.9,1.1
			C450.2,247,450.4,247.1,450.5,247.4z"
        />
        <path
          class="st0"
          d="M531.9,222.1c-0.3,0.4-0.6,0.8-0.9,1.2c0.1,0.1,0.2,0.1,0.3,0.2c0.4-0.2,0.6-0.3,0.8-0.4
			C531.9,222.8,531.9,222.5,531.9,222.1z"
        />
        <path
          class="st0"
          d="M501.5,248.2c0.1,0.3,0.4,0.5,0.7,0.8c0.3-0.4,0.6-0.6,0.6-0.7c-0.2-0.3-0.5-0.4-0.8-0.6
			C501.9,247.9,501.5,248.1,501.5,248.2z"
        />
        <path
          class="st0"
          d="M493.5,261.9c-0.2,0-0.5,0.4-0.8,0.7c0,0-0.1,0-0.1,0.1c0.4,0.1,0.8,0.3,1.3,0.4
			C494.2,262.4,494.2,261.9,493.5,261.9z"
        />
        <path
          class="st0"
          d="M502.8,218.6c-0.2-0.2-0.5-0.3-0.8-0.4c-0.1,0-0.3,0.3-0.7,0.6c0.5,0.1,0.8,0.3,1.2,0.3
			C502.6,219.1,502.9,218.6,502.8,218.6z"
        />
        <path
          class="st0"
          d="M377.3,247.7c0.3,0.4,0.6,0.7,1.2,1.4c0.1-0.6,0.3-0.9,0.2-1.1C378.4,247.7,378.1,247.2,377.3,247.7z"
        />
        <path
          class="st0"
          d="M593.7,192.6c0.6-0.7,0.6-0.7,0-1.3C593.2,191.8,593.3,192.2,593.7,192.6z"
        />
        <path
          class="st0"
          d="M559.5,201.7c0,0.5,0.2,0.8,0.6,0.9c0.2,0.1,0.4,0.1,0.6,0.1c0.1-0.4,0-0.6-0.1-0.8S560.1,201.7,559.5,201.7z
			"
        />
        <path
          class="st0"
          d="M503.6,264.2c-0.4,0.9,0.2,1.1,1,1.2C504.6,264.7,504.6,264.2,503.6,264.2z"
        />
        <path
          class="st0"
          d="M491.3,213.6c-0.5-0.1-0.8-0.2-1.2-0.3c-0.1,0.1-0.2,0.2-0.3,0.3c0.3,0.4,0.5,0.7,0.9,1.3
			C490.9,214.2,491.1,213.9,491.3,213.6z"
        />
        <path
          class="st0"
          d="M442.9,237.7c-0.2-0.2-0.5-0.3-0.8-0.3c-0.2,0-0.4,0.3-0.6,0.5c0.3,0.2,0.6,0.3,1,0.6
			C442.7,238.1,443,237.8,442.9,237.7z"
        />
        <path
          class="st0"
          d="M353,228.2c-0.4,1.2-0.4,1.2,0.9,1.6C353.5,229.2,353.3,228.8,353,228.2z"
        />
        <path
          class="st0"
          d="M340.6,241.5c0.2,0.3,0.4,0.6,0.8,1.1C341.9,241.6,341.5,241.4,340.6,241.5z"
        />
        <path
          class="st0"
          d="M351.8,227.2c0.4,0.1,0.7,0.2,0.9,0.2c0.3-0.2,0.6-0.5,0.9-0.7c-0.1-0.1-0.2-0.2-0.3-0.3
			C352.7,226.6,352,226.6,351.8,227.2z"
        />
        <path
          class="st0"
          d="M441.6,239.8c0.2,0.1,0.6,0.3,0.7,0.2c0.2-0.2,0.4-0.4,0.5-0.7c0-0.1-0.3-0.2-0.6-0.4
			C442,239.3,441.8,239.6,441.6,239.8z"
        />
        <path
          class="st0"
          d="M490.5,235.2c0,0,0,0.1-0.1,0.3c1,0.3,1.1,0.3,1.3,0c0.1-0.1,0.1-0.3,0.1-0.4
			C491.4,234.7,490.9,234.9,490.5,235.2z"
        />
        <path
          class="st0"
          d="M488.1,222c-0.3,0-0.7,0-1-0.1c0,0.2-0.1,0.3-0.1,0.5c0.3,0,0.7,0.1,1,0.1C488,222.4,488.1,222.2,488.1,222z"
        />
        <path
          class="st0"
          d="M495.2,248.3c-0.1,0-0.4,0.1-0.4,0.2c-0.2,0.5,0.1,0.7,0.8,0.8C495.8,248.8,495.9,248.4,495.2,248.3z"
        />
        <path
          class="st0"
          d="M469,259.9c-0.1,0.2-0.3,0.5-0.4,0.7c0,0.1,0.3,0.2,0.6,0.4c0.1-0.4,0.3-0.6,0.3-0.9
			C469.5,260.1,469.2,260,469,259.9z"
        />
        <path
          class="st0"
          d="M455.9,253.9c0.4,0.1,0.7,0.2,0.7,0.2c0.2-0.2,0.4-0.5,0.5-0.7l-0.4-0.2C456.5,253.4,456.3,253.6,455.9,253.9
			z"
        />
        <path
          class="st0"
          d="M540.6,213.8c-0.7-0.3-1.1-0.1-1.4,0.6C540,214.5,540.4,214.3,540.6,213.8z"
        />
        <path
          class="st0"
          d="M491.2,232c-0.2,0.1-0.4,0.3-0.7,0.5c0.3,0.1,0.6,0.3,0.7,0.3c0.2-0.1,0.4-0.3,0.5-0.5
			C491.7,232.2,491.3,232,491.2,232z"
        />
        <path
          class="st0"
          d="M491.5,243.6c0.2,0.1,0.5,0.2,0.7,0.2s0.4-0.2,0.7-0.4c-0.2-0.1-0.4-0.3-0.6-0.3s-0.5,0-0.7,0.1
			C491.6,243.3,491.5,243.6,491.5,243.6z"
        />
        <path
          class="st0"
          d="M355.7,227.6c-0.6-0.2-1-0.7-1.5,0.1C354.6,228,355,228.2,355.7,227.6z"
        />
        <path
          class="st0"
          d="M433.7,237.6c0-0.1-0.4-0.3-0.5-0.2c-0.2,0.1-0.4,0.3-0.6,0.6c0.3,0.1,0.6,0.2,0.7,0.2
			C433.5,238,433.7,237.8,433.7,237.6z"
        />
        <path
          class="st0"
          d="M462.1,249.1c-0.8,0.6-0.8,0.6-0.5,0.8c0.2,0.1,0.5,0.1,0.9,0.3C462.3,249.7,462.2,249.4,462.1,249.1z"
        />
        <path
          class="st0"
          d="M455.9,239.9C455.9,239.9,456,239.9,455.9,239.9C456,239.8,456,239.8,455.9,239.9
			C455.9,239.8,455.9,239.8,455.9,239.9C455.9,239.8,455.9,239.9,455.9,239.9z"
        />
        <path
          class="st0"
          d="M455.3,241.4c0.7-0.5,1-1,0.6-1.5C455.5,240.3,455.1,240.8,455.3,241.4z"
        />
        <path
          class="st0"
          d="M467.1,250.5c-0.2,0.2-0.4,0.3-0.7,0.6c0.4,0.1,0.6,0.2,0.7,0.2c0.2-0.1,0.4-0.3,0.4-0.4
			C467.5,250.8,467.2,250.7,467.1,250.5z"
        />
        <path
          class="st0"
          d="M374.1,249.6c0-0.1-0.2-0.2-0.5-0.4c-0.3,0.3-0.4,0.5-0.6,0.7c0.2,0.1,0.4,0.3,0.5,0.2
			C373.8,250,374,249.8,374.1,249.6z"
        />
        <path
          class="st0"
          d="M495,234c-0.2,0.3-0.3,0.5-0.4,0.7c0.2,0.1,0.5,0.2,0.7,0.2c0.1,0,0.4-0.3,0.3-0.4
			C495.6,234.3,495.3,234.2,495,234z"
        />
        <path
          class="st0"
          d="M361.4,255.7c-0.1,0.2-0.2,0.5-0.2,0.7c0,0.1,0.4,0.3,0.4,0.3c0.2-0.1,0.4-0.3,0.5-0.5c0-0.1-0.2-0.2-0.3-0.4
			C361.7,255.8,361.5,255.7,361.4,255.7z"
        />
        <path
          class="st0"
          d="M451.2,245.7c1.1-0.2,1.2-0.3,0.7-1.3C451.7,244.8,451.4,245.3,451.2,245.7z"
        />
        <path
          class="st0"
          d="M593.2,189.4c0,0.2,0.3,0.3,0.7,0.5c0.2-0.3,0.3-0.5,0.3-0.7c0-0.1-0.4-0.3-0.5-0.3
			C593.5,189,593.2,189.3,593.2,189.4z"
        />
        <path
          class="st0"
          d="M530.7,259c0.3,0.1,0.6,0.1,0.8,0.2c0.1-0.2,0.2-0.3,0.2-0.5c-0.2-0.1-0.5-0.1-0.7-0.2
			C531,258.6,530.8,258.8,530.7,259z"
        />
        <path
          class="st0"
          d="M576.5,211.1c0.3-0.3,0.6-0.5,0.8-0.8c0,0-0.1-0.2-0.3-0.4c-0.3,0.4-0.6,0.7-0.8,1
			C576.3,211,576.4,211.1,576.5,211.1z"
        />
        <path
          class="st0"
          d="M599.2,188l0.2,0.2c0.3-0.2,0.5-0.4,0.8-0.6c-0.2-0.1-0.3-0.2-0.5-0.3C599.6,187.5,599.3,187.7,599.2,188z"
        />
        <path
          class="st0"
          d="M379.6,244.8c0-0.7-0.8-0.6-1.2-0.7C378.5,244.5,378.8,244.9,379.6,244.8z"
        />
        <path
          class="st0"
          d="M378.3,244.1C378.3,244,378.3,244,378.3,244.1C378.3,244,378.3,244,378.3,244.1
			C378.2,244,378.2,244,378.3,244.1L378.3,244.1z"
        />
        <path
          class="st0"
          d="M521.7,228.2c-0.3-0.4-0.4-0.6-0.7-1.1C520.8,227.9,520.8,228.2,521.7,228.2z"
        />
        <path
          class="st0"
          d="M497.9,245.3C497.9,245.2,498,245.2,497.9,245.3c0.1,0,0.1-0.1,0.1-0.1S498,245.2,497.9,245.3
			C497.9,245.2,497.9,245.2,497.9,245.3z"
        />
        <path
          class="st0"
          d="M497.9,245.3c-0.6,0.1-1.1,0.2-1.7,0.4C497,246.1,497,246.1,497.9,245.3z"
        />
        <path
          class="st0"
          d="M550.7,192.7c-0.1,0.2-0.1,0.3-0.2,0.5c0.2,0,0.3,0,0.4,0C550.9,193.1,550.9,192.9,550.7,192.7z"
        />
        <path
          class="st0"
          d="M550.9,193.3c-0.1,0.1-0.2,0.1-0.3,0.2c0,0-0.1-0.1-0.2-0.2c-0.1,0.2-0.2,0.4-0.2,0.6
			C550.6,193.7,550.9,193.5,550.9,193.3z"
        />
        <path
          class="st0"
          d="M495.1,235.9c0,0.1,0.2,0.3,0.4,0.5c0.3-0.3,0.4-0.5,0.6-0.7c-0.2-0.1-0.4-0.3-0.6-0.2
			C495.4,235.5,495.2,235.7,495.1,235.9z"
        />
        <path
          class="st0"
          d="M514.8,213.2c0.1,0.1,0.1,0.2,0.2,0.3c0.2-0.1,0.4-0.1,0.6-0.2c0.1-0.1,0.2-0.3,0.3-0.4
			c-0.1,0-0.1-0.1-0.2-0.1C515.4,212.9,515.1,213,514.8,213.2z"
        />
        <path
          class="st0"
          d="M597.7,184.7c-0.5,0.1-0.7,0.3-0.6,0.7c0,0.1,0.3,0.2,0.4,0.1C597.9,185.3,598,185,597.7,184.7z"
        />
        <path
          class="st0"
          d="M364.1,245.1C364.1,245.2,364.1,245.2,364.1,245.1c0-0.3-0.1-0.5-0.2-0.7h-0.1c0,0.1,0.1,0.2,0.1,0.3
			C364,244.9,364,245,364.1,245.1z"
        />
        <path
          class="st0"
          d="M457.7,245.3c0.2-0.2,0.3-0.4,0.4-0.6c0,0-0.3-0.2-0.4-0.1c-0.2,0.1-0.4,0.3-0.7,0.5
			C457.3,245.2,457.6,245.4,457.7,245.3z"
        />
        <path
          class="st0"
          d="M450.8,231.9C450.8,231.9,450.8,232,450.8,231.9h0.1H450.8L450.8,231.9z"
        />
        <path
          class="st0"
          d="M449.9,231.3c-0.1,0-0.3,0.3-0.3,0.3c0.1,0.5,0.7,0.3,1.1,0.3C450.7,231.5,450.6,231.2,449.9,231.3z"
        />
        <path
          class="st0"
          d="M448.4,233c0.1-0.2,0.3-0.5,0.4-0.7c-0.2,0-0.4-0.1-0.4-0.1c-0.2,0.2-0.3,0.4-0.5,0.6
			C448.2,232.9,448.3,233,448.4,233z"
        />
        <path
          class="st0"
          d="M570.6,208c-0.3,0-0.6-0.1-0.8,0c-0.2,0-0.5,0.1-0.7,0.2c0,0.1,0,0.1,0,0.2c0.5,0,1-0.1,1.5-0.1
			C570.7,208.2,570.6,208.1,570.6,208z"
        />
        <path
          class="st0"
          d="M343.2,237.1c0.1,0.1,0.2,0.2,0.3,0.3c0.3-0.2,0.7-0.4,1-0.6c-0.1-0.1-0.1-0.2-0.2-0.2
			C344,236.8,343.6,236.9,343.2,237.1z"
        />
        <path
          class="st0"
          d="M562.1,185.2c0.1,0.1,0.3,0.3,0.4,0.4c0.1-0.1,0.2-0.1,0.3-0.2c-0.1-0.1-0.3-0.2-0.4-0.4
			C562.3,185.1,562.2,185.1,562.1,185.2z"
        />
        <path
          class="st0"
          d="M392.9,233.1c0.1-0.3,0-0.5-0.3-0.7c0,0.2,0,0.4,0,0.6C392.7,233,392.8,233,392.9,233.1z"
        />
        <path
          class="st0"
          d="M499.5,269.7c0.1,0.2,0.2,0.4,0.3,0.7c0.2,0,0.3-0.1,0.5-0.1c-0.1-0.2-0.3-0.4-0.4-0.6
			C499.7,269.6,499.6,269.6,499.5,269.7z"
        />
        <path
          class="st0"
          d="M548.1,181.9c-0.4-0.2-0.8-0.5-1.1,0.1c0,0.1,0.1,0.2,0.1,0.2C547.5,182.1,547.8,182,548.1,181.9z"
        />
        <path
          class="st0"
          d="M374.2,257.9c-0.3-0.5-0.5-0.7-0.7-1c-0.1,0.1-0.3,0.1-0.4,0.2C373.1,257.4,373.2,257.8,374.2,257.9z"
        />
        <path
          class="st0"
          d="M549.9,183.9c0.2,0.1,0.4,0.1,0.6,0.1c0.2,0,0.5-0.1,0.8-0.1C550.8,183.8,550.4,183.3,549.9,183.9z"
        />
        <path
          class="st0"
          d="M375.1,241.9c0.2,0.3,0.3,0.6,0.5,0.8c0.1,0,0.2-0.1,0.3-0.1c-0.2-0.3-0.4-0.5-0.6-0.8
			C375.3,241.8,375.2,241.8,375.1,241.9z"
        />
        <path
          class="st0"
          d="M496.1,244.3c-0.5,0.5-0.7,1,0,1.3c-0.1-0.2-0.1-0.4-0.1-0.6C495.9,244.7,496,244.5,496.1,244.3z"
        />
        <path
          class="st0"
          d="M484.4,231.5c0,0,0.4-0.2,0.4-0.3c0-0.5-0.3-0.5-1-0.3C484,231.1,484.2,231.3,484.4,231.5z"
        />
        <path
          class="st0"
          d="M458.7,247.8c0.1,0.1,0.3,0.3,0.4,0.3c0.2,0,0.3-0.2,0.6-0.4c-0.2-0.1-0.3-0.3-0.4-0.3
			C459,247.5,458.8,247.7,458.7,247.8z"
        />
        <path
          class="st0"
          d="M511.7,252.7c-0.4-0.2-0.7-0.4-1.2-0.7C510.6,252.9,511,252.9,511.7,252.7z"
        />
        <path
          class="st0"
          d="M447.8,270.7c0,0.1,0,0.2,0.1,0.2c0.5,0.2,0.7-0.1,0.9-0.4C448.4,270.2,448.1,270.2,447.8,270.7z"
        />
        <path
          class="st0"
          d="M408.8,242.5L408.8,242.5c-0.1,0.2-0.1,0.4-0.2,0.6c0,0,0,0.1-0.1,0.1l0.1-0.1c0.2-0.1,0.3-0.3,0.5-0.4
			C409.1,242.6,409,242.5,408.8,242.5z"
        />
        <path
          class="st0"
          d="M448.8,237.2c-0.3,0.1-0.5,0.2-0.8,0.3c0.1,0.2,0.2,0.5,0.3,0.7C448.8,237.9,448.9,237.6,448.8,237.2z"
        />
        <path
          class="st0"
          d="M490.8,228.1c-0.2,0-0.4,0.2-0.5,0.3c0,0.1,0.2,0.2,0.4,0.4c0.2-0.2,0.5-0.4,0.5-0.5
			C491.2,228.3,490.9,228.1,490.8,228.1z"
        />
        <path
          class="st0"
          d="M524.4,204.7c0.1,0.3,0.2,0.6,0.3,0.9C525.1,204.9,525.1,204.9,524.4,204.7z"
        />
        <path
          class="st0"
          d="M452.6,245.5c0,0.4,0,0.8-0.1,1.2c0.1,0,0.2,0,0.3,0c0.1-0.4,0.1-0.8,0.2-1.2
			C452.8,245.4,452.7,245.4,452.6,245.5z"
        />
        <path
          class="st0"
          d="M379.4,261.7c0.2,0.3,0.4,0.5,0.8,0.9C380.3,262,380.1,261.7,379.4,261.7z"
        />
        <path
          class="st0"
          d="M378.6,251.5c0.2-0.1,0.5-0.3,0.7-0.4c0,0-0.1-0.2-0.2-0.3c-0.2,0.2-0.5,0.4-0.7,0.5
			C378.5,251.4,378.5,251.4,378.6,251.5z"
        />
        <path
          class="st0"
          d="M489.6,227.2c0,0,0,0.2,0,0.3c0.3-0.1,0.6-0.1,0.9-0.2c0-0.1-0.1-0.2-0.1-0.3
			C490.1,227,489.9,227.1,489.6,227.2z"
        />
        <path
          class="st0"
          d="M446.5,234.7c-0.2,0.1-0.3,0.2-0.5,0.4c0.2,0.2,0.3,0.3,0.4,0.4c0.2-0.2,0.3-0.3,0.4-0.5
			C446.9,234.9,446.6,234.7,446.5,234.7z"
        />
        <path
          class="st0"
          d="M346.6,245c0.2,0.2,0.4,0.4,0.6,0.6c0.1,0,0.2-0.1,0.2-0.1c-0.2-0.2-0.3-0.5-0.5-0.7
			C346.8,244.9,346.7,244.9,346.6,245z"
        />
        <path
          class="st0"
          d="M484.6,233.6c-0.2,0-0.4,0.2-0.6,0.3c0.2,0.1,0.4,0.3,0.5,0.3c0.2-0.1,0.4-0.3,0.6-0.5
			C484.9,233.7,484.7,233.6,484.6,233.6z"
        />
        <path
          class="st0"
          d="M546,194.1c-0.1-0.2-0.2-0.5-0.3-0.7c-0.1,0.1-0.2,0.1-0.4,0.2c0.2,0.2,0.3,0.4,0.5,0.6
			C545.9,194.2,545.9,194.2,546,194.1z"
        />
        <path
          class="st0"
          d="M394.2,223.4c0.2,0.1,0.3,0.1,0.4,0.2l-0.1-0.1l-0.1-0.1C394.3,223.4,394.3,223.4,394.2,223.4z"
        />
        <path
          class="st0"
          d="M481.5,256.7c0.1,0,0.1,0,0.2,0c0-0.3,0-0.5,0-0.8c-0.1,0-0.3,0-0.4,0C481.4,256.2,481.4,256.5,481.5,256.7z"
        />
        <path
          class="st0"
          d="M502.1,260.7c0,0.1,0.2,0.2,0.3,0.3c0.1,0,0.4-0.2,0.3-0.2c-0.1-0.1-0.2-0.3-0.4-0.5
			C502.2,260.5,502,260.7,502.1,260.7z"
        />
        <path
          class="st0"
          d="M498.9,264.4c-0.2,0.4,0.1,0.6,0.7,0.6c-0.2-0.3-0.3-0.5-0.4-0.8C499.2,264.2,499,264.3,498.9,264.4z"
        />
        <path
          class="st0"
          d="M390.2,228c-0.3,0.1-0.4,0.2-0.7,0.7c0.3-0.2,0.5-0.3,0.7-0.4C390.2,228.2,390.2,228.1,390.2,228z"
        />
        <path
          class="st0"
          d="M593.1,200c0.1,0,0.2,0,0.3,0c0.1-0.3,0.1-0.5,0.2-0.8c-0.2,0-0.3,0-0.5,0C593.1,199.5,593.1,199.7,593.1,200
			z"
        />
        <path
          class="st0"
          d="M544.1,194.8c-0.1-0.1-0.3-0.1-0.4-0.2c-0.1,0.3-0.3,0.5-0.4,0.8c0.1,0,0.2,0.1,0.2,0.1
			C543.7,195.3,543.9,195,544.1,194.8z"
        />
        <path
          class="st0"
          d="M599,197.7v-0.1h-0.1h-0.1c-0.1,0.2-0.1,0.4-0.2,0.6c0.1,0,0.3,0,0.4,0C599,198,599,197.8,599,197.7z"
        />
        <path
          class="st0"
          d="M436.8,246.2c-0.2,0.1-0.3,0.2-0.5,0.4c0.2,0.1,0.4,0.2,0.5,0.2c0.1-0.1,0.3-0.2,0.3-0.3
			C437.1,246.4,436.9,246.3,436.8,246.2z"
        />
        <path
          class="st0"
          d="M498.6,268.5c0,0.3-0.1,0.4-0.1,0.6c0,0.1,0.2,0.1,0.4,0.2c0.1-0.2,0.2-0.3,0.2-0.5S498.9,268.6,498.6,268.5z
			"
        />
        <path
          class="st0"
          d="M462.4,255.6c0.2,0,0.4,0.1,0.5,0.1c0.1-0.1,0.2-0.2,0.2-0.3c-0.1,0-0.3-0.1-0.4-0.1S462.5,255.4,462.4,255.6
			z"
        />
        <path
          class="st0"
          d="M336.6,252.6c0.1,0,0.3,0,0.4,0.1c0.1-0.2,0.1-0.5,0.2-0.7c-0.1,0-0.2,0-0.3,0
			C336.8,252.1,336.7,252.4,336.6,252.6z"
        />
        <path
          class="st0"
          d="M455,247.9c0.1,0,0.2,0.1,0.3,0.1c0.1-0.2,0.2-0.4,0.3-0.6c-0.1,0-0.1,0-0.2,0
			C455.3,247.5,455.1,247.7,455,247.9z"
        />
        <path
          class="st0"
          d="M478.4,234.9L478.4,234.9c0.1,0.1,0.1,0.2,0.2,0.2c0.1-0.1,0.2-0.2,0.3-0.3c-0.2,0-0.5,0-0.7,0
			C478.3,234.8,478.3,234.9,478.4,234.9L478.4,234.9z"
        />
        <path
          class="st0"
          d="M472.2,254.9c0,0.1,0.2,0.2,0.2,0.3c0.2-0.1,0.3-0.2,0.6-0.4c-0.3-0.1-0.4-0.2-0.5-0.1
			C472.4,254.7,472.2,254.8,472.2,254.9z"
        />
        <path
          class="st0"
          d="M498.1,261.2c-0.1,0.1-0.2,0.2-0.4,0.3c0.2,0.1,0.4,0.1,0.5,0.2c0-0.1,0.1-0.2,0.1-0.4
			C498.3,261.3,498.1,261.2,498.1,261.2z"
        />
        <path
          class="st0"
          d="M382.5,254c-0.1,0.1-0.3,0.2-0.4,0.3c0.2,0.1,0.3,0.1,0.5,0.2c0.1-0.1,0.2-0.2,0.2-0.3
			C382.7,254.1,382.5,254,382.5,254z"
        />
        <path
          class="st0"
          d="M354.8,232.8c-0.2-0.2-0.3-0.5-0.5-0.7c-0.1,0.1-0.2,0.1-0.3,0.2c0.2,0.2,0.4,0.4,0.6,0.6
			C354.7,232.8,354.8,232.8,354.8,232.8z"
        />
        <path
          class="st0"
          d="M491.9,261.9c0.1,0.3,0,0.7,0.7,0.7C492.5,262.3,492.5,261.9,491.9,261.9z"
        />
        <path
          class="st0"
          d="M363.2,257.7c0-0.2,0-0.5,0-0.7c-0.1,0-0.2,0-0.3,0c0,0.2,0,0.5,0.1,0.7C363.1,257.7,363.1,257.7,363.2,257.7
			z"
        />
        <path
          class="st0"
          d="M496.5,243.6c0.3,0.2,0.5,0.3,0.7,0.4C497.1,243.8,497.2,243.4,496.5,243.6z"
        />
        <path
          class="st0"
          d="M497.4,244.2v-0.1l-0.1-0.1C497.3,244.1,497.3,244.1,497.4,244.2L497.4,244.2z"
        />
        <path
          class="st0"
          d="M543.1,217.8l-0.2,0.2c0.1,0.1,0.2,0.2,0.3,0.2c0.1-0.1,0.2-0.2,0.3-0.2C543.3,217.9,543.2,217.9,543.1,217.8
			z"
        />
        <path
          class="st0"
          d="M548.5,249.5c0.3,0.1,0.5,0.2,0.6,0.2s0.2-0.1,0.3-0.2c-0.1-0.1-0.2-0.3-0.4-0.3
			C549,249.2,548.8,249.4,548.5,249.5z"
        />
        <path
          class="st0"
          d="M352.4,242.4c0.1-0.1,0.3-0.3,0.4-0.4c-0.1,0-0.1-0.1-0.2-0.1c-0.2,0.1-0.4,0.3-0.5,0.4
			C352.2,242.3,352.3,242.3,352.4,242.4z"
        />
        <path
          class="st0"
          d="M480.7,229.7c0-0.1-0.2-0.2-0.4-0.4c-0.1,0.4-0.3,0.5-0.2,0.6c0,0.1,0.2,0.1,0.4,0.1
			C480.6,229.9,480.7,229.8,480.7,229.7z"
        />
        <path
          class="st0"
          d="M494.4,243.8c0.1,0,0.2-0.2,0.3-0.3c-0.1-0.1-0.2-0.2-0.4-0.2c-0.1,0-0.2,0.1-0.4,0.3
			C494.1,243.7,494.2,243.8,494.4,243.8z"
        />
        <path
          class="st0"
          d="M465.1,264.1c-0.1,0.2-0.2,0.3-0.2,0.4c0.1,0,0.3,0.1,0.4,0.1s0.2-0.2,0.1-0.2
			C465.3,264.3,465.2,264.2,465.1,264.1z"
        />
        <path
          class="st0"
          d="M550.4,187.2c0.1,0,0.2,0.1,0.2,0.1c0.1,0,0.1-0.1,0.2-0.1l0,0c-0.1-0.1-0.1-0.1-0.2-0.2
			C550.5,187,550.4,187.1,550.4,187.2z"
        />
        <path
          class="st0"
          d="M400.9,245.8c0.2,0.1,0.5,0.2,0.7,0.3C401.5,245.9,401.2,245.8,400.9,245.8z"
        />
        <path
          class="st0"
          d="M454.7,267.1c0,0.1,0.1,0.2,0.1,0.2c0.1-0.1,0.2-0.1,0.2-0.2c0,0-0.1-0.1-0.1-0.2
			C454.9,267,454.8,267,454.7,267.1z"
        />
        <path
          class="st0"
          d="M402.5,246.4c-0.2,0-0.5-0.1-0.7-0.1c0.2,0.1,0.4,0.2,0.6,0.4C402.4,246.5,402.4,246.4,402.5,246.4z"
        />
        <path
          class="st0"
          d="M401.7,246.3c0,0-0.1,0-0.1-0.1c0,0,0,0-0.1,0c0,0,0,0,0,0.1C401.6,246.2,401.7,246.2,401.7,246.3z"
        />
        <path
          class="st0"
          d="M467.5,262.8c0.1,0.1,0.1,0.1,0.2,0.2c0.1-0.1,0.2-0.1,0.2-0.2s-0.1-0.1-0.1-0.2
			C467.7,262.7,467.6,262.8,467.5,262.8z"
        />
        <path
          class="st0"
          d="M548.1,186.9L548,187c0.1,0.1,0.2,0.2,0.3,0.3c0.1-0.1,0.1-0.1,0.2-0.2C548.4,187,548.2,186.9,548.1,186.9z"
        />
        <path
          class="st0"
          d="M500,255.5c-0.1-0.1-0.3-0.2-0.4-0.3c-0.1,0.1-0.1,0.1-0.2,0.2c0.1,0.1,0.2,0.2,0.3,0.2
			C499.8,255.6,499.9,255.5,500,255.5z"
        />
        <path
          class="st0"
          d="M391.2,250c-0.2,0.1-0.4,0.2-0.6,0.2c0,0.1,0.1,0.1,0.1,0.2c0.2-0.1,0.4-0.1,0.7-0.2
			C391.2,250.1,391.2,250,391.2,250z"
        />
        <path
          class="st0"
          d="M356.5,230.7c0-0.4-0.1-0.7-0.1-0.9C355.9,230.1,356.3,230.3,356.5,230.7z"
        />
        <path
          class="st0"
          d="M358.4,242.8c0.1,0,0.2,0,0.3,0c0.1,0,0-0.2,0.1-0.2c-0.1,0-0.2,0-0.2,0C358.4,242.6,358.4,242.7,358.4,242.8
			z"
        />
        <path
          class="st0"
          d="M600.9,187.8c0.1,0.1,0.2,0.1,0.3,0.1s0.2,0,0.3-0.1c-0.1-0.1-0.1-0.2-0.2-0.2
			C601.1,187.7,601,187.8,600.9,187.8z"
        />
        <path
          class="st0"
          d="M501.9,223.2c0,0,0.1-0.1,0.2-0.1c-0.1,0-0.2-0.1-0.3-0.1l-0.1,0.1C501.7,223.1,501.8,223.1,501.9,223.2z"
        />
        <path
          class="st0"
          d="M447.5,239.1c0.1,0,0.2,0.1,0.3,0.1c0.1-0.2,0.2-0.4,0.3-0.6c0-0.1,0.1-0.1,0.1-0.2c-0.1,0.1-0.1,0.1-0.2,0.2
			C447.9,238.7,447.7,238.9,447.5,239.1z"
        />
        <path
          class="st0"
          d="M440.6,235.8c0,0.1,0,0.2,0.1,0.3c0,0,0.1,0,0.1-0.1C440.7,236,440.7,235.9,440.6,235.8z"
        />
        <path
          class="st0"
          d="M453.2,250.9c-0.1,0.1-0.3,0.1-0.4,0.2c0.1,0.1,0.1,0.2,0.1,0.2c0.1-0.1,0.2-0.1,0.3-0.2
			S453.2,250.9,453.2,250.9z"
        />
        <path
          class="st0"
          d="M440.5,235.7L440.5,235.7c0.1,0.1,0.1,0.1,0.1,0.1v-0.1C440.5,235.7,440.5,235.7,440.5,235.7z"
        />
        <path
          class="st0"
          d="M439.8,235.5c0.2,0,0.4,0.1,0.6,0.1c-0.1-0.1-0.3-0.3-0.4-0.4C440,235.4,439.9,235.5,439.8,235.5z"
        />
        <path
          class="st0"
          d="M551.2,217c-0.1,0-0.2,0-0.2,0.1v0.1c0,0,0,0,0.1-0.1C551.1,217.1,551.1,217.1,551.2,217z"
        />
        <path
          class="st0"
          d="M551.7,216.8c-0.2,0.1-0.3,0.2-0.5,0.3c0.2-0.1,0.4-0.1,0.6-0.2C551.8,216.8,551.7,216.8,551.7,216.8z"
        />
        <path
          class="st0"
          d="M436.6,242.2c0.2,0,0.4,0,0.5-0.1s0.1-0.2,0.1-0.3c-0.2,0-0.3,0-0.5,0.1C436.7,241.9,436.7,242.1,436.6,242.2
			z"
        />
        <path
          class="st0"
          d="M594.8,201.8c0.1-0.1,0.2-0.2,0.3-0.3c-0.1,0-0.1-0.1-0.2-0.1c-0.1,0.1-0.2,0.1-0.2,0.2
			C594.7,201.6,594.8,201.7,594.8,201.8z"
        />
        <path
          class="st0"
          d="M466.4,246.1c0,0-0.1-0.1-0.2-0.2c-0.1,0.1-0.2,0.2-0.4,0.3c0.1,0.1,0.2,0.1,0.3,0.1
			C466.2,246.3,466.3,246.2,466.4,246.1z"
        />
        <path
          class="st0"
          d="M426.7,245.7c0-0.1-0.2-0.2-0.3-0.3c-0.1,0.2-0.2,0.3-0.2,0.5c0.1,0,0.3,0.1,0.4,0.1
			C426.6,245.9,426.7,245.7,426.7,245.7z"
        />
        <path
          class="st0"
          d="M376.7,246.9c-0.1,0.1-0.2,0.1-0.3,0.2c0,0.1,0.1,0.1,0.1,0.2c0.1-0.1,0.2-0.3,0.3-0.4
			C376.8,246.9,376.7,246.9,376.7,246.9z"
        />
        <path
          class="st0"
          d="M505.2,250.3c-0.1-0.1-0.2-0.1-0.3-0.1c0,0.1-0.1,0.2,0,0.3c0,0,0.2,0,0.3,0.1
			C505.2,250.4,505.3,250.3,505.2,250.3z"
        />
        <path
          class="st0"
          d="M505.4,228.9c0.1,0,0.3,0.1,0.4,0.1s0.1-0.2,0.2-0.3c-0.1,0-0.3-0.1-0.4-0.1
			C505.5,228.7,505.5,228.8,505.4,228.9z"
        />
        <path
          class="st0"
          d="M393.1,239.6c0-0.1-0.1-0.1-0.2-0.2c-0.1,0.1-0.2,0.2-0.3,0.3c0,0,0.1,0.1,0.3,0.4
			C393,239.8,393.1,239.7,393.1,239.6z"
        />
        <path
          class="st0"
          d="M388.5,225.8c0.1,0,0.2-0.1,0.2-0.1c-0.1-0.1-0.2-0.1-0.3-0.2c-0.1,0.1-0.1,0.1-0.2,0.2
			C388.3,225.7,388.4,225.8,388.5,225.8z"
        />
        <path
          class="st0"
          d="M511.5,246.3c-0.2-0.1-0.3-0.1-0.5-0.1l-0.1,0.1c0.1,0.1,0.2,0.2,0.3,0.2
			C511.2,246.5,511.3,246.4,511.5,246.3z"
        />
        <path
          class="st0"
          d="M406.2,269.3c0.1,0,0.2-0.1,0.3-0.1c-0.1-0.1-0.2-0.3-0.3-0.4C406.2,269,406.2,269.1,406.2,269.3z"
        />
        <path
          class="st0"
          d="M351.3,249.5c0.1,0,0.2,0,0.2,0c0-0.2,0.1-0.3,0.1-0.5c-0.1,0-0.2,0-0.2,0
			C351.4,249.2,351.3,249.3,351.3,249.5z"
        />
        <path
          class="st0"
          d="M440.7,249.7c0-0.2,0.1-0.3,0.1-0.5c-0.1,0-0.2,0-0.3,0C440.6,249.3,440.6,249.5,440.7,249.7z"
        />
        <path
          class="st0"
          d="M485,222.9c-0.1-0.1-0.2-0.2-0.2-0.2c-0.1,0-0.2,0.1-0.3,0.2c0.1,0,0.2,0.1,0.3,0.1
			C484.8,223,484.9,222.9,485,222.9z"
        />
        <path
          class="st0"
          d="M459.7,255.8h0.1c0-0.1,0.1-0.2,0.1-0.2c-0.1,0-0.2,0-0.2,0C459.8,255.6,459.8,255.7,459.7,255.8z"
        />
        <path
          class="st0"
          d="M385.3,228.9l0.1-0.1l-0.1-0.1l0,0C385.2,228.8,385.3,228.9,385.3,228.9z"
        />
        <path
          class="st0"
          d="M355.6,250.8c0-0.1-0.1-0.2-0.1-0.2c-0.1,0.1-0.2,0.1-0.2,0.2c0,0.1,0.1,0.1,0.1,0.2
			C355.4,251,355.6,250.9,355.6,250.8z"
        />
        <path
          class="st0"
          d="M603.1,182c-0.1,0-0.1,0-0.2,0c0,0.2,0.1,0.3,0.1,0.5c0.1,0,0.1,0,0.2-0.1C603.3,182.3,603.2,182.1,603.1,182
			z"
        />
        <path
          class="st0"
          d="M437.6,258.9c0,0,0.2,0.1,0.3,0.1c0.1-0.1,0.1-0.3,0.2-0.4c-0.1,0-0.3-0.1-0.3,0
			C437.7,258.7,437.6,258.8,437.6,258.9z"
        />
        <path
          class="st0"
          d="M338,254.4c-0.1,0.1-0.2,0.1-0.2,0.2c0,0.1,0.1,0.1,0.1,0.2c0.1-0.1,0.2-0.1,0.3-0.2
			C338.2,254.6,338,254.5,338,254.4z"
        />
        <path
          class="st0"
          d="M476.3,223.2c-0.1,0-0.2,0-0.4,0c0,0.1-0.1,0.2-0.1,0.3s0.1,0.1,0.2,0.2C476,223.5,476.2,223.4,476.3,223.2z"
        />
        <path
          class="st0"
          d="M457.8,241.9c0-0.2-0.1-0.3-0.1-0.5c-0.1,0-0.2,0-0.2,0.1c0.1,0.1,0.1,0.3,0.2,0.4
			C457.7,242,457.8,241.9,457.8,241.9z"
        />
        <path
          class="st0"
          d="M485.4,236.2C485.4,236.2,485.5,236.2,485.4,236.2C485.5,236.2,485.5,236.2,485.4,236.2c0.1,0,0.1-0.1,0-0.1
			C485.5,236.1,485.4,236.1,485.4,236.2z"
        />
        <path
          class="st0"
          d="M484.4,237.3c0.1,0,0.2-0.1,0.3-0.1c-0.1-0.1-0.1-0.1-0.2-0.2c-0.1,0.1-0.2,0.1-0.3,0.2
			C484.3,237.2,484.3,237.3,484.4,237.3z"
        />
        <path
          class="st0"
          d="M385,260.4c0,0.1-0.1,0.2-0.1,0.2c0.1,0.1,0.1,0.1,0.2,0.2c0-0.1,0.1-0.2,0.1-0.2
			C385.2,260.5,385.1,260.5,385,260.4z"
        />
        <path
          class="st0"
          d="M460.7,240.1c-0.1,0-0.2,0.1-0.3,0.2l0.1,0.1c0.1-0.1,0.2-0.1,0.3-0.2C460.8,240.2,460.7,240.1,460.7,240.1z"
        />
        <path
          class="st0"
          d="M442.4,250.2c0.1,0,0.2,0,0.3,0l0.1-0.1c-0.1,0-0.1-0.1-0.2-0.1C442.5,250.1,442.5,250.1,442.4,250.2z"
        />
        <path
          class="st0"
          d="M550.5,219l0.1-0.1c0-0.1-0.1-0.1-0.2-0.2c0,0.1-0.1,0.2-0.1,0.3C550.3,219,550.4,219,550.5,219z"
        />
        <path
          class="st0"
          d="M550.8,217.5c0.1,0,0.1-0.1,0.1-0.1c0-0.1,0-0.1,0-0.2c-0.1,0.1-0.1,0.1-0.1,0.2V217.5z"
        />
        <path
          class="st0"
          d="M551.5,194.8c0-0.1-0.1-0.1-0.1-0.2c-0.1,0.1-0.2,0.1-0.2,0.2c0,0.1,0.1,0.1,0.2,0.2
			C551.4,194.9,551.5,194.8,551.5,194.8z"
        />
        <path
          class="st0"
          d="M429.5,254.8c0,0.1,0.1,0.1,0.1,0.2l0.1-0.1c0-0.1-0.1-0.1-0.1-0.2C429.6,254.7,429.6,254.8,429.5,254.8z"
        />
        <path
          class="st0"
          d="M454.8,236.9c0,0,0,0.1,0.1,0.1c0,0,0.1,0,0.1-0.1v-0.1C454.9,236.9,454.9,236.9,454.8,236.9z"
        />
        <path
          class="st0"
          d="M514.2,238.8c0.1,0,0.2,0.1,0.2,0.1c0.1,0,0.1-0.1,0.2-0.2c-0.1,0-0.2,0-0.3,0
			C514.2,238.7,514.2,238.8,514.2,238.8z"
        />
        <path
          class="st0"
          d="M493.6,244.2c0,0-0.1,0-0.2,0c0,0,0,0.1,0.1,0.1S493.6,244.3,493.6,244.2L493.6,244.2z"
        />
        <path
          class="st0"
          d="M454.8,234.8l-0.1,0.1c0.1,0,0.2,0,0.3,0l0.1-0.1C455,234.8,454.9,234.8,454.8,234.8z"
        />
        <path
          class="st0"
          d="M477.7,229.6c0.1,0,0.1,0,0.1-0.1c0,0,0-0.1-0.1-0.1C477.8,229.5,477.7,229.5,477.7,229.6L477.7,229.6z"
        />
        <path
          class="st0"
          d="M486.3,246.1c0-0.1-0.1-0.3-0.1-0.4c-0.1,0.1-0.1,0.3-0.2,0.4C486.1,246.1,486.2,246.1,486.3,246.1z"
        />
        <path
          class="st0"
          d="M364.6,253l0.1,0.1l0.1-0.1c0,0-0.1-0.1-0.2-0.1V253z"
        />
        <path
          class="st0"
          d="M463,251.7c-0.1,0-0.2,0-0.3,0c-0.1,0-0.1,0.1-0.1,0.2c0.1,0,0.2,0,0.3,0C462.9,251.8,462.9,251.8,463,251.7z
			"
        />
        <path
          class="st0"
          d="M335.4,257.9C335.4,257.9,335.5,257.9,335.4,257.9c0.1-0.2,0.1-0.2,0.1-0.3
			C335.5,257.7,335.5,257.7,335.4,257.9L335.4,257.9z"
        />
        <path
          class="st0"
          d="M335.3,258.3c0-0.1,0.1-0.2,0.1-0.4c-0.1,0.1-0.2,0.2-0.2,0.3C335.2,258.2,335.3,258.3,335.3,258.3z"
        />
        <path
          class="st0"
          d="M595.7,200.4l-0.1,0.1c0,0.1,0.1,0.1,0.1,0.2l0.1-0.1C595.8,200.5,595.7,200.5,595.7,200.4z"
        />
        <path
          class="st0"
          d="M507.4,219.3c0.1,0,0.2,0,0.3,0l0.1-0.1c-0.1,0-0.2-0.1-0.3-0.1C507.5,219.1,507.4,219.2,507.4,219.3z"
        />
        <path
          class="st0"
          d="M594.6,199.6c0,0.1,0.1,0.1,0.1,0.2l0.1-0.1c0-0.1-0.1-0.1-0.1-0.2C594.7,199.5,594.6,199.5,594.6,199.6z"
        />
        <path
          class="st0"
          d="M438.2,233l-0.1,0.1c0.1,0.1,0.1,0.1,0.2,0.2l0.1-0.1C438.4,233.1,438.3,233.1,438.2,233z"
        />
        <path
          class="st0"
          d="M503.7,244c0,0-0.1-0.1-0.2-0.1c0,0.1-0.1,0.2-0.1,0.2c0.1,0,0.2,0,0.3,0.1C503.7,244.1,503.8,244,503.7,244z
			"
        />
        <path
          class="st0"
          d="M372.5,247.5c0-0.1-0.1-0.1-0.1-0.2l-0.1,0.1c0.1,0.1,0.1,0.1,0.2,0.2C372.4,247.5,372.5,247.5,372.5,247.5z"
        />
        <path
          class="st0"
          d="M381,245.4c-0.1,0-0.2-0.1-0.3-0.1c0,0.1-0.1,0.1-0.1,0.2c0.1,0,0.2,0,0.3,0C380.9,245.5,381,245.4,381,245.4
			z"
        />
        <path
          class="st0"
          d="M549.4,183.4c0.1,0,0.2,0,0.3-0.1c0-0.1-0.1-0.1-0.1-0.2C549.5,183.2,549.4,183.3,549.4,183.4
			C549.3,183.3,549.3,183.4,549.4,183.4z"
        />
        <path
          class="st0"
          d="M516.8,214.5c-0.1,0-0.1-0.1-0.2-0.1c-0.1,0-0.1,0.1-0.2,0.2C516.5,214.6,516.6,214.6,516.8,214.5
			C516.7,214.6,516.8,214.5,516.8,214.5z"
        />
        <path
          class="st0"
          d="M592.5,227.8v-0.1C592.5,227.7,592.4,227.8,592.5,227.8C592.4,227.8,592.5,227.8,592.5,227.8z"
        />
        <path
          class="st0"
          d="M406,268.6l0.1,0.1c0,0,0,0,0,0.1v-0.1C406.1,268.7,406.1,268.6,406,268.6z"
        />
        <path
          class="st0"
          d="M405.7,268.4c0.1,0.1,0.2,0.2,0.3,0.3c-0.1-0.1-0.1-0.2-0.2-0.4L405.7,268.4z"
        />
        <path
          class="st0"
          d="M554.5,205.4c0.1,0,0.1,0.1,0.2,0.1c0-0.1,0.1-0.2,0.1-0.3C554.7,205.3,554.6,205.3,554.5,205.4z"
        />
        <path
          class="st0"
          d="M555.3,204.8c-0.1,0.1-0.2,0.2-0.3,0.3c0.2-0.1,0.3-0.1,0.5-0.2C555.4,204.9,555.4,204.8,555.3,204.8z"
        />
        <path
          class="st0"
          d="M555,205.1L555,205.1c-0.1,0-0.1,0-0.1,0.1C554.9,205.2,554.9,205.2,555,205.1
			C554.9,205.2,555,205.1,555,205.1z"
        />
        <path
          class="st0"
          d="M549.9,184.1c0,0,0-0.1,0.1-0.2l0,0c0,0,0,0-0.1,0C549.9,184,549.9,184.1,549.9,184.1z"
        />
        <path
          class="st0"
          d="M466,261.2c0,0,0.1,0.1,0.2,0.1c0-0.1,0.1-0.2,0.1-0.3l-0.1-0.1C466.1,261.1,466,261.2,466,261.2z"
        />
        <path
          class="st0"
          d="M599.3,233.1l0.1-0.1c-0.1,0-0.2,0-0.3,0l-0.1,0.1C599.1,233.1,599.2,233.1,599.3,233.1z"
        />
        <path
          class="st0"
          d="M349.1,246.4c0.1,0.1,0.1,0.1,0.1,0.2l0.1-0.1c0-0.1-0.1-0.1-0.1-0.2C349.2,246.4,349.1,246.4,349.1,246.4z"
        />
        <path
          class="st0"
          d="M348.9,228.8l0.1-0.1c0-0.1-0.1-0.1-0.1-0.2c-0.1,0.1-0.1,0.1-0.2,0.2C348.7,228.7,348.8,228.8,348.9,228.8z"
        />
        <path
          class="st0"
          d="M481.6,258.7c0-0.1,0-0.1,0-0.2h-0.1C481.6,258.7,481.6,258.7,481.6,258.7z"
        />
        <path
          class="st0"
          d="M598.3,233.6c-0.1,0-0.1,0.1-0.2,0.1c0.1,0.1,0.2,0.1,0.3,0.2C598.4,233.8,598.4,233.7,598.3,233.6z"
        />
        <path
          class="st0"
          d="M598.6,234L598.6,234c-0.1-0.1-0.1-0.1-0.1-0.1S598.5,233.9,598.6,234C598.5,234,598.6,234,598.6,234z"
        />
        <path
          class="st0"
          d="M481.8,259.9l0.1,0.1l0.1-0.1l-0.1-0.1C481.8,259.8,481.8,259.8,481.8,259.9z"
        />
        <path
          class="st0"
          d="M529.5,251c0.1,0.1,0.2,0.1,0.2,0.2c0-0.1-0.1-0.2-0.1-0.3C529.5,251,529.5,251,529.5,251z"
        />
        <path
          class="st0"
          d="M529.7,251.2v0.1h0.1C529.8,251.3,529.8,251.3,529.7,251.2C529.8,251.2,529.7,251.2,529.7,251.2z"
        />
        <path
          class="st0"
          d="M453.2,268.6l-0.1,0.1l0.1,0.1l0.1,0.1l0.1-0.1l0,0C453.3,268.7,453.3,268.7,453.2,268.6z"
        />
        <path
          class="st0"
          d="M557.6,186.6v-0.1c0,0,0-0.1-0.1-0.1c0,0-0.1,0.1,0,0.1C557.5,186.6,557.6,186.6,557.6,186.6z"
        />
        <path
          class="st0"
          d="M356.8,231.1L356.8,231.1c0-0.1-0.1-0.1-0.1-0.1s0,0,0,0.1C356.7,231.1,356.8,231.1,356.8,231.1z"
        />
        <path
          class="st0"
          d="M506.1,258l0.1,0.1c0-0.1,0.1-0.2,0.1-0.3l-0.1-0.1C506.2,257.8,506.1,257.9,506.1,258z"
        />
        <path
          class="st0"
          d="M340.6,236.2L340.6,236.2c0,0.1-0.1,0.2-0.1,0.3C340.6,236.3,340.6,236.3,340.6,236.2z"
        />
        <path
          class="st0"
          d="M518.9,261.2l0.1,0.1c0,0,0.1,0,0.1-0.1c0,0,0-0.1-0.1-0.1C519,261.2,518.9,261.2,518.9,261.2z"
        />
        <path
          class="st0"
          d="M546.6,192.1l0.1,0.1c0.1,0,0.2-0.1,0.2-0.1l-0.1-0.1C546.8,191.9,546.7,192,546.6,192.1z"
        />
        <path
          class="st0"
          d="M560.6,268.4c0,0.1,0.1,0.1,0.2,0.2c0.1-0.1,0.2-0.2,0.2-0.2c-0.1-0.1-0.2-0.1-0.3-0.2
			C560.7,268.3,560.6,268.4,560.6,268.4z"
        />
        <path
          class="st0"
          d="M486.5,210.3c0.1,0,0.2,0,0.3-0.1c0-0.1-0.1-0.1-0.1-0.2c-0.1,0.1-0.2,0.1-0.3,0.2L486.5,210.3z"
        />
        <path
          class="st0"
          d="M549.7,181.5c0-0.1,0-0.1,0-0.2c-0.1,0-0.1,0.1-0.2,0.1C549.5,181.5,549.6,181.5,549.7,181.5z"
        />
        <path
          class="st0"
          d="M556.3,182.1C556.3,182.1,556.2,182.1,556.3,182.1c-0.1,0-0.1,0-0.2,0C556.2,182.2,556.2,182.2,556.3,182.1
			C556.3,182.2,556.3,182.1,556.3,182.1z"
        />
        <path
          class="st0"
          d="M548.7,184.4l0.1-0.1c0,0-0.1,0-0.1-0.1l-0.1,0.1C548.6,184.4,548.7,184.4,548.7,184.4z"
        />
        <polygon class="st0" points="353,230.4 352.9,230.4 353,230.5 		" />
        <path
          class="st0"
          d="M356.6,229.6c0,0.1-0.1,0.2-0.1,0.2l0,0l0,0C356.5,229.7,356.5,229.6,356.6,229.6z"
        />
        <path
          class="st0"
          d="M547.2,189c0-0.1-0.1-0.1-0.1-0.2c0,0.1-0.1,0.1-0.1,0.2C547,189,547.1,189,547.2,189z"
        />
        <path
          class="st0"
          d="M547.3,189.1C547.3,189.1,547.2,189.1,547.3,189.1C547.2,189,547.2,189,547.3,189.1
			C547.2,189.1,547.2,189.1,547.3,189.1C547.2,189.1,547.2,189.1,547.3,189.1z"
        />
        <path
          class="st0"
          d="M547.4,189.2c-0.1,0-0.1,0-0.2-0.1v0.1C547.3,189.2,547.4,189.2,547.4,189.2z"
        />
        <path
          class="st0"
          d="M353.2,232c0,0,0-0.1,0.1-0.1C353.2,231.9,353.1,232,353.2,232c-0.1,0-0.1,0.1-0.1,0.1S353.1,232.1,353.2,232
			z"
        />
        <polygon class="st0" points="355.9,231.9 356,231.8 355.9,231.8 		" />
        <path
          class="st0"
          d="M543.3,194.3c-0.1,0-0.2,0-0.2,0c0,0.1,0,0.1,0.1,0.2C543.2,194.3,543.2,194.3,543.3,194.3z"
        />
        <path
          class="st0"
          d="M543,194.2L543,194.2c-0.1-0.1-0.1-0.1-0.1-0.1C542.9,194.2,543,194.2,543,194.2L543,194.2z"
        />
        <polygon class="st0" points="593.9,185.3 593.9,185.4 594.1,185.4 		" />
        <polygon class="st0" points="597.6,188.2 597.5,188.2 597.6,188.3 		" />
        <path
          class="st0"
          d="M352,243.5l-0.1,0.1c0.1,0,0.2,0,0.2-0.1C352.1,243.5,352.1,243.5,352,243.5z"
        />
        <path
          class="st0"
          d="M524.5,206.5c0-0.1,0.1-0.1,0.1-0.2c0-0.1,0-0.2,0.1-0.2c0,0.1-0.1,0.1-0.1,0.2S524.5,206.5,524.5,206.5z"
        />
        <polygon class="st0" points="383.9,238.7 383.8,238.7 383.8,238.8 		" />
        <path
          class="st0"
          d="M550.8,203l0.1-0.1l-0.1-0.1l-0.1,0.1C550.7,203,550.8,203,550.8,203z"
        />
        <polygon class="st0" points="380.2,244.9 380.2,245 380.3,245 		" />
        <path
          class="st0"
          d="M336,256.7c0.1,0,0.2,0,0.2-0.1c0,0-0.1,0-0.1-0.1C336.1,256.6,336.1,256.6,336,256.7z"
        />
        <path
          class="st0"
          d="M439.5,235.9c0,0.1-0.1,0.2-0.1,0.3C439.4,236.1,439.5,236,439.5,235.9c0.2-0.1,0.3-0.2,0.4-0.3l0,0
			c0,0,0,0-0.1,0C439.7,235.6,439.6,235.8,439.5,235.9z"
        />
        <path
          class="st0"
          d="M448.1,234.3l0.1-0.1l-0.1-0.1l-0.1,0.1C448,234.2,448,234.3,448.1,234.3z"
        />
        <polygon class="st0" points="451,233.9 451.1,233.8 451,233.8 		" />
        <polygon class="st0" points="522.9,218.9 523,218.9 523,218.8 		" />
        <path
          class="st0"
          d="M443.7,237.3c0.1,0,0.2,0,0.2-0.1l-0.1-0.1C443.7,237.2,443.7,237.2,443.7,237.3z"
        />
        <path
          class="st0"
          d="M488.2,227.8c0,0-0.1,0-0.1-0.1c0,0,0,0,0,0.1H488.2z"
        />
        <path
          class="st0"
          d="M448.2,238.4c0.1-0.1,0.1-0.1,0.2-0.2l0,0l0,0C448.3,238.2,448.2,238.3,448.2,238.4z"
        />
        <path
          class="st0"
          d="M417.9,246.3l-0.1,0.1c0,0,0.1,0,0.1,0.1C417.9,246.5,417.9,246.4,417.9,246.3z"
        />
        <path
          class="st0"
          d="M552,217.5c0,0-0.1,0-0.1,0.1c0,0,0,0.1-0.1,0.1c0,0,0.1,0,0.1-0.1S551.9,217.5,552,217.5z"
        />
        <path
          class="st0"
          d="M551.8,217.7C551.7,217.7,551.7,217.7,551.8,217.7C551.7,217.7,551.8,217.7,551.8,217.7
			C551.8,217.6,551.8,217.6,551.8,217.7z"
        />
        <path
          class="st0"
          d="M418.4,246.9l-0.1,0.1c0,0,0.1,0,0.1,0.1l0.1-0.1C418.5,246.9,418.4,246.9,418.4,246.9z"
        />
        <polygon class="st0" points="383.4,256.6 383.5,256.6 383.5,256.5 		" />
        <path
          class="st0"
          d="M542.2,222.1c0.1-0.1,0.1-0.1,0.1-0.1S542.2,222,542.2,222.1c-0.1,0-0.1,0.1-0.2,0.1
			C542.1,222.2,542.1,222.1,542.2,222.1z"
        />
        <path
          class="st0"
          d="M531.9,224.7c0,0.1,0,0.1,0,0.2h0.1C532,224.9,532.1,224.8,531.9,224.7C532,224.7,531.9,224.7,531.9,224.7z"
        />
        <polygon class="st0" points="599,210.2 598.9,210.2 599,210.3 		" />
        <polygon class="st0" points="383.9,257.1 384,257.1 384,257 		" />
        <path
          class="st0"
          d="M497.5,242.6l-0.1,0.1l0.1,0.1c0-0.1,0.1-0.1,0.1-0.2C497.6,242.6,497.6,242.6,497.5,242.6z"
        />
        <polygon class="st0" points="399.1,265.6 399.2,265.6 399.1,265.5 		" />
        <polygon class="st0" points="493.9,245.1 494,245 493.9,245 		" />
        <path
          class="st0"
          d="M431.1,259.1L431.1,259.1L431.1,259.1L431.1,259.1c0.1-0.1,0.1-0.1,0.1-0.2
			C431.2,258.9,431.1,259,431.1,259.1z"
        />
        <path
          class="st0"
          d="M431,259.4c0-0.1,0.1-0.2,0.1-0.2c-0.1,0.1-0.2,0.1-0.2,0.2C430.9,259.3,430.9,259.4,431,259.4z"
        />
        <polygon class="st0" points="486.4,247.2 486.3,247.2 486.4,247.3 		" />
        <polygon class="st0" points="383.6,269.9 383.7,269.8 383.6,269.8 		" />
        <polygon class="st0" points="399.7,266.4 399.7,266.3 399.6,266.3 		" />
        <path
          class="st0"
          d="M511,242.5l-0.1-0.1l-0.1,0.1l0.1,0.1C511,242.6,511,242.5,511,242.5z"
        />
        <polygon class="st0" points="394.3,271.2 394.4,271.1 394.3,271.1 		" />
        <polygon class="st0" points="513.7,246.8 513.8,246.7 513.7,246.7 		" />
        <path
          class="st0"
          d="M555.7,238.3L555.7,238.3c0.1,0,0.2-0.1,0.1-0.1l-0.1-0.1C555.8,238.2,555.7,238.3,555.7,238.3z"
        />
        <path
          class="st0"
          d="M519.6,248.8c0,0-0.1,0-0.1-0.1l-0.1,0.1l0.1,0.1C519.6,248.9,519.6,248.8,519.6,248.8z"
        />
        <path
          class="st0"
          d="M466.8,261.4l0.1,0.1l0.1-0.1l-0.1-0.1C466.9,261.3,466.9,261.4,466.8,261.4z"
        />
        <polygon class="st0" points="504.9,253.5 504.9,253.4 504.8,253.5 		" />
        <polygon class="st0" points="486.9,258 486.8,258 486.8,258.1 		" />
        <path
          class="st0"
          d="M469,262.5l0.1,0.1l0.1-0.1c0,0-0.1,0-0.1-0.1L469,262.5z"
        />
        <path
          class="st0"
          d="M530,251.4v-0.1c-0.1,0-0.1,0-0.2,0C529.9,251.3,530,251.4,530,251.4z"
        />
        <polygon class="st0" points="491.4,261.6 491.4,261.5 491.3,261.5 		" />
        <path
          class="st0"
          d="M470,266.4L470,266.4c0.1-0.1,0.1-0.2,0.1-0.2l-0.1,0.1V266.4z"
        />
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  name: "SoccerCover_c3",
  props: ["fill"],
};
</script>
